/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656cdf69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656cdf69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"fb6699d6-41d2-4a31-a714-5a422c5b48fb","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"finding-information-about-printer-topic.html","desc":"การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์ แหล่งข้อมูลและที่ที่จะหาได้ คุณกำลังหาอะไร พบได้ที่นี่ คำแนะนำเกี่ยวกับการตั้งค่าเบื้องต้น","descFull":"การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์ แหล่งข้อมูลและที่ที่จะหาได้ คุณกำลังหาอะไร พบได้ที่นี่ คำแนะนำเกี่ยวกับการตั้งค่าเบื้องต้น โปรดดูเอกสารประกอบการติดตั้งที่ให้มาพร้อมกับเครื่องพิมพ์ ซอฟต์แวร์เครื่องพิมพ์ ไดรเวอร์แฟกซ์หรือพิมพ์ เฟิร์มแวร์ของเครื่องพิมพ์ ยูทิลิตี้ ไปที่   www.lexmark.com/downloads คู่มือผู้ใช้ แบบอินเทอร์แอคทีฟ ไปที่  https://support.lexmark.com วิดีโอการใช้งาน ไปที่  https://infoserve.lexmark.com/idv/ ข้อมูลความช่วยเหลือสำหรับการใช้ซอฟต์แวร์เครื่องพิมพ์ ความช่วยเหลือสำหรับระบบปฏิบัติการ Windows หรือ Macintosh—เปิดโปรแกรมหรือแอปพลิเคชันซอฟต์แวร์เครื่องพิมพ์ แล้วคลิก  ความช่วยเหลือ คลิกที่   เพื่อดูข้อมูลต่างๆ ความช่วยเหลือจะถูกติดตั้งพร้อมกับซอฟต์แวร์เครื่องพิมพ์โดยอัตโนมัติ ซอฟต์แวร์เครื่องพิมพ์จะอยู่ในโฟลเดอร์โปรแกรมเครื่องพิมพ์ หรือบนเดสก์ทอป ขึ้นอยู่กับระบบปฏิบัติการ เอกสาร ความช่วยเหลือทางแชทสด ความช่วยเหลือทางอีเมล ความช่วยเหลือด้วยเสียง ไปที่  https://support.lexmark.com เลือกประเทศหรือพื้นที่ของท่าน แล้วเลือกผลิตภัณฑ์เพื่อดูไซต์บริการรองรับที่เหมาะสม สามารถดูข้อมูลการติดต่อของฝ่ายให้คำปรึกษาลูกค้าสำหรับประเทศหรือพื้นที่ของคุณได้บนเว็บไซต์ หรือในใบรับประกันที่มาพร้อมกับเครื่องพิมพ์ เตรียมข้อมูลต่อไปนี้ให้พร้อมเมื่อคุณติดต่อฝ่ายให้คำปรึกษาลูกค้า: สถานที่และวันที่ซื้อ ประเภทและหมายเลขประจำเครื่อง โปรดดูข้อมูลเพิ่มเติมที่  ข้อมูลเพื่อความปลอดภัย ข้อมูลเกี่ยวกับกฎระเบียบ ข้อมูลเกี่ยวกับการรับประกัน ข้อมูลด้านสิ่งแวดล้อม ข้อมูลเกี่ยวกับการรับประกันจะแตกต่างกันไปตามแต่ละประเทศหรือภูมิภาค: ในสหรัฐอเมริกา —โปรดดูคำประกาศเกี่ยวกับการรับประกันแบบจำกัดที่มาพร้อมกับเครื่องพิมพ์ หรือไปที่  https://support.lexmark.com ในประเทศหรือพื้นที่อื่นๆ —โปรดดูใบรับประกันที่ให้มาพร้อมกับเครื่องพิมพ์ คู่มือแนะนำข้อมูลผลิตภัณฑ์ —โปรดดูในเอกสารที่ให้มาพร้อมกับเครื่องพิมพ์ หรือไปที่  https://support.lexmark.com ข้อมูลเกี่ยวกับหนังสือเดินทางดิจิตอลของ Lexmark ไปที่  https://csr.lexmark.com/digital-passport.php การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์"},{"UUID":"52cd2a2a-5eef-4709-993a-502de82cb08b","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"finding-printer-serial-number-topic.html","desc":"","descFull":"การค้นหาหมายเลขประจำเครื่องของเครื่องพิมพ์ เปิดถาด ค้นหาหมายเลขประจำเครื่องทางด้านขวาของเครื่องพิมพ์ หมายเลขประจำเครื่องของเครื่องพิมพ์ หมายเลขประจำเครื่อง"},{"UUID":"7fd5c76e-1091-442e-9e74-7412e3a82bad","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"printer-configurations-topic.html","desc":"การกำหนดค่าเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าได้กำหนดค่าเครื่องพิมพ์บนพื้นผิวที่เรียบ แข็งแรงและมั่นคง รุ่นเบื้องต้น ชิ้นส่วนของรุ่นเครื่องพิมพ์เบื้องต้น","descFull":"การกำหนดค่าเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าได้กำหนดค่าเครื่องพิมพ์บนพื้นผิวที่เรียบ แข็งแรงและมั่นคง รุ่นเบื้องต้น ชิ้นส่วนของรุ่นเครื่องพิมพ์เบื้องต้น 1 ตัวป้อนเอกสารอัตโนมัติ (ADF) 2 แผงควบคุม 3 พอร์ต USB 4 ตัวป้อนกระดาษอเนกประสงค์ 5 ถาดมาตรฐาน 550 แผ่น 6 ถาดมาตรฐาน รุ่นที่กำหนดค่าแล้ว การติดตั้งตัวเลือกอย่างน้อยหนึ่งตัวเลือกบนเครื่องพิมพ์หรือบน MFP ของคุณอาจต้องใช้ฐานแบบมีล้อเลื่อน เฟอร์นิเจอร์ หรือคุณลักษณะอื่นๆ เพื่อป้องกันความไม่เสถียรซึ่งอาจทำให้เกิดการบาดเจ็บได้ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการกำหนดค่าที่รองรับ โปรดดูที่  www.lexmark.com/multifunctionprinters การติดตั้งตัวเลือกอย่างน้อยหนึ่งตัวเลือกบนเครื่องพิมพ์หรือบน MFP ของคุณอาจต้องใช้ฐานแบบมีล้อเลื่อน เฟอร์นิเจอร์ หรือคุณลักษณะอื่นๆ เพื่อป้องกันความไม่เสถียรซึ่งอาจทำให้เกิดการบาดเจ็บได้ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการกำหนดค่าที่รองรับ โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน ให้ปิดถาดอื่นๆ ไว้จนกว่าจำเป็นต้องใช้ ชิ้นส่วนของรุ่นเครื่องพิมพ์ที่กำหนดค่าแล้ว # ตัวเลือกฮาร์ดแวร์ ตัวเลือกฮาร์ดแวร์สำรอง 1  ไม่สามารถติดตั้งร่วมกับอุปกรณ์เย็บเล่มหรืออุปกรณ์เย็บเล่มตอกรู 2  จำเป็นต้องติดตั้งร่วมกับถาดเสริม 550 แผ่นและถาด 550 แผ่น 2 ถาดหรือถาดบรรจุคู่ 2000 แผ่น 3  จำเป็นต้องติดตั้งร่วมกับถาดเสริม 550 แผ่น 4  จำเป็นต้องติดตั้งร่วมกับถาดเสริม 550 แผ่นและรายการใดรายการหนึ่งต่อไปนี้: ถาด 550 แผ่น 2 ถาด, ถาดบรรจุคู่ 2000 แผ่น หรือแบบหมุน 1 อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ 1 อุปกรณ์เรียงกระดาษออฟเซ็ต 1 อุปกรณ์ส่งกระดาษ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ 2 ถาด 1500 แผ่น 2 ไม่มี 3 ถาดบรรจุคู่ 2000 แผ่น 3 ถาด 550 แผ่น 2 ถาด 3 แบบหมุน 3 4 ถาดเสริม 550 แผ่น ไม่มี 5 อุปกรณ์เย็บเล่ม 4 อุปกรณ์เย็บเล่มตอกรู 4 ตัวเลือกบางรายการอาจไม่สามารถใช้งานได้ สำหรับข้อมูลเพิ่มเติม โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ การกำหนดค่าเครื่องพิมพ์"},{"UUID":"5d63315a-49e9-4e9a-a918-9d9461273fda","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"using-control-panel-topic.html","desc":"การใช้แผงควบคุม ส่วนของแผงควบคุมและการทำงาน ส่วนแผงควบคุม ฟังก์ชัน 1","descFull":"การใช้แผงควบคุม ส่วนของแผงควบคุมและการทำงาน ส่วนแผงควบคุม ฟังก์ชัน 1 ปุ่มเปิด/ปิด เปิดหรือปิดเครื่องพิมพ์ หากต้องการปิดเครื่องพิมพ์ ให้กดปุ่มเปิด/ปิดค้างไว้เป็นเวลาห้าวินาที ตั้งให้เครื่องพิมพ์อยู่ในโหมดพักเครื่อง ปลุกเครื่องพิมพ์จากโหมดพักเครื่องหรือไฮเบอร์เนต 2 ส่วนแสดงผล ดูข้อความเครื่องพิมพ์และสถานะวัสดุสิ้นเปลือง ตั้งค่าและใช้งานเครื่องพิมพ์ 3 ไฟแสดงสถานะ ตรวจสอบสถานะของเครื่องพิมพ์ แผงควบคุม การใช้ การใช้แผงควบคุม"},{"UUID":"8bc9eb24-569e-45f0-bb5a-c561893472d3","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"using-home-screen-topic.html","desc":"ไอคอนหน้าจอหลัก หน้าจอหลักของคุณอาจแตกต่างกันไปขึ้นอยู่กับการตั้งค่า การปรับแต่งหน้าจอหลัก การตั้งค่าการจัดการ และ","descFull":"ไอคอนหน้าจอหลัก หน้าจอหลักของคุณอาจแตกต่างกันไปขึ้นอยู่กับการตั้งค่า การปรับแต่งหน้าจอหลัก การตั้งค่าการจัดการ และ Embedded Solutions ที่ใช้งานของคุณ ไอคอนหน้าจอหลักและฟังก์ชัน # ชื่อไอคอน ฟังก์ชัน 1 ผู้ใช้ แสดงหากผู้ใช้ลงชื่อเข้าใช้เครื่องพิมพ์ 2 ข้อมูลที่แสดง แสดงข้อมูลเครื่องพิมพ์แบบกำหนดเอง เช่น IP แอดเดรสของเครื่องพิมพ์หรือวันที่และเวลา 3 วัสดุสิ้นเปลือง แสดงสถานะของวัสดุสิ้นเปลือง 4 การแจ้งเตือน แสดงคำเตือนหรือข้อความแสดงข้อผิดพลาดของเครื่องพิมพ์เมื่อต้องดำเนินการกับเครื่องพิมพ์เพื่อประมวลผลต่อ ดูข้อมูลเพิ่มเติมเกี่ยวกับคำเตือนหรือข้อความของเครื่องพิมพ์และวิธีการล้างคำเตือนหรือข้อความ 5 พิมพ์ พิมพ์ภาพถ่ายและเอกสารต่างๆ 6 ทำสำเนา ทำสำเนาภาพถ่ายและเอกสารต่างๆ 7 สแกน สแกนเอกสาร 8 แฟกซ์ ส่งข้อความผ่านแฟกซ์ การใช้หน้าจอหลัก ไอคอนหน้าจอหลัก"},{"UUID":"a0910e8b-403d-482c-8cef-df31c82a3085","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"colors-of-indicator-light-topic.html","desc":"สีของไฟแสดงสถานะ สีของไฟแสดงสถานะและสถานะเครื่องพิมพ์ สีของไฟแสดงสถานะ สถานะเครื่องพิมพ์ ปิด","descFull":"สีของไฟแสดงสถานะ สีของไฟแสดงสถานะและสถานะเครื่องพิมพ์ สีของไฟแสดงสถานะ สถานะเครื่องพิมพ์ ปิด เครื่องพิมพ์ปิดอยู่ สีน้ำเงินสว่างนิ่ง เครื่องพิมพ์พร้อมใช้งาน กะพริบเป็นสีน้ำเงิน เครื่องพิมพ์กำลังพิมพ์หรือกำลังประมวลผลข้อมูล กะพริบเป็นสีแดง ผู้ใช้ต้องดำเนินการจัดการเครื่องพิมพ์ สีเหลืองสว่างนิ่ง เครื่องพิมพ์อยู่ในโหมดพักเครื่อง สีเหลืองกะพริบ เครื่องพิมพ์อยู่ในโหมดหลับลึกหรือโหมดไฮเบอร์เนต ไฟแสดงสถานะ สถานะเครื่องพิมพ์ สภาพของเครื่องพิมพ์"},{"UUID":"369e3f87-f0a4-40d7-888b-64168bb50878","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์ การใส่กระดาษเข้าในถาด ADF และบนกระจกสแกนเนอร์ ตัวป้อนเอกสารอัตโนมัติ","descFull":"การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์ การใส่กระดาษเข้าในถาด ADF และบนกระจกสแกนเนอร์ ตัวป้อนเอกสารอัตโนมัติ (ADF) กระจกสแกนเนอร์ ใช้ ADF สำหรับเอกสารที่มีหลายหน้าหรือสองด้าน ใส่เอกสารต้นฉบับหงายหน้าขึ้น สำหรับเอกสารที่มีหลายหน้า ตรวจสอบให้แน่ใจว่าได้จัดแนวขอบกระดาษให้ตรงกันก่อนใส่ ตรวจสอบให้แน่ใจว่าปรับตัวกั้น ADF ให้ตรงกับความกว้างของกระดาษที่ใส่ ใช้กระจกสแกนเนอร์สำหรับเอกสารหน้าเดียว หน้าหนังสือ สื่อที่มีขนาดเล็ก (เช่น โปสการ์ด หรือภาพถ่าย) แผ่นใส กระดาษภาพถ่าย หรือสื่อที่บาง (เช่น กระดาษที่ตัดมาจากนิตยสาร) วางเอกสารคว่ำหน้าลงตรงมุมที่มีลูกศรชี้ การทำสำเนา การใช้ตัวป้อนเอกสารอัตโนมัติ (ADF) การทำสำเนา การใช้กระจกสแกนเนอร์"},{"UUID":"c1325535-edd3-45ec-8fa9-5a2ef328e151","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์","link":"locating-security-slot-topic.html","desc":"การค้นหาช่องสำหรับความปลอดภัย เครื่องพิมพ์มีคุณสมบัติการล็อคเพื่อรักษาความปลอดภัย ใส่ล็อคเพื่อรักษาความปลอดภัยแบบที่ใช้กับคอมพิวเตอร์แล็ปท็อปส่วนใหญ่ตามตำแหน่งที่แสดงในภาพเพื่อล็อคเครื่องพิมพ์ให้อยู่กับที่ ช่องสำหรับความปลอดภัย การค้นหา","descFull":"การค้นหาช่องสำหรับความปลอดภัย เครื่องพิมพ์มีคุณสมบัติการล็อคเพื่อรักษาความปลอดภัย ใส่ล็อคเพื่อรักษาความปลอดภัยแบบที่ใช้กับคอมพิวเตอร์แล็ปท็อปส่วนใหญ่ตามตำแหน่งที่แสดงในภาพเพื่อล็อคเครื่องพิมพ์ให้อยู่กับที่ ช่องสำหรับความปลอดภัย การค้นหา การค้นหาช่องสำหรับความปลอดภัย"},{"UUID":"8585b1be-b2fb-4d8a-b5e6-cad40510d42e","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"คำแนะนำเกี่ยวกับกระดาษ ใช้กระดาษที่เหมาะสมเพื่อป้องกันกระดาษติดและช่วยให้แน่ใจว่าการพิมพ์จะไม่มีปัญหา โปรดใช้กระดาษใหม่ที่ไม่ชำรุดเสียหาย ก่อนใส่กระดาษควร ให้ตรวจสอบด้านที่สามารถพิมพ์ได้ของกระดาษเสียก่อน","descFull":"คำแนะนำเกี่ยวกับกระดาษ ใช้กระดาษที่เหมาะสมเพื่อป้องกันกระดาษติดและช่วยให้แน่ใจว่าการพิมพ์จะไม่มีปัญหา โปรดใช้กระดาษใหม่ที่ไม่ชำรุดเสียหาย ก่อนใส่กระดาษควร ให้ตรวจสอบด้านที่สามารถพิมพ์ได้ของกระดาษเสียก่อน โดยปกติแล้วจะระบุข้อมูลนี้บนบรรจุภัณฑ์กระดาษ ห้ามใช้กระดาษที่ถูกตัดหรือเล็มด้วยมือ อย่าใส่กระดาษที่มีขนาด ประเภท หรือน้ำหนักที่แตกต่างกันปนกันในถาดเดียว เพราะอาจทำให้กระดาษติด ห้ามใช้กระดาษเคลือบ เว้นแต่จะถูกออกแบบมาโดยเฉพาะสำหรับการพิมพ์แบบอิเล็กโทรโฟโตกราฟี สำหรับข้อมูลเพิ่มเติม โปรดดูที่  คำแนะนำเกี่ยวกับกระดาษและวัสดุพิมพ์ชนิดพิเศษ กระดาษ การเลือก คำแนะนำเกี่ยวกับกระดาษ"},{"UUID":"831ec49c-ed72-44c2-bf02-15c3c8b7d42e","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"คุณลักษณะของกระดาษ คุณลักษณะของกระดาษต่อไปนี้จะส่งผลต่อคุณภาพการพิมพ์และความน่าเชื่อถือ พิจารณาปัจจัยเหล่านี้ก่อนที่จะพิมพ์ น้ำหนัก ถาดสามารถป้อนกระดาษที่มีน้ำหนักหลากหลาย","descFull":"คุณลักษณะของกระดาษ คุณลักษณะของกระดาษต่อไปนี้จะส่งผลต่อคุณภาพการพิมพ์และความน่าเชื่อถือ พิจารณาปัจจัยเหล่านี้ก่อนที่จะพิมพ์ น้ำหนัก ถาดสามารถป้อนกระดาษที่มีน้ำหนักหลากหลาย กระดาษที่เบากว่า 60 แกรม 2  (16 ปอนด์) อาจแข็งไม่พอที่จะป้อนได้อย่างถูกต้อง และอาจทำให้กระดาษติด สำหรับข้อมูลเพิ่มเติม ดูหัวข้อ “น้ำหนักกระดาษที่รองรับ” ม้วนงอ การม้วนงอเป็นแนวโน้มของกระดาษที่จะม้วนงอบริเวณขอบ การม้วนงอมากเกินไปอาจทำให้เกิดปัญหาเกี่ยวกับการป้อนกระดาษ การม้วนงออาจเกิดขึ้นได้หลังจากที่กระดาษผ่านเครื่องพิมพ์ในตำแหน่งที่มีอุณหภูมิสูง การจัดเก็บกระดาษที่ไม่ได้ห่อไว้ในสภาพร้อน ชื้น เย็น หรือแห้งอาจทำให้กระดาษม้วนงอก่อนการพิมพ์ รวมถึงอาจทำให้เกิดปัญหาเกี่ยวกับการป้อนกระดาษได้ ความเรียบเนียน ความเรียบเนียนของกระดาษมีผลโดยตรงต่อคุณภาพการพิมพ์ หากกระดาษหยาบเกินไป หมึกจะไม่สามารถซึมเข้าไปในกระดาษได้อย่างถูกต้อง หากกระดาษเรียบเกินไป อาจทำให้เกิดปัญหาเกี่ยวกับการป้อนกระดาษหรือคุณภาพการพิมพ์ได้ เราขอแนะนำให้ใช้กระดาษที่มีคะแนน Sheffield 50 คะแนน ปริมาณความชื้น ปริมาณความชื้นในกระดาษจะส่งผลกระทบต่อคุณภาพการพิมพ์และความสามารถในการป้อนกระดาษอย่างถูกต้องของเครื่องพิมพ์ ทิ้งกระดาษไว้ในห่อกระดาษดั้งเดิมจนกว่าคุณจะใช้ กระดาษที่สัมผัสกับความชื้น อาจทำให้มีประสิทธิภาพลดลง ก่อนพิมพ์ ให้เก็บกระดาษไว้ในห่อกระดาษดั้งเดิมห่อกระดาษเป็นเวลา 24-48 ชั่วโมง สภาพแวดล้อมที่เก็บกระดาษต้องเหมือนกันกับเครื่องพิมพ์ ขยายเวลาออกไปหลายวันหากสภาพแวดล้อมการจัดเก็บหรือการขนส่งแตกต่างจากสภาพแวดล้อมของเครื่องพิมพ์เป็นอย่างมาก กระดาษหนาอาจต้องใช้เวลาในการปรับสภาพนานขึ้นด้วย ทิศทางของเกรน เกรนหมายถึงการเรียงแนวของเส้นใยกระดาษในแผ่นกระดาษ โดยจะมี  เกรนยาว ที่เรียงแนวตามด้านยาวของกระดาษหรือ  เกรนสั้น ที่เรียงแนวตามด้านกว้างของกระดาษ สำหรับทิศทางของเกรนที่แนะนำ โปรดดูหัวข้อ “น้ำหนักกระดาษที่รองรับ” ส่วนประกอบเส้นใย กระดาษถ่ายเอกสารคุณภาพสูงส่วนใหญ่จะทำจากเยื่อกระดาษที่ผ่านการชุบสารเคมี 100 เปอร์เซ็นต์ ส่วนประกอบดังกล่าวทำให้กระดาษมีความแข็งแรงในระดับสูง ส่งผลให้มีปัญหาเกี่ยวกับการป้อนกระดาษน้อยลงและได้คุณภาพการพิมพ์ที่ดีขึ้น กระดาษที่มีเส้นใย เช่น ผ้าฝ้าย อาจมีผลเสียต่อการจัดการกระดาษ คุณลักษณะของกระดาษ"},{"UUID":"cef9a63c-95f8-420d-a5c3-bc06a9604c18","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"กระดาษที่ไม่สามารถใช้ได้ ไม่แนะนำให้ใช้กระดาษประเภทต่อไปนี้กับเครื่องพิมพ์: กระดาษที่ผ่านกระบวนการทางเคมีที่ใช้ทำสำเนาโดยไม่ใช้กระดาษคาร์บอน หรือที่เรียกว่ากระดาษไร้คาร์บอน กระดาษทำสำเนาแบบไม่ใช้คาร์บอน","descFull":"กระดาษที่ไม่สามารถใช้ได้ ไม่แนะนำให้ใช้กระดาษประเภทต่อไปนี้กับเครื่องพิมพ์: กระดาษที่ผ่านกระบวนการทางเคมีที่ใช้ทำสำเนาโดยไม่ใช้กระดาษคาร์บอน หรือที่เรียกว่ากระดาษไร้คาร์บอน กระดาษทำสำเนาแบบไม่ใช้คาร์บอน (CCP) หรือกระดาษที่ไม่ต้องใช้คาร์บอน (NCR) กระดาษที่พิมพ์แบบฟอร์มซึ่งมีสารเคมีที่อาจเปื้อนเครื่องพิมพ์ กระดาษที่พิมพ์แบบฟอร์มซึ่งอาจได้รับผลกระทบจากอุณหภูมิใน ฟิวเซอร์ของเครื่องพิมพ์ กระดาษแบบฟอร์มที่ต้องลงทะเบียน (ตำแหน่งการพิมพ์ที่แม่นยำในหน้ากระดาษ) มากกว่า ±2.3 มม. (±0.09 นิ้ว) เช่น แบบฟอร์ม Optical Character Recognition (OCR) ในบางครั้ง สามารถปรับเปลี่ยนการลงทะเบียนได้โดยใช้แอปพลิเคชันซอฟต์แวร์เพื่อพิมพ์บนฟอร์มเหล่านี้ได้สำเร็จ กระดาษเคลือบ (กระดาษปอนด์แบบลบได้) กระดาษใยสังเคราะห์ หรือกระดาษความร้อน กระดาษที่มีขอบยับ แข็ง หรือมีผิวหยาบมาก หรือกระดาษงอ กระดาษที่ไม่ผ่าน EN12281:2002 (ยุโรป) กระดาษที่มีน้ำหนักน้อยกว่า 60 แกรม 2  (16 ปอนด์) แบบฟอร์มหรือเอกสารหลายส่วน กระดาษที่ไม่สามารถใช้ได้"},{"UUID":"3313b43d-9321-4601-83ba-3bf688d71681","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"การจัดเก็บกระดาษ ใช้คำแนะนำในการจัดเก็บกระดาษเหล่านี้เพื่อช่วยหลีกเลี่ยงกระดาษติดและคุณภาพการพิมพ์ไม่สม่ำเสมอ: เก็บกระดาษไว้ในห่อกระดาษดั้งเดิมในสภาพแวดล้อมเดียวกับเครื่องพิมพ์เป็นเวลา 24 ถึง","descFull":"การจัดเก็บกระดาษ ใช้คำแนะนำในการจัดเก็บกระดาษเหล่านี้เพื่อช่วยหลีกเลี่ยงกระดาษติดและคุณภาพการพิมพ์ไม่สม่ำเสมอ: เก็บกระดาษไว้ในห่อกระดาษดั้งเดิมในสภาพแวดล้อมเดียวกับเครื่องพิมพ์เป็นเวลา 24 ถึง 48 ชั่วโมงก่อนพิมพ์ ยืดเวลาออกไป 2-3 วัน หากสภาพแวดล้อมการจัดเก็บหรือการขนส่งแตกต่างจากสภาพแวดล้อมของเครื่องพิมพ์เป็นอย่างมาก กระดาษหนาอาจต้องใช้เวลาในการปรับสภาพนานขึ้นด้วย เพื่อผลลัพธ์ที่ดีที่สุด ให้เก็บกระดาษในที่ที่มีอุณหภูมิ 21°C (70°F) และความชื้นสัมพัทธ์ 40 เปอร์เซ็นต์ ผู้ผลิตฉลากส่วนใหญ่แนะนำให้พิมพ์ในช่วงอุณหภูมิ 18 – 24°C (65 – 75°F) ที่ความชื้นสัมพัทธ์ระหว่าง 40 ถึง 60 เปอร์เซ็นต์ จัดเก็บกระดาษในกล่อง บนพาเลทหรือชั้นวางแทนการวางบนพื้น จัดเก็บบรรจุภัณฑ์แยกชิ้นบนพื้นผิวเรียบ ห้ามจัดวางของใดๆ ไว้บนบรรจุภัณฑ์กระดาษแต่ละชิ้น นำกระดาษออกจากกล่องหรือห่อเมื่อพร้อมที่จะใส่ลงในเครื่องพิมพ์แล้วเท่านั้น กล่องกระดาษและห่อจะช่วยให้กระดาษแห้งสะอาดและเรียบเสมอกัน การจัดเก็บกระดาษ"},{"UUID":"77d6633c-9ced-4c24-ae3b-bf93d9485cb3","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"การเลือกแบบฟอร์มที่พิมพ์ล่วงหน้าและกระดาษหัวจดหมาย ใช้กระดาษเกรนยาว ใช้เฉพาะแบบฟอร์มและกระดาษหัวจดหมายที่พิมพ์โดยใช้กระบวนการพิมพ์ภาพพิมพ์แบบออฟเซ็ตหรือการพิมพ์ปรุลาย หลีกเลี่ยงกระดาษที่มีผิวหยาบหรือขรุขระมาก ใช้หมึกที่ไม่ได้รับผลกระทบจากเรซินในผงหมึก","descFull":"การเลือกแบบฟอร์มที่พิมพ์ล่วงหน้าและกระดาษหัวจดหมาย ใช้กระดาษเกรนยาว ใช้เฉพาะแบบฟอร์มและกระดาษหัวจดหมายที่พิมพ์โดยใช้กระบวนการพิมพ์ภาพพิมพ์แบบออฟเซ็ตหรือการพิมพ์ปรุลาย หลีกเลี่ยงกระดาษที่มีผิวหยาบหรือขรุขระมาก ใช้หมึกที่ไม่ได้รับผลกระทบจากเรซินในผงหมึก หมึกที่มีส่วนผสมของออกซิเดชันหรือน้ำมันจะมีคุณสมบัติตรงตามข้อกำหนดเหล่านี้ แต่หมึกที่ทำจากยางอาจไม่มี พิมพ์ตัวอย่างบนแบบฟอร์มที่พิมพ์ล่วงหน้าและกระดาษหัวจดหมายที่คิดว่าจะใช้ก่อนซื้อในปริมาณมาก การดำเนินการนี้จะกำหนดว่าหมึกในแบบฟอร์มหรือหัวจดหมายจะส่งผลต่อคุณภาพการพิมพ์หรือไม่ หากมีข้อสงสัย โปรดติดต่อผู้จำหน่ายกระดาษของคุณ เมื่อพิมพ์บนกระดาษหัวจดหมาย ให้ใส่กระดาษในแนวการพิมพ์ที่ถูกต้องสำหรับเครื่องพิมพ์ของคุณ สำหรับข้อมูลเพิ่มเติม โปรดดูที่  คำแนะนำเกี่ยวกับกระดาษและวัสดุพิมพ์ชนิดพิเศษ เมื่อพิมพ์บนกระดาษหัวจดหมาย ให้ใส่กระดาษในแนวการพิมพ์ที่ถูกต้องสำหรับเครื่องพิมพ์ของคุณ กระดาษ แบบฟอร์มที่พิมพ์ล่วงหน้า แบบฟอร์มที่พิมพ์ล่วงหน้า การเลือก กระดาษ กระดาษหัวจดหมาย กระดาษหัวจดหมาย การเลือก"},{"UUID":"c5940b9a-7d9c-4a66-ad2a-dc7f084f63e1","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษ แนวการพิมพ์ ถาดมาตรฐาน","descFull":"ขนาดกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษ แนวการพิมพ์ ถาดมาตรฐาน 550 แผ่น ตัวป้อนกระดาษอเนกประสงค์ การพิมพ์สองด้าน ตัวป้อนเอกสารอัตโนมัติ 1  รองรับในเครื่องพิมพ์บางรุ่นเท่านั้น 2  รองรับเมื่อกำหนดค่าจากเมนูการตั้งค่าแบบยูนิเวอร์แซลเท่านั้น 3  รองรับขนาดกระดาษตั้งแต่ 95 x 139.7 มม. (3.74 x 5.5 นิ้ว) ถึง 297 x 355.6 มม. (11.69 x 14 นิ้ว) 4  ความยาวสูงสุดของขนาดกระดาษยูนิเวอร์แซลในกรณีที่กระดาษป้ายประกาศมีขนาด 1320.8 mm/52 นิ้ว ใส่กระดาษป้ายประกาศเพียงครั้งละหนึ่งแผ่นเท่านั้น 5  รองรับขนาดกระดาษตั้งแต่ 95 x 139.7 มม. (3.74 x 5.5 นิ้ว) ถึง 320 x 457.2 มม. (12.6 x 18 นิ้ว) 6  รองรับขนาดกระดาษตั้งแต่ 105 x 139.7 มม. (4.13 x 5.5 นิ้ว) ถึง 320 x 457.2 มม. (12.59 x 18 นิ้ว) 7  รองรับขนาดกระดาษตั้งแต่ 76.2 x 128 มม. (3 x 5.04 นิ้ว) ถึง 297 x 432 มม. (11.69 x 17.01 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น X ✓ X X ป้อนขอบยาว X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X 1/3 A4 ป้อนขอบสั้น ✓ ✓ X ✓ ป้อนขอบยาว X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น X ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ X ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น X ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12.0 x 18.0 นิ้ว) ป้อนขอบสั้น X ✓ ✓ X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X ✓ ✓ X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X ✓ 2 X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Universal ไม่ใช้ ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"f5011b79-944b-4534-acaf-8b46d6769813","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับตามถาดเสริม ขนาดกระดาษ แนวการพิมพ์ ถาดเสริม 550","descFull":"ขนาดกระดาษที่รองรับตามถาดเสริม ขนาดกระดาษ แนวการพิมพ์ ถาดเสริม 550 แผ่น ถาด 550 แผ่น 2 ถาด ถาดบรรจุคู่ 2000 แผ่น ถาด 1500 แผ่น 1  รองรับเมื่อกำหนดค่าจากเมนูการตั้งค่าแบบยูนิเวอร์แซลเท่านั้น 2  รองรับขนาดกระดาษตั้งแต่ 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ถึง 304.8 x 457.2 มม. (12 x 18 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว X X X X 1/3 A4 ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว ✓ ✓ X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว ✓ ✓ X ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว X X X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว ✓ ✓ X X Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ 1 ✓ 1 X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น ✓ 1 ✓ 1 X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น ✓ ✓ X X Universal ไม่ใช้ ✓ 2 ✓ 2 ✓ ✓ ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"9895a01b-f3ff-46ed-8cc6-5ac4b872875c","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับตามถาดกระดาษออก ขนาดกระดาษที่รองรับตามถาดกระดาษออก อุปกรณ์ส่งกระดาษและอุปกรณ์เย็บเล่มตอกรูหรืออุปกรณ์เย็บเล่มจะถูกติดตั้งกับเครื่องพิมพ์ อย่างใดอย่างหนึ่ง ขนาดกระดาษ","descFull":"ขนาดกระดาษที่รองรับตามถาดกระดาษออก ขนาดกระดาษที่รองรับตามถาดกระดาษออก อุปกรณ์ส่งกระดาษและอุปกรณ์เย็บเล่มตอกรูหรืออุปกรณ์เย็บเล่มจะถูกติดตั้งกับเครื่องพิมพ์ อย่างใดอย่างหนึ่ง ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษ +  อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษ +  อุปกรณ์เย็บเล่ม ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์ส่งกระดาษ) ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปก‑ รณ์เย็บเล่ม) ถาด 3 (ถาดอุปก‑ รณ์ส่งกระดาษ) 1  รองรับขนาดกระดาษตั้งแต่ 90 x 148 มม. (3.55 x 5.83 นิ้ว) ถึง 320 x 600 มม. (12.59 x 23.62 นิ้ว) 2  รองรับขนาดกระดาษตั้งแต่ 90 x 148 มม. (3.55 x 5.83 นิ้ว) ถึง 320 x 1260 มม. (12.59 x 49.6 นิ้ว) 3  รองรับขนาดกระดาษตั้งแต่ 182 x 257 มม. (7.17 x 10.12 นิ้ว) ถึง 304.8 x 457.2 มม. (12 x 18 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X ✓ A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X X 1/3 A4 ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X ✓ A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ✓ ✓ X ✓ Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Universal ไม่ใช้ ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ และอุปกรณ์เย็บเล่มตอกรูหรืออุปกรณ์เย็บเล่มจะถูกติดตั้งกับเครื่องพิมพ์ อย่างใดอย่างหนึ่ง อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ +  อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ +  อุปกรณ์เย็บเล่ม ขนาดกระดาษ แนวการพิมพ์ ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์ส่งกระดาษ) ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปก‑ รณ์เย็บเล่ม) ถาด 3 (ถาดอุปก‑ รณ์ส่งกระดาษ) 1  รองรับขนาดกระดาษตั้งแต่ 90 x 148 มม. (3.55 x 5.83 นิ้ว) ถึง 320 x 600 มม. (12.59 x 23.62 นิ้ว) 2  รองรับขนาดกระดาษตั้งแต่ 90 x 148 มม. (3.55 x 5.83 นิ้ว) ถึง 297 x 1260 มม. (11.69 x 49.6 นิ้ว) 3  รองรับขนาดกระดาษตั้งแต่ 182 x 257 มม. (7.17 x 10.12 นิ้ว) ถึง 304.8 x 457.2 มม. (12 x 18 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X X 1/3 A4 ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว X X X X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ X ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ✓ ✓ ✓ X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ✓ ✓ X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X ✓ X X X ✓ Universal ไม่ใช้ ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"dacc44a1-d43d-4fcb-bd58-497f7a2102e3","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับสำหรับงานเย็บเล่มและเจาะรู ขนาดกระดาษที่รองรับโดยอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ขนาดกระดาษ แนวการพิมพ์ ลวดเย็บ","descFull":"ขนาดกระดาษที่รองรับสำหรับงานเย็บเล่มและเจาะรู ขนาดกระดาษที่รองรับโดยอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ขนาดกระดาษ แนวการพิมพ์ ลวดเย็บ ครั้งเดียว คู่ คู่ทางซ้าย 4x6 การ์ด ป้อนขอบสั้น X X X ป้อนขอบยาว X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X ป้อนขอบยาว X X X 1/3 A4 ป้อนขอบสั้น X X X ป้อนขอบยาว X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X ป้อนขอบยาว X X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ป้อนขอบยาว ✓ ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X ป้อนขอบยาว X X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ X X ป้อนขอบยาว ✓ ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ป้อนขอบยาว ✓ ✓ X Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ X Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X ขนาดกระดาษที่รองรับโดยอุปกรณ์เย็บเล่มแบบตอกลวดเย็บ ขนาดกระดาษ แนวการพิมพ์ ลวดเย็บ อุปกรณ์ตอกรู ครั้งเดียว คู่ คู่ทางซ้าย สองรู สามรู สี่รู 4x6 การ์ด ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X 1/3 A4 ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X ✓ X X ป้อนขอบยาว X X X ✓ X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X ✓ X X ป้อนขอบยาว X X X ✓ X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X X X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X X X X ขนาดกระดาษที่รองรับโดยอุปกรณ์เย็บเล่ม ขนาดกระดาษ แนวการพิมพ์ ลวดเย็บ อุปกรณ์ตอกรู ครั้งเดียว คู่ คู่ทางซ้าย สองรู สามรู สี่รู 4x6 การ์ด ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X 1/3 A4 ป้อนขอบสั้น X X X X X X ป้อนขอบยาว X X X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X ✓ X X ป้อนขอบยาว X X X ✓ X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ X X X ป้อนขอบยาว ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ X ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X ✓ X X ป้อนขอบยาว X X X ✓ X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X ป้อนขอบยาว ✓ ✓ ✓ ✓ ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X X X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X X X X ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"25bf0c5a-494b-4c4c-b48a-2d56ba7027e2","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับสำหรับงานพับทบ ขนาดกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับเท่านั้น","descFull":"ขนาดกระดาษที่รองรับสำหรับงานพับทบ ขนาดกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับเท่านั้น C fold Z fold Z fold ครึ่งหน้า V fold ถาดมาตรฐาน ถาดมาตรฐาน ถาดมาตรฐาน ถาดมาตรฐาน 4x6 การ์ด ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X 1/3 A4 ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น X X ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น X X X X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X X ขนาดกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษและอุปกรณ์เย็บเล่ม ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษ + อุปกรณ์เย็บเล่ม V fold หลายพับ V fold ถาด 2 ถาดมาตรฐาน, ถาด 1, ถาด 2 4x6 การ์ด ป้อนขอบสั้น X X ป้อนขอบยาว X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X 1/3 A4 ป้อนขอบสั้น X X ป้อนขอบยาว X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว X X A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว X X JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว X X Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X ขนาดกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ และอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บและตัวตอกรู ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ C fold Z fold Z fold ครึ่งหน้า V fold ถาด 2 ถาด 2 ถาดมาตรฐาน, ถาด 2 ถาดมาตรฐาน, ถาด 2 4x6 การ์ด ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X 1/3 A4 ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น X X ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น X X X X ป้อนขอบยาว X X X X Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น X X X X Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X ✓ Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X X ขนาดกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับและอุปกรณ์เย็บเล่ม ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่ม C fold Z fold Z fold ครึ่งหน้า V fold หลายพับ V fold ถาด 3 ถาด 3 ถาดมาตรฐาน, ถาด 1, ถาด 3 ถาด 2 ถาดมาตรฐาน, ถาด 1, ถาด 2, ถาด 3 4x6 การ์ด ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X 1/3 A4 ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X X A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น X X X ✓ ✓ ป้อนขอบยาว X X X X X JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น X X ✓ ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น X X X X X ป้อนขอบยาว X X X X X Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ ป้อนขอบยาว X X X X X Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น X X X ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X X X ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X X X ✓ Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X X X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X X X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X X X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X X X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X X X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X X X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X X X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X X X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X X X X ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"0ee3e17d-c0dd-46a0-aa56-de4f6cdcf19b","title":"ขนาดกระดาษที่รองรับ","link":"paper-guidelines-topic.html","desc":"ขนาดกระดาษที่รองรับสำหรับงานเรียงกระดาษออฟเซ็ต ขนาดกระดาษที่รองรับโดยอุปกรณ์เรียงกระดาษออฟเซ็ตหรืออุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์เรียงกระดาษออฟเซ็ต","descFull":"ขนาดกระดาษที่รองรับสำหรับงานเรียงกระดาษออฟเซ็ต ขนาดกระดาษที่รองรับโดยอุปกรณ์เรียงกระดาษออฟเซ็ตหรืออุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์เรียงกระดาษออฟเซ็ต อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ 1  รองรับขนาดกระดาษตั้งแต่ 90 x 148 มม. (3.55 x 5.83 นิ้ว) ถึง 320 x 600 มม. (12.59 x 23.62 นิ้ว) 2  รองรับขนาดกระดาษตั้งแต่ 148 x 148 มม. (5.83 x 5.83 นิ้ว) ถึง 297 x 431.8 มม. (11.69 x 17 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น X X ป้อนขอบยาว X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X 1/3 A4 ป้อนขอบสั้น X X ป้อนขอบยาว X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ X ป้อนขอบยาว ✓ X Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น X X SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น ✓ X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น ✓ X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น ✓ X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น ✓ X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น ✓ X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น ✓ X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น ✓ X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น ✓ X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น ✓ X Universal ไม่ใช้ ✓ 1 ✓ 2 ขนาดกระดาษที่รองรับตามถาดกระดาษออก ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษ + อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษ + อุปกรณ์เย็บเล่ม ถาด 1 ถาด 1 1  รองรับขนาดกระดาษตั้งแต่ 139.7 x 148 มม. (5.5 x 5.83 นิ้ว) ถึง 304.8 x 600 มม. (12 x 23.62 นิ้ว) 2  รองรับขนาดกระดาษตั้งแต่ 125 x 148 มม. (4.93 x 5.83 นิ้ว) ถึง 304.8 x 457.2 มม. (12 x 18 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น X X ป้อนขอบยาว X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X 1/3 A4 ป้อนขอบสั้น X X ป้อนขอบยาว X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X Universal ไม่ใช้ ✓ 1 ✓ 2 ขนาดกระดาษที่รองรับโดยถาดกระดาษออก (มีอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ) ขนาดกระดาษ แนวการพิมพ์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่ม ถาด 1 ถาด 1 1  รองรับขนาดกระดาษตั้งแต่ 139.7 x 148 มม. (5.5 x 5.83 นิ้ว) ถึง 304.8 x 600 มม. (12 x 23.62 นิ้ว) 2  รองรับขนาดกระดาษตั้งแต่ 125 x 148 มม. (4.93 x 5.83 นิ้ว) ถึง 304.8 x 457.2 มม. (12 x 18 นิ้ว) 4x6 การ์ด ป้อนขอบสั้น X X ป้อนขอบยาว X X A6 105 x 148 มม. (4.13 x 5.83 นิ้ว) ป้อนขอบสั้น X X ป้อนขอบยาว X X 1/3 A4 ป้อนขอบสั้น X X ป้อนขอบยาว X X A5 148 x 210 มม. (5.83 x 8.27 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A4 210 x 297 มม. (8.27 x 11.7 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ A3 297 x 420 มม. (11.69 x 16.54 นิ้ว) ป้อนขอบสั้น ✓ ✓ JIS B5 182 x 257 มม. (7.17 x 10.1 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ JIS B4 257 x 364 มม. (10.12 x 14.33 นิ้ว) ป้อนขอบสั้น ✓ ✓ Statement 139.7 x 215.9 มม. (5.5 x 8.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Executive 184.2 x 266.7 มม. (7.25 x 10.5 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Letter 215.9 x 279.4 มม. (8.5 x 11 นิ้ว) ป้อนขอบสั้น ✓ ✓ ป้อนขอบยาว ✓ ✓ Folio 215.9 x 330.2 มม. (8.5 x 13 นิ้ว) ป้อนขอบสั้น ✓ ✓ Oficio (เม็กซิโก) (216 × 340 มม.) 215.9 x 340.4 มม. (8.5 x 13.4 นิ้ว) ป้อนขอบสั้น ✓ ✓ Legal 215.9 x 355.6 มม. (8.5 x 14 นิ้ว) ป้อนขอบสั้น ✓ ✓ Ledger 279.4 x 431.8 มม. (11 x 17 นิ้ว) ป้อนขอบสั้น ✓ ✓ 12x18 304.8 x 457.2 มม. (12 x 18 นิ้ว) ป้อนขอบสั้น ✓ ✓ SRA3 320.04 x 449.58 มม. (12.6 x 17.7 นิ้ว) ป้อนขอบสั้น X X Envelope (Choukei #3) 120 x 235 มม. (4.75 x 9.25 นิ้ว) ป้อนขอบสั้น X X Hagaki 100 x 148 มม. (3.94 x 5.83 นิ้ว) ป้อนขอบสั้น X X ซองขนาด B5 (176 x 250 มม.) 176 x 250 มม. (6.93 x 9.84 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #9) 98.4 x 225.4 มม. (3.875 x 8.9 นิ้ว) ป้อนขอบสั้น X X Envelope (Commercial #10) 104.8 x 241.3 มม. (4.12 x 9.5 นิ้ว) ป้อนขอบสั้น X X ซองขนาด 7 3/4 (โมนาช) (98 x 190 มม.) 98.4 x 190.5 มม. (3.875 x 7.5 นิ้ว) ป้อนขอบสั้น X X Envelope (DL) 110 x 220 มม. (4.33 x 8.66 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C4) 229 x 324 มม. (9 x 12.8 นิ้ว) ป้อนขอบสั้น X X Envelope (ISO C5) 162 x 229 มม. (6.38 x 9 นิ้ว) ป้อนขอบสั้น X X Universal ไม่ใช้ ✓ 1 ✓ 2 ขนาดกระดาษที่รองรับ ขนาดกระดาษ ที่รองรับ"},{"UUID":"e01de512-4cb1-4c91-8ecf-0cc1ca6828e6","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"น้ำหนักกระดาษที่รองรับ น้ำหนักกระดาษที่รองรับ น้ำหนักกระดาษที่รองรับโดยเครื่องพิมพ์ ถาดมาตรฐานหรือถาดเสริม 550","descFull":"น้ำหนักกระดาษที่รองรับ น้ำหนักกระดาษที่รองรับ น้ำหนักกระดาษที่รองรับโดยเครื่องพิมพ์ ถาดมาตรฐานหรือถาดเสริม 550 แผ่น, ถาด 550 แผ่น 2 ถาด, ถาด 1500 แผ่น และถาดบรรจุคู่ 2000 แผ่น ตัวป้อนกระดาษอเนกประสงค์ การพิมพ์สองด้าน ตัวป้อนเอกสารอัตโนมัติ 60–300 แกรม 2 (16–80 ปอนด์) 60–300 แกรม 2 (16–80 ปอนด์) 60–220 แกรม 2 (16–59 ปอนด์) 50–150 แกรม 2 (14–40 ปอนด์) น้ำหนักกระดาษที่รองรับ น้ำหนักกระดาษ ที่รองรับ"},{"UUID":"d1f1a61f-a5ec-4c9d-8ce0-b3c2a5ccbc98","title":"การเลือกกระดาษ","link":"paper-guidelines-topic.html","desc":"ประเภทกระดาษที่รองรับ ประเภทกระดาษที่รองรับ ประเภทกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษ ถาดมาตรฐาน","descFull":"ประเภทกระดาษที่รองรับ ประเภทกระดาษที่รองรับ ประเภทกระดาษที่รองรับตามการกำหนดค่าพื้นฐาน ขนาดกระดาษ ถาดมาตรฐาน 550 แผ่น ตัวป้อนกระดาษอเนกประสงค์ การพิมพ์สองด้าน ตัวป้อนเอกสารอัตโนมัติ กระดาษธรรมดา ✓ ✓ ✓ ✓ กระดาษแข็ง ✓ ✓ ✓ X กระดาษรีไซเคิล ✓ ✓ ✓ ✓ กระดาษมัน ✓ ✓ ✓ X กระดาษมันน้ำหนักมาก ✓ ✓ ✓ X ฉลาก ✓ ✓ X X ฉลากไวนิล ✓ ✓ X X กระดาษปอนด์ ✓ ✓ ✓ ✓ ซองจดหมาย ✓ ✓ X X ซองจดหมายแบบหยาบ ✓ ✓ X X กระดาษหัวจดหมาย ✓ ✓ ✓ ✓ กระดาษแบบฟอร์ม ✓ ✓ ✓ ✓ กระดาษสี ✓ ✓ ✓ ✓ กระดาษบาง ✓ ✓ ✓ ✓ กระดาษหนา ✓ ✓ ✓ ✓ กระดาษหยาบผสมใยฝ้าย ✓ ✓ ✓ X ประเภทที่กำหนดเอง ✓ ✓ ✓ ✓ ประเภทกระดาษที่รองรับตามถาดเสริม ขนาดกระดาษ ถาดเสริม 550 แผ่น ถาด 550 แผ่น 2 ถาด ถาดบรรจุคู่ 2000 แผ่น ถาด 1500 แผ่น กระดาษธรรมดา ✓ ✓ ✓ ✓ กระดาษแข็ง ✓ ✓ ✓ ✓ แผ่นใส X X X X กระดาษรีไซเคิล ✓ ✓ ✓ ✓ กระดาษมัน ✓ ✓ ✓ ✓ กระดาษมันน้ำหนักมาก ✓ ✓ ✓ ✓ ฉลาก ✓ ✓ X X ฉลากไวนิล ✓ ✓ X X กระดาษปอนด์ ✓ ✓ ✓ ✓ ซองจดหมาย ✓ ✓ X X ซองจดหมายแบบหยาบ ✓ ✓ X X กระดาษหัวจดหมาย ✓ ✓ ✓ ✓ กระดาษแบบฟอร์ม ✓ ✓ ✓ ✓ กระดาษสี ✓ ✓ ✓ ✓ กระดาษบาง ✓ ✓ ✓ ✓ กระดาษหนา ✓ ✓ ✓ ✓ กระดาษหยาบผสมใยฝ้าย ✓ ✓ ✓ ✓ ประเภทที่กำหนดเอง ✓ ✓ ✓ ✓ ประเภทกระดาษที่รองรับตามถาดกระดาษออก ขนาดกระดาษ อุปกรณ์ส่งกระดาษ + อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษ + อุปกรณ์เย็บเล่ม ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ, อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์ส่งกระดาษ) ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ, อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์เย็บเล่ม) ถาด 3 (ถาดอุปกรณ์ส่งกระดาษ) *  ความยาวสูงสุดของขนาดกระดาษยูนิเวอร์แซลในกรณีที่กระดาษป้ายประกาศมีขนาด 1320.8 mm/52 นิ้ว ใส่กระดาษป้ายประกาศเพียงครั้งละหนึ่งแผ่นเท่านั้น กระดาษธรรมดา ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษแข็ง ✓ ✓ ✓ ✓ ✓ X ✓ กระดาษรีไซเคิล ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษมัน ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษมันน้ำหนักมาก ✓ ✓ ✓ ✓ ✓ X ✓ ฉลาก ✓ ✓ ✓ ✓ ✓ X X ฉลากไวนิล ✓ ✓ ✓ ✓ ✓ X X กระดาษปอนด์ ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ซองจดหมาย X X ✓ X X X ✓ ซองจดหมายแบบหยาบ X X ✓ X X X ✓ กระดาษหัวจดหมาย ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษแบบฟอร์ม ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษสี ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษบาง ✓ ✓ ✓ ✓ ✓ ✓ * ✓ กระดาษหนา ✓ ✓ ✓ ✓ ✓ X X กระดาษหยาบผสมใยฝ้าย ✓ ✓ ✓ ✓ ✓ X X ประเภทที่กำหนดเอง ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ประเภทกระดาษที่รองรับตามถาดกระดาษออก (มีอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ) ขนาดกระดาษ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่มแบบตอกลวดเย็บ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ + อุปกรณ์เย็บเล่ม ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์ส่งกระดาษ) ถาดมาตรฐาน (ถาดด้านบนอุปกรณ์เย็บเล่ม) ถาด 1 (ลวดเย็บ/ อุปกรณ์เย็บเล่มตอกรู, ถาดออฟเซ็ต) ถาด 2 (ถาดอุปกรณ์เย็บเล่ม) ถาด 3 (ถาดอุปกรณ์ส่งกระดาษ) *  ความยาวสูงสุดของขนาดกระดาษยูนิเวอร์แซลในกรณีที่กระดาษป้ายประกาศมีขนาด 1320.8 mm/52 นิ้ว ใส่กระดาษป้ายประกาศเพียงครั้งละหนึ่งแผ่นเท่านั้น กระดาษธรรมดา ✓ ✓ ✓ ✓ ✓ ✓ ✓ กระดาษแข็ง ✓ ✓ ✓ ✓ ✓ X ✓ กระดาษรีไซเคิล ✓ ✓ ✓ ✓ ✓ ✓ ✓ กระดาษมัน ✓ ✓ ✓ ✓ ✓ ✓ ✓ กระดาษมันน้ำหนักมาก ✓ ✓ ✓ ✓ ✓ X ✓ ฉลาก ✓ ✓ ✓ ✓ ✓ X ✓ ฉลากไวนิล ✓ ✓ ✓ ✓ ✓ X ✓ กระดาษปอนด์ ✓ ✓ ✓ ✓ ✓ ✓ ✓ ซองจดหมาย X X ✓ X X X ✓ ซองจดหมายแบบหยาบ X X ✓ X X X ✓ กระดาษหัวจดหมาย ✓ ✓ ✓ ✓ ✓ X ✓ กระดาษแบบฟอร์ม ✓ ✓ ✓ ✓ ✓ X ✓ กระดาษสี ✓ ✓ ✓ ✓ ✓ ✓ ✓ กระดาษบาง ✓ ✓ ✓ ✓ ✓ ✓ ✓ กระดาษหนา ✓ ✓ ✓ ✓ ✓ X X กระดาษหยาบผสมใยฝ้าย ✓ ✓ ✓ ✓ ✓ X X ประเภทที่กำหนดเอง ✓ ✓ ✓ ✓ ✓ ✓ * ✓ ประเภทกระดาษที่รองรับโดยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ อุปกรณ์เรียงกระดาษออฟเซ็ต, อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ขนาดกระดาษ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับเท่านั้น อุปกรณ์เรียงกระดาษออฟเซ็ต อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ กระดาษธรรมดา ✓ ✓ ✓ กระดาษแข็ง ✓ ✓ ✓ กระดาษรีไซเคิล ✓ ✓ ✓ กระดาษมัน ✓ ✓ ✓ กระดาษมันน้ำหนักมาก ✓ ✓ ✓ ฉลาก ✓ ✓ ✓ ฉลากไวนิล ✓ ✓ ✓ กระดาษปอนด์ ✓ ✓ ✓ ซองจดหมาย ✓ ✓ ✓ ซองจดหมายแบบหยาบ ✓ ✓ ✓ กระดาษหัวจดหมาย ✓ ✓ ✓ กระดาษแบบฟอร์ม ✓ ✓ ✓ กระดาษสี ✓ ✓ ✓ กระดาษบาง ✓ ✓ ✓ กระดาษหนา ✓ ✓ ✓ กระดาษหยาบผสมใยฝ้าย ✓ ✓ ✓ ประเภทที่กำหนดเอง ✓ ✓ ✓ ประเภทกระดาษที่รองรับโดยลวดเย็บ อุปกรณ์เย็บเล่มตอกรู และอุปกรณ์เย็บเล่ม ขนาดกระดาษ ถาดด้านบนอุปกรณ์เย็บเล่ม (ถาดมาตรฐาน) ถาดอุปกรณ์เย็บเล่ม (ถาด 1) ออฟเซ็ต อุปกรณ์ตอกรู ลวดเย็บ พับทบ ออฟเซ็ต อุปกรณ์ตอกรู ลวดเย็บ พับทบ กระดาษธรรมดา X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษแข็ง X X X X ✓ X X X กระดาษรีไซเคิล X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษมัน X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษมันน้ำหนักมาก X X X X ✓ X X X ฉลาก X X X X ✓ X X X ฉลากไวนิล X X X X ✓ X X X กระดาษปอนด์ X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษหัวจดหมาย X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษแบบฟอร์ม X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษสี X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษบาง X ✓ X ✓ ✓ ✓ ✓ ✓ กระดาษหนา X X X X ✓ X X X กระดาษหยาบผสมใยฝ้าย X ✓ X X ✓ ✓ X X ประเภทที่กำหนดเอง X ✓ X ✓ ✓ ✓ ✓ ✓ ประเภทกระดาษที่รองรับ ชนิดกระดาษ ที่รองรับ"},{"UUID":"c6cc3b38-0d15-4b6b-abd0-ab684292fa64","title":"คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์","link":"supported-applications-topic.html","desc":"แอปพลิเคชันที่รองรับ แอปพลิเคชันและรุ่นเครื่องพิมพ์ที่รองรับ แอปพลิเคชัน รุ่นเครื่องพิมพ์ ศูนย์การสแกน","descFull":"แอปพลิเคชันที่รองรับ แอปพลิเคชันและรุ่นเครื่องพิมพ์ที่รองรับ แอปพลิเคชัน รุ่นเครื่องพิมพ์ ศูนย์การสแกน CX833 CX961 CX962 CX963 XC8355 XC9635 XC9645 XC9655 Display Customization CX833 CX961 CX962 CX963 XC8355 XC9635 XC9645 XC9655 ฝ่ายให้คำปรึกษาลูกค้า XC8355, XC9635, XC9645, XC9655 Device Quotas XC8355, XC9635, XC9645, XC9655 แอปพลิเคชันเครื่องพิมพ์ แอปพลิเคชันที่ติดตั้งล่วงหน้า"},{"UUID":"a3dfdde7-006f-498d-82c4-825567260c5e","title":"คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์","link":"supported-applications-topic.html","desc":"แฟลชไดรฟ์และประเภทไฟล์ที่รองรับ แฟลชไดรฟ์ แฟลชไดรฟ์ที่รองรับ USB 2.0","descFull":"แฟลชไดรฟ์และประเภทไฟล์ที่รองรับ แฟลชไดรฟ์ แฟลชไดรฟ์ที่รองรับ USB 2.0 หรือเก่ากว่า แฟลชไดรฟ์ที่รองรับ New Technology File System (NFTS) หรือระบบไฟล์ File Allocation Table (FAT32) ประเภทไฟล์ ประเภทไฟล์ที่รองรับ เอกสาร ภาพ PDF (เวอร์ชัน 1.7 หรือก่อนหน้า) รูปแบบไฟล์ Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG หรือ JPG TIFF หรือ TIF GIF BMP PNG PCX DCX แฟลชไดรฟ์ที่รองรับ ประเภทไฟล์ที่รองรับ"},{"UUID":"6e8f4fb1-401b-499d-93aa-fc41162ef0fe","title":"คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์","link":"supported-applications-topic.html","desc":"ตัวเลือกภายในที่ใช้ได้ ฮาร์ดดิสก์ คุณสมบัติที่มีใบอนุญาต IPDS บาร์โค้ด","descFull":"ตัวเลือกภายในที่ใช้ได้ ฮาร์ดดิสก์ คุณสมบัติที่มีใบอนุญาต IPDS บาร์โค้ด พอร์ตโซลูชันภายใน (ISP) ของ  Lexmark การ์ด RS‑232C แบบอนุกรม MarkNet  N8230 Fiber Ethernet 100BASE-FX(LC), 1000BASE-SX(LC) พอร์ตโซลูชันภายใน (ISP) ตัวเลือกภายใน การ์ดเฟิร์มแวร์ ฮาร์ดดิสก์"},{"UUID":"8a50bed3-5816-4a44-828f-05ce964b76d7","title":"ตั้งค่า ติดตั้ง และกำหนดค่า","link":"selecting-location-printer-topic.html","desc":"การเลือกตำแหน่งสำหรับเครื่องพิมพ์ วางให้มีพื้นที่เพียงพอสำหรับการเปิดถาด ฝาครอบ และฝาปิด และเพื่อติดตั้งตัวเลือกฮาร์ดแวร์","descFull":"การเลือกตำแหน่งสำหรับเครื่องพิมพ์ วางให้มีพื้นที่เพียงพอสำหรับการเปิดถาด ฝาครอบ และฝาปิด และเพื่อติดตั้งตัวเลือกฮาร์ดแวร์ ติดตั้งเครื่องพิมพ์ใกล้กับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต ห้ามวางหรือใช้ผลิตภัณฑ์นี้ใกล้บริเวณที่มีน้ำหรือเปียกน้ำ ตรวจสอบให้แน่ใจว่าการหมุนเวียนของอากาศภายในห้องเป็นไปตามมาตรฐาน ASHRAE 62 หรือมาตรฐาน CEN Technical Committee 156 เตรียมพื้นผิวที่เรียบ แข็งแรงและมั่นคง เก็บเครื่องพิมพ์ให้: สะอาด แห้ง และปราศจากฝุ่น ห่างจากลวดเย็บกระดาษและคลิปหนีบกระดาษ ห่างจากการไหลเวียนของอากาศโดยตรงจากเครื่องปรับอากาศ เครื่องทำความร้อน หรืออุปกรณ์ระบายอากาศ ปราศจากแสงแดดและความชื้นโดยตรง ศึกษาอุณหภูมิที่แนะนำและหลีกเลี่ยงความผันผวน อุณหภูมิที่แนะนำ อุณหภูมิแวดล้อม อุณหภูมิการเก็บรักษา จัดให้มีพื้นที่ว่างตามที่แนะนำต่อไปนี้รอบๆ เครื่องพิมพ์เพื่อการระบายอากาศที่ดี: พื้นที่ว่างที่แนะนำรอบๆ เครื่องพิมพ์ 1 ด้านบน 2 ด้านหลัง 3 ด้านขวา 4 ด้านหน้า 5 ด้านซ้าย เครื่องพิมพ์ การเลือกตำแหน่งสำหรับ การเลือกตำแหน่ง สำหรับเครื่องพิมพ์ เครื่องพิมพ์ ระยะห่างต่ำสุด การเคลื่อนย้ายเครื่องพิมพ์"},{"UUID":"42da7b89-4664-4a88-926f-1f36be8b1269","title":"ตั้งค่า ติดตั้ง และกำหนดค่า","link":"printer-ports-topic.html","desc":"พอร์ตเครื่องพิมพ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล เช่น สายไฟ","descFull":"พอร์ตเครื่องพิมพ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล เช่น สายไฟ สายแฟกซ์หรือสายโทรศัพท์ ขณะเกิดฟ้าแลบฟ้าร้อง เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้ใช้แต่สายไฟที่ให้มาพร้อมกับผลิตภัณฑ์นี้หรือสายไฟที่ใช้แทนกันได้ซึ่งได้รับการรับรองจากผู้ผลิตเท่านั้น เพื่อลดความเสี่ยงที่จะเกิดอัคคีภัย ให้ใช้เฉพาะสาย 26 AWG หรือสายเชื่อมต่อสัญญาณที่ใหญ่กว่า (RJ-11) เมื่อเชื่อมต่อผลิตภัณฑ์นี้เข้ากับเครือข่ายโทรศัพท์สาธารณะ สำหรับผู้ใช้ในออสเตรเลีย สายเคเบิ้ลต้องได้รับการอนุมัติจาก Australian Communications and Media Authority เพื่อป้องกันการสูญเสียข้อมูลหรือเครื่องพิมพ์ทำงานผิดพลาด อย่าสัมผัสสายเคเบิล USB, อะแดปเตอร์เครือข่ายไร้สายแบบไร้สายใดๆ หรือเครื่องพิมพ์ในบริเวณที่แสดงไว้ในภาพขณะที่กำลังพิมพ์งาน พอร์ตและเบ้าปลั๊กเครื่องพิมพ์และฟังก์ชัน พอร์ตเครื่องพิมพ์ ฟังก์ชัน 1 ถาดรับงานพิมพ์หรือพอร์ตตัวเลือก เชื่อมต่อเครื่องพิมพ์เข้ากับถาดรับงานพิมพ์หรือตัวเลือก 2 พอร์ต USB ต่อแป้นพิมพ์หรือตัวเลือกที่ใช้งานร่วมกันได้ 3 พอร์ต LINE สามารถใช้งานได้เมื่อติดตั้งการ์ดแฟกซ์เท่านั้น เชื่อมต่อเครื่องพิมพ์เข้ากับสายโทรศัพท์ที่ใช้งานได้ผ่านแจ็คที่ผนังแบบมาตรฐาน (RJ-11), ตัวกรอง DSL หรืออะแดปเตอร์ VoIP หรืออะแดปเตอร์อื่นๆ ที่ให้คุณใช้สายโทรศัพท์เพื่อส่งและรับแฟกซ์ 4 พอร์ต EXT สามารถใช้งานได้เมื่อติดตั้งการ์ดแฟกซ์เท่านั้น เชื่อมต่ออุปกรณ์เพิ่มเติม (โทรศัพท์หรือเครื่องตอบรับอัตโนมัติ) เข้ากับเครื่องพิมพ์และสายโทรศัพท์ ใช้พอร์ตนี้หากคุณไม่มีสายแฟกซ์เฉพาะสำหรับเครื่องพิมพ์ และหากประเทศหรือภูมิภาคของคุณรองรับวิธีการเชื่อมต่อนี้ 5 พอร์ตเครื่องพิมพ์ USB เชื่อมต่อเครื่องพิมพ์เข้ากับคอมพิวเตอร์ 6 พอร์ตอีเทอร์เน็ต เชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย 7 เบ้าปลั๊กสำหรับสายไฟ เชื่อมต่อเครื่องพิมพ์เข้ากับเต้าเสียบที่ต่อลงดินอย่างเหมาะสม พอร์ตเครื่องพิมพ์ พอร์ต USB พอร์ตอีเทอร์เน็ต เบ้าปลั๊กสำหรับสายไฟ"},{"UUID":"aa883268-fe06-42ea-ba35-e591f53c9bc9","title":"การกำหนดค่าแอปและโซลูชัน","link":"setting-up-scan-center-topic.html","desc":"การตั้งค่าศูนย์การสแกน จากแผงควบคุม เลือก  ศูนย์การสแกน","descFull":"การตั้งค่าศูนย์การสแกน จากแผงควบคุม เลือก  ศูนย์การสแกน เลือกและสร้างปลายทาง จากนั้นกำหนดการตั้งค่า จะบันทึกเฉพาะปลายทางที่สร้างจาก Embedded Web Server เท่านั้น หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับโซลูชัน สแกนเอกสาร ศูนย์การสแกน การตั้งค่า"},{"UUID":"957ec18f-e849-49e8-b62f-ce051ee1d9c8","title":"การกำหนดค่าแอปและโซลูชัน","link":"setting-up-scan-center-topic.html","desc":"การใช้ Display Customization การใช้ Display","descFull":"การใช้ Display Customization การใช้ Display Customization ตรวจสอบว่าเปิดใช้งานการตั้งค่าภาพพักหน้าจอ การแสดงสไลด์ และภาพพื้นหลังจาก Embedded Web Server ไปที่  แอป Display Customization กำหนดค่า การจัดการภาพพักหน้าจอและการแสดงสไลด์ ในส่วนภาพพักหน้าจอและการแสดงสไลด์ ให้เพิ่ม แก้ไข หรือลบภาพ คุณสามารถเพิ่มภาพได้สูงสุด 10 ภาพ เมื่อเปิดใช้งาน จะแสดงไอคอนสถานะบนภาพพักหน้าจอเมื่อมีข้อผิดพลาด คำเตือน หรือการแจ้งเตือนบนคลาวด์เท่านั้น ใช้การเปลี่ยนแปลง การเปลี่ยนภาพพื้นหลัง จากแผงควบคุม เลือก  เปลี่ยนภาพพื้นหลัง เลือกภาพที่จะใช้ ใช้การเปลี่ยนแปลง การแสดงสไลด์จากแฟลชไดรฟ์ เสียบแฟลชไดร์ฟเข้าในพอร์ต USB จากแผงควบคุม เลือก  การแสดงสไลด์ คุณสามารถนำแฟลชไดรฟ์ออกได้หลังจากเริ่มการแสดงสไลด์ แต่ภาพจะไม่ได้จัดเก็บภาพไว้ในเครื่องพิมพ์ หากการแสดงสไลด์หยุด ให้เสียบแฟลชไดรฟ์อีกครั้งเพื่อดูภาพ Display Customization การใช้ การปรับแต่งส่วนแสดงผล การเปลี่ยนภาพพื้นหลัง การใช้การแสดงสไลด์ การจัดการภาพพักหน้าจอ"},{"UUID":"eb92eeb5-3d5e-4133-8ff0-d859b31aaa82","title":"การกำหนดค่าแอปและโซลูชัน","link":"setting-up-scan-center-topic.html","desc":"การกำหนดค่าบุ๊คมาร์ค การสร้างบุ๊คมาร์ค เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส","descFull":"การกำหนดค่าบุ๊คมาร์ค การสร้างบุ๊คมาร์ค เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิกที่  บุ๊คมาร์ค เพิ่มบุ๊คมาร์ค แล้วพิมพ์ชื่อบุ๊คมาร์ค เลือกชนิดโปรโตคอล แอดเดรส  แล้วเลือกทำอย่างใดอย่างหนึ่งต่อไปนี้ สำหรับ HTTP และ HTTPS ให้พิมพ์ URL ที่คุณต้องการบุ๊คมาร์ค สำหรับ HTTPS ตรวจสอบให้แน่ใจว่าใช้ชื่อคอมพิวเตอร์แม่ข่ายแทน IP แอดเดรส ตัวอย่างเช่น พิมพ์  myWebsite.com/sample.pdf  แทนการพิมพ์  123.﻿123.123.123/sample.pdf  ตรวจสอบให้แน่ใจว่าชื่อคอมพิวเตอร์แม่ข่ายตรงกับค่าของชื่อทั่วไป (CN) ในใบรับรองเซิร์ฟเวอร์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการรับค่า CN ในใบรับรองเซิร์ฟเวอร์ โปรดดูข้อมูลวิธีใช้สำหรับเว็บเบราเซอร์ของคุณ สำหรับ FTP ให้พิมพ์ FTP แอดเดรส ตัวอย่างเช่น  myServer/myDirectory  ป้อนหมายเลขพอร์ต FTP พอร์ต 21 เป็นพอร์ตเริ่มต้นสำหรับการส่งคำสั่ง สำหรับ SMB ให้พิมพ์ที่อยู่โฟลเดอร์เครือข่าย ตัวอย่างเช่น  myServer/myShare/myFile.pdf  พิมพ์ชื่อโดเมนเครือข่าย หากจำเป็น ให้เลือกประเภท การตรวจสอบความถูกต้อง สำหรับ FTP และ SMB ในการจำกัดการเข้าถึงบุ๊คมาร์ค ให้ป้อนรหัส PIN แอปพลิเคชันรองรับประเภทไฟล์ต่อไปนี้: PDF, JPEG และ TIFF สามารถใช้ไฟล์ประเภทอื่นๆ เช่น DOCX และ XLSX ได้ในเครื่องพิมพ์บางรุ่น คลิก  บันทึก การสร้างโฟลเดอร์ เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิกที่  บุ๊คมาร์ค เพิ่มโฟลเดอร์ แล้วพิมพ์ชื่อโฟลเดอร์ ในการจำกัดการเข้าถึงโฟลเดอร์ ให้ป้อนรหัส PIN คลิก  บันทึก บุ๊คมาร์ค การสร้าง การสร้างบุ๊คมาร์ค"},{"UUID":"f842d15a-72b1-470a-a1f3-c15b4943c248","title":"การกำหนดค่าแอปและโซลูชัน","link":"setting-up-scan-center-topic.html","desc":"การกำหนดค่าสมุดที่อยู่ การเพิ่มผู้ติดต่อ เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส","descFull":"การกำหนดค่าสมุดที่อยู่ การเพิ่มผู้ติดต่อ เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  สมุดที่อยู่  จากนั้นคลิก  เพิ่มผู้ติดต่อ หากจำเป็น ให้ระบุวิธีลงชื่อเข้าใช้เพื่ออนุญาตการเข้าถึงแอปพลิเคชัน คลิก  บันทึก การเพิ่มกลุ่ม เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  สมุดที่อยู่  จากนั้นคลิก  เพิ่มผู้ติดต่อ คุณสามารถกำหนดผู้ติดต่อหนึ่งรายหรือมากกว่านั้นไปยังกลุ่มได้ คลิก  บันทึก การเพิ่มผู้ติดต่อ การเพิ่มกลุ่ม สมุดที่อยู่"},{"UUID":"6158f5d8-f450-4132-b751-b68cdf2a9eb3","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การเปิดใช้งานการแนะนำด้วยเสียง จากหน้าจอหลัก ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง","descFull":"การเปิดใช้งานการแนะนำด้วยเสียง จากหน้าจอหลัก ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง ใช้นิ้วมือสองนิ้วแตะ  ตกลง หากท่าทางดังกล่าวใช้ไม่ได้ผล ให้กดให้แรงขึ้น จากแป้นพิมพ์ ให้กดปุ่ม  5  ค้างไว้จนกระทั่งคุณได้ยินข้อความเสียง กด  แท็บ  เพื่อเลื่อนเคอร์เซอร์ที่โฟกัสไปยังปุ่มตกลง จากนั้นกด  Enter เมื่อเปิดใช้งานการแนะนำด้วยเสียง ให้ใช้นิ้วมือสองนิ้วเลือกรายการที่ต้องการบนส่วนแสดงผล การแนะนำด้วยเสียงมีการรองรับภาษาที่จำกัด การแนะนำด้วยเสียง การเปิดใช้งาน การเปิดใช้งานการแนะนำด้วยเสียง"},{"UUID":"de7ef799-ec2e-4594-8703-3943de21ee19","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การปิดใช้งานการแนะนำด้วยเสียง ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง ใช้นิ้วมือสองนิ้วดำเนินการดังนี้:","descFull":"การปิดใช้งานการแนะนำด้วยเสียง ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง ใช้นิ้วมือสองนิ้วดำเนินการดังนี้: เลือก  การแนะนำด้วยเสียง  แล้วเลือก  ตกลง เลือก  ยกเลิก หากท่าทางดังกล่าวใช้ไม่ได้ผล ให้กดให้แรงขึ้น การกดปุ่มเปิด/ปิดหรือนำเครื่องพิมพ์เข้าสู่โหมดพักเครื่องหรือโหมดไฮเบอร์เนตยังจะเป็นการปิดใช้งานการแนะนำด้วยเสียงอีกด้วย การแนะนำด้วยเสียง การปิดใช้งาน การปิดใช้งานการแนะนำด้วยเสียง"},{"UUID":"bea4fb7e-7dbd-4204-a50f-97605a8845b2","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การเลื่อนดูบนหน้าจอโดยใช้ท่าทาง จะใช้ท่าทางส่วนใหญ่ได้เฉพาะเมื่อเปิดใช้งานการแนะนำด้วยเสียง ใช้แป้นพิมพ์จริงเพื่อพิมพ์ตัวอักษรและปรับการตั้งค่าบางอย่าง ท่าทางและการทำงาน ท่าทาง","descFull":"การเลื่อนดูบนหน้าจอโดยใช้ท่าทาง จะใช้ท่าทางส่วนใหญ่ได้เฉพาะเมื่อเปิดใช้งานการแนะนำด้วยเสียง ใช้แป้นพิมพ์จริงเพื่อพิมพ์ตัวอักษรและปรับการตั้งค่าบางอย่าง ท่าทางและการทำงาน ท่าทาง ฟังก์ชัน ใช้นิ้วมือหนึ่งนิ้วปัดไปทางซ้าย จากนั้นปัดขึ้น เปิดใช้หรือออกจากโหมดการเข้าถึง ท่าทางนี้ยังใช้ได้เมื่อเครื่องพิมพ์อยู่ในโหมดปกติเช่นกัน แตะสองครั้งโดยใช้นิ้วมือหนึ่งนิ้ว เลือกตัวเลือกหรือรายการบนหน้าจอ แตะสองครั้งที่ไอคอนหน้าจอหลักโดยใช้นิ้วมือสองนิ้ว ปิดใช้งานโหมดการเข้าถึง แตะสามครั้งโดยใช้นิ้วมือหนึ่งนิ้ว ซูมเข้าหรือซูมออกข้อความและภาพ เปิดใช้งานโหมดการขยายเพื่อใช้คุณสมบัติการซูม ปัดไปทางขวาหรือปัดลงโดยใช้นิ้วมือหนึ่งนิ้ว เลื่อนไปยังรายการถัดไปบนหน้าจอ ใช้นิ้วมือหนึ่งนิ้วปัดไปทางซ้าย หรือปัดขึ้น เลื่อนไปยังรายการก่อนหน้าบนหน้าจอ ใช้นิ้วมือหนึ่งนิ้วปัดขึ้นแล้วปัดลง เลื่อนไปยังรายการแรกบนหน้าจอ Pan (การถ่ายภาพมุมกว้าง) เข้าถึงส่วนต่างๆ ของภาพที่ซูมซึ่งอยู่เกินขีดจำกัดของหน้าจอ ใช้นิ้วมือสองนิ้วเพื่อลากภาพที่ซูม เปิดใช้งานโหมดการขยายเพื่อใช้ท่าทางการเลื่อน ใช้นิ้วมือหนึ่งนิ้วปัดขึ้นแล้วปัดไปทางขวา เพิ่มระดับเสียง ท่าทางนี้ยังใช้ได้เมื่อเครื่องพิมพ์อยู่ในโหมดปกติเช่นกัน ใช้นิ้วมือหนึ่งนิ้วปัดลงแล้วปัดไปทางขวา ลดระดับเสียง ท่าทางนี้ยังใช้ได้เมื่อเครื่องพิมพ์อยู่ในโหมดปกติเช่นกัน ใช้นิ้วมือหนึ่งนิ้วปัดขึ้นแล้วปัดไปทางซ้าย ออกจากแอปพลิเคชันและย้อนกลับไปยังหน้าจอหลัก ใช้นิ้วมือหนึ่งนิ้วปัดลงแล้วปัดไปทางซ้าย กลับไปยังการตั้งค่าก่อนหน้า การเลื่อนดูบนหน้าจอ การใช้ท่าทาง ท่าทางบนหน้าจอสัมผัส ท่าทางบนหน้าจอ"},{"UUID":"a4578d57-e9b7-4617-a1ab-252c9ffd519e","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การใช้แป้นพิมพ์บนหน้าจอ เมื่อแป้นพิมพ์บนหน้าจอปรากฏขึ้น ให้ทำอย่างน้อยหนึ่งรายการต่อไปนี้: แตะปุ่มเพื่อพูดและพิมพ์ตัวอักษรลงในช่อง ลากนิ้วมือไปยังตัวอักษรต่างๆ","descFull":"การใช้แป้นพิมพ์บนหน้าจอ เมื่อแป้นพิมพ์บนหน้าจอปรากฏขึ้น ให้ทำอย่างน้อยหนึ่งรายการต่อไปนี้: แตะปุ่มเพื่อพูดและพิมพ์ตัวอักษรลงในช่อง ลากนิ้วมือไปยังตัวอักษรต่างๆ เพื่อพูดและพิมพ์ตัวอักษรลงในช่อง แตะกล่องข้อความโดยใช้นิ้วมือสองนิ้วเพื่อพูดตัวอักษรในช่อง แตะ  Backspace  เพื่อลบตัวอักษร แป้นพิมพ์บนหน้าจอ การใช้"},{"UUID":"905cf3b3-eea3-4a1e-8d18-da9dafcd45a0","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การเปิดใช้งานโหมดการขยาย ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง สำหรับเครื่องพิมพ์รุ่นที่ไม่มีลำโพงในตัว","descFull":"การเปิดใช้งานโหมดการขยาย ด้วยการเคลื่อนไหวเพียงหนึ่งครั้งโดยใช้นิ้วมือเพียงหนึ่งนิ้วบนส่วนแสดงผล ปัดไปทางซ้ายช้าๆ แล้วปัดขึ้นจนกว่าคุณจะได้ยินข้อความเสียง สำหรับเครื่องพิมพ์รุ่นที่ไม่มีลำโพงในตัว ให้ใช้หูฟังเพื่อฟังข้อความ ใช้นิ้วมือสองนิ้วดำเนินการดังนี้: แตะ  โหมดการขยาย แตะ  ตกลง หากท่าทางดังกล่าวใช้ไม่ได้ผล ให้กดให้แรงขึ้น สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการนำทางในหน้าจอขยาย โปรดดู  โหมดการขยาย การเปิดใช้งาน การเปิดใช้งานโหมดการขยาย"},{"UUID":"132d8cae-4989-4cd2-aac6-e2d071a99b7f","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การปรับอัตราเสียงพูดของการแนะนำด้วยเสียง จากแผงควบคุม ไปที่  ตั้งค่า","descFull":"การปรับอัตราเสียงพูดของการแนะนำด้วยเสียง จากแผงควบคุม ไปที่  ตั้งค่า อุปกรณ์ การเข้าถึง อัตราเสียงพูด เลือกอัตราเสียงพูด การแนะนำด้วยเสียง การปรับความเร็วของอัตราเสียงพูด การปรับความเร็วของอัตราเสียงพูด การแนะนำด้วยเสียง การปรับความเร็วของอัตราเสียงพูด การแนะนำด้วยเสียง"},{"UUID":"543eb2b1-69d2-4d0b-85c5-0f8b0cb9bac7","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การปรับระดับเสียงที่ตั้งไว้ของหูฟัง จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การปรับระดับเสียงที่ตั้งไว้ของหูฟัง จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การเข้าถึง ปรับระดับเสียงหูฟัง ระดับเสียงจะรีเซ็ตเป็นค่าเริ่มต้นหลังจากที่ผู้ใช้ออกจากโหมดการเข้าถึง หรือเมื่อเครื่องพิมพ์เริ่มทำงานหลังจากอยู่ในโหมดพักเครื่องหรือไฮเบอร์เนต ระดับเสียงหูฟัง การปรับ การปรับระดับเสียงหูฟัง"},{"UUID":"57a0915e-2ee3-4ec4-ae67-0d798b19e1a6","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การปรับระดับเสียงที่ตั้งไว้ของลำโพงภายใน จากแผงควบคุม ปัดไปทางขวาที่ศูนย์ควบคุม ปรับระดับเสียง หากเปิดใช้งานโหมดเงียบ","descFull":"การปรับระดับเสียงที่ตั้งไว้ของลำโพงภายใน จากแผงควบคุม ปัดไปทางขวาที่ศูนย์ควบคุม ปรับระดับเสียง หากเปิดใช้งานโหมดเงียบ เสียงเตือนจะถูกปิด การตั้งค่านี้ยังทำให้เครื่องพิมพ์ทำงานช้าลงด้วย ระดับเสียงจะรีเซ็ตเป็นค่าเริ่มต้นหลังจากที่ผู้ใช้ออกจากโหมดการเข้าถึง หรือเมื่อเครื่องพิมพ์เริ่มทำงานหลังจากอยู่ในโหมดพักเครื่องหรือโหมดไฮเบอร์เนต ระดับเสียงลำโพง การปรับ การปรับระดับเสียงลำโพง"},{"UUID":"6a67e251-5849-4ef3-a86f-743040e98b89","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง","link":"activating-voice-guidance-topic.html","desc":"การเปิดใช้งานรหัสผ่านด้วยการพูดหรือหมายเลขประจำตัวส่วนบุคคล จากแผงควบคุม ไปที่  ตั้งค่า","descFull":"การเปิดใช้งานรหัสผ่านด้วยการพูดหรือหมายเลขประจำตัวส่วนบุคคล จากแผงควบคุม ไปที่  ตั้งค่า อุปกรณ์ การเข้าถึง พูดรหัสผ่าน/รหัส PIN เปิดใช้งานการตั้งค่า รหัสผ่านแบบพูด การเปิดใช้งาน Personal Identification Number การเปิดใช้งาน"},{"UUID":"eb47e30a-ec25-4ae7-9378-1cf007089981","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้แฟกซ์อนาล็อก การตั้งค่าฟังก์ชันแฟกซ์โดยใช้แฟกซ์อนาล็อก จำเป็นต้องติดตั้งการ์ดแฟกซ์สำหรับเครื่องพิมพ์ที่จะใช้แฟกซ์อนาล็อก สามารถใช้วิธีการเชื่อมต่อบางวิธีได้ในบางประเทศหรือภูมิภาคเท่านั้น หากเปิดใช้งานฟังก์ชันแฟกซ์และไม่ได้ตั้งค่าไว้อย่างสมบูรณ์","descFull":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้แฟกซ์อนาล็อก การตั้งค่าฟังก์ชันแฟกซ์โดยใช้แฟกซ์อนาล็อก จำเป็นต้องติดตั้งการ์ดแฟกซ์สำหรับเครื่องพิมพ์ที่จะใช้แฟกซ์อนาล็อก สามารถใช้วิธีการเชื่อมต่อบางวิธีได้ในบางประเทศหรือภูมิภาคเท่านั้น หากเปิดใช้งานฟังก์ชันแฟกซ์และไม่ได้ตั้งค่าไว้อย่างสมบูรณ์ ไฟสัญญาณอาจกะพริบเป็นสีแดง หากคุณไม่มีสภาพแวดล้อม TCP/IP ให้ใช้แผงควบคุมเพื่อตั้งค่าแฟกซ์ เพื่อป้องกันข้อมูลสูญหายหรือเครื่องพิมพ์ทำงานผิดพลาด อย่าสัมผัสกับสายเคเบิลหรือเครื่องพิมพ์ในบริเวณที่แสดงไว้ในภาพ ในระหว่างที่กำลังส่งหรือรับแฟกซ์ การใช้แผงควบคุม จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์ การตั้งค่าแฟกซ์ทั่วไป กำหนดค่าการตั้งค่า การใช้ Embedded Web Server เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนแผงควบคุม IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์ การตั้งค่าแฟกซ์ทั่วไป กำหนดค่าการตั้งค่า ใช้การเปลี่ยนแปลง แฟกซ์อนาล็อก การตั้งค่า การตั้งค่าแฟกซ์อนาล็อก"},{"UUID":"7acad479-0959-4224-98f1-72d30261f5de","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้ etherFAX การตั้งค่าฟังก์ชันแฟกซ์โดยใช้ etherFAX เฟิร์มแวร์ของเครื่องพิมพ์ต้องได้รับการอัพเดตเป็นเวอร์ชันล่าสุด","descFull":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้ etherFAX การตั้งค่าฟังก์ชันแฟกซ์โดยใช้ etherFAX เฟิร์มแวร์ของเครื่องพิมพ์ต้องได้รับการอัพเดตเป็นเวอร์ชันล่าสุด สำหรับข้อมูลเพิ่มเติม ดูส่วน “การอัปเดตเฟิร์มแวร์” จำเป็นต้องติดตั้งชุดใบอนุญาตที่เหมาะสมในเครื่องพิมพ์ของคุณ สำหรับข้อมูลเพิ่มเติม โปรดติดต่อ etherFAX ตรวจสอบว่าคุณได้ลงทะเบียนเครื่องพิมพ์ในพอร์ทัล etherFAX สำหรับข้อมูลเพิ่มเติม ไปที่  https://www.etherfax.net/lexmark หมายเลขประจำเครื่องของเครื่องพิมพ์จำเป็นต้องลงทะเบียน โปรดดูข้อมูลเพิ่มเติมที่  เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนแผงควบคุม IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์ การตั้งค่าแฟกซ์ทั่วไป การตั้งค่าแฟกซ์  จะปรากฏขึ้นหาก  โหมดแฟกซ์  ถูกตั้งค่าเป็น  แฟกซ์ . ในช่อง ชื่อแฟกซ์ ให้พิมพ์ชื่อที่ไม่ซ้ำกัน ในช่อง หมายเลขแฟกซ์ ป้อนหมายเลขแฟกซ์ที่ระบุ etherFAX จากเมนู  การส่งแฟกซ์  ให้เลือก  etherFAX เมนูนี้จะปรากฏเมื่อมีวิธีการส่งแฟกซ์ที่สามารถใช้งานได้มากกว่าหนึ่งรายการเท่านั้น หากเครื่องพิมพ์มีการติดตั้งเฉพาะ etherFAX จะได้รับการกำหนดค่าไว้โดยอัตโนมัติ ใช้การเปลี่ยนแปลง etherFAX การตั้งค่าฟังก์ชันแฟกซ์ การตั้งค่าฟังก์ชันแฟกซ์ โดยใช้ etherFAX"},{"UUID":"37a0ab5a-0e1f-4200-a86c-ffa85d681c76","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้เซิร์ฟเวอร์แฟกซ์ คุณสมบัตินี้ช่วยให้คุณส่งข้อความแฟกซ์ไปยังผู้ให้บริการแฟกซ์ที่รองรับการรับอีเมลได้ คุณสมบัตินี้รองรับเฉพาะข้อความแฟกซ์ขาออกเท่านั้น เพื่อรองรับการรับแฟกซ์ ให้ตรวจสอบว่ามีการกำหนดค่าแฟกซ์ผ่านอุปกรณ์","descFull":"การตั้งค่าฟังก์ชันแฟกซ์โดยใช้เซิร์ฟเวอร์แฟกซ์ คุณสมบัตินี้ช่วยให้คุณส่งข้อความแฟกซ์ไปยังผู้ให้บริการแฟกซ์ที่รองรับการรับอีเมลได้ คุณสมบัตินี้รองรับเฉพาะข้อความแฟกซ์ขาออกเท่านั้น เพื่อรองรับการรับแฟกซ์ ให้ตรวจสอบว่ามีการกำหนดค่าแฟกซ์ผ่านอุปกรณ์ เช่น อนาล็อก, etherFAX หรือ Fax Over IP (FoIP) ไว้ในเครื่องพิมพ์ของคุณแล้ว เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนแผงควบคุม IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า แฟกซ์ จากเมนู  โหมดแฟกซ์  ให้เลือก  เซิร์ฟเวอร์แฟกซ์  แล้วคลิก  บันทึก คลิก  การตั้งค่าเซิร์ฟเวอร์แฟกซ์ ในช่อง  เพื่อฟอร์แมต  ให้พิมพ์  [#]@myfax.com  โดยที่  [#]  คือหมายเลขแฟกซ์และ  myfax.com  คือโดเมนของผู้ให้บริการแฟกซ์ หากจำเป็น ให้กำหนดค่าช่อง แอดเดรสตอบกลับหัวเรื่อง หรือ ข้อความ หากต้องการให้เครื่องพิมพ์รับข้อความแฟกซ์ ให้เปิดใช้งานการตั้งค่าการรับแฟกซ์ผ่านอุปกรณ์ ตรวจสอบให้แน่ใจว่าคุณได้กำหนดค่าแฟกซ์ผ่านอุปกรณ์แล้ว คลิก  บันทึก คลิก  การตั้งค่าอีเมลเซิร์ฟเวอร์แฟกซ์  จากนั้นเปิดใช้งาน  ใช้เซิร์ฟเวอร์ SMTP ของอีเมล หากไม่มีการกำหนดค่าการตั้งค่า โปรดดูที่  ใช้การเปลี่ยนแปลง เซิร์ฟเวอร์แฟกซ์, การใช้ การตั้งค่าฟังก์ชันแฟกซ์ การตั้งค่าฟังก์ชันแฟกซ์โดยใช้เซิร์ฟเวอร์แฟกซ์"},{"UUID":"5758ae85-3882-4e97-a740-65abdfdcc69f","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งค่าแฟกซ์โดยใช้สายโทรศัพท์มาตรฐาน การตั้งค่าแฟกซ์โดยใช้สายโทรศัพท์มาตรฐาน คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล","descFull":"การตั้งค่าแฟกซ์โดยใช้สายโทรศัพท์มาตรฐาน การตั้งค่าแฟกซ์โดยใช้สายโทรศัพท์มาตรฐาน คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล เช่น สายไฟ สายแฟกซ์หรือสายโทรศัพท์ ขณะเกิดฟ้าแลบฟ้าร้อง เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต อย่าใช้งานแฟกซ์ขณะเกิดฟ้าแลบฟ้าร้อง เพื่อลดความเสี่ยงที่จะเกิดอัคคีภัย ให้ใช้เฉพาะสาย 26 AWG หรือสายเชื่อมต่อสัญญาณที่ใหญ่กว่า (RJ-11) เมื่อเชื่อมต่อผลิตภัณฑ์นี้เข้ากับเครือข่ายโทรศัพท์สาธารณะ สำหรับผู้ใช้ในออสเตรเลีย สายเคเบิ้ลต้องได้รับการอนุมัติจาก Australian Communications and Media Authority การตั้งค่า 1: เครื่องพิมพ์เชื่อมต่อเข้ากับสายแฟกซ์โดยเฉพาะ เชื่อมต่อปลายด้านหนึ่งของสายโทรศัพท์เข้ากับพอร์ตของเครื่องพิมพ์ เชื่อมต่อปลายอีกด้านของสายเคเบิลเข้ากับช่องเสียบโทรศัพท์อนาล็อกที่ผนังซึ่งสามารถใช้งานได้ คุณสามารถตั้งให้เครื่องพิมพ์รับแฟกซ์โดยอัตโนมัติ (ตั้งให้  การรับสายอัตโนมัติ  เป็น  เปิด ) หรือด้วยตนเอง (ตั้งให้  การรับสายอัตโนมัติ  เป็น  ปิด ) หากต้องการรับแฟกซ์โดยอัตโนมัติ ให้ตั้งเครื่องพิมพ์รับแฟกซ์ตามจำนวนครั้งของสัญญาณเรียกเข้า การตั้งค่า 2: เครื่องพิมพ์ใช้สายร่วมกับเครื่องตอบรับอัตโนมัติ หากคุณใช้บริการเสียงเรียกเข้าเฉพาะ ให้ตรวจสอบให้แน่ใจว่าได้ตั้งรูปแบบสัญญาณสายเรียกเข้าที่ถูกต้องสำหรับเครื่องพิมพ์ มิฉะนั้น เครื่องพิมพ์จะไม่รับแฟกซ์ แม้ว่าคุณจะตั้งให้เครื่องพิมพ์รับแฟกซ์โดยอัตโนมัติก็ตาม เชื่อมต่อเข้ากับช่องเสียบสายโทรศัพท์ที่ผนังเดียวกันแล้ว เชื่อมต่อปลายด้านหนึ่งของสายโทรศัพท์เข้ากับพอร์ตของเครื่องพิมพ์ เชื่อมต่อปลายอีกด้านของสายเคเบิลเข้ากับช่องเสียบอนาล็อกที่ผนังซึ่งสามารถใช้งานได้ เชื่อมต่อเครื่องตอบรับอัตโนมัติเข้ากับพอร์ตโทรศัพท์ของเครื่องพิมพ์ เชื่อมต่อกับช่องที่ผนังช่องอื่น เชื่อมต่อปลายด้านหนึ่งของสายโทรศัพท์เข้ากับพอร์ตของเครื่องพิมพ์ เชื่อมต่อปลายอีกด้านของสายเคเบิลเข้ากับช่องเสียบอนาล็อกที่ผนังซึ่งสามารถใช้งานได้ หากคุณมีหมายเลขโทรศัพท์เพียงหมายเลขเดียวในสาย ให้ตั้งเครื่องพิมพ์ให้รับแฟกซ์โดยอัตโนมัติ ตั้งให้เครื่องพิมพ์รับสายเรียกเข้าสองครั้งหลังจากเครื่องตอบรับอัตโนมัติ ตัวอย่างเช่น หากเครื่องตอบรับอัตโนมัติรับสายหลังจากมีสัญญาณเรียกเข้า 4 ครั้ง ให้ตั้ง  เสียงเรียกเข้าเพื่อให้รับสาย  ของเครื่องพิมพ์เป็น  6 การตั้งค่าการแฟกซ์ การใช้การเชื่อมต่อสายโทรศัพท์มาตรฐาน การตั้งค่าแฟกซ์ การใช้การเชื่อมต่อสายโทรศัพท์มาตรฐาน เครื่องตอบรับ การตั้งค่า"},{"UUID":"206841a0-2b75-444b-b18b-ea0794466ef5","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งค่าแฟกซ์ในประเทศหรือภูมิภาคที่มีช่องเสียบโทรศัพท์ติดผนังและปลั๊กที่ต่างกัน การตั้งค่าแฟกซ์ในประเทศหรือภูมิภาคที่มีช่องเสียบโทรศัพท์ติดผนังและปลั๊กที่ต่างกัน คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล","descFull":"การตั้งค่าแฟกซ์ในประเทศหรือภูมิภาคที่มีช่องเสียบโทรศัพท์ติดผนังและปลั๊กที่ต่างกัน การตั้งค่าแฟกซ์ในประเทศหรือภูมิภาคที่มีช่องเสียบโทรศัพท์ติดผนังและปลั๊กที่ต่างกัน คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟฟ้าช็อต อย่าติดตั้งผลิตภัณฑ์นี้หรือเชื่อมต่อสายไฟหรือสายเคเบิล เช่น สายไฟ สายแฟกซ์หรือสายโทรศัพท์ ขณะเกิดฟ้าแลบฟ้าร้อง เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต อย่าใช้งานแฟกซ์ขณะเกิดฟ้าแลบฟ้าร้อง เพื่อลดความเสี่ยงที่จะเกิดอัคคีภัย ให้ใช้เฉพาะสาย 26 AWG หรือสายเชื่อมต่อสัญญาณที่ใหญ่กว่า (RJ-11) เมื่อเชื่อมต่อผลิตภัณฑ์นี้เข้ากับเครือข่ายโทรศัพท์สาธารณะ สำหรับผู้ใช้ในออสเตรเลีย สายเคเบิ้ลต้องได้รับการอนุมัติจาก Australian Communications and Media Authority ช่องเสียบมาตรฐานที่ผนังที่ใช้ในประเทศหรือภูมิภาคส่วนใหญ่คือ RJ‑11 หากช่องเสียบที่ผนังหรืออุปกรณ์ในสถานที่ของคุณไม่สามารถใช้ร่วมกับการเชื่อมต่อประเภทนี้ได้ ให้ใช้อะแดปเตอร์โทรศัพท์ อะแดปเตอร์สำหรับประเทศหรือภูมิภาคของคุณอาจไม่ได้มาพร้อมกับเครื่องพิมพ์ และอาจต้องซื้อแยกต่างหาก อาจมีการติดตั้งปลั๊กอะแดปเตอร์ไว้ในพอร์ตโทรศัพท์ของเครื่องพิมพ์ ห้ามถอดปลั๊กอะแดปเตอร์ออกจากพอร์ตโทรศัพท์ของเครื่องพิมพ์หากกำลังเชื่อมต่อกับระบบโทรศัพท์แบบอนุกรมหรือแบบเรียงซ้อน หมายเลขชิ้นส่วนปลั๊กอะแดปเตอร์ ชื่อชิ้นส่วน หมายเลขชิ้นส่วน ปลั๊กอะแดปเตอร์ Lexmark 40X8519 การเชื่อมต่อเครื่องพิมพ์เข้ากับช่องเสียบผนังที่ไม่ใช่ RJ‑11 เชื่อมต่อปลายด้านหนึ่งของสายโทรศัพท์เข้ากับพอร์ตของเครื่องพิมพ์ ต่อปลายอีกด้านหนึ่งของสายเคเบิลเข้ากับอะแดปเตอร์ RJ‑11 จากนั้นให้ต่ออะแดปเตอร์เข้ากับช่องเสียบที่ผนัง หากต้องการเชื่อมต่ออุปกรณ์อื่นที่มีขั้วต่อที่ไม่ใช่ RJ‑11 เข้ากับช่องเสียบติดผนังตัวเดียวกัน ให้เชื่อมต่ออุปกรณ์ดังกล่าวเข้ากับอะแดปเตอร์โทรศัพท์โดยตรง การตั้งค่าแฟกซ์ การตั้งค่าการแฟกซ์"},{"UUID":"fb2f52b0-a29b-4dd6-b7bf-dbfd449b20eb","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การเชื่อมต่อกับบริการเสียงเรียกเข้าเฉพาะ บริการเสียงเรียกเข้าเฉพาะช่วยให้คุณมีหมายเลขโทรศัพท์หลายหมายเลขในสายโทรศัพท์เดียว หมายเลขโทรศัพท์แต่ละหมายเลขจะมีรูปแบบเสียงเรียกเข้าที่แตกต่างกัน จากแผงควบคุม ไปที่","descFull":"การเชื่อมต่อกับบริการเสียงเรียกเข้าเฉพาะ บริการเสียงเรียกเข้าเฉพาะช่วยให้คุณมีหมายเลขโทรศัพท์หลายหมายเลขในสายโทรศัพท์เดียว หมายเลขโทรศัพท์แต่ละหมายเลขจะมีรูปแบบเสียงเรียกเข้าที่แตกต่างกัน จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ ส่วนควบคุมของผู้ดูแล เปิดการรับสาย เลือกรูปแบบเสียงเรียกเข้า บริการเสียงเรียกเข้าเฉพาะ การเชื่อมต่อเครื่องพิมพ์เข้ากับบริการกำหนดเสียงเรียกเข้าเฉพาะ การกำหนดรูปแบบเสียงเรียกเข้าไปยังเครื่องพิมพ์"},{"UUID":"73308387-e26e-4b86-93d4-534f6ac7b9bc","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การตั้งวันที่และเวลาแฟกซ์ การตั้งวันที่และเวลาแฟกซ์ จากแผงควบคุม ไปที่ ","descFull":"การตั้งวันที่และเวลาแฟกซ์ การตั้งวันที่และเวลาแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ ค่ากำหนด วันที่และเวลา กำหนดค่า กำหนดค่าการตั้งค่า การแฟกซ์ การตั้งวันที่และเวลา วันที่และเวลา การตั้งค่าการแฟกซ์"},{"UUID":"6730f3af-32f7-404c-a7d5-b260ac5698d7","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การกำหนดค่าเวลาออมแสง จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การกำหนดค่าเวลาออมแสง จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ ค่ากำหนด วันที่และเวลา กำหนดค่า ในเมนู  โซนเวลา  ให้เลือก  (UTC+user) กำหนดเอง ในเมนู  กำหนดค่า  ให้เลือก  ความต่างเวลา UTC กำหนดค่าการตั้งค่า การกำหนดค่าเวลาออมแสง เวลาออมแสง การกำหนดค่า"},{"UUID":"b455d7bc-457d-45d0-8a24-6018a3e47973","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์","link":"setting-up-printer-to-fax-group.html","desc":"การกำหนดค่าการตั้งค่าลำโพงแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การกำหนดค่าการตั้งค่าลำโพงแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์ การตั้งค่าลำโพง ปฏิบัติดังต่อไปนี้: ตั้ง  โหมดลำโพง  เป็น  เปิดเสมอ ตั้ง  ระดับเสียงลำโพง  เป็น  สูง เปิดใช้  ระดับเสียงเรียกเข้า การกำหนดค่าการตั้งค่า ลำโพงแฟกซ์ ลำโพงแฟกซ์ การกำหนดค่าการตั้งค่า"},{"UUID":"b92eca89-c3c7-4012-bc10-80d17927edfb","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การตั้งค่าขนาดและประเภทของวัสดุพิมพ์ชนิดพิเศษ การตั้งค่าขนาดและประเภทของวัสดุพิมพ์ชนิดพิเศษ สำหรับวัสดุพิมพ์ชนิดพิเศษ เช่น ฉลาก","descFull":"การตั้งค่าขนาดและประเภทของวัสดุพิมพ์ชนิดพิเศษ การตั้งค่าขนาดและประเภทของวัสดุพิมพ์ชนิดพิเศษ สำหรับวัสดุพิมพ์ชนิดพิเศษ เช่น ฉลาก กระดาษแข็ง หรือซองจดหมาย ให้ดำเนินการต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ เลือกแหล่งกระดาษ แล้วตั้งค่าขนาดและประเภทของวัสดุพิมพ์ชนิดพิเศษ การตั้งค่าขนาดกระดาษ การตั้งค่าประเภทกระดาษ"},{"UUID":"ad81f7fd-5c04-4ca1-9f53-204d4aadb9c5","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การกำหนดการตั้งค่ากระดาษยูนิเวอร์แซล การกำหนดการตั้งค่ากระดาษยูนิเวอร์แซล เมนู  การตั้งค่าแบบยูนิเวอร์แซล","descFull":"การกำหนดการตั้งค่ากระดาษยูนิเวอร์แซล การกำหนดการตั้งค่ากระดาษยูนิเวอร์แซล เมนู  การตั้งค่าแบบยูนิเวอร์แซล  ช่วยให้คุณสามารถตั้งค่าขนาดและความสูงของขนาดกระดาษที่ไม่ได้ตั้งค่าไว้ล่วงหน้าในเครื่องพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าวัสดุพิมพ์ การตั้งค่าแบบยูนิเวอร์แซล เลือก  ถาดป้อนเอกสารทั้งหมด  จากนั้น กำหนดค่าการตั้งค่าสำหรับขนาดกระดาษที่คุณต้องการปรับเปลี่ยน การตั้งค่าขนาดกระดาษ การปรับขนาดกระดาษแบบกำหนดเอง"},{"UUID":"7b8c6bb1-69f7-4a7c-8b00-15206e174f00","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การใส่กระดาษในถาด 550 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน","descFull":"การใส่กระดาษในถาด 550 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน ให้ปิดถาดอื่นๆ ไว้จนกว่าจำเป็นต้องใช้ เปิดถาด เพื่อหลีกเลี่ยงกระดาษติด อย่าเปิดถาดออกขณะที่เครื่องพิมพ์กำลังทำงาน ปรับตัวนำให้ตรงกับขนาดของกระดาษที่คุณใส่ ใช้สัญญาณด้านล่างถาดเพื่อจัดตำแหน่งตัวกั้น กระดาษที่ตอกรูแล้วรองรับเฉพาะในถาดมาตรฐาน 550 แผ่นเท่านั้น กระดาษขนาด A3 รองรับเฉพาะในถาดเสริม 550 แผ่นเท่านั้น งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ ป้อนปึกกระดาษโดยให้ด้านที่ต้องการจะพิมพ์หงายหน้าขึ้น อย่าเลื่อนกระดาษเข้าไปในถาด ตรวจสอบว่าตัวนำกระดาษด้านข้างพอดีกันกับกระดาษ ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด การใส่กระดาษเยอะเกินไปอาจทำให้กระดาษติด ใส่ถาดกระดาษ หากจำเป็น ให้ตั้งขนาดกระดาษและประเภทกระดาษให้ตรงกับกระดาษที่ใส่ในถาด เมื่อติดตั้งถาดรับงานพิมพ์แล้ว หน้ากระดาษจะถูกหมุน 180° เมื่อทำการพิมพ์ เมื่อใส่กระดาษหัวจดหมาย ให้ดำเนินการใดๆ ต่อไปนี้: ในกรณีที่ไม่มีถาดรับงานพิมพ์ ในกรณีที่มีถาดรับงานพิมพ์ การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบสั้น การพิมพ์แบบหนึ่งด้าน ขอบสั้น การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบสั้น การพิมพ์แบบสองด้าน ขอบสั้น เมื่อใส่กระดาษที่ตอกรูแล้ว ให้ดำเนินการใดๆ ต่อไปนี้: ในกรณีที่ไม่มีถาดรับงานพิมพ์เสริม ในกรณีที่มีถาดรับงานพิมพ์เสริม การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบสั้น การพิมพ์แบบหนึ่งด้าน ขอบสั้น การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบสั้น การพิมพ์แบบสองด้าน ขอบสั้น ถาด 550 แผ่น การป้อน การป้อนกระดาษในถาด 550 แผ่น การป้อนกระดาษในถาด"},{"UUID":"954755b2-e313-483e-8e5d-2fcfd10de603","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การใส่กระดาษในถาดบรรจุคู่ 2000 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน","descFull":"การใส่กระดาษในถาดบรรจุคู่ 2000 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน ให้ปิดถาดอื่นๆ ไว้จนกว่าจำเป็นต้องใช้ เปิดถาด เพื่อหลีกเลี่ยงกระดาษติด อย่าดึงถาดออกขณะที่เครื่องพิมพ์กำลังทำงาน งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ ป้อนปึกกระดาษในถาดรองกระดาษทางด้านขวา โดยให้ด้านที่ต้องการจะพิมพ์หงายหน้าขึ้น อย่าเลื่อนกระดาษเข้าไปในถาด ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด การใส่กระดาษเยอะเกินไปอาจทำให้กระดาษติด ใส่ถาดรองกระดาษด้านขวาเข้าในเครื่องพิมพ์ ป้อนปึกกระดาษในถาดรองกระดาษทางด้านซ้าย โดยให้ด้านที่ต้องการจะพิมพ์หงายหน้าขึ้น ใส่ถาดกระดาษ หากจำเป็น ให้ตั้งขนาดกระดาษและประเภทกระดาษให้ตรงกับกระดาษที่ใส่ในถาด เมื่อติดตั้งถาดรับงานพิมพ์แล้ว หน้ากระดาษจะถูกหมุน 180° เมื่อทำการพิมพ์ เมื่อใส่กระดาษหัวจดหมายสำหรับการพิมพ์หนึ่งด้าน ให้ใส่กระดาษโดยหงายหน้าขึ้นและให้ส่วนหัวหันเข้าหาด้านหน้าของถาด เมื่อใส่กระดาษหัวจดหมายสำหรับการพิมพ์สองด้าน ให้ใส่กระดาษโดยคว่ำหน้าลงและให้ส่วนหัวหันเข้าหาด้านหน้าของถาด ถาดบรรจุคู่ 2000 แผ่น การป้อน การป้อนกระดาษในถาดบรรจุคู่ 2000 แผ่น การป้อนกระดาษในถาด"},{"UUID":"49e864ec-ac3f-4e6f-b7a8-3857a5f3f2d7","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การใส่กระดาษในถาด 1500 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน","descFull":"การใส่กระดาษในถาด 1500 แผ่น เพื่อลดความเสี่ยงจากความไม่แน่นอนของอุปกรณ์ ให้ใส่ถาดกระดาษแยกกัน ให้ปิดถาดอื่นๆ ไว้จนกว่าจำเป็นต้องใช้ เปิดฝาปิด K เพื่อหลีกเลี่ยงกระดาษติด อย่าเปิดถาดออกขณะที่เครื่องพิมพ์กำลังทำงาน งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ ป้อนปึกกระดาษโดยให้ด้านที่ต้องการจะพิมพ์คว่ำหน้าลง อย่าเลื่อนกระดาษเข้าไปในถาด ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด การใส่กระดาษเยอะเกินไปอาจทำให้กระดาษติด ปิดฝาปิด K หากจำเป็น ให้ตั้งขนาดกระดาษและประเภทกระดาษให้ตรงกับกระดาษที่ใส่ในถาด เมื่อใส่กระดาษหัวจดหมายสำหรับการพิมพ์หนึ่งด้าน ให้ใส่กระดาษโดยคว่ำหน้าลงและให้ส่วนหัวหันเข้าหาด้านหลังของเครื่องพิมพ์ เมื่อใส่กระดาษหัวจดหมายสำหรับการพิมพ์สองด้าน ให้ใส่กระดาษโดยหงายหน้าขึ้นและให้ส่วนหัวหันเข้าหาด้านหลังของเครื่องพิมพ์ เมื่อใส่กระดาษขนาดอื่น ให้ตรวจสอบว่าได้ปรับตัวนำแล้ว ปฏิบัติดังต่อไปนี้: ใช้ไขควงหัวแบนเพื่อถอดสกรูออกจากตัวนำกระดาษ นำตัวนำกระดาษออก ปรับตัวนำกระดาษให้ตรงกับขนาดของกระดาษที่คุณใส่ ติดตั้งสกรูบนตัวนำกระดาษ ถาด 1500 แผ่น การป้อน การป้อนกระดาษในถาด"},{"UUID":"d2d11f52-aaa5-4b68-b0a3-0cd11e39a8ed","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การใส่ตัวป้อนกระดาษอเนกประสงค์ เปิดตัวป้อนกระดาษอเนกประสงค์ ปรับตัวนำกระดาษด้านข้างให้ตรงกับขนาดของกระดาษที่คุณใส่ งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ","descFull":"การใส่ตัวป้อนกระดาษอเนกประสงค์ เปิดตัวป้อนกระดาษอเนกประสงค์ ปรับตัวนำกระดาษด้านข้างให้ตรงกับขนาดของกระดาษที่คุณใส่ งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ ใส่กระดาษ ตรวจสอบว่าตัวนำกระดาษด้านข้างพอดีกันกับกระดาษ เมื่อใส่กระดาษหัวจดหมาย ให้ดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: ในกรณีที่ไม่มีถาดรับงานพิมพ์ ในกรณีที่มีถาดรับงานพิมพ์ การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว เมื่อใส่กระดาษที่ตอกรูแล้ว ให้ดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: ในกรณีที่ไม่มีถาดรับงานพิมพ์ ในกรณีที่มีถาดรับงานพิมพ์ การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบหนึ่งด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว การพิมพ์แบบสองด้าน ขอบยาว สำหรับซองจดหมาย ใส่ซองจดหมายโดยหงายด้านที่มีแผ่นปิดไปที่ด้านหลังของเครื่องพิมพ์ ใส่ซองจดหมายของยุโรปโดยหงายด้านที่มีแผ่นปิดขึ้น และป้อนเข้าในตัวป้อนกระดาษอเนกประสงค์ก่อน เมื่อติดตั้งถาดรับงานพิมพ์ เครื่องพิมพ์จะหมุนไปทางหน้ากระดาษ 180° การป้อนกระดาษ ในตัวป้อนกระดาษอเนกประสงค์ การป้อนกระดาษหัวจดหมาย การป้อนกระดาษที่ตอกรูแล้ว"},{"UUID":"0c1b518e-7df9-4659-b651-e4e5692e8630","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ","link":"loading-trays-group.html","desc":"การเชื่อมโยงถาด เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู","descFull":"การเชื่อมโยงถาด เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า กระดาษ การกำหนดค่าถาด ตั้งค่าขนาดกระดาษและประเภทกระดาษเหมือนกันสำหรับถาดที่คุณกำลังเชื่อมโยง ตรวจสอบว่าได้ใส่ถาดที่เชื่อมโยงโดยมีแนวกระดาษเหมือนกัน บันทึกการตั้งค่า คลิก  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การกำหนดค่าถาด ตั้งให้  การเชื่อมโยงถาด  เป็น  อัตโนมัติ บันทึกการตั้งค่า ในการยกเลิกการเชื่อมโยงถาด ให้ตรวจสอบว่าไม่มีถาดที่มีการตั้งค่าขนาดกระดาษและประเภทกระดาษเหมือนกัน อุณหภูมิของฟิวเซอร์จะแตกต่างกันไปตามประเภทกระดาษที่ระบุ เพื่อหลีกเลี่ยงปัญหาเกี่ยวกับการพิมพ์ ให้ตรวจสอบว่าการตั้งค่าประเภทกระดาษในเครื่องพิมพ์กับกระดาษที่ใส่ไว้ในถาดนั้นเหมือนกัน การยกเลิกการเชื่อมโยงถาด การเชื่อมโยงถาด การเชื่อมโยงถาด การยกเลิกการเชื่อมโยงถาด"},{"UUID":"ac8efa5c-2d31-4615-80a7-f0abfe43c2f0","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การติดตั้งซอฟต์แวร์เครื่องพิมพ์ ไดรเวอร์การพิมพ์จะรวมอยู่ในชุดโปรแกรมติดตั้งซอฟต์แวร์ สำหรับคอมพิวเตอร์ Macintosh ที่มี","descFull":"การติดตั้งซอฟต์แวร์เครื่องพิมพ์ ไดรเวอร์การพิมพ์จะรวมอยู่ในชุดโปรแกรมติดตั้งซอฟต์แวร์ สำหรับคอมพิวเตอร์ Macintosh ที่มี macOS เวอร์ชัน 10.7 หรือใหม่กว่า คุณไม่จำเป็นต้องติดตั้งไดรเวอร์เพื่อพิมพ์ด้วยเครื่องพิมพ์ที่รองรับ AirPrint หากต้องการคุณสมบัติการพิมพ์ที่กำหนดเอง คุณต้องดาวน์โหลดไดรเวอร์การพิมพ์ ขอรับสำเนาของชุดโปรแกรมติดตั้งซอฟต์แวร์ จากแผ่น CD ซอฟต์แวร์ที่ให้มาพร้อมกับเครื่องพิมพ์ของคุณ ไปที่   www.lexmark.com/downloads ไปที่  www.dell.com/support/printers จากเว็บไซต์ของเรา หรือร้านค้าที่คุณซื้อเครื่องพิมพ์ เรียกใช้ตัวติดตั้ง แล้วปฏิบัติตามคำแนะนำที่ปรากฏบนหน้าจอคอมพิวเตอร์ การติดตั้งซอฟต์แวร์เครื่องพิมพ์ ซอฟต์แวร์เครื่องพิมพ์ การติดตั้ง การติดตั้งไดรเวอร์การพิมพ์ ไดรเวอร์การพิมพ์ การติดตั้ง"},{"UUID":"c2ce3108-64cc-417d-b735-c12c94641b5d","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การติดตั้งไดรเวอร์แฟกซ์ ไปที่  www.lexmark.com/downloads ","descFull":"การติดตั้งไดรเวอร์แฟกซ์ ไปที่  www.lexmark.com/downloads  ค้นหารุ่นเครื่องพิมพ์ของคุณแล้วดาวน์โหลดชุดโปรแกรมติดตั้งที่เหมาะสม ไปที่เว็บไซต์ของเราหรือร้านค้าที่คุณซื้อเครื่องพิมพ์ และขอรับชุดโปรแกรมติดตั้ง ไปที่  www.dell.com/support  แล้วดาวน์โหลดชุดโปรแกรมติดตั้งที่เหมาะสม จากคอมพิวเตอร์ของคุณ ให้คลิก คุณสมบัติเครื่องพิมพ์ แล้วไปที่แท็บ การกำหนดค่า เรียกใช้ตัวติดตั้ง แล้วปฏิบัติตามคำแนะนำที่ปรากฏบนหน้าจอคอมพิวเตอร์ เลือก แฟกซ์ แล้วคลิก ใช้ ไดรเวอร์แฟกซ์ การติดตั้ง การติดตั้งไดรเวอร์แฟกซ์"},{"UUID":"cf5950cb-239c-42e1-9d0c-8be681cd135d","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การเพิ่มเครื่องพิมพ์เข้ากับคอมพิวเตอร์ ก่อนที่จะเริ่มต้น ให้เลือกทำอย่างใดอย่างหนึ่งต่อไปนี้: เชื่อมต่อเครื่องพิมพ์และคอมพิวเตอร์เข้ากับเครือข่ายเดียวกัน หากต้องการข้อมูลเพิ่มเติมเกี่ยวกับการเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย","descFull":"การเพิ่มเครื่องพิมพ์เข้ากับคอมพิวเตอร์ ก่อนที่จะเริ่มต้น ให้เลือกทำอย่างใดอย่างหนึ่งต่อไปนี้: เชื่อมต่อเครื่องพิมพ์และคอมพิวเตอร์เข้ากับเครือข่ายเดียวกัน หากต้องการข้อมูลเพิ่มเติมเกี่ยวกับการเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย โปรดดูที่  การเชื่อมต่อคอมพิวเตอร์เข้ากับเครื่องพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  เชื่อมต่อเครื่องพิมพ์เข้ากับคอมพิวเตอร์โดยใช้สาย USB โปรดดูข้อมูลเพิ่มเติมที่  สายเคเบิล USB จะจำหน่ายแยกต่างหาก สำหรับผู้ใช้ Windows ติดตั้งไดรเวอร์การพิมพ์บนคอมพิวเตอร์ โปรดดูข้อมูลเพิ่มเติมที่  เปิด  เครื่องพิมพ์และสแกนเนอร์  แล้วคลิก  เพิ่มเครื่องพิมพ์หรือสแกนเนอร์ ทั้งนี้ขึ้นอยู่กับการเชื่อมต่อเครื่องพิมพ์ของคุณ ให้ดำเนินการข้อใดข้อหนึ่งต่อไปนี้: เลือกเครื่องพิมพ์จากรายการ จากนั้นคลิกที่ เพิ่มอุปกรณ์ คลิ  แสดงเครื่องพิมพ์ Wi-Fi Direct  เลือกเครื่องพิมพ์แล้วคลิก เพิ่มอุปกรณ์ คลิก เครื่องพิมพ์ที่ฉันต้องการไม่อยู่ในรายการ  จากนั้นจากหน้าต่าง เพิ่มเครื่องพิมพ์  ให้ดำเนินการดังนี้: เลือก เพิ่มเครื่องพิมพ์โดยใช้ IP แอดเดรสหรือชื่อโฮสต์  แล้วคลิก ถัดไป ในช่องประเภทอุปกรณ์ เลือก  อุปกรณ์ TCP/IP ในช่องชื่อโฮสต์หรือ IP แอดเดรส ให้พิมพ์ IP แอดเดรสของเครื่องพิมพ์แล้วคลิก ถัดไป ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง เลือกไดรเวอร์การพิมพ์ จากนั้นคลิก ถัดไป เลือก ใช้ไดรเวอร์ที่ติดตั้งอยู่ในปัจจุบัน (แนะนำ)  แล้วคลิก ถัดไป พิมพ์ชื่อเครื่องพิมพ์แล้วคลิก ถัดไป คลิก  เสร็จสิ้น . สำหรับผู้ใช้ Macintosh เปิด  เครื่องพิมพ์และสแกนเนอร์ คลิก  เพิ่มเครื่องพิมพ์ สแกนเนอร์ หรือแฟกซ์  จากนั้นเลือกเครื่องพิมพ์ จากเมนู  เพิ่มเครื่องพิมพ์  ให้เลือกไดรเวอร์การพิมพ์ ในการใช้ไดรเวอร์การพิมพ์ของ Macintosh ให้เลือก  AirPrint  หรือ  Secure AirPrint หากต้องการคุณสมบัติการพิมพ์ที่กำหนดเอง คุณต้องเลือกไดรเวอร์การพิมพ์ ในการติดตั้งไดรเวอร์ โปรดดูที่  หากต้องการคุณสมบัติการพิมพ์ที่กำหนดเอง คุณต้องเลือกไดรเวอร์การพิมพ์ของผู้ผลิต ในการติดตั้งไดรเวอร์ โปรดดูที่  การเพิ่มเครื่องพิมพ์ การเพิ่มเครื่องพิมพ์เข้ากับคอมพิวเตอร์"},{"UUID":"9f69ced0-ff93-418b-a74e-cba9c151e52c","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การส่งออกไฟล์การกำหนดค่า เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู","descFull":"การส่งออกไฟล์การกำหนดค่า เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง จาก Embedded Web Server ให้คลิก  ส่งออกการกำหนดค่า เลือกการกำหนดค่าที่จะส่งออก ไฟล์จะถูกส่งออกในรูปแบบ ZIP หรือ CSV ขึ้นอยู่กับการกำหนดค่าที่คุณเลือก การส่งออกไฟล์การกำหนดค่า ไฟล์การกำหนดค่า การส่งออก"},{"UUID":"0a663e07-f315-487a-8f77-7eea617fdb26","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การนำเข้าไฟล์การกำหนดค่า เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู","descFull":"การนำเข้าไฟล์การกำหนดค่า เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง จาก Embedded Web Server ให้คลิก  นำเข้าการกำหนดค่า เรียกดูตำแหน่งที่บันทึกไฟล์ดังกล่าว ไฟล์จะถูกบันทึกไว้ในรูปแบบ ZIP หรือ CSV คลิก  นำเข้า การนำเข้าไฟล์การกำหนดค่า ไฟล์การกำหนดค่า การนำเข้า"},{"UUID":"22f5b4d9-aa2e-4e71-a203-a42ed9ea455d","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"กำลังเพิ่มตัวเลือกที่มีในไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เปิดโฟลเดอร์เครื่องพิมพ์ เลือกเครื่องพิมพ์ที่คุณต้องการอัปเดตแล้วเลือกทำอย่างใดอย่างหนึ่งต่อไปนี้:","descFull":"กำลังเพิ่มตัวเลือกที่มีในไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เปิดโฟลเดอร์เครื่องพิมพ์ เลือกเครื่องพิมพ์ที่คุณต้องการอัปเดตแล้วเลือกทำอย่างใดอย่างหนึ่งต่อไปนี้: สำหรับ Windows 7 หรือใหม่กว่า ให้เลือก  คุณสมบัติเครื่องพิมพ์ สำหรับรุ่นก่อนหน้า ให้เลือก  คุณสมบัติ ไปที่แท็บ การกำหนดค่า  แล้วเลือก  อัปเดตทันที ‑ ถามเครื่องพิมพ์ ใช้การเปลี่ยนแปลง สำหรับผู้ใช้ Macintosh เปิด  เครื่องพิมพ์และสแกนเนอร์ คลิก  เพิ่มเครื่องพิมพ์ สแกนเนอร์ หรือแฟกซ์  จากนั้นเลือกเครื่องพิมพ์ เลือกไดรเวอร์การพิมพ์ ใช้การเปลี่ยนแปลง การเพิ่มตัวเลือกฮาร์ดแวร์ ในไดรเวอร์การพิมพ์ ไดรเวอร์การพิมพ์ การเพิ่มตัวเลือกฮาร์ดแวร์"},{"UUID":"d343e3fe-891e-4f27-9a18-9f6e04191442","title":"การอัพเดตเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การอัปเดตเฟิร์มแวร์โดยใช้แผงควบคุม โดยใช้ศูนย์การแจ้งเตือน วิธีนี้ใช้ได้ในรุ่นเครื่องพิมพ์บางรุ่นเท่านั้น จากแผงควบคุม ไปที่ศูนย์การแจ้งเตือน","descFull":"การอัปเดตเฟิร์มแวร์โดยใช้แผงควบคุม โดยใช้ศูนย์การแจ้งเตือน วิธีนี้ใช้ได้ในรุ่นเครื่องพิมพ์บางรุ่นเท่านั้น จากแผงควบคุม ไปที่ศูนย์การแจ้งเตือน แล้วเลือก การอัปเดตเฟิร์มแวร์ที่มีอยู่ เลือก  ติดตั้งตอนนี้ เครื่องพิมพ์จะรีบูตอัตโนมัติหลังการอัปเดต โดยใช้เมนูการตั้งค่า จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ อัปเดตเฟิร์มแวร์ เลือก  ตรวจสอบการอัปเดต  หรือ  ตรวจสอบการอัปเดตตอนนี้ หากมีรายการอัปเดตใหม่ ให้เลือก  ติดตั้งตอนนี้ เครื่องพิมพ์จะรีบูตอัตโนมัติหลังการอัปเดต การอัพเดตเฟิร์มแวร์ การใช้แผงควบคุม เฟิร์มแวร์, การอัพเดต การใช้แผงควบคุม"},{"UUID":"c996a624-7c2a-4453-a007-cbd95bef716f","title":"การอัพเดตเฟิร์มแวร์","link":"installing-printer-software-topic.html","desc":"การจัดการเฟิร์มแวร์โดยใช้ Embedded Web Server ก่อนที่คุณจะเริ่มต้น","descFull":"การจัดการเฟิร์มแวร์โดยใช้ Embedded Web Server ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบดังต่อไปนี้: คุณได้ดาวน์โหลดเฟิร์มแวร์เครื่องพิมพ์ล่าสุดจาก  https://support.lexmark.com  และบันทึกไปยังแฟลชไดรฟ์หรือคอมพิวเตอร์ของคุณ หากปรับใช้เฟิร์มแวร์เครื่องพิมพ์ ให้แตกไฟล์เฟิร์มแวร์ FLS จากแพ็คเกจ ZIP คุณได้ดาวน์โหลดซอฟต์แวร์เครื่องพิมพ์ล่าสุดและบันทึกไปยังแฟลชไดรฟ์หรือคอมพิวเตอร์ของคุณ สำหรับข้อมูลเพิ่มเติม โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ คุณได้ดาวน์โหลดซอฟต์แวร์เครื่องพิมพ์ล่าสุดและบันทึกไปยังแฟลชไดรฟ์หรือคอมพิวเตอร์ของคุณ หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อตัวแทนจำหน่ายของคุณ คุณไม่ได้กำลังใช้รหัสพิเศษบนเครื่องพิมพ์ของคุณเพื่อหลีกเลี่ยงการสูญเสียฟังก์ชันการทำงานนี้ ตรวจสอบว่าเครื่องพิมพ์ทั้งหมดที่ได้รับการอัพเดตเฟิร์มแวร์เปิดอยู่ในระหว่างกระบวนการอัพเดตเฟอร์มแวร์ทั้งหมด การปิดเครื่องพิมพ์ในระหว่างการอัพเดตเฟิร์มแวร์อาจทำให้เครื่องพิมพ์เสียหายร้ายแรง หากเครื่องพิมพ์เชื่อมต่อกับเครือข่ายขณะตรวจสอบการอัพเดต ไม่จำเป็นต้องดาวน์โหลดเฟิร์มแวร์ เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  อุปกรณ์ . เลื่อนลง แล้วคลิก อัพเดตเฟิร์มแวร์ คลิก  ตรวจสอบการอัพเดต  หรือ  ตรวจสอบการอัพเดตตอนนี้  ขึ้นอยู่กับรุ่นเครื่องพิมพ์ของคุณ หากมีรายการสำหรับการอัพเดตใหม่ ให้คลิก  ข้าพเจ้ายินยอม เริ่มการอัพเดต เครื่องพิมพ์จะรีบูตอัตโนมัติหลังการอัปเดต การอัพเดตเฟิร์มแวร์ การใช้ Embedded Web Server เฟิร์มแวร์, การอัพเดต การใช้ Embedded Web Server"},{"UUID":"e283c105-b8b9-4550-a189-be1794b90a63","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งถาดเสริม 550 แผ่น เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์","descFull":"การติดตั้งถาดเสริม 550 แผ่น เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ ดึงถาดเสริม 550 แผ่นออกจากบรรจุภัณฑ์ เพื่อหลีกเลี่ยงไม่ให้ถาดเสียหาย ตรวจสอบว่าได้ยึดด้านข้างด้านหน้าและด้านหลังขณะที่ยกขึ้น ติดฝาครอบถาดด้านขวา ดึงถาดรองกระดาษ 550 แผ่นออก ถอดฝาครอบถาดด้านบนออก ถอดสกรูออก ติดฝาครอบถาดด้านล่าง ติดตั้งสกรู ติดฝาครอบถาดด้านบน ใส่ถาดรองกระดาษ 550 แผ่น ถอดฝาครอบที่อยู่ข้างใต้ทางด้านขวาของเครื่องพิมพ์ จัดวางเครื่องพิมพ์ให้ตรงกับถาด 550 แผ่น แล้วลดระดับเครื่องพิมพ์ลงจนกระทั่งเข้าที่ หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20 กก. (44 ปอนด์) อาจต้องใช้คนสองคนขึ้นไปยกเครื่องพิมพ์อย่างปลอดภัย ดึงถาดรองกระดาษมาตรฐานออก ยึดถาด 550 แผ่นกับเครื่องพิมพ์ให้แน่น ใส่ถาดรองกระดาษมาตรฐาน ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับเครื่องพิมพ์ให้แน่น เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มถาดในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  การติดตั้งถาด 550 แผ่น ถาด 550 แผ่น การติดตั้ง ตัวเลือกฮาร์ดแวร์ ถาด 550 แผ่น"},{"UUID":"58508173-0bbc-42b1-afa2-7d375cc9c46c","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งถาด 550 แผ่น 2 ถาด","descFull":"การติดตั้งถาด 550 แผ่น 2 ถาด เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก จำเป็นต้องติดตั้งตัวเลือกนี้ร่วมกับถาดเสริม 550 แผ่น วางตัวเลือกนี้ที่ด้านล่างของการกำหนดค่า หากติดตั้งถาด 550 แผ่นอยู่แล้ว ให้ถอดถาดดังกล่าวออก นำฝาครอบด้านข้างถาดออก นำฝาครอบถาดด้านล่างออก แล้ววางถาดไว้ที่ด้านบนของตัวเลือกนี้ งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำถาด 550 แผ่น 2 ถาดออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ล็อคล้อเลื่อนเพื่อไม่ให้ถาด 550 แผ่น 2 ถาดเคลื่อนที่ จัดวางถาด 550 แผ่นให้ตรงกับถาด 550 แผ่น 2 ถาด แล้วลดระดับลงจนกระทั่งเข้าที่ เพื่อหลีกเลี่ยงไม่ให้ถาดเสียหาย ตรวจสอบว่าได้ยึดด้านข้างด้านหน้าและด้านหลังขณะที่ยกถาดขึ้น ดึงถาดรองกระดาษ 550 แผ่นออก ยึดถาด 550 แผ่นกับถาด 550 แผ่น 2 ถาด ใส่ถาดรองกระดาษ 550 แผ่น ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับถาด 550 แผ่น 2 ถาดให้แน่น ถอดฝาครอบที่อยู่ข้างใต้ทางด้านขวาของเครื่องพิมพ์ จัดวางเครื่องพิมพ์ให้ตรงกับถาดเสริม แล้วลดระดับเครื่องพิมพ์ลงจนกระทั่งเข้าที่ หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20กก. (44ปอนด์) อาจต้องใช้คนสองคนขึ้นไปยกเครื่องพิมพ์อย่างปลอดภัย ดึงถาดรองกระดาษมาตรฐานออก ยึดถาด 550 แผ่นกับเครื่องพิมพ์ให้แน่น ใส่ถาดรองกระดาษมาตรฐาน ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับเครื่องพิมพ์ให้แน่น เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มถาดในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  ถาด 550 แผ่น 2 ถาด การติดตั้ง ตัวเลือกฮาร์ดแวร์ ถาด 550 แผ่น 2 ถาด การติดตั้งถาด 550 แผ่น 2 ถาด"},{"UUID":"ea4eb564-9d8a-47fe-b4d6-30453574d526","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การใส่กระดาษในถาดบรรจุคู่ 2000 แผ่น การใส่กระดาษในถาดบรรจุคู่ 2000","descFull":"การใส่กระดาษในถาดบรรจุคู่ 2000 แผ่น การใส่กระดาษในถาดบรรจุคู่ 2000 แผ่น เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก จำเป็นต้องติดตั้งตัวเลือกนี้ร่วมกับถาดเสริม 550 แผ่น วางตัวเลือกนี้ที่ด้านล่างของการกำหนดค่า หากติดตั้งถาด 550 แผ่นอยู่แล้ว ให้ถอดถาดดังกล่าวออก นำฝาครอบด้านข้างถาดออก นำฝาครอบถาดด้านล่างออก แล้ววางถาดไว้ที่ด้านบนของตัวเลือกนี้ งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำถาดบรรจุคู่ออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ล็อคล้อเลื่อนเพื่อไม่ให้ถาดบรรจุคู่เคลื่อนที่ D จัดวางถาด 550 แผ่นให้ตรงกับถาดบรรจุคู่ แล้วลดระดับลงจนกระทั่งเข้าที่ เพื่อหลีกเลี่ยงไม่ให้ถาดเสียหาย ตรวจสอบว่าได้ยึดด้านข้างด้านหน้าและด้านหลังขณะที่ยกถาดขึ้น ดึงถาดรองกระดาษ 550 แผ่นออก ยึดถาด 550 แผ่นกับถาดบรรจุคู่ให้แน่น ใส่ถาดรองกระดาษ ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับถาดบรรจุคู่ให้แน่น ถอดฝาครอบที่อยู่ข้างใต้ทางด้านขวาของเครื่องพิมพ์ จัดวางเครื่องพิมพ์ให้ตรงกับถาดเสริม แล้วลดระดับเครื่องพิมพ์ลงจนกระทั่งเข้าที่ หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20กก. (44ปอนด์) อาจต้องใช้คนสองคนขึ้นไปยกเครื่องพิมพ์อย่างปลอดภัย ดึงถาดกระดาษมาตรฐานออกมา ยึดถาด 550 แผ่นกับเครื่องพิมพ์ให้แน่น ใส่ถาดกระดาษ ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับเครื่องพิมพ์ให้แน่น เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มถาดในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  ถาดบรรจุคู่ 2000 แผ่น การติดตั้ง ตัวเลือกฮาร์ดแวร์ ถาดบรรจุคู่ 2000 แผ่น การติดตั้งถาดบรรจุคู่ 2000 แผ่น"},{"UUID":"9fc18ccf-b9b6-4e9b-b3da-abf0c05eac4e","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งตู้ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งตู้ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก จำเป็นต้องติดตั้งตัวเลือกนี้ร่วมกับถาด 550 แผ่น วางตัวเลือกนี้ที่ด้านล่างของการกำหนดค่า หากติดตั้งถาด 550 แผ่นอยู่แล้ว ให้ถอดถาดดังกล่าวออก นำฝาครอบถาดด้านล่างออก แล้ววางไว้ที่ด้านบนของตัวเลือกนี้ งานนี้จำเป็นต้องใช้ไขควงหัวแบน แกะตู้ออกจากบรรจุภัณฑ์ แล้วประกอบ ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ ล็อคล้อเลื่อนเพื่อไม่ให้ตู้เคลื่อนที่ ติดฝาครอบด้านข้างของถาด 550 แผ่น จัดวางถาดให้ตรงกับตู้ แล้วลดระดับลงจนกระทั่งเข้าที่ เพื่อหลีกเลี่ยงไม่ให้ถาดเสียหาย ตรวจสอบว่าได้ยึดด้านข้างด้านหน้าและด้านหลังขณะที่ยกขึ้น ดึงถาดรองกระดาษออก ยึดถาดกับตู้ให้แน่น ใส่ถาดรองกระดาษ ยึดชิ้นส่วนด้านหลังของถาดเข้ากับตู้ให้แน่น ถอดฝาครอบที่อยู่ข้างใต้ทางด้านขวาของเครื่องพิมพ์ จัดวางเครื่องพิมพ์ให้ตรงกับตู้และถาด แล้วลดระดับลงจนกระทั่งเข้าที่ หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20กก. (44ปอนด์) อาจต้องใช้คนสองคนขึ้นไปยกเครื่องพิมพ์อย่างปลอดภัย ดึงถาดรองกระดาษมาตรฐานออก ยึดถาด 550 แผ่นกับเครื่องพิมพ์ให้แน่น ใส่ถาดรองกระดาษมาตรฐาน ยึดชิ้นส่วนด้านหลังของถาด 550 แผ่นเข้ากับเครื่องพิมพ์ให้แน่น เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ แบบหมุน การติดตั้ง ตัวเลือกฮาร์ดแวร์ แบบหมุน การติดตั้งตู้"},{"UUID":"20f5672c-fd33-48ce-9aeb-6134d5f8f71b","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งถาด 1500 แผ่น เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์","descFull":"การติดตั้งถาด 1500 แผ่น เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก ก่อนติดตั้งตัวเลือกนี้ ตรวจสอบให้แน่ใจว่าถาดเสริม 550 แผ่นและถาด 500 แผ่น 2 ถาดหรือถาด 2000 แผ่นอย่างใดอย่างหนึ่งติดตั้งไว้แล้ว งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ ถอดฝาครอบจุดเชื่อมต่อ อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบพอร์ต อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบสกรูออกจากเครื่องพิมพ์ อย่าทิ้งฝาครอบสกรู นำถาด 1500 แผ่นออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ติดตั้งสกรูบนแผ่นยึด ต่อแผ่นยึดเข้ากับเครื่องพิมพ์ ใช้แผ่นยิดและสกรูที่มาพร้อมกับถาด 1500 แผ่น ติดตั้งสกรูที่เหลืออยู่ ติดตั้งถาด 1500 แผ่น เชื่อมต่อสายเคเบิลของถาดเข้ากับเครื่องพิมพ์ ติดฝาครอบสายเคเบิลของถาด เลื่อนถาด 1500 แผ่นไปทางเครื่องพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเครื่องพิมพ์เข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มถาดในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  การติดตั้งถาด 1500 แผ่น ถาด 1500 แผ่น การติดตั้ง ตัวเลือกฮาร์ดแวร์ ถาด 1500 แผ่น"},{"UUID":"e2cc8692-fa33-43b0-be15-36df75e7baeb","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์","descFull":"การติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ติดตั้งตัวนำการป้อนกระดาษ นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบลูกกลิ้งให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ถอดฝาครอบด้านหลังซ้ายออก อย่าทิ้งสกรูและฝาครอบ ถอดฝาครอบถาดด้านในออก อย่าทิ้งฝาครอบดังกล่าว จัดแนวแล้วใส่ฝาครอบถาดด้านในที่มาพร้อมกับอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ติดตั้งสกรูเข้ากับฝาครอบถาดด้านใน ติดแถบเลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ใส่อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ ติดตั้งแผ่นยึดเพื่อยึดถาดรองพิมพ์เข้ากับเครื่องพิมพ์ ใช้สกรูที่มาพร้อมกับถาดรองพิมพ์ ติดฝาครอบด้านหลังซ้าย แล้วเลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บไปทางซ้าย ติดฝาครอบกรอบด้านบนซ้ายที่มาพร้อมกับถาดรองพิมพ์ ใส่ตลับลวดเย็บเข้าไปในถาดรองพิมพ์จนกระทั่งมีเสียง คลิก เข้าที่ ปิดฝาด้านหน้า แล้วเลื่อนถาดรองพิมพ์ไปทางเครื่องพิมพ์ เชื่อมต่อสายเคเบิลของตัวเลือกเข้ากับเครื่องพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเครื่องพิมพ์เข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มถาดรองพิมพ์ในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  การติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การติดตั้ง ตัวเลือกฮาร์ดแวร์ อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ"},{"UUID":"531e2b50-96ea-4d5a-af50-19315547b727","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต การติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์","descFull":"การติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต การติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์เรียงกระดาษออฟเซ็ตออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ติดฝาครอบด้านหลังด้านในเข้ากับอุปกรณ์เรียงกระดาษออฟเซ็ต นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด จัดแนวแล้วติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ตเข้ากับเครื่องพิมพ์ ตรวจสอบว่าชิ้นส่วนติดเข้ากันและอยู่ในแนวเดียวกับเครื่องพิมพ์ ติดแถบป้องกันของอุปกรณ์เรียงกระดาษออฟเซ็ตเข้ากับเครื่องพิมพ์ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ติดฝาครอบแฟลกถาดจนมีเสียง คลิก เข้าที่ เสียบปลายด้านหนึ่งของสายไฟเครื่องพิมพ์เข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ เพิ่มอุปกรณ์เรียงกระดาษออฟเซ็ตในไดรเวอร์การพิมพ์เพื่อให้พร้อมใช้งานสำหรับงานพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  อุปกรณ์เรียงกระดาษออฟเซ็ต การติดตั้ง การติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต ตัวเลือกฮาร์ดแวร์ การติดตั้ง"},{"UUID":"c9d57127-bdf8-4fe2-9cce-3f922bfa8475","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก นอกจากนี้ ยังสามารถติดตั้งตัวเลือกนี้ร่วมกับอุปกรณ์เย็บเล่มแบบตอกลวดเย็บหรืออุปกรณ์เย็บเล่มอีกด้วย งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับตัวเลือกเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบลูกกลิ้งให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ปิดฝาด้านหน้า นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบด้านหลังซ้ายออก อย่าทิ้งสกรูและฝาครอบ ถอดฝาครอบถาดด้านในออก อย่าทิ้งสกรูและฝาครอบ จัดแนวแล้วใส่ฝาครอบถาดด้านในที่มาพร้อมกับตัวเลือก ติดตั้งสกรูเข้ากับฝาครอบถาดด้านใน ติดเทปโฟมเข้ากับตัวเลือก เปิดฝาปิด F แล้วขันสกรูให้แน่น ปิดฝาปิด F ติดแผ่นโลหะเข้ากับตัวเลือก ใส่ตัวเลือกเข้าไป ตรวจสอบให้แน่ใจว่ามีแผ่นโลหะอยู่ที่ด้านหน้าของเครื่องพิมพ์ เปิดฝาปิด F จากนั้นใช้ไขควงที่มาพร้อมกับตัวเลือกติดตั้งสกรู ปิดฝาปิด F ติดตั้งสกรูเข้ากับตัวเลือก ติดฝาครอบด้านหลังซ้าย เปิดฝาด้านหน้า แล้วติดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ ปิดฝาด้านหน้า ยกแผ่นปิดถาดขึ้น จากนั้นจัดแนวให้ตรงกันและติดถาดตัวเลือก ติดตั้งสกรูเข้ากับถาดตัวเลือก ติดตั้งฝาครอบขอบ เชื่อมต่อสายเคเบิลของตัวเลือกเข้ากับเครื่องพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ ตัวเลือกฮาร์ดแวร์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การติดตั้ง"},{"UUID":"d24fa1c3-21eb-4d25-b45d-a5a9662ff42f","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เย็บเล่มตอกรูและตัวเลือกของอุปกรณ์ส่งกระดาษ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งอุปกรณ์เย็บเล่มตอกรูและตัวเลือกของอุปกรณ์ส่งกระดาษ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์ส่งกระดาษออกจากบรรจุภัณฑ์ นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับอุปกรณ์ส่งกระดาษเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ปิดฝาด้านหน้า นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบออก อย่าทิ้งฝาครอบดังกล่าว ติดแผ่นโลหะ ใส่อุปกรณ์ส่งกระดาษเข้าไป เปิดที่จับ G จากนั้นติดตั้งสกรูเข้ากับด้านหน้าของอุปกรณ์ส่งกระดาษ ปิดที่จับ G ติดตั้งสกรูกับด้านหลังของอุปกรณ์ส่งกระดาษ เปิดฝาด้านหน้า แล้วติดฝาครอบที่มาพร้อมกับอุปกรณ์ส่งกระดาษเข้ากับด้านซ้ายของเครื่องพิมพ์ ปิดฝาด้านหน้า การนำอุปกรณ์เย็บเล่มแบบตอกลวดเย็บออกจากบรรจุภัณฑ์ ติดตั้งอุปกรณ์รักษาระดับ ดึงเทปที่พันรอบอุปกรณ์เย็บเล่มออก ติดแผ่นโลหะเข้ากับอุปกรณ์เย็บเล่ม ติดเทปโฟมเข้ากับอุปกรณ์เย็บเล่ม ติดแตัวนำการป้อนกระดาษเข้ากับอุปกรณ์เย็บเล่ม ติดถาดเข้ากับอุปกรณ์เย็บเล่ม เปิดฝาปิดอุปกรณ์เย็บเล่ม แล้วใส่กล่องอุปกรณ์ตอกรูเข้าไป วางอุปกรณ์ต่อขยายถาดเข้าในถาดของอุปกรณ์เย็บเล่ม อุปกรณ์ต่อขยายถาดใช้สำหรับกระดาษขนาด A3 หรือยาวกว่านั้น และในสภาวะที่มีความชื้นสูงเพื่อช่วยในการเรียงกระดาษ ความจุของถาดจะลดลงเมื่อมีการใช้อุปกรณ์ต่อขยายถาด ปิดฝาถาดรับงานพิมพ์ ต่อแผ่นยึดเข้ากับเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าสกรูอยู่ในแนวเดียวกับรอยมาร์กเกอร์บนแผ่นยึด ติดแผ่นโลหะที่มาพร้อมกับอุปกรณ์ส่งกระดาษกับเครื่องพิมพ์ เปิดฝาปิดอุปกรณ์เย็บเล่ม ถอดสกรูออก แล้วดึงล็อคของอุปกรณ์เย็บเล่ม ติดอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ ล็อคอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ จากนั้นติดตั้งสกรู เชื่อมต่อสายเคเบิลของอุปกรณ์เย็บเล่มกับเครื่องพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ ตัวเลือกฮาร์ดแวร์ อุปกรณ์ส่งกระดาษ ตัวเลือกฮาร์ดแวร์ อุปกรณ์เย็บเล่มตอกรู อุปกรณ์ส่งกระดาษ การติดตั้ง อุปกรณ์เย็บเล่มตอกรู การติดตั้ง"},{"UUID":"f679368d-bf3c-4253-b2fe-d2f448c7da54","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เย็บเล่มตอกรูและอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งอุปกรณ์เย็บเล่มตอกรูและอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับตัวเลือกเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ปิดฝาด้านหน้า นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบด้านหลังซ้ายออก อย่าทิ้งสกรูและฝาครอบ ถอดฝาครอบถาดด้านในออก อย่าทิ้งสกรูและฝาครอบ จัดแนวแล้วใส่ฝาครอบถาดด้านในที่มาพร้อมกับอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ติดตั้งสกรูเข้ากับฝาครอบถาดด้านใน ติดเทปโฟมเข้ากับตัวเลือก เปิดฝาปิด F แล้วขันสกรูให้แน่น ปิดฝาปิด F ติดแผ่นโลหะเข้ากับตัวเลือก ใส่ตัวเลือกเข้าไป ตรวจสอบให้แน่ใจว่ามีแผ่นโลหะอยู่ที่ด้านหน้าของเครื่องพิมพ์ เปิดฝาปิด F จากนั้นใช้ไขควงที่มาพร้อมกับตัวเลือกติดตั้งสกรู ปิดฝาปิด F ติดตั้งสกรูเข้ากับตัวเลือก ติดฝาครอบด้านหลังซ้าย การนำอุปกรณ์เย็บเล่มแบบตอกลวดเย็บออกจากบรรจุภัณฑ์ ติดตั้งอุปกรณ์รักษาระดับ ดึงเทปที่พันรอบอุปกรณ์เย็บเล่มออก ติดแผ่นโลหะเข้ากับอุปกรณ์เย็บเล่ม ติดเทปโฟมเข้ากับอุปกรณ์เย็บเล่ม นำส่วนโฟมเล็กๆ ที่ด้านขวาของอุปกรณ์เย็บเล่ม ติดแตัวนำการป้อนกระดาษเข้ากับอุปกรณ์เย็บเล่ม ติดถาดเข้ากับอุปกรณ์เย็บเล่ม เปิดฝาปิดอุปกรณ์เย็บเล่ม แล้วใส่กล่องอุปกรณ์ตอกรูเข้าไป วางอุปกรณ์ต่อขยายถาดเข้าในถาดของอุปกรณ์เย็บเล่ม อุปกรณ์ต่อขยายถาดใช้สำหรับกระดาษขนาด A3 หรือยาวกว่านั้น และในสภาวะที่มีความชื้นสูงเพื่อช่วยในการเรียงกระดาษ ความจุของถาดจะลดลงเมื่อมีการใช้อุปกรณ์ต่อขยายถาด ปิดฝาถาดรับงานพิมพ์ ยกแผ่นปิดถาดขึ้น จากนั้นจัดแนวให้ตรงกันและติดฝาครอบเข้ากับตัวเลือก ติดตั้งสกรู เปิดฝาด้านหน้า แล้วติดฝาครอบขอบที่มาพร้อมกับตัวเลือก ต่อแผ่นยึดเข้ากับเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าสกรูอยู่ในแนวเดียวกับรอยมาร์กเกอร์บนแผ่นยึด เปิดฝาปิดอุปกรณ์เย็บเล่ม ถอดสกรูออก แล้วดึงล็อคของอุปกรณ์เย็บเล่ม เชื่อมต่อสายเคเบิลของตัวเลือกเข้ากับเครื่องพิมพ์ เชื่อมต่อสายเคเบิลของอุปกรณ์เย็บเล่มกับตัวเลือก ติดอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ ล็อคอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ จากนั้นติดตั้งสกรู ปิดฝาถาดรับงานพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ ตัวเลือกฮาร์ดแวร์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ตัวเลือกฮาร์ดแวร์ อุปกรณ์เย็บเล่มตอกรู อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การติดตั้ง อุปกรณ์เย็บเล่มตอกรู การติดตั้ง"},{"UUID":"d6bcb252-bc50-448e-b6bd-1857c0f133cb","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เย็นเล่มและตัวเลือกของอุปกรณ์ส่งกระดาษ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งอุปกรณ์เย็นเล่มและตัวเลือกของอุปกรณ์ส่งกระดาษ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์ส่งกระดาษออกจากบรรจุภัณฑ์ นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับอุปกรณ์ส่งกระดาษเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบลูกกลิ้งให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ปิดฝาด้านหน้า นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบออก อย่าทิ้งฝาครอบดังกล่าว ติดแผ่นโลหะ ใส่อุปกรณ์ส่งกระดาษเข้าไป เปิดที่จับ G จากนั้นติดตั้งสกรูเข้ากับด้านหน้าของอุปกรณ์ส่งกระดาษ ปิดที่จับ G ติดตั้งสกรูกับด้านหลังของอุปกรณ์ส่งกระดาษ เปิดฝาด้านหน้า แล้วติดฝาครอบที่มาพร้อมกับอุปกรณ์ส่งกระดาษเข้ากับด้านซ้ายของเครื่องพิมพ์ ปิดฝาด้านหน้า นำอุปกรณ์เย็บเล่มออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ติดแผ่นโลหะเข้ากับอุปกรณ์เย็บเล่ม ติดเทปโฟมเข้ากับอุปกรณ์เย็บเล่ม ติดแตัวนำการป้อนกระดาษเข้ากับอุปกรณ์เย็บเล่ม ติดถาดด้านบนกับอุปกรณ์เย็บเล่ม ยกแผ่นปิดถาดขึ้น จากนั้นติดถาดด้านล่างกับอุปกรณ์เย็บเล่ม เปิดฝาปิดถาดรับงานพิมพ์ นำวัสดุบรรจุภัณฑ์ออกจากกล่องอุปกรณ์ตอกรู แล้วใส่เข้าในอุปกรณ์เย็บเล่ม วางอุปกรณ์ต่อขยายถาดบนถาดของอุปกรณ์เย็บเล่ม อุปกรณ์ต่อขยายถาดใช้สำหรับกระดาษขนาด A3 หรือยาวกว่านั้น และในสภาวะที่มีความชื้นสูงเพื่อช่วยในการเรียงกระดาษ ความจุของถาดจะลดลงเมื่อมีการใช้อุปกรณ์ต่อขยายถาด ติดถาดเข้ากับด้านหลังของอุปกรณ์เย็บเล่ม ปิดฝาถาดรับงานพิมพ์ ต่อแผ่นยึดเข้ากับเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าสกรูอยู่ในแนวเดียวกับรอยมาร์กเกอร์บนแผ่นยึด ติดแผ่นโลหะที่มาพร้อมกับอุปกรณ์ส่งกระดาษกับเครื่องพิมพ์ เปิดฝาปิดอุปกรณ์เย็บเล่ม ถอดสกรูออก แล้วดึงล็อคของอุปกรณ์เย็บเล่ม ติดอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ ล็อคอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ จากนั้นติดตั้งสกรู ปิดฝาถาดรับงานพิมพ์ เชื่อมต่อสายเคเบิลของอุปกรณ์เย็บเล่มกับเครื่องพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ การติดตั้งอุปกรณ์ส่งกระดาษ การติดตั้ง อุปกรณ์ส่งกระดาษ การติดตั้งอุปกรณ์เย็บเล่ม การติดตั้ง อุปกรณ์เย็บเล่ม"},{"UUID":"6c46e2ff-0605-432b-ac41-bb11f97274da","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งอุปกรณ์เย็บเล่มและอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งอุปกรณ์เย็บเล่มและอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ นำอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับออกจากบรรจุภัณฑ์ นำถาดมาตรฐานออก อย่าทิ้งถาดดังกล่าว ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งปิด ก่อนติดตั้งตัวเลือกนี้ ใส่แฟลกของถาดทางออกไว้ในตำแหน่งเปิด ถอดลูกกลิ้งสำรองออก อย่าทิ้งลูกกลิ้งดังกล่าว ใส่ลูกกลิ้งตัวป้อนกระดาษที่มาพร้อมกับตัวเลือกเข้าไปให้มีเสียง คลิก เข้าที่ ตรวจสอบให้แน่ใจว่ามีสปริงโลหะอยู่ที่ด้านหน้าของลูกกลิ้งตัวป้อนกระดาษ ใส่ฝาครอบลูกกลิ้งให้มีเสียง คลิก เข้าที่ เปิดฝาด้านหน้า แล้วถอดฝาครอบที่ด้านซ้ายของเครื่องพิมพ์ อย่าทิ้งสกรูและฝาครอบ ปิดฝาด้านหน้า นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษออก อย่าทิ้งฝาครอบดังกล่าว ถอดฝาครอบด้านหลังซ้ายออก อย่าทิ้งสกรูและฝาครอบ ถอดฝาครอบถาดด้านในออก อย่าทิ้งสกรูและฝาครอบ จัดแนวแล้วใส่ฝาครอบถาดด้านในที่มาพร้อมกับตัวเลือก ติดตั้งสกรูเข้ากับฝาครอบถาดด้านใน ติดเทปโฟมเข้ากับตัวเลือก เปิดฝาปิด F แล้วขันสกรูให้แน่น ปิดฝาปิด F ติดแผ่นโลหะเข้ากับตัวเลือก ใส่ตัวเลือกเข้าไป ตรวจสอบให้แน่ใจว่ามีแผ่นโลหะอยู่ที่ด้านหน้าของเครื่องพิมพ์ เปิดฝาปิด F จากนั้นใช้ไขควงที่มาพร้อมกับตัวเลือกติดตั้งสกรู ปิดฝาปิด F ติดตั้งสกรูเข้ากับตัวเลือก ติดฝาครอบด้านหลังซ้าย นำอุปกรณ์เย็บเล่มออกจากบรรจุภัณฑ์ แล้วนำบรรจุภัณฑ์ทั้งหมดออก ติดแผ่นโลหะเข้ากับอุปกรณ์เย็บเล่ม ติดเทปโฟมเข้ากับอุปกรณ์เย็บเล่ม ติดแตัวนำการป้อนกระดาษเข้ากับอุปกรณ์เย็บเล่ม ติดถาดด้านบนกับอุปกรณ์เย็บเล่ม ยกแผ่นปิดถาดขึ้น จากนั้นติดถาดด้านล่างกับอุปกรณ์เย็บเล่ม เปิดฝาปิดถาดรับงานพิมพ์ นำวัสดุบรรจุภัณฑ์ออกจากกล่องอุปกรณ์ตอกรู แล้วใส่เข้าในอุปกรณ์เย็บเล่ม วางอุปกรณ์ต่อขยายถาดบนถาดของอุปกรณ์เย็บเล่ม อุปกรณ์ต่อขยายถาดใช้สำหรับกระดาษขนาด A3 หรือยาวกว่านั้น และในสภาวะที่มีความชื้นสูงเพื่อช่วยในการเรียงกระดาษ ความจุของถาดจะลดลงเมื่อมีการใช้อุปกรณ์ต่อขยายถาด ติดถาดเข้ากับด้านหลังของอุปกรณ์เย็บเล่ม ปิดฝาถาดรับงานพิมพ์ ยกแผ่นปิดถาดขึ้น จากนั้นจัดแนวให้ตรงกันและติดฝาครอบเข้ากับตัวเลือก ติดตั้งสกรู เปิดฝาด้านหน้า แล้วติดฝาครอบขอบที่มาพร้อมกับตัวเลือก ต่อแผ่นยึดเข้ากับเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าสกรูอยู่ในแนวเดียวกับรอยมาร์กเกอร์บนแผ่นยึด เปิดฝาปิดอุปกรณ์เย็บเล่ม ถอดสกรูออก แล้วดึงล็อคของอุปกรณ์เย็บเล่ม เชื่อมต่อสายเคเบิลของตัวเลือกเข้ากับเครื่องพิมพ์ เชื่อมต่อสายเคเบิลของอุปกรณ์เย็บเล่มกับตัวเลือก ติดอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ ล็อคอุปกรณ์เย็บเล่มเข้ากับเครื่องพิมพ์ จากนั้นติดตั้งสกรู ปิดฝาถาดรับงานพิมพ์ เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ ตัวเลือกฮาร์ดแวร์ อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ตัวเลือกฮาร์ดแวร์ อุปกรณ์เย็บเล่ม อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การติดตั้ง อุปกรณ์เย็บเล่ม การติดตั้ง"},{"UUID":"2dfa9f2c-a8ea-4a60-b076-d75bff446eba","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งชั้นวางแป้นพิมพ์ ปิดเครื่องพิมพ์ เปิดฝาปิด B ถอดฝาครอบด้านหน้าออก","descFull":"การติดตั้งชั้นวางแป้นพิมพ์ ปิดเครื่องพิมพ์ เปิดฝาปิด B ถอดฝาครอบด้านหน้าออก แล้วปิดฝาปิด B นำชั้นวางแป้นพิมพ์ออกจากบรรจุภัณฑ์ ใส่สายเคเบิลแป้นพิมพ์เข้าไปในชั้น พันสายเคเบิลเป็นวงภายในชั้น ถอดส่วนครอบแบบยึดติดออก จัดแนวให้ตรง แล้วติดแป้นพิมพ์เข้ากับฐาน จัดแนวชั้น เชื่อมต่อสายเคเบิลแป้นพิมพ์กับเครื่องพิมพ์ ใส่เข้าในชั้น แล้วติดเข้ากับเครื่องพิมพ์ เปิดเครื่องพิมพ์ ตัวเลือกฮาร์ดแวร์ ชั้นแป้นพิมพ์ ชั้นแป้นพิมพ์ การติดตั้ง การติดตั้งชั้นวางแป้นพิมพ์"},{"UUID":"20f300f9-2629-4a2f-8f53-a8eb1e63dd4e","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งการ์ดแฟกซ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งการ์ดแฟกซ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ เปิดฝาครอบบอร์ดตัวควบคุม ส่วนประกอบอิเล็กทรอนิกส์ของบอร์ดตัวควบคุมจะเสียหายจากไฟฟ้าสถิตได้ง่าย สัมผัสผิวโลหะของเครื่องพิมพ์ก่อนสัมผัสกับส่วนประกอบไฟฟ้าหรือขั้วต่อของบอร์ดตัวควบคุม ถอดฝาครอบพอร์ตแฟกซ์ออก อย่าทิ้งสกรูและฝาครอบ นำการ์ดแฟกซ์ออกจากบรรจุภัณฑ์ ต่อสายแฟกซ์เข้ากับบอร์ดตัวควบคุม จัดแนวแล้วติดตั้งการ์ดแฟกซ์เข้ากับเครื่องพิมพ์ ปิดฝาครอบบอร์ดตัวควบคุมให้มีเสียง คลิก เข้าที่ แล้วติดตั้งสกรู เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟไหม้หรือไฟฟ้าช็อต เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ การ์ดแฟกซ์ การติดตั้ง การติดตั้งตัวเลือกภายใน การ์ดแฟกซ์"},{"UUID":"39276014-868b-420c-a80d-2ce3998e7b96","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งตัวอ่านการ์ด เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ","descFull":"การติดตั้งตัวอ่านการ์ด เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก ปิดเครื่องพิมพ์ เปิดฝาปิด B เปิดฝาครอบพอร์ต USB ด้านหน้า ถอดฝาครอบพอร์ต USB ด้านล่าง หากเครื่องพิมพ์ของคุณไม่มีชิ้นส่วนนี้ ให้ดำเนินการในขั้นตอนถัดไป ถอดฝาครอบป้องกันออกจากตัวอ่านการ์ด ใส่ตัวอ่านการ์ด ติดฝาครอบพอร์ตด้านล่างจนมีเสียง คลิก เข้าที่ ติดตัวนำสติกเกอร์ ติดฝาครอบพอร์ต USB ด้านหน้าจนมีเสียง คลิก เข้าที่ ปิดฝา B จนมีเสียง คลิก เข้าที่ เปิดเครื่องพิมพ์ ตัวอ่านการ์ด การติดตั้ง ตัวเลือกภายใน ตัวอ่านการ์ด"},{"UUID":"456188eb-ff76-43d9-b45b-55c5092a6cae","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การติดตั้งพอร์ตโซลูชันภายใน การติดตั้งพอร์ตโซลูชันภายใน เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์","descFull":"การติดตั้งพอร์ตโซลูชันภายใน การติดตั้งพอร์ตโซลูชันภายใน เพื่อหลีกเลี่ยงความเสี่ยงต่อการถูกไฟฟ้าช็อต หากคุณต้องการเข้าถึงบอร์ดตัวควบคุมหรือติดตั้งฮาร์ดแวร์หรืออุปกรณ์หน่วยความจำเสริมในบางครั้งหลังจากติดตั้งเครื่องพิมพ์ ให้ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบก่อนดำเนินการต่อ หากคุณกำลังเชื่อมต่ออุปกรณ์อื่นๆ เข้ากับเครื่องพิมพ์ ให้ปิดอุปกรณ์เหล่านั้นด้วยและถอดสายเคเบิลที่ต่อเข้ากับเครื่องพิมพ์ออก งานนี้จำเป็นต้องใช้ไขควงหัวแบน ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ เปิดฝาครอบบอร์ดตัวควบคุม ส่วนประกอบอิเล็กทรอนิกส์ของบอร์ดตัวควบคุมจะเสียหายจากไฟฟ้าสถิตได้ง่าย สัมผัสผิวโลหะของเครื่องพิมพ์ก่อนสัมผัสกับส่วนประกอบไฟฟ้าหรือขั้วต่อของบอร์ดตัวควบคุม ถอดฝาครอบพอร์ตโซลูชันภายใน (ISP) ออก อย่าทิ้งสกรูและฝาครอบ นำชุด ISP ออกจากบรรจุภัณฑ์ อุปกรณ์ที่ให้มาของ ISP 1 ISP 2 สายต่อขยาย ISP 3 แผ่นยึด 4 สกรูบิดมือ ติดแผ่นยึดเข้ากับบอร์ดตัวควบคุมจนมีเสียง คลิก เข้าที่ ติด ISP เข้ากับแผ่นยึด จากนั้นเชื่อมต่อสายต่อขยาย ISP กับจุดเชื่อมต่อบนบอร์ดตัวควบคุม ต่อชุด ISP เข้ากับเครื่องพิมพ์อย่างแน่นหนา ปิดฝาครอบบอร์ดตัวควบคุม เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟไหม้หรือไฟฟ้าช็อต เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ พอร์ตโซลูชันภายใน การติดตั้ง ตัวเลือกการติดตั้ง พอร์ตโซลูชันภายใน"},{"UUID":"046169ea-2ae5-4d1d-bef4-464856527b8f","title":"การติดตั้งตัวเลือกฮาร์ดแวร์","link":"installing-optional-550-sheet-tray-topic.html","desc":"การเปลี่ยนการตั้งค่าพอร์ตเครื่องพิมพ์หลังจากติดตั้งพอร์ตโซลูชันภายใน หากเครื่องพิมพ์มี IP แอดเดรสคงที่ อย่าเปลี่ยนแปลงการกำหนดค่า","descFull":"การเปลี่ยนการตั้งค่าพอร์ตเครื่องพิมพ์หลังจากติดตั้งพอร์ตโซลูชันภายใน หากเครื่องพิมพ์มี IP แอดเดรสคงที่ อย่าเปลี่ยนแปลงการกำหนดค่า หากคอมพิวเตอร์ถูกกำหนดค่าให้ใช้ชื่อเครือข่ายแทน IP แอดเดรส อย่าเปลี่ยนแปลงการกำหนดค่า หากท่านกำลังเพิ่มพอร์ตโซลูชันภายในแบบไร้สาย (ISP) เข้ากับเครื่องพิมพ์ที่กำหนดค่าไว้ก่อนหน้านี้สำหรับการเชื่อมต่ออีเธอร์เน็ต ให้ยกเลิกการเชื่อมต่อเครื่องพิมพ์จากเครือข่ายอีเธอร์เน็ต สำหรับผู้ใช้ Windows เปิดโฟลเดอร์เครื่องพิมพ์ จากเมนูทางลัดของเครื่องพิมพ์ที่มี ISP ใหม่ ให้เปิดคุณสมบัติของเครื่องพิมพ์ กำหนดค่าพอร์ตจากรายการ อัปเดต IP แอดเดรส ใช้การเปลี่ยนแปลง สำหรับผู้ใช้ Macintosh จากการกำหนดค่าระบบในเมนู Apple ให้ไปที่รายการเครื่องพิมพ์ จากนั้นเลือก  + IP พิมพ์ IP แอดเดรสในช่องแอดเดรส ใช้การเปลี่ยนแปลง การตั้งค่าพอร์ตเครื่องพิมพ์ การเปลี่ยน การเปลี่ยนการตั้งค่าพอร์ตเครื่องพิมพ์หลังจากติดตั้ง ISP"},{"UUID":"cdd9f578-bb19-43d5-b616-422c12e932f3","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบดังต่อไปนี้: ตั้งให้","descFull":"การเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบดังต่อไปนี้: ตั้งให้ อะแดปเตอร์ที่ใช้งานอยู่  เป็น  อัตโนมัติ  จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต ภาพรวมเครือข่าย อะแดปเตอร์ที่ใช้งาน สายเคเบิลอีเทอร์เน็ตไม่ได้เชื่อมต่อเข้ากับเครื่องพิมพ์ การใช้แผงควบคุม จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต ไร้สาย ตั้งค่าบนแผงเครื่องพิมพ์ เลือกเครือข่าย เลือกเครือข่าย Wi-Fi แล้วพิมพ์รหัสผ่านเครือข่าย สำหรับเครื่องพิมพ์ที่รองรับความสามารถในการใช้งาน Wi-Fi ภายในตัว จะมีข้อความแจ้งให้ตั้งค่าเครือข่าย Wi-Fi ปรากฏขึ้นระหว่างการตั้งค่าครั้งแรก การเชื่อมต่อเครื่องพิมพ์กับ Wi-Fi การเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่ายไร้สาย การเชื่อมต่อเครือข่ายแบบไร้สาย"},{"UUID":"09a80f99-a737-4bc2-b2ff-b64f54bf8469","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่ายแบบไร้สายโดยใช้ Wi‑Fi Protected Setup (WPS)","descFull":"การเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่ายแบบไร้สายโดยใช้ Wi‑Fi Protected Setup (WPS) ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบดังต่อไปนี้: จุดเข้าใช้งาน (เราเตอร์แบบไร้สาย) ผ่านการรับรองจาก WPS หรือใช้ร่วมกับ WPS ได้ หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับจุดเข้าใช้งานของคุณ มีการติดตั้งอะแดปเตอร์เครือข่ายแบบไร้สายไว้ในเครื่องพิมพ์ของคุณแล้ว หากต้องการข้อมูลเพิ่มเติม โปรดดูในคำแนะนำที่ให้มาพร้อมกับอะแดปเตอร์ ตั้งให้ อะแดปเตอร์ที่ใช้งานอยู่  เป็น  อัตโนมัติ  จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต ภาพรวมเครือข่าย อะแดปเตอร์ที่ใช้งาน การใช้วิธีการกดปุ่ม จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต แบบไร้สาย Wi-Fi Protected Setup เริ่มต้นวิธีการกดปุ่ม ปฏิบัติตามคำแนะนำที่ปรากฏบนส่วนแสดงผล การใช้วิธี Personal Identification Number (PIN) จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต แบบไร้สาย Wi-Fi Protected Setup วิธีรหัส PIN เริ่มต้น คัดลอกรหัส WPS PIN แปดหลัก เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของจุดเข้าใช้งานในช่องแอดเดรส หากต้องการรู้ IP แอดเดรส โปรดดูในเอกสารที่ให้มาพร้อมกับจุดเข้าใช้งานของคุณ หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง เข้าใช้การตั้งค่า WPS หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับจุดเข้าใช้งานของคุณ ป้อนรหัส PIN แปดหลักและบันทึกการเปลี่ยนแปลง Wi‑Fi Protected Setup เครือข่ายแบบไร้สาย เครือข่ายแบบไร้สาย Wi‑Fi Protected Setup การเชื่อมต่อกับเครือข่ายไร้สาย การใช้วิธีรหัส PIN การเชื่อมต่อกับเครือข่ายไร้สาย การใช้วิธีการกดปุ่ม"},{"UUID":"c2499f85-1853-4a45-92e6-fdb177a71099","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การกำหนดค่า Wi-Fi Direct Wi-Fi Direct","descFull":"การกำหนดค่า Wi-Fi Direct Wi-Fi Direct  จะเปิดใช้งานอุปกรณ์ Wi-Fi เพื่อเชื่อมต่อกับอุปกรณ์ Wi-Fi อื่นโดยตรงโดยไม่ต้องใช้จุดเข้าใช้งาน (เราเตอร์แบบไร้สาย) จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต Wi-Fi Direct กำหนดค่าการตั้งค่า เปิดใช้งาน Wi-Fi Direct —ให้เครื่องพิมพ์สามารถเผยแพร่เครือข่าย Wi‑Fi Direct ของเครื่องพิมพ์ได้ ชื่อ Wi-Fi Direct —กำหนดชื่อให้กับเครือข่าย Wi-Fi Direct รหัสผ่าน Wi-Fi Direct —กำหนดรหัสผ่านสำหรับการตรวจสอบการรักษาความปลอดภัยแบบไร้สายเมื่อใช้การเชื่อมต่อแบบ peer‑to-peer แสดงรหัสผ่านในหน้าการตั้งค่า —แสดงรหัสผ่านในหน้าการตั้งค่าเครือข่าย หมายเลขช่องที่ต้องการ —กำหนดช่องที่ต้องการของเครือข่าย Wi‑Fi Direct IP แอดเดรสของเจ้าของกลุ่ม —กำหนด IP แอดเดรสของเจ้าของกลุ่ม ยอมรับการร้องขอปุ่มกดโดยอัตโนมัติ —ให้เครื่องพิมพ์ยอมรับการร้องขอการเชื่อมต่อโดยอัตโนมัติ การยอมรับคำขอปุ่มกดโดยอัตโนมัตินั้นไม่ปลอดภัย ตามค่าเริ่มต้น จะไม่แสดงรหัสผ่านเครือข่าย Wi-Fi Direct บนส่วนแสดงผลเครื่องพิมพ์ เพื่อแสดงรหัสผ่านให้ เปิดใช้งานไอคอนเปิดดูรหัสผ่าน ให้ไปที่แผงควบคุม แล้วไปที่  การตั้งค่า การรักษาความปลอดภัย อื่นๆ เปิดใช้งานมองเห็นรหัสผ่าน/รหัส PIN หากต้องการทราบรหัสผ่านของเครือข่าย Wi-Fi Direct โดยไม่แสดงบนส่วนแสดงผลของเครื่องพิมพ์ ให้พิมพ์  หน้าการตั้งค่าเครือข่าย  จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เครือข่าย หน้าการตั้งค่าเครือข่าย Wi-Fi Direct การกำหนดค่า การกำหนดค่า Wi-Fi Direct"},{"UUID":"04e17c64-5175-4e30-bada-6f1432c0c9b7","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การเชื่อมต่ออุปกรณ์มือถือกับเครื่องพิมพ์ ก่อนเชื่อมต่ออุปกรณ์มือถือของคุณ โปรดตรวจสอบว่าได้มีการกำหนดค่า Wi-Fi Direct","descFull":"การเชื่อมต่ออุปกรณ์มือถือกับเครื่องพิมพ์ ก่อนเชื่อมต่ออุปกรณ์มือถือของคุณ โปรดตรวจสอบว่าได้มีการกำหนดค่า Wi-Fi Direct แล้ว โปรดดูข้อมูลเพิ่มเติมที่  การใช้ Wi-Fi Direct คำแนะนำเหล่านี้ใช้ได้กับอุปกรณ์มือถือที่ใช้แพลตฟอร์ม  Android  เท่านั้น จากอุปกรณ์มือถือ ให้ไปที่เมนู การตั้งค่า เปิดใช้งาน  Wi‑Fi  แล้วแตะ  Wi-Fi Direct เลือกชื่อ Wi-Fi Direct ของเครื่องพิมพ์ ยืนยันการเชื่อมต่อบนแผงควบคุมเครื่องพิมพ์ การใช้ Wi-Fi จากอุปกรณ์มือถือ ให้ไปที่เมนู การตั้งค่า แตะ  Wi-Fi  แล้วเลือกชื่อ Wi-Fi Direct ของเครื่องพิมพ์ สตริง DIRECT-xy (ที่ x และ y เป็นอักขระแบบสุ่มสองตัว) จะเพิ่มไว้ก่อนชื่อ Wi-Fi Direct ป้อนรหัสผ่าน Wi-Fi Direct การเชื่อมต่ออุปกรณ์มือถือ ไปยังเครื่องพิมพ์ การเชื่อมต่อกับเครื่องพิมพ์ การใช้ Wi-Fi Direct"},{"UUID":"ab7f95dc-0e5f-4ff4-a430-51d8dda34a6e","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi Direct การเชื่อมต่อคอมพิวเตอร์เข้ากับเครื่องพิมพ์ ก่อนเชื่อมต่อคอมพิวเตอร์ของคุณ โปรดตรวจสอบว่าได้มีการกำหนดค่า","descFull":"Wi-Fi Direct การเชื่อมต่อคอมพิวเตอร์เข้ากับเครื่องพิมพ์ ก่อนเชื่อมต่อคอมพิวเตอร์ของคุณ โปรดตรวจสอบว่าได้มีการกำหนดค่า Wi-Fi Direct แล้ว โปรดดูข้อมูลเพิ่มเติมที่  สำหรับผู้ใช้ Windows เปิด  เครื่องพิมพ์และสแกนเนอร์  แล้วคลิก  เพิ่มเครื่องพิมพ์หรือสแกนเนอร์ คลิก  แสดงเครื่องพิมพ์ Wi-Fi Direct  แล้วเลือกชื่อ Wi-Fi Direct ของเครื่องพิมพ์ จากส่วนแสดงผลของเครื่องพิมพ์ ให้จดบันทึกรหัส PIN 8 หลักของเครื่องพิมพ์ไว้ ป้อนรหัส PIN ในคอมพิวเตอร์ หากยังไม่ได้ติดตั้งไดรเวอร์การพิมพ์ Windows จะดาวน์โหลดไดรเวอร์ที่เหมาะสม สำหรับผู้ใช้ Macintosh คลิกไอคอนไร้สายแล้วเลือกชื่อ Wi-Fi Direct ของเครื่องพิมพ์ สตริง DIRECT-xy (ที่ x และ y เป็นอักขระแบบสุ่มสองตัว) จะเพิ่มไว้ก่อนชื่อ Wi-Fi Direct พิมพ์รหัสผ่าน Wi-Fi Direct สลับคอมพิวเตอร์ของคุณกลับไปยังเครือข่ายก่อนหน้าหลังจากยกเลิกการเชื่อมต่อจากเครือข่าย Wi-Fi Direct การเชื่อมต่อคอมพิวเตอร์เข้ากับเครื่องพิมพ์"},{"UUID":"65f14032-668d-48db-ac51-52463480d146","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การปิดใช้งานเครือข่าย Wi-Fi จากแผงควบคุม ไปที่ ","descFull":"การปิดใช้งานเครือข่าย Wi-Fi จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต ภาพรวมเครือข่าย อะแดปเตอร์ที่ใช้งาน เครือข่ายมาตรฐาน เลือก  ใช่  เพื่อรีสตาร์ทเครื่องพิมพ์ เครือข่าย Wi‑Fi การปิดใช้งาน การปิดใช้งานเครือข่าย Wi-Fi"},{"UUID":"03c79ac0-0e9f-4fc1-8178-d90afa449693","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การตรวจสอบการเชื่อมต่อเครื่องพิมพ์ การตรวจสอบการเชื่อมต่อเครื่องพิมพ์ จากแผงควบคุม ไปที่ ","descFull":"การตรวจสอบการเชื่อมต่อเครื่องพิมพ์ การตรวจสอบการเชื่อมต่อเครื่องพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เครือข่าย หน้าการตั้งค่าเครือข่าย ตรวจสอบส่วนแรกของหน้าและยืนยันว่าสถานะเป็นเชื่อมต่อแล้ว หากสถานะยังเป็นไม่ได้เชื่อมต่อ จุดเชื่อมต่อ LAN อาจไม่ทำงาน หรือสายเคเบิลเครือข่ายอาจทำงานผิดปกติ ติดต่อผู้ดูแลระบบของคุณเพื่อขอความช่วยเหลือ การตรวจสอบการเชื่อมต่อเครือข่าย การเชื่อมต่อเครื่องพิมพ์กับเครือข่าย การตรวจสอบ"},{"UUID":"f52e0cde-f287-41ee-9998-e2aa65c7bdfe","title":"การเชื่อมต่อเครือข่าย","link":"connecting-printer-to-wireless-network-topic.html","desc":"การตั้งค่าการพิมพ์แบบต่อเนื่อง (Windows เท่านั้น) ตั้งค่าพารามิเตอร์ในเครื่องพิมพ์ จากแผงควบคุม","descFull":"การตั้งค่าการพิมพ์แบบต่อเนื่อง (Windows เท่านั้น) ตั้งค่าพารามิเตอร์ในเครื่องพิมพ์ จากแผงควบคุม ให้ไปที่เมนูสำหรับการตั้งค่าพอร์ต ค้นหาเมนูสำหรับการตั้งค่าพอร์ตอนุกรมแล้วปรับการตั้งค่าหากจำเป็น ใช้การเปลี่ยนแปลง จากคอมพิวเตอร์ของคุณ ให้เปิดโฟลเดอร์เครื่องพิมพ์แล้วเลือกเครื่องพิมพ์ของคุณ เปิดคุณสมบัติเครื่องพิมพ์แล้วเลือกพอร์ต COM จากรายการ ตั้งค่าพารามิเตอร์พอร์ต COM ใน Device Manager การพิมพ์แบบอนุกรมจะลดความเร็วในการพิมพ์ ตรวจสอบให้แน่ใจว่าสายเคเบิลอนุกรมเชื่อมต่อกับพอร์ตอนุกรมที่เครื่องพิมพ์ของคุณ การตั้งค่าการพิมพ์จากพอร์ตอนุกรม การพิมพ์จากพอร์ตอนุกรม การตั้งค่า"},{"UUID":"bb6f4149-f9a0-4bc0-ba9b-648c166172a2","title":"รักษาความปลอดภัยของเครื่องพิมพ์","link":"erasing-printer-memory-topic.html","desc":"การลบหน่วยความจำเครื่องพิมพ์ ในการลบหน่วยความจำชั่วคราวหรือข้อมูลบัฟเฟอร์ในเครื่องพิมพ์ของคุณ ให้ปิดเครื่องพิมพ์ ในการลบหน่วยความจำถาวร การตั้งค่าอุปกรณ์และการตั้งค่าเครือข่าย","descFull":"การลบหน่วยความจำเครื่องพิมพ์ ในการลบหน่วยความจำชั่วคราวหรือข้อมูลบัฟเฟอร์ในเครื่องพิมพ์ของคุณ ให้ปิดเครื่องพิมพ์ ในการลบหน่วยความจำถาวร การตั้งค่าอุปกรณ์และการตั้งค่าเครือข่าย การตั้งค่าการรักษาความปลอดภัย และ Embedded solutions ให้ดำเนินการดังนี้: จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา การลบข้อมูลไม่สามารถใช้งานได้ . เลือก ทำความสะอาดข้อมูลหน่วยความจำถาวรทั้งหมด แล้วเลือก ลบ เลือก เริ่มตัวช่วยตั้งค่าเริ่มต้น หรือ ให้เครื่องพิมพ์ทำงานแบบออฟไลน์ แล้วเลือก ถัดไป เริ่มต้นกระบวนการ กระบวนการนี้ยังทำลายคีย์การเข้ารหัสที่ใช้ในการปกป้องข้อมูลผู้ใช้อีกด้วย การทำลายคีย์การเข้ารหัสจะทำให้ไม่สามารถกู้ข้อมูลกลับคืนได้ หน่วยความจำแบบลบเลือนได้ การลบ หน่วยความจำถาวร การลบ หน่วยความจำของเครื่องพิมพ์ การลบ การลบ หน่วยความจำของเครื่องพิมพ์ การลบ หน่วยความจำแบบลบเลือนได้ การลบ หน่วยความจำถาวร"},{"UUID":"b17b9639-b49f-4eb5-9541-061f8283e96b","title":"รักษาความปลอดภัยของเครื่องพิมพ์","link":"erasing-printer-storage-drive-topic.html","desc":"การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์ การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์ จากแผงควบคุม ไปที่ ","descFull":"การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์ การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา การลบข้อมูลไม่สามารถใช้งานได้ . ดำเนินการต่อไปนี้ โดยขึ้นอยู่กับไดรฟ์จัดเก็บข้อมูลที่ติดตั้งบนเครื่องพิมพ์ของคุณ: สำหรับฮาร์ดดิสก์ เลือก ทำความสะอาดข้อมูลทั้งหมดบนฮาร์ดดิสก์  เลือก ลบ  แล้วเลือกวิธีการลบข้อมูล กระบวนการทำความสะอาดฮาร์ดดิสก์อาจใช้เวลาตั้งแต่หลายนาทีจนถึงมากกว่าหนึ่งชั่วโมง ซึ่งทำให้เครื่องพิมพ์ไม่สามารถทำงานอื่นๆ ได้ สำหรับไดรฟ์จัดเก็บข้อมูลอัจฉริยะ เลือก ลบข้อมูลผู้ใช้ทั้งหมดบน ISD แบบเข้ารหัส  แล้วเลือก  ลบ ไดรฟ์จัดเก็บข้อมูล การลบ ฮาร์ดดิสก์ การลบ ไดรฟ์จัดเก็บข้อมูลอัจฉริยะ การลบ การลบ ไดรฟ์จัดเก็บข้อมูล การลบ ฮาร์ดดิสก์ การลบ ไดรฟ์จัดเก็บข้อมูลอัจฉริยะ"},{"UUID":"ecc3806e-049f-4d19-806e-2ea5f78d3325","title":"รักษาความปลอดภัยของเครื่องพิมพ์","link":"restoring-factory-default-settings-topic.html","desc":"การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ คืนค่าเริ่มต้นจากโรงงาน เลือก  คืนค่าการตั้งค่า เลือกการตั้งค่าที่คุณต้องการคืนค่า แล้วเลือก  คืนค่า ค่ามาตรฐานที่กำหนดมาจากโรงงาน การคืนค่า การตั้งค่าเครื่องพิมพ์ การคืนค่าเริ่มต้นจากโรงงาน"},{"UUID":"982d22ab-478d-468d-bef9-e13cc3f01d44","title":"รักษาความปลอดภัยของเครื่องพิมพ์","link":"statement-of-volatility-topic.html","desc":"คำประกาศเกี่ยวกับความถาวรของข้อมูล คำประกาศเกี่ยวกับความถาวรของข้อมูล ประเภทของหน่วยความจำและคำอธิบาย ประเภทของหน่วยความจำ คำอธิบาย","descFull":"คำประกาศเกี่ยวกับความถาวรของข้อมูล คำประกาศเกี่ยวกับความถาวรของข้อมูล ประเภทของหน่วยความจำและคำอธิบาย ประเภทของหน่วยความจำ คำอธิบาย หน่วยความจำแบบลบเลือนได้ เครื่องพิมพ์จะใช้ Random Access Memory (RAM) มาตรฐานเพื่อบัฟเฟอร์ข้อมูลผู้ใช้ชั่วคราวระหว่างงานพิมพ์ปกติและงานทำสำเนา หน่วยความจำถาวร เครื่องพิมพ์อาจใช้หน่วยความจำถาวร 2 รูปแบบ: EEPROM และ NAND (หน่วยความจำแฟลช) หน่วยความจำทั้งสองประเภทใช้สำหรับจัดเก็บระบบปฏิบัติการ การตั้งค่าเครื่องพิมพ์ และข้อมูลเครือข่าย และยังจัดเก็บการตั้งค่าของสแกนเนอร์และบุ๊คมาร์ค รวมถึง Embedded Solutions อีกด้วย ไดรฟ์จัดเก็บข้อมูลของฮาร์ดดิสก์ เครื่องพิมพ์บางรุ่นอาจมีไดรฟ์ฮาร์ดดิสก์ ฮาร์ดดิสก์ของเครื่องพิมพ์ถูกออกแบบมาเพื่อการใช้งานสำหรับเครื่องพิมพ์โดยเฉพาะ ฮาร์ดดิสก์ช่วยให้เครื่องพิมพ์สามารถเก็บข้อมูลผู้ใช้ที่บัฟเฟอร์ไว้จากงานพิมพ์ที่มีความซับซ้อน ข้อมูลฟอร์ม และข้อมูลฟอนต์ ไดรฟ์จัดเก็บข้อมูลอัจฉริยะ (ISD) เครื่องพิมพ์บางรุ่นอาจมี ISD ติดตั้งอยู่ ISD ช่วยให้หน่วยความจำแฟลชแบบถาวรสามารถเก็บข้อมูลผู้ใช้จากงานพิมพ์ที่มีความซับซ้อน ข้อมูลฟอร์ม และข้อมูลฟอนต์ ให้ลบเนื้อหาในหน่วยความจำของเครื่องพิมพ์ที่ติดตั้งไว้ในกรณีต่อไปนี้: เครื่องพิมพ์ถูกเลิกใช้งาน ฮาร์ดดิสก์หรือ ISD ของเครื่องพิมพ์ถูกเปลี่ยน เครื่องพิมพ์ถูกย้ายไปยังแผนกอื่นหรือสถานที่อื่น เครื่องพิมพ์กำลังรับบริการจากบุคคลภายนอกองค์กรของคุณ เครื่องพิมพ์ถูกนำออกจากสถานที่ของคุณเพื่อรับบริการ เครื่องพิมพ์ถูกขายให้กับองค์กรอื่น หากต้องการกำจัดไดรฟ์จัดเก็บข้อมูล ให้ปฏิบัติตามนโยบายและขั้นตอนดำเนินการต่างๆ ขององค์กร คำประกาศเกี่ยวกับความถาวรของข้อมูล หน่วยความจำแบบลบเลือนได้ หน่วยความจำถาวร ไดรฟ์จัดเก็บข้อมูลของฮาร์ดดิสก์ ไดรฟ์จัดเก็บข้อมูลอัจฉริยะ การลบหน่วยความจำเครื่องพิมพ์ การรักษาความปลอดภัยข้อมูลเครื่องพิมพ์"},{"UUID":"83c81d4a-0078-4640-bccf-9af1b37b36e2","title":"พิมพ์","link":"printing-from-computer-topic.html","desc":"การพิมพ์จากคอมพิวเตอร์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก","descFull":"การพิมพ์จากคอมพิวเตอร์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า หากจำเป็น ให้ปรับการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้เลือก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ แล้วเลือกการตั้งค่าจาก ค่าที่กำหนดไว้ล่วงหน้า หากจำเป็น ให้ปรับการตั้งค่า คลิกที่  พิมพ์ การพิมพ์ จากคอมพิวเตอร์ เอกสาร, การพิมพ์ จากคอมพิวเตอร์"},{"UUID":"1d18c63c-9679-4aac-9c72-dd8c962b7828","title":"การพิมพ์จากอุปกรณ์มือถือ","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ Lexmark Print Lexmark ","descFull":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ Lexmark Print Lexmark  Print คือโซลูชันการพิมพ์งานผ่านอุปกรณ์มือถือที่ใช้แพลตฟอร์ม  Android  เวอร์ชัน 6.0 หรือใหม่กว่า ช่วยให้คุณสามารถส่งเอกสารและรูปภาพไปยังเครื่องพิมพ์ที่เชื่อมต่อกับเครือข่ายและเซิร์ฟเวอร์การจัดการการพิมพ์ ตรวจสอบว่าคุณดาวน์โหลดแอป Lexmark Print จาก  Google Play  Store และเปิดใช้งานในอุปกรณ์มือถือ ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์และอุปกรณ์มือถือเชื่อมต่อกับเครือข่ายเดียวกัน จากอุปกรณ์มือถือ ให้เลือกเอกสารจากตัวจัดการไฟล์ ส่งหรือแบ่งปันเอกสารไปยัง Lexmark Print แอปของบุคคลภายนอกบางแอปอาจไม่รองรับคุณสมบัติส่งหรือแชร์ หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับแอป เลือกเครื่องพิมพ์ หากจำเป็น ให้ปรับการตั้งค่า พิมพ์เอกสาร Lexmark Print การใช้ การพิมพ์เอกสาร จากอุปกรณ์มือถือ อุปกรณ์มือถือ การพิมพ์จาก"},{"UUID":"72cea525-3aba-4c76-9fe3-d7084df0ae46","title":"การพิมพ์จากอุปกรณ์มือถือ","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"การพิมพ์จากอุปกรณ์มือถือโดยใช้บริการงานพิมพ์ Mopria™ บริการงานพิมพ์ Mopria คือโซลูชันการพิมพ์งานผ่านอุปกรณ์แบบพกพาที่ใช้","descFull":"การพิมพ์จากอุปกรณ์มือถือโดยใช้บริการงานพิมพ์ Mopria™ บริการงานพิมพ์ Mopria คือโซลูชันการพิมพ์งานผ่านอุปกรณ์แบบพกพาที่ใช้  Android  เวอร์ชัน 5.0 หรือใหม่กว่า ซึ่งให้คุณพิมพ์ไปยังเครื่องพิมพ์ที่ผ่านการรับรอง Mopria™ ได้โดยตรง ตรวจสอบว่าคุณดาวน์โหลดแอปพลิเคชัน Mopria Print Service จาก  Google Play  Store และเปิดใช้งานในอุปกรณ์มือถือ จากอุปกรณ์มือถือ ให้เปิดแอปพลิเคชันที่ใช้งานร่วมกันได้ หรือเลือกเอกสารจากตัวจัดการไฟล์ แตะ  พิมพ์ เลือกเครื่องพิมพ์ แล้วปรับการตั้งค่าหากจำเป็น แตะ  บริการงานพิมพ์ Mopria การพิมพ์ จากอุปกรณ์มือถือ อุปกรณ์มือถือ การพิมพ์จาก การพิมพ์ การใช้บริการงานพิมพ์ Mopria"},{"UUID":"c0829767-057d-4565-a199-e8e0ae8f75d8","title":"การพิมพ์จากอุปกรณ์มือถือ","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ AirPrint คุณสมบัติของซอฟต์แวร์ AirPrint คือการพิมพ์งานผ่านอุปกรณ์แบบพกพาที่ให้คุณพิมพ์โดยตรงจากอุปกรณ์","descFull":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ AirPrint คุณสมบัติของซอฟต์แวร์ AirPrint คือการพิมพ์งานผ่านอุปกรณ์แบบพกพาที่ให้คุณพิมพ์โดยตรงจากอุปกรณ์ Apple ไปยังเครื่องพิมพ์ที่รองรับ AirPrint ตรวจสอบให้แน่ใจว่าอุปกรณ์ Apple และเครื่องพิมพ์เชื่อมต่ออยู่กับเครือข่ายเดียวกัน หากเครือข่ายมีฮับไร้สายหลายฮับ ให้ตรวจสอบให้แน่ใจว่าอุปกรณ์ทั้งสองเครื่องเชื่อมต่อกับซับเน็ตเดียวกัน แอปพลิเคชันนี้รองรับเฉพาะในอุปกรณ์ Apple บางรุ่นเท่านั้น จากอุปกรณ์เคลื่อนที่ของคุณ ให้เลือกเอกสารจากตัวจัดการไฟล์หรือเปิดแอปพลิเคชันที่เข้ากันได้ แตะ  พิมพ์ เลือกเครื่องพิมพ์ แล้วปรับการตั้งค่าหากจำเป็น พิมพ์เอกสาร การใช้ AirPrint การพิมพ์ จากอุปกรณ์มือถือ อุปกรณ์มือถือ การพิมพ์จาก"},{"UUID":"0ead72e0-1487-45b7-9087-d53317850e92","title":"การพิมพ์จากอุปกรณ์มือถือ","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ Wi-Fi Direct ® Wi‑Fi","descFull":"การพิมพ์จากอุปกรณ์มือถือโดยใช้ Wi-Fi Direct ® Wi‑Fi Direct  คือบริการการพิมพ์ที่ให้คุณพิมพ์ไปยังเครื่องพิมพ์ที่รองรับ Wi-Fi Direct ตรวจสอบให้แน่ใจว่าอุปกรณ์เคลื่อนที่เชื่อมต่อกับเครือข่ายไร้สายของเครื่องพิมพ์แล้ว โปรดดูข้อมูลเพิ่มเติมที่  จากอุปกรณ์มือถือให้เปิดแอปพลิเคชันที่ใช้งานร่วมกันได้ หรือเลือกเอกสารจากตัวจัดการไฟล์ของคุณ ทั้งนี้ขึ้นอยู่กับอุปกรณ์เคลื่อนที่ของคุณ ให้ดำเนินการข้อใดข้อหนึ่งต่อไปนี้: แตะ  พิมพ์ แตะ  พิมพ์ แตะ  พิมพ์ เลือกเครื่องพิมพ์ แล้วปรับการตั้งค่าหากจำเป็น พิมพ์เอกสาร Wi-Fi Direct การพิมพ์จากอุปกรณ์มือถือ การพิมพ์ จากอุปกรณ์มือถือ อุปกรณ์มือถือ การพิมพ์จาก การพิมพ์ การใช้ Wi-Fi Direct"},{"UUID":"684b9574-affe-4292-a5e8-3434eac3617f","title":"พิมพ์","link":"printing-from-flash-drive-topic.html","desc":"การพิมพ์จากแฟลชไดรฟ์ เสียบแฟลชไดรฟ์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับแฟลชไดรฟ์ที่รองรับ โปรดดูที่ ","descFull":"การพิมพ์จากแฟลชไดรฟ์ เสียบแฟลชไดรฟ์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับแฟลชไดรฟ์ที่รองรับ โปรดดูที่  หากเสียบแฟลชไดร์ฟขณะที่ข้อความแสดงข้อผิดพลาดปรากฏขึ้น เครื่องพิมพ์จะไม่สนใจแฟลชไดร์ฟ หากเสียบแฟลชไดร์ฟขณะที่เครื่องพิมพ์กำลังประมวลผลงานพิมพ์อื่นๆ จะแสดงคำว่า  ไม่ว่าง  บนส่วนแสดงผล จากแผงควบคุม เลือก  พิมพ์ เลือก  ไดรฟ์ USB  แล้วเลือกเอกสารที่คุณต้องการพิมพ์ หากจำเป็น ให้กำหนดค่าการตั้งค่า พิมพ์เอกสาร เพื่อป้องกันข้อมูลหรือเครื่องพิมพ์ทำงานผิดพลาด อย่าสัมผัสแฟลชไดร์ฟหรือเครื่องพิมพ์ในบริเวณที่แสดงไว้ในภาพขณะกำลังพิมพ์งาน อ่านข้อมูล หรือเขียนข้อมูลจากอุปกรณ์หน่วยความจำ การพิมพ์ จากแฟลชไดรฟ์ แฟลชไดรฟ์ การพิมพ์จาก"},{"UUID":"d5c4d783-53c6-48f1-97ef-2f3c5a5b09b2","title":"พิมพ์","link":"configuring-confidential-jobs-topic.html","desc":"การกำหนดค่างานลับ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การกำหนดค่างานลับ จากแผงควบคุม ไปที่  การตั้งค่า การรักษาความปลอดภัย การตั้งค่างานพิมพ์เอกสารที่เป็นความลับ กำหนดค่าการตั้งค่า รายการเมนูและคำอธิบาย  การตั้งค่าการพิมพ์ข้อมูลที่เป็นความลับ การตั้งค่า คำอธิบาย รหัส PIN ไม่ถูกต้องจำนวนสูงสุด ตั้งขีดจำกัดสำหรับการป้อน PIN ไม่่ถูกต้อง เมื่อถึงขีดจำกัด งานพิมพ์สำหรับชื่อผู้ใช้นั้นจะถูกลบออก การหมดอายุของงานลับ กำหนดเวลาหมดอายุของแต่ละรายการสำหรับงานที่ระงับไว้ก่อนที่จะถูกลบออกจากหน่วยความจำของเครื่องพิมพ์ ฮาร์ดดิสก์หรือไดรฟ์จัดเก็บข้อมูลอัจฉริยะ งานที่ระงับไว้เป็น  เป็นความลับ ,  ทำซ้ำ ,  สำรอง  หรือ  ตรวจสอบงาน ทำซ้ำการหมดอายุของงาน ตั้งเวลาหมดอายุสำหรับงานพิมพ์ที่คุณต้องการทำซ้ำ ตรวจสอบการหมดอายุของงาน ตั้งค่าเวลาหมดอายุสำหรับการพิมพ์สำเนาของงานเพื่อให้คุณตรวจสอบคุณภาพก่อนพิมพ์สำเนาที่เหลือ กำหนดการหมดอายุของงาน ตั้งเวลาหมดอายุสำหรับงานที่คุณต้องการจัดเก็บไว้ในเครื่องพิมพ์เพื่อพิมพ์ในภายหลัง จำเป็นต้องระงับงานทั้งหมด ตั้งเครื่องพิมพ์ให้ระงับงานพิมพ์ทั้งหมด เก็บเอกสารที่ซ้ำกัน ตั้งให้เครื่องพิมพ์เก็บรักษาเอกสารทั้งหมดที่มีชื่อไฟล์เหมือนกันไว้ งานพิมพ์เอกสารที่เป็นความลับ การกำหนดค่า งานที่ระงับไว้ การกำหนดค่า การจัดเก็บงานพิมพ์ การระงับงานพิมพ์"},{"UUID":"90bbd078-d54f-49e9-954b-ee2f818b443c","title":"พิมพ์","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก","descFull":"การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  พิมพ์และระงับ คลิก  ใช้พิมพ์และระงับ  แล้วกำหนดชื่อผู้ใช้ เลือกจากประเภทงานพิมพ์ใด ๆ ต่อไปนี้: งานพิมพ์เอกสารที่เป็นความลับ —เครื่องพิมพ์จะขอ Personal Identification Number ก่อนจึงจะอนุญาตการพิมพ์ หากคุณเลือกประเภทงานนี้ โปรดป้อน Personal Identification Number (PIN) ที่เป็นตัวเลขสี่หลัก ตรวจสอบการพิมพ์ —เครื่องพิมพ์จะพิมพ์สำเนาจำนวนหนึ่งฉบับ และระงับสำเนาฉบับที่เหลือซึ่งคุณร้องขอจากไดรเวอร์ในหน่วยความจำเครื่องพิมพ์ สำรองการพิมพ์ —เครื่องพิมพ์จัดเก็บงานไว้ในหน่วยความจำเพื่อให้คุณสามารถพิมพ์งานนี้ได้ในภายหลัง ทำซ้ำการพิมพ์ —เครื่องพิมพ์พิมพ์สำเนางานที่ร้องขอทั้งหมด และจัดเก็บงานไว้ในหน่วยความจำเพื่อให้คุณสามารถพิมพ์สำเนาฉบับเพิ่มเติมในภายหลัง คลิก  ตกลง คลิกที่  พิมพ์ จากแผงควบคุมเครื่องพิมพ์ ให้ปล่อยงานพิมพ์ เลือก  พิมพ์ เลือก  งานที่ระงับไว้  แล้วเลือกชื่อผู้ใช้ของคุณ สำหรับงานพิมพ์เอกสารที่เป็นความลับ เลือก  เอกสารที่เป็นความลับ  ป้อน PIN แล้วเลือก  ตกลง เลือกงานพิมพ์ แล้วเลือก  พิมพ์ สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้เลือก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนูดรอปดาวน์  การรักษาความปลอดภัยของงานพิมพ์  เปิดใช้งาน  พิมพ์ด้วย PIN  แล้วป้อน PIN ที่เป็นตัวเลขสี่หลัก คลิกที่  พิมพ์ จากแผงควบคุมเครื่องพิมพ์ ให้ปล่อยงานพิมพ์ เลือก  งานที่ระงับไว้  แล้วเลือกชื่อคอมพิวเตอร์ เลือก  เป็นความลับ  แล้วป้อน PIN เลือกงานพิมพ์ แล้วเลือก  พิมพ์ การพิมพ์ งานที่ระงับไว้ การพิมพ์ งานพิมพ์เอกสารที่เป็นความลับ งานพิมพ์เอกสารที่เป็นความลับ การพิมพ์ งานที่ระงับไว้ การพิมพ์"},{"UUID":"a639c923-dec8-41c1-9c43-b7b5c378dcdf","title":"พิมพ์","link":"printing-font-sample-list-topic.html","desc":"การพิมพ์รายการตัวอย่างฟอนต์ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การพิมพ์รายการตัวอย่างฟอนต์ จากแผงควบคุม ไปที่  การตั้งค่า  รายงาน พิมพ์ พิมพ์ฟอนต์ เลือกประเภทฟอนต์ การพิมพ์ รายการตัวอย่างฟอนต์ รายการตัวอย่างฟอนต์ การพิมพ์"},{"UUID":"b44d7154-f832-4ca8-b37f-b14dc66c1376","title":"พิมพ์","link":"printing-directory-list-topic.html","desc":"การพิมพ์รายการไดเรกทอรี่ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การพิมพ์รายการไดเรกทอรี่ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน พิมพ์ เลือก  ไดเรกทอรี่การพิมพ์ การพิมพ์ รายการไดเรกทอรี่ รายการไดเรกทอรี่ การพิมพ์"},{"UUID":"7f7a7dc6-c092-4caf-8a9f-d3b9bf74e083","title":"พิมพ์","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"การใส่แผ่นคั่นในงานพิมพ์ เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์","descFull":"การใส่แผ่นคั่นในงานพิมพ์ เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  กระดาษ/การเย็บเล่ม . ในเมนู  แผ่นคั่น  เลือกการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . แผ่นคั่น การวาง การใส่แผ่นคั่น"},{"UUID":"2b203f54-5376-401a-aada-51d1387eb98c","title":"พิมพ์","link":"canceling-print-job-topic.html","desc":"การยกเลิกงานพิมพ์ จากแผงควบคุม เลือก  คิวงาน","descFull":"การยกเลิกงานพิมพ์ จากแผงควบคุม เลือก  คิวงาน เลือก  พิมพ์  แล้วเลือกงานที่จะยกเลิก หากเอกสารกำลังอยู่ในระหว่างการพิมพ์ ให้เลือก  ยกเลิกงาน  ในมุมขวาล่างของส่วนแสดงผลเพื่อหยุดการพิมพ์ งานพิมพ์ การยกเลิก การยกเลิกงานที่สั่งพิมพ์"},{"UUID":"815bea0e-08c5-4d73-80e3-8f326c6c559c","title":"พิมพ์","link":"adjusting-toner-darkness-topic.html","desc":"การปรับความเข้มของหมึก จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การปรับความเข้มของหมึก จากแผงควบคุม ไปที่  การตั้งค่า คุณภาพ การพิมพ์ ปรับการตั้งค่าสำหรับ  ความเข้มของหมึก ความเข้มของหมึก การปรับ การปรับความเข้มของหมึก"},{"UUID":"c05bdb3c-feda-4cd7-9b60-0533bbb00375","title":"ทำสำเนา","link":"making-copies-topic.html","desc":"การทำสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เพื่อหลีกเลี่ยงรูปภาพถูกตัด","descFull":"การทำสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เพื่อหลีกเลี่ยงรูปภาพถูกตัด ตรวจสอบให้แน่ใจว่าเอกสารต้นฉบับและงานพิมพ์มีขนาดกระดาษเท่ากัน จากแผงควบคุม ให้เลือก  ทำสำเนา  แล้วระบุจำนวนสำเนา หากจำเป็น ให้ปรับการตั้งค่าการทำสำเนา ทำสำเนาเอกสาร การทำสำเนา การทำสำเนา เอกสาร การทำสำเนา การใช้ ADF การทำสำเนา การใช้กระจกสแกนเนอร์"},{"UUID":"497ffff7-bc88-4dde-b2fd-56e5c139cb39","title":"ทำสำเนา","link":"copying-photos-topic.html","desc":"การทำสำเนาภาพถ่าย การทำสำเนาภาพถ่าย วางภาพถ่ายลงบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่","descFull":"การทำสำเนาภาพถ่าย การทำสำเนาภาพถ่าย วางภาพถ่ายลงบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม เนื้อหา ประเภทเนื้อหา ภาพถ่าย เลือก  แหล่งเนื้อหา  แล้วเลือกการตั้งค่าที่ตรงกับภาพถ่ายต้นฉบับมากที่สุด ทำสำเนาภาพถ่าย การทำสำเนา ภาพถ่าย ภาพถ่าย, การทำสำเนา"},{"UUID":"4eac7cdf-99ec-4333-9de8-d9a026c54937","title":"ทำสำเนา","link":"copying-on-letterhead-topic.html","desc":"การทำสำเนาบนกระดาษหัวจดหมาย การทำสำเนาบนกระดาษหัวจดหมาย ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การทำสำเนาบนกระดาษหัวจดหมาย การทำสำเนาบนกระดาษหัวจดหมาย ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา ทำสำเนาจาก เลือกขนาดของเอกสารต้นฉบับ เลือก  ทำสำเนาไปยัง แล้วเลือกแหล่งกระดาษที่มีหัวจดหมาย หากคุณใส่กระดาษหัวจดหมายเข้าไปในตัวป้อนกระดาษอเนกประสงค์ เลือก  ตัวป้อนกระดาษอเนกประสงค์  เลือกขนาดกระดาษ แล้วเลือก  กระดาษหัวจดหมาย ทำสำเนาเอกสาร การทำสำเนา บนกระดาษหัวจดหมาย กระดาษหัวจดหมาย การทำสำเนา"},{"UUID":"c3cf4e35-6eed-4200-b7b6-cb73220d1243","title":"ทำสำเนา","link":"copying-on-both-sides-of-paper-topic.html","desc":"การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม ด้าน เลือกการตั้งค่า ทำสำเนาเอกสาร การทำสำเนา บนหน้ากระดาษทั้งสองด้าน การทำสำเนาสองด้าน การทำสำเนาสองด้าน"},{"UUID":"e6a8e943-7541-449c-b2c8-193ab7de4c02","title":"ทำสำเนา","link":"reducing-or-enlarging-copies-topic.html","desc":"การย่อหรือขยายขนาดสำเนา การย่อหรือขยายขนาดสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การย่อหรือขยายขนาดสำเนา การย่อหรือขยายขนาดสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม ปรับขนาด เลือกการตั้งค่า การเปลี่ยนขนาดของเอกสารต้นฉบับหรือเอาต์พุตหลังจากการตั้งค่า  ขนาด  จะคืนค่าขนาดเป็น  อัตโนมัติ ทำสำเนาเอกสาร การลดขนาดสำเนา การขยายขนาดสำเนา ขนาดสำเนา การปรับ"},{"UUID":"b5d76ab9-0597-4492-af06-9c51d40454d1","title":"ทำสำเนา","link":"collating-copies-topic.html","desc":"การเรียงหน้าสำเนา การเรียงหน้าสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การเรียงหน้าสำเนา การเรียงหน้าสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม เรียงหน้า เปิด [1,2,1,2,1,2] ทำสำเนาเอกสาร การเรียงหน้าสำเนา การจัดเรียงสำเนาหลายชุด"},{"UUID":"b4c862c0-c839-4890-9a1e-2d4a07086d55","title":"ทำสำเนา","link":"placing-separator-sheets-between-copies-topic.html","desc":"การใส่แผ่นคั่นระหว่างสำเนา การใส่แผ่นคั่นระหว่างสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การใส่แผ่นคั่นระหว่างสำเนา การใส่แผ่นคั่นระหว่างสำเนา ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม แผ่นคั่น เปิดใช้งานเมนู แล้วเลือกการตั้งค่า ทำสำเนาเอกสาร แผ่นคั่น การเพิ่ม การใส่แผ่นคั่น"},{"UUID":"bfd47eb4-e95a-4006-9262-b88a01c025fb","title":"ทำสำเนา","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา การตั้งค่าเพิ่มเติม จำนวนหน้าต่อด้าน เปิดใช้งานเมนู แล้วเลือกการตั้งค่า ทำสำเนาเอกสาร การทำสำเนาเอกสารหลายหน้า ลงบนกระดาษแผ่นเดียว การประหยัดกระดาษ"},{"UUID":"e01fabcd-1778-40dc-b947-e8f44a3d8268","title":"ทำสำเนา","link":"copying-cards-topic.html","desc":"การสำเนาบัตร การสำเนาบัตร วางบัตรคว่ำบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่","descFull":"การสำเนาบัตร การสำเนาบัตร วางบัตรคว่ำบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ทำสำเนา ทำสำเนาจาก บัตรประจำตัว ทำสำเนาบัตร การทำสำเนา การ์ด บัตร การทำสำเนา"},{"UUID":"21d1ad8b-0f49-4536-b6a5-3eb6056eaa09","title":"ทำสำเนา","link":"creating-copy-shortcut-topic.html","desc":"การสร้างทางลัดสำเนา การสร้างทางลัดสำเนา จากแผงควบคุม เลือก ","descFull":"การสร้างทางลัดสำเนา การสร้างทางลัดสำเนา จากแผงควบคุม เลือก  ทำสำเนา กำหนดการตั้งค่า แล้วเลือก  สร้างทางลัด การสร้างทางลัด ทำสำเนา การเพิ่มทางลัด ทำสำเนา"},{"UUID":"d8676bd9-336d-491c-a708-c13619fe7eaa","title":"อีเมล","link":"configuring-smtp-settings-topic.html","desc":"การกำหนดค่าการตั้งค่า SMTP การกำหนดค่าการตั้งค่า SMTP กำหนดการตั้งค่า","descFull":"การกำหนดค่าการตั้งค่า SMTP การกำหนดค่าการตั้งค่า SMTP กำหนดการตั้งค่า Simple Mail Transfer Protocol (SMTP) เพื่อส่งเอกสารที่สแกนผ่านอีเมล การตั้งค่าจะแตกต่างกันไปตามผู้ให้บริการอีเมลแต่ละราย ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เชื่อมต่อกับเครือข่าย และเชื่อมต่อเครือข่ายเข้ากับอินเตอร์เน็ตแล้ว การใช้แผงควบคุม จากแผงควบคุม ไปที่  การตั้งค่า อีเมล การตั้งค่าอีเมล กำหนดค่าการตั้งค่า การใช้ Embedded Web Server เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า อีเมล ในเมนู  การตั้งค่าอีเมล  ให้กำหนดค่าการตั้งค่า คลิก  บันทึก ผู้ให้บริการอีเมล AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live หรือ Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail หากพบข้อผิดพลาดในการใช้การตั้งค่าที่ได้จัดไว้ โปรดติดต่อผู้ให้บริการของคุณ หากรายชื่อผู้ให้บริการไม่ปรากฏบนรายการ โปรดติดต่อผู้ให้บริการของคุณ AOL Mail การตั้งค่าสำหรับ AOL Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.aol.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การรักษาความปลอดภัยบัญชี AOL  ลงชื่อเข้าใช้บัญชีผู้ใช้ของคุณ จากนั้นคลิก  สร้างและจัดการรหัสผ่านแอป Comcast Mail การตั้งค่าสำหรับ Comcast Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.comcast.net พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านบัญชี ตรวจสอบว่าเปิดใช้งานการตั้งค่า Third Party Access Security บนบัญชีผู้ใช้ของคุณแล้ว สำหรับข้อมูลเพิ่มเติม ไปที่  หน้าความช่วยเหลือ Comcast Xfinity Connect Gmail ตรวจสอบว่าเปิดใช้การตรวจสอบสองขั้นตอนในบัญชีของคุณแล้ว เพื่อเปิดใช้การตรวจสอบสองขั้นตอน ให้ไปที่หน้า  การรักษาความปลอดภัยบัญชี Google  ล็อกอินเข้าสู่บัญชีของคุณ จากนั้นจากส่วน  วิธีการลงชื่อเข้าใช้ Google  ให้คลิก  การตรวจสอบ 2 ขั้นตอน การตั้งค่า SMTP สำหรับ Gmail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.gmail.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การรักษาความปลอดภัยบัญชี Google  ล็อกอินเข้าสู่บัญชีของคุณ จากนั้นจากส่วน  วิธีการลงชื่อเข้าใช้ Google  ให้คลิก  การตรวจสอบ 2 ขั้นตอน รหัสผ่านแอป “ รหัสผ่านแอป ” จะแสดงเฉพาะเมื่อเปิดใช้การตรวจสอบสองขั้นตอนเท่านั้น iCloud Mail ตรวจสอบว่าเปิดใช้การตรวจสอบสองขั้นตอนในบัญชีของคุณแล้ว การตั้งค่าสำหรับ iCloud Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.mail.me.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การจัดการบัญชี iCloud  ลงชื่อเข้าบัญชีของคุณ จากนั้นในส่วน  การลงชื่อเข้าใช้และการรักษาความปลอดภัย  ให้คลิก  รหัสผ่านเฉพาะแอป สร้างรหัสผ่านเฉพาะแอป Mail.com การตั้งค่าสำหรับ Mail.com การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.mail.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านบัญชี NetEase Mail (mail.126.com) ตรวจสอบว่าเปิดใช้งานบริการ SMTP บนบัญชีผู้ใช้ของคุณแล้ว ในการเปิดใช้บริการ จากโฮมเพจของ NetEase Mail ให้คลิก  การตั้งค่า POP3/SMTP/IMAP  แล้วเปิดใช้  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP การตั้งค่าสำหรับ NetEase Mail (mail.126.com) การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.126.com พอร์ตเกตเวย์ SMTP หลัก 465 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านการอนุญาต จะใช้รหัสผ่านการอนุญาตได้เมื่อเปิดใช้งาน  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP  อยู่ NetEase Mail (mail.163.com) ตรวจสอบว่าเปิดใช้งานบริการ SMTP บนบัญชีผู้ใช้ของคุณแล้ว ในการเปิดใช้บริการ จากโฮมเพจของ NetEase Mail ให้คลิก  การตั้งค่า POP3/SMTP/IMAP  แล้วเปิดใช้  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP การตั้งค่าสำหรับ NetEase Mail (mail.163.com) การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.163.com พอร์ตเกตเวย์ SMTP หลัก 465 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านการอนุญาต จะใช้รหัสผ่านการอนุญาตได้เมื่อเปิดใช้งาน  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP  อยู่ NetEase Mail (mail.yeah.net) ตรวจสอบว่าเปิดใช้งานบริการ SMTP บนบัญชีผู้ใช้ของคุณแล้ว ในการเปิดใช้บริการ จากโฮมเพจของ NetEase Mail ให้คลิก  การตั้งค่า POP3/SMTP/IMAP  แล้วเปิดใช้  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP การตั้งค่าสำหรับ NetEase Mail (mail.yeah.net) การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.yeah.net พอร์ตเกตเวย์ SMTP หลัก 465 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านการอนุญาต จะใช้รหัสผ่านการอนุญาตได้เมื่อเปิดใช้งาน  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP  อยู่ Outlook Live หรือ Microsoft 365 การตั้งค่าเหล่านี้ใช้กับโดเมนอีเมล outlook.com และ hotmail.com และบัญชี Microsoft 365 การตั้งค่าสำหรับ Outlook Live หรือ Microsoft 365 การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.office365.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านบัญชีหรือรหัสผ่านแอป สำหรับบัญชีที่ปิดใช้งานการตรวจสอบสองขั้นตอน ให้ใช้รหัสผ่านบัญชีของคุณ สำหรับบัญชี outlook.com หรือ hotmail.com ที่เปิดใช้การตรวจสอบสองขั้นตอน ให้ใช้รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การจัดการบัญชี Outlook Live  ลงชื่อเข้าใช้บัญชีผู้ใช้ของคุณ จากนั้นคลิก  สร้างรหัสผ่านแอปใหม่ สำหรับตัวเลือกการตั้งค่าเพิ่มเติมสำหรับธุรกิจที่ใช้ Microsoft 365 ให้ไปที่  เพจวิธีใช้ของ Microsoft 365 QQ Mail ตรวจสอบว่าเปิดใช้งานบริการ SMTP บนบัญชีผู้ใช้ของคุณแล้ว เมื่อต้องการเปิดใช้งานบริการ จากโฮมเพจ QQ Mail ให้คลิก  การตั้งค่า บัญชี  จากส่วน  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  ให้เปิดใช้  บริการ POP3/SMTP  หรือ  บริการ IMAP/SMTP การตั้งค่าสำหรับ QQ Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.qq.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสการให้สิทธิ ในการสร้างรหัสการอนุญาต จากโฮมเพจของ QQ Mail ให้คลิก  การตั้งค่า บัญชี จากนั้นจากส่วน  บริการ POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  ให้คลิก  สร้างรหัสการอนุญาต Sina Mail ตรวจสอบว่าเปิดใช้งานบริการ POP3/SMTP บนบัญชีผู้ใช้ของคุณแล้ว เพื่อเปิดใช้บริการ จากโฮมเพจของ Sina Mail ให้คลิก  การตั้งค่า การตั้งค่าเพิ่มเติม ปลายทางผู้ใช้ POP/IMAP/SMTP  แล้วเปิดใช้งาน  บริการ POP3/SMTP การตั้งค่าสำหรับ Sina Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.sina.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสการให้สิทธิ เพื่อสร้างรหัสการอนุญาต จากโฮมเพจอีเมล ให้คลิก  การตั้งค่า การตั้งค่าเพิ่มเติม ปลายทางผู้ใช้ POP/IMAP/SMTP  แล้วเปิดใช้งาน  สถานะรหัสการอนุญาต Sohu Mail ตรวจสอบว่าเปิดใช้งานบริการ SMTP บนบัญชีผู้ใช้ของคุณแล้ว ในการเปิดใช้บริการ จากโฮมเพจของ Sohu Mail ให้คลิก  ตัวเลือก การตั้งค่า POP3/SMTP/IMAP  แล้วเปิดใช้  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP การตั้งค่าสำหรับ Sohu Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.sohu.com พอร์ตเกตเวย์ SMTP หลัก 465 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านอิสระ จะใช้รหัสผ่านแบบอิสระได้เมื่อเปิดใช้งาน  บริการ IMAP/SMTP  หรือ  บริการ POP3/SMTP  อยู่ Yahoo! Mail การตั้งค่าสำหรับ Yahoo! Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.mail.yahoo.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การรักษาความปลอดภัยบัญชี Yahoo  ลงชื่อเข้าบัญชีผู้ใช้ของคุณ และจากส่วน  รหัสผ่านแอป  ให้คลิก  สร้างรหัสผ่านแอป Zoho Mail การตั้งค่าสำหรับ Zoho Mail การตั้งค่า ค่า เกตเวย์ SMTP หลัก smtp.zoho.com พอร์ตเกตเวย์ SMTP หลัก 587 ใช้ SSL/TLS จำเป็นต้องใช้ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิดใช้งานแล้ว แอดเดรสตอบกลับ ที่อยู่อีเมลของคุณ การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ลงชื่อเข้าใช้ / ธรรมดา อีเมลแบบเริ่มต้นโดยอุปกรณ์ ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ รหัสผู้ใช้ของอุปกรณ์ ที่อยู่อีเมลของคุณ รหัสผ่านของอุปกรณ์ รหัสผ่านบัญชีหรือรหัสผ่านแอป สำหรับบัญชีที่ปิดใช้งานการตรวจสอบสองขั้นตอน ให้ใช้รหัสผ่านบัญชีของคุณ สำหรับบัญชีที่เปิดใช้การตรวจสอบสองขั้นตอน ให้ใช้รหัสผ่านแอป ในการสร้างรหัสผ่านแอป ให้ไปที่หน้า  การรักษาความปลอดภัยบัญชี Zoho Mail  ลงชื่อเข้าบัญชีผู้ใช้ของคุณ และจากส่วน  รหัสผ่านเฉพาะแอปพลิเคชัน  ให้คลิก  สร้างรหัสผ่านใหม่ ผู้ให้บริการอีเมล การกำหนดค่า การตั้งค่าเซิร์ฟเวอร์อีเมล การตั้งค่า SMTP การกำหนดค่า ฟังก์ชันอีเมล การตั้งค่า การตั้งค่าเซิร์ฟเวอร์อีเมล การกำหนดค่า"},{"UUID":"023a9e4c-4f41-42eb-ada6-127525566d2e","title":"อีเมล","link":"sending-email-topic.html","desc":"การส่งอีเมล ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าได้กำหนดค่าการตั้งค่า SMTP แล้ว","descFull":"การส่งอีเมล ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าได้กำหนดค่าการตั้งค่า SMTP แล้ว โปรดดูข้อมูลเพิ่มเติมที่  ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  สแกน อีเมล ป้อนข้อมูลที่จำเป็น แล้วเลือก  ถัดไป หากจำเป็น ให้กำหนดค่าการตั้งค่า เลือก  สแกน  แล้วส่งอีเมล อีเมล การส่ง การส่งอีเมล"},{"UUID":"f56b88e0-dbb8-4264-be32-3a09fd9de84a","title":"อีเมล","link":"creating-email-shortcut-topic.html","desc":"การสร้างทางลัดอีเมล การใช้แผงควบคุม จากแผงควบคุม ไปที่ ","descFull":"การสร้างทางลัดอีเมล การใช้แผงควบคุม จากแผงควบคุม ไปที่  สแกน อีเมล ป้อนข้อมูลที่จำเป็น แล้วเลือก  สร้างทางลัด การใช้ Embedded Web Server เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  ทางลัด เพิ่มทางลัด กำหนดค่าการตั้งค่า คลิก  บันทึก การสร้างทางลัด อีเมล การเพิ่มทางลัด อีเมล ทางลัดอีเมล การสร้าง"},{"UUID":"6bfab131-4c8c-4144-80b0-26607bec4a21","title":"แฟกซ์","link":"sending-fax-topic.html","desc":"การส่งแฟกซ์ การส่งแฟกซ์ การใช้แผงควบคุม ใส่เอกสารต้นฉบับในถาด ADF","descFull":"การส่งแฟกซ์ การส่งแฟกซ์ การใช้แผงควบคุม ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม เลือก  แฟกซ์ เลือก  เพิ่มผู้รับ  หรือ สมุดที่อยู่ หากจำเป็น ให้ปรับการตั้งค่า ส่งแฟกซ์ การใช้คอมพิวเตอร์ ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าติดตั้งไดรเวอร์แฟกซ์แล้ว โปรดดูข้อมูลเพิ่มเติมที่  สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  แฟกซ์ เปิดใช้งานแฟกซ์ ตั้งค่าการแสดงผลก่อนการส่งแฟกซ์ทุกครั้ง แล้วป้อนหมายเลขผู้รับ หากจำเป็น ให้กำหนดค่าการตั้งค่า ส่งแฟกซ์ สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้เลือก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ที่มี  ‑ แฟกซ์  ตามหลังชื่อ ในช่อง ถึง ให้ป้อนหมายเลขผู้รับ หากจำเป็น ให้กำหนดค่าการตั้งค่า ส่งแฟกซ์ การส่งแฟกซ์ แฟกซ์ การส่ง"},{"UUID":"b88028db-7b08-4adf-b912-49a82edde84a","title":"แฟกซ์","link":"scheduling-fax-topic.html","desc":"การกำหนดเวลาการแฟกซ์ การกำหนดเวลาการแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การกำหนดเวลาการแฟกซ์ การกำหนดเวลาการแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม เลือก  แฟกซ์ เลือก  เพิ่มผู้รับ  หรือ  สมุดที่อยู่  จากนั้นป้อนข้อมูลที่จำเป็น เลือก  เวลาส่ง  กำหนดค่าวันที่และเวลา จากนั้นเลือก  เสร็จสิ้น หากจำเป็น ให้กำหนดการตั้งค่าแฟกซ์อื่นๆ ส่งแฟกซ์ การกำหนดเวลาการแฟกซ์ แฟกซ์ การกำหนดเวลา"},{"UUID":"695778f2-f451-41d2-8875-a0c87aa095cc","title":"แฟกซ์","link":"creating-fax-destination-shortcut-topic.html","desc":"การสร้างทางลัดปลายทางแฟกซ์ การสร้างทางลัดปลายทางแฟกซ์ จากแผงควบคุม เลือก ","descFull":"การสร้างทางลัดปลายทางแฟกซ์ การสร้างทางลัดปลายทางแฟกซ์ จากแผงควบคุม เลือก  แฟกซ์ เลือก  เพิ่มผู้รับ  หรือ  สมุดที่อยู่  จากนั้นป้อนข้อมูลที่จำเป็น หากจำเป็น ให้ปรับการตั้งค่า เลือก  สร้างทางลัด การสร้างทางลัด ปลายทางแฟกซ์ ปลายทางแฟกซ์ การสร้างทางลัด การเพิ่มทางลัด ปลายทางแฟกซ์ ทางลัด, กำลังสร้าง ปลายทางแฟกซ์"},{"UUID":"84c56205-2f65-4dcc-a8c7-d16a64ef6e49","title":"แฟกซ์","link":"changing-fax-resolution-topic.html","desc":"การเปลี่ยนความละเอียดของแฟกซ์ การเปลี่ยนความละเอียดของแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การเปลี่ยนความละเอียดของแฟกซ์ การเปลี่ยนความละเอียดของแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม เลือก  แฟกซ์ เลือก  เพิ่มผู้รับ  หรือ  สมุดที่อยู่  จากนั้นป้อนข้อมูลที่จำเป็น เลือก  ความละเอียด  แล้วเลือกการตั้งค่า ส่งแฟกซ์ ความละเอียดของแฟกซ์ การเปลี่ยน การเปลี่ยนความละเอียดของแฟกซ์"},{"UUID":"f8a425b4-c070-40a8-9e44-96389090873a","title":"แฟกซ์","link":"adjusting-fax-darkness-topic.html","desc":"การปรับความเข้มของแฟกซ์ การปรับความเข้มของแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การปรับความเข้มของแฟกซ์ การปรับความเข้มของแฟกซ์ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม เลือก  แฟกซ์ เลือก  เพิ่มผู้รับ  หรือ  สมุดที่อยู่  จากนั้นป้อนข้อมูลที่จำเป็น เลือก  การตั้งค่าเพิ่มเติม ความเข้ม  แล้วปรับการตั้งค่า ส่งแฟกซ์ การปรับความเข้มของแฟกซ์ ความเข้มของแฟกซ์ การปรับ"},{"UUID":"42d01b59-6f87-4325-996e-8f756b8eb47a","title":"แฟกซ์","link":"printing-fax-log-topic.html","desc":"การพิมพ์บันทึกการแฟกซ์ การพิมพ์บันทึกการแฟกซ์ จากแผงควบคุม ไปที่ ","descFull":"การพิมพ์บันทึกการแฟกซ์ การพิมพ์บันทึกการแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน แฟกซ์ เลือกบันทึกแฟกซ์ บันทึกแฟกซ์ การพิมพ์ การพิมพ์บันทึกแฟกซ์"},{"UUID":"af635a6e-235d-45a4-99b3-1bbe52cf48cc","title":"แฟกซ์","link":"blocking-junk-faxes-topic.html","desc":"การปิดกั้นแฟกซ์ที่ไม่ต้องการ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การปิดกั้นแฟกซ์ที่ไม่ต้องการ จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ ส่วนควบคุมของผู้ดูแล เปิดใช้งานเมนู  บล็อคแฟกซ์ที่ไม่มีชื่อ แฟกซ์ที่ไม่ต้องการ การปิดกั้น การปิดกั้นแฟกซ์ที่ไม่ต้องการ"},{"UUID":"ad5117a8-9d53-4d18-9393-47ebe07099a4","title":"แฟกซ์","link":"holding-faxes-topic.html","desc":"การระงับแฟกซ์ การระงับแฟกซ์ จากแผงควบคุม ไปที่ ","descFull":"การระงับแฟกซ์ การระงับแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ การระงับแฟกซ์ เลือกการตั้งค่า การระงับแฟกซ์ แฟกซ์ที่รับ การระงับ แฟกซ์ การระงับ"},{"UUID":"6de909e9-2d22-4be1-a756-9912fd9e6a39","title":"แฟกซ์","link":"forwarding-fax-topic.html","desc":"การส่งต่อแฟกซ์ การส่งต่อแฟกซ์ จากแผงควบคุม ไปที่ ","descFull":"การส่งต่อแฟกซ์ การส่งต่อแฟกซ์ จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ ส่วนควบคุมของผู้ดูแล เลือก  การส่งต่อแฟกซ์  จากนั้นเลือก  พิมพ์และส่งต่อ  หรือ  ส่งต่อ ในเมนู  ส่งต่อไปยัง  ให้เลือกปลายทาง จากนั้นกำหนดค่าการตั้งค่า การส่งต่อแฟกซ์ แฟกซ์ การส่งต่อ"},{"UUID":"e2f8678d-4c0a-4be7-a2d9-7af231503246","title":"สแกน","link":"scanning-to-computer-topic.html","desc":"การสแกนไปยังคอมพิวเตอร์ ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเครื่องพิมพ์เชื่อมต่อเข้ากับเครือข่ายเดียวกัน สำหรับผู้ใช้ Windows","descFull":"การสแกนไปยังคอมพิวเตอร์ ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าคอมพิวเตอร์และเครื่องพิมพ์เชื่อมต่อเข้ากับเครือข่ายเดียวกัน สำหรับผู้ใช้ Windows การใช้ Lexmark ScanBack Utility จากคอมพิวเตอร์ ให้เรียกใช้  Lexmark ScanBack Utility  แล้วคลิก  สร้างโปรไฟล์ ในการดาวน์โหลดยูทิลิตี ให้ไปที่  www.lexmark.com/downloads หากคุณต้องการใช้โปรไฟล์การสแกนที่มีอยู่ คลิก โปรไฟล์ที่มีอยู่ คลิก  ตั้งค่า  แล้วเพิ่ม IP แอดเดรสของเครื่องพิมพ์ ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 คลิก  ตกลง  แล้วคลิก  ปิด . เลือกรูปแบบและขนาดของเอกสารที่จะสแกน เลือกรูปแบบไฟล์และความละเอียดของการสแกน จากนั้นคลิก  ถัดไป พิมพ์ชื่อโปรไฟล์การสแกนที่ไม่ซ้ำกัน เรียกดูตำแหน่งที่คุณต้องการบันทึกเอกสารที่สแกน จากนั้นสร้างชื่อไฟล์ ในการนำโปรไฟล์การสแกนกลับมาใช้ใหม่ ให้เปิดใช้  สร้างทางลัด แล้วสร้างชื่อทางลัดเฉพาะ คลิก  เสร็จสิ้น . ใส่เอกสารต้นฉบับลงในตัวป้อนเอกสารอัตโนมัติหรือบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  โปรไฟล์การสแกน  Scan to Computer  แล้วเลือกโปรไฟล์การสแกน บนคอมพิวเตอร์ของคุณ คลิก  สแกนเสร็จสมบูรณ์ . สำหรับผู้ใช้ Windows การใช้ Windows Fax and Scan ตรวจสอบให้แน่ใจว่าได้เพิ่มเครื่องพิมพ์ลงในคอมพิวเตอร์แล้ว โปรดดูข้อมูลเพิ่มเติมที่  ใส่เอกสารต้นฉบับลงในตัวป้อนเอกสารอัตโนมัติหรือบนกระจกสแกนเนอร์ จากคอมพิวเตอร์ ให้เปิด  Windows Fax and Scan คลิก สแกนใหม่  แล้วเลือกแหล่งการสแกน หากจำเป็น ให้เปลี่ยนการตั้งค่าการสแกน สแกนเอกสาร คลิก  บันทึกเป็น  พิมพ์ชื่อไฟล์ แล้วคลิก  บันทึก สำหรับผู้ใช้ Macintosh ตรวจสอบให้แน่ใจว่าได้เพิ่มเครื่องพิมพ์ลงในคอมพิวเตอร์แล้ว โปรดดูข้อมูลเพิ่มเติมที่  ใส่เอกสารต้นฉบับลงในตัวป้อนเอกสารอัตโนมัติหรือบนกระจกสแกนเนอร์ จากคอมพิวเตอร์ ให้ดำเนินการข้อใดข้อหนึ่งต่อไปนี้: เปิด  ตัวจับภาพ เปิด  เครื่องพิมพ์และสแกนเนอร์ แล้วเลือกเครื่องพิมพ์ คลิก  สแกน เปิดสแกนเนอร์ จากหน้าต่าง สแกนเนอร์ ให้ทำอย่างน้อยหนึ่งอย่างต่อไปนี้: เลือกตำแหน่งที่ตั้งที่คุณต้องการบันทึกเอกสารที่สแกน เลือกขนาดของเอกสารต้นฉบับ ในการสแกนจาก ADF ให้เลือก  ตัวป้อนเอกสาร  จาก  เมนูสแกน  หรือเปิดใช้งาน  ใช้ตัวป้อนเอกสาร หากจำเป็น ให้กำหนดค่าการสแกน คลิก  สแกน การสแกนไปยังคอมพิวเตอร์ คอมพิวเตอร์, การสแกนไปยัง Lexmark ScanBack Utility"},{"UUID":"86fa03b3-6ba7-44cb-8ad5-f595f0f54092","title":"สแกน","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"การสแกนไปยังเซิร์ฟเวอร์ FTP การสแกนไปยังเซิร์ฟเวอร์ FTP ก่อนเริ่มต้น","descFull":"การสแกนไปยังเซิร์ฟเวอร์ FTP การสแกนไปยังเซิร์ฟเวอร์ FTP ก่อนเริ่มต้น ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เชื่อมต่อกับเซิร์ฟเวอร์ FTP แล้ว ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  สแกน FTP ป้อนข้อมูลที่จำเป็น แล้วเลือก  ถัดไป หากจำเป็น ให้กำหนดการตั้งค่า FTP สแกนเอกสาร เซิร์ฟเวอร์ FTP การสแกนไปยัง การสแกน ไปยังเซิร์ฟเวอร์ FTP"},{"UUID":"e8126d71-2e0d-4936-8739-622a038fae91","title":"สแกน","link":"creating-FTP-shortcut-topic.html","desc":"การสร้างทางลัด FTP การสร้างทางลัด FTP จากแผงควบคุม","descFull":"การสร้างทางลัด FTP การสร้างทางลัด FTP จากแผงควบคุม เลือก  สแกน FTP ป้อนเซิร์ฟเวอร์แอดเดรส FTP แล้วแตะ  สร้างทางลัด การสร้างทางลัด FTP แอดเดรส การเพิ่มทางลัด FTP แอดเดรส"},{"UUID":"c277e116-2cf6-4588-a242-4404821bcd5b","title":"สแกน","link":"scanning-to-network-folder-topic.html","desc":"การสแกนไปยังโฟลเดอร์เครือข่าย ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบว่าโฟลเดอร์เครือข่ายที่คุณต้องการสแกนเอกสารนั้นได้รับการกำหนดค่าแล้วหรือไม่ ใส่เอกสารต้นฉบับในถาด ADF","descFull":"การสแกนไปยังโฟลเดอร์เครือข่าย ก่อนที่คุณจะเริ่มต้น ให้ตรวจสอบว่าโฟลเดอร์เครือข่ายที่คุณต้องการสแกนเอกสารนั้นได้รับการกำหนดค่าแล้วหรือไม่ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ จากแผงควบคุม ไปที่  ศูนย์การสแกน โฟลเดอร์เครือข่าย เลือกโฟลเดอร์เครือข่ายที่เกี่ยวข้อง หากต้องการเพิ่มโฟลเดอร์เครือข่าย ดู  สแกนเอกสาร การสแกน ไปยังโฟลเดอร์เครือข่าย โฟลเดอร์เครือข่าย การสแกนไปยัง"},{"UUID":"977cee85-a550-4297-8ca9-047307655485","title":"สแกน","link":"configuring-network-folder-destination-topic.html","desc":"การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย จากแผงควบคุม ไปที่ ","descFull":"การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย จากแผงควบคุม ไปที่  ศูนย์การสแกน โฟลเดอร์เครือข่าย สร้างโฟลเดอร์เครือข่าย กำหนดค่าการตั้งค่าที่จำเป็น ลงชื่อเข้าใช้เครือข่าย แล้วเลือก  ถัดไป กำหนดการตั้งค่าโฟลเดอร์เครือข่าย แล้วเลือก  เสร็จสิ้น สำหรับการสแกนเอกสารไปยังโฟลเดอร์เครือข่าย ให้ดู  ปลายทางของโฟลเดอร์เครือข่าย การกำหนดค่า การสร้างโฟลเดอร์เครือข่าย"},{"UUID":"a22f717b-5570-41cb-8dbc-7958e5969501","title":"สแกน","link":"creating-network-folder-shortcut-topic.html","desc":"การสร้างทางลัดโฟลเดอร์เครือข่าย เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู","descFull":"การสร้างทางลัดโฟลเดอร์เครือข่าย เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  ทางลัด เพิ่มทางลัด จากเมนู ประเภททางลัด  ให้เลือก  โฟลเดอร์เครือข่าย แล้วกำหนดค่าการตั้งค่า ใช้การเปลี่ยนแปลง ทางลัดโฟลเดอร์เครือข่าย การสร้างทางลัด"},{"UUID":"eb9d45c0-40a2-4140-a3e5-e9e2fae416a6","title":"สแกน","link":"scanning-to-flash-drive-topic.html","desc":"การสแกนไปยังแฟลชไดร์ฟ การสแกนไปยังแฟลชไดร์ฟ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์","descFull":"การสแกนไปยังแฟลชไดร์ฟ การสแกนไปยังแฟลชไดร์ฟ ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เสียบแฟลชไดรฟ์ จากแผงควบคุม ให้เลือก  สแกน  แล้วเลือก  ไดรฟ์ USB เลือกตำแหน่งที่ต้องการบันทึกไฟล์ สร้างชื่อไฟล์ แล้วเลือก  ถัดไป กำหนดค่าการตั้งค่าการสแกน สแกนเอกสาร เพื่อป้องกันข้อมูลหรือเครื่องพิมพ์ทำงานผิดพลาด อย่าสัมผัสแฟลชไดร์ฟหรือเครื่องพิมพ์ในบริเวณที่แสดงไว้ในภาพขณะกำลังพิมพ์งาน อ่านข้อมูล หรือเขียนข้อมูลจากอุปกรณ์หน่วยความจำ การสแกน ไปยังแฟลชไดรฟ์ แฟลชไดรฟ์ การสแกนไปยัง"},{"UUID":"ac924c7d-177d-42c5-839e-2354d73eb4f1","title":"เมนูเครื่องพิมพ์","link":"menu-map-topic.html","desc":"ผังเมนู 1  แสดงขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มเท่านั้น 2","descFull":"ผังเมนู 1  แสดงขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มเท่านั้น 2  แสดงขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลเท่านั้น อุปกรณ์ ค่ากำหนด โหมดประหยัด แผงควบคุมระยะไกล การแจ้งเตือน การจัดการพลังงาน แชร์ข้อมูลกับ Lexmark การเข้าถึง คืนค่าเริ่มต้นจากโรงงาน การดูแลรักษา อัพเดตเฟิร์มแวร์ เกี่ยวกับเครื่องพิมพ์นี้ อุปกรณ์ ค่ากำหนด โหมดประหยัด แผงควบคุมระยะไกล การแจ้งเตือน การจัดการพลังงาน การเข้าถึง คืนค่าเริ่มต้นจากโรงงาน การดูแลรักษา อัพเดตเฟิร์มแวร์ เกี่ยวกับเครื่องพิมพ์นี้ พิมพ์ การจัดวาง การเย็บเล่ม 1 ตั้งค่า คุณภาพ การทำบัญชีงาน PDF PostScript PCL ภาพ กระดาษ การกำหนดค่าถาด การกำหนดค่าวัสดุพิมพ์ การกำหนดค่าถาด 1 ทำสำเนา ค่าเริ่มต้นของการทำสำเนา แฟกซ์ ค่าเริ่มต้นของแฟกซ์ อีเมล การตั้งค่าอีเมล ค่าเริ่มต้นของอีเมล การตั้งค่าเว็บลิงก์ FTP ค่าเริ่มต้นของ FTP ไดรฟ์ USB การสแกนแฟลชไดรฟ์ การพิมพ์แฟลชไดรฟ์ เครือข่าย/พอร์ต ภาพรวมเครือข่าย แบบไร้สาย Wi‑Fi Direct การจัดการบริการบนโทรศัพท์มือถือ อีเทอร์เน็ต TCP/IP SNMP IPSec 802.1x การกำหนดค่า LPD การตั้งค่า HTTP/FTP ThinPrint USB จำกัดการเข้าถึงจากเครือข่ายภายนอก การรักษาความปลอดภัย วิธีลงชื่อเข้าใช้ กำหนดเวลาอุปกรณ์ USB บันทึกการตรวจประเมินความปลอดภัย ข้อจำกัดการลงชื่อเข้าใช้ การตั้งค่างานพิมพ์เอกสารที่เป็นความลับ การเข้ารหัส ลบไฟล์ข้อมูลชั่วคราว การตั้งค่าโซลูชั่น LDAP อื่นๆ บริการระบบคลาวด์ การลงทะเบียนบริการระบบคลาวด์ รายงาน หน้าการตั้งค่าเมนู อุปกรณ์ พิมพ์ ทางลัด แฟกซ์ เครือข่าย การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ การทำความสะอาดสแกนเนอร์ Forms Merge 2 Forms Merge ผังเมนู เมนูเครื่องพิมพ์"},{"UUID":"ad3fa870-e6fd-4915-89dd-370d0dea2834","title":"อุปกรณ์","link":"preferences-topic.html","desc":"ค่ากำหนด รายการเมนูและคำอธิบายค่ากำหนด รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"ค่ากำหนด รายการเมนูและคำอธิบายค่ากำหนด รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ภาษาที่แสดง ไม่ใช้ [รายการภาษา] ตั้งภาษาของข้อความที่ปรากฏบนส่วนแสดงผล ประเทศ/ภูมิภาค ไม่ใช้ [รายชื่อประเทศหรือภูมิภาค] ระบุประเทศหรือภูมิภาคที่เครื่องพิมพ์ถูกกำหนดค่าการใช้งานเอาไว้ รันการตั้งค่าเริ่มต้น ไม่ใช้ ปิด * เปิด รันตัวช่วยการตั้งค่า แป้นพิมพ์ ประเภทแป้นพิมพ์ [รายการภาษา] เลือกภาษาเป็นประเภทแป้นพิมพ์ ค่า  ประเภทแป้นพิมพ์  ทั้งหมดอาจไม่ปรากฏหรืออาจต้องใช้ฮาร์ดแวร์พิเศษเพื่อให้ปรากฏ วันที่และเวลา กำหนดค่า วันที่และเวลาปัจจุบัน ตั้งวันที่และเวลาด้วยตนเอง รูปแบบวันที่  ( ดด‑วว‑ปปปป *) รูปแบบเวลา  [ 12 ชั่วโมง ก่อนเที่ยงวัน/หลังเที่ยงวัน *] โซนเวลา ความต่างเวลา DST (GMT) เริ่มปรับเวลาตามฤดูกาล สิ้นสุดการปรับเวลาตามฤดูกาล การปรับชดเชยเวลาตามฤดูกาล กำหนดค่าวันที่และเวลา และโปรโตคอลเวลาเครือข่ายของเครื่องพิมพ์ ดด‑วว‑ปปปป  เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา  วว-ดด-ปปปป  เป็นการตั้งค่าเริ่มต้นจากโรงงานสากล ความต่างเวลา UTC (GMT) ,  เริ่มปรับเวลาตามฤดูกาล ,  สิ้นสุดการปรับเวลาตามฤดูกาล  และ  การปรับชดเชยเวลาตามฤดูกาล  จะปรากฏขึ้นเฉพาะเมื่อการตั้งค่า  โซนเวลา  เป็น  (UTC+ผู้ใช้) กำหนดเอง รหัสคีย์  และ  รหัสผ่าน  จะปรากฏขึ้นเฉพาะเมื่อการตั้งค่า  เปิดใช้การตรวจสอบความถูกต้อง  เป็น  คีย์ MD5 โปรโตคอลเวลาเครือข่าย เปิดใช้งาน NTP  ( เปิด *) เซิร์ฟเวอร์ NTP เปิดใช้การตรวจสอบความถูกต้อง  ( ไม่มี *) รหัสคีย์ รหัสผ่าน ขนาดกระดาษ ไม่ใช้ สหรัฐอเมริกา * เมตริก ระบุหน่วยวัดสำหรับขนาดกระดาษ ประเทศหรือภูมิภาคที่เลือกไว้ในตัวช่วยตั้งค่าเริ่มต้นจะกำหนดการตั้งค่าขนาดกระดาษเริ่มต้น ความสว่างของหน้าจอ ไม่ใช้ 20–100%  (100*) ปรับความสว่างของส่วนแสดงผล การเข้าใช้งานแฟลชไดรฟ์ ไม่ใช้ ปิดใช้งานแล้ว เปิดใช้งานแล้ว * เปิดใช้งานการเข้าถึงฟังก์ชันแฟลชไดรฟ์ของเครื่องพิมพ์ นำพื้นหลังออกได้ ไม่ใช้ ปิด เปิด * ระบุว่าอนุญาตให้นำพื้นหลังออกหรือไม่ ใช้การสแกนงานแบบกำหนดเองได้ ไม่ใช้ ปิด เปิด * ระบุว่าจะให้การตั้งค่า การสแกนงานแบบกำหนดเอง ปรากฏขึ้นสำหรับการทำสำเนา การสแกน และการแฟกซ์หรือไม่ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น สแกนจากแท่นสแกนแบบหน้าเดียว ไม่ใช้ ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้สแกนงานทุกประเภทที่ใช้กระจกสแกนเนอร์เป็นหน้าเดียว เครื่องพิมพ์จะกลับไปยังหน้าจอหลักหลังจากทำการสแกนแท่นสแกนหนึ่งรายการแทนการแสดงข้อความแจ้ง อุปกรณ์มีเสียง ปิดเสียงทั้งหมด ปิด * เปิด กำหนดค่าการตั้งค่าเสียงของเครื่องพิมพ์ การตอบกลับด้วยปุ่ม ปิด เปิด * ระดับเสียง 0–10  (5*) เสียงบี๊พที่ใส่ใน ADF ปิด เปิด * การควบคุมการแจ้งเตือน ปิด ครั้งเดียว * ต่อเนื่อง การแจ้งเตือนตลับหมึก ปิด ครั้งเดียว * ต่อเนื่อง โหมดลำโพง ปิดเสมอ * เปิดเสมอ เปิดจนกว่าจะเชื่อมต่อ ระดับเสียงเรียกเข้า ปิด * เปิด หมดเวลาหน้าจอ ไม่ใช้ 5–300 วินาที  (60*) ตั้งเวลาเมื่อไม่ได้ใช้งานเป็นวินาทีก่อนที่หน้าจอจะแสดงหน้าจอหลัก หรือก่อนที่เครื่องพิมพ์จะทำให้ผู้ใช้ออกจากระบบโดยอัตโนมัติ เมนู ค่ากำหนด"},{"UUID":"2a8464dd-8871-47e9-85d2-cfae35442b85","title":"อุปกรณ์","link":"preferences-topic.html","desc":"โหมดประหยัด รายการเมนูและคำอธิบาย โหมดประหยัด รายการเมนู รายการเมนูย่อย","descFull":"โหมดประหยัด รายการเมนูและคำอธิบาย โหมดประหยัด รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน พิมพ์ ด้าน 1 ด้าน 2 ด้าน * เลือกว่าจะพิมพ์บนกระดาษด้านเดียวหรือทั้งสองด้าน จำนวนหน้าต่อด้าน ปิด * 2 หน้าต่อหนึ่งด้าน 3 หน้าต่อหนึ่งด้าน 4 หน้าต่อหนึ่งด้าน 6 หน้าต่อหนึ่งด้าน 9 หน้าต่อหนึ่งด้าน 12 หน้าต่อหนึ่งด้าน 16 หน้าต่อหนึ่งด้าน ระบุจำนวนของหน้าที่คุณต้องการพิมพ์ลงบนด้านเดียวของหน้ากระดาษ ความเข้มของหมึก 1–5  (4*) กำหนดความจางหรือความเข้มของรูปข้อความ ตัวบันทึกสี ปิด * เปิด ตั้งให้เครื่องพิมพ์ลดปริมาณหมึกที่ใช้เมื่อพิมพ์กราฟิกและรูปภาพต่างๆ ทำสำเนา ด้าน 1 ด้านเป็น 1 ด้าน * 1 ด้านเป็น 2 ด้าน 2 ด้านเป็น 1 ด้าน 2 ด้านเป็น 2 ด้าน ระบุลักษณะการสแกนตามเอกสารต้นฉบับ จำนวนหน้าต่อด้าน ปิด * 2 หน้าแนวตั้ง 4 หน้าแนวตั้ง 2 หน้าแนวนอน 4 หน้าแนวนอน ระบุจำนวนของหน้าที่คุณต้องการทำสำเนาลงบนด้านเดียวของหน้ากระดาษ ความเข้ม 1–9  (5*) กำหนดความเข้มของภาพข้อความที่สแกน เมนู โหมดประหยัด"},{"UUID":"abe7d00c-3cbe-4f35-ac36-7cd3227ad7a5","title":"อุปกรณ์","link":"preferences-topic.html","desc":"แผงควบคุมระยะไกล รายการเมนูแผงควบคุมระยะไกลและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"แผงควบคุมระยะไกล รายการเมนูแผงควบคุมระยะไกลและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การเชื่อมต่อ VNC จากภายนอก ไม่อนุญาต * อนุญาต เชื่อมต่อเครื่องลูกข่าย Virtual Network Computing (VNC) ภายนอกเข้ากับแผงควบคุมระยะไกล ประเภทการตรวจสอบความถูกต้อง ไม่มี * การตรวจสอบความถูกต้องตามมาตรฐาน ตั้งประเภทการตรวจสอบความถูกต้องเมื่อเข้าใช้เซิร์ฟเวอร์เครื่องลูกข่าย VNC รหัสผ่าน VNC การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านเพื่อเชื่อมต่อกับเซิร์ฟเวอร์เครื่องลูกข่าย VNC จะปรากฏรายการเมนูนี้เมื่อตั้ง  ประเภทการตรวจสอบความถูกต้อง  เป็น  การตรวจสอบความถูกต้องมาตรฐาน  เท่านั้น เมนู แผงควบคุมระยะไกล"},{"UUID":"f20dda90-8d10-41c5-9217-7054d0dac779","title":"อุปกรณ์","link":"preferences-topic.html","desc":"การแจ้งเตือน รายการเมนูและคำอธิบายการแจ้งเตือน รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"การแจ้งเตือน รายการเมนูและคำอธิบายการแจ้งเตือน รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เสียงบี๊พที่ใส่ใน ADF ไม่ใช้ ปิด เปิด * ระบุว่าเครื่องพิมพ์ส่งเสียงบี๊พแบบกำหนดเองหรือไม่ เมื่อมีการโหลดเอกสารต้นฉบับลงใน ADF การควบคุมการแจ้งเตือน ไม่ใช้ ปิด ครั้งเดียว * ต่อเนื่อง ตั้งจำนวนครั้งที่เสียงเตือนดังขึ้นเมื่อผู้ใช้จำเป็นต้องดำเนินการจัดการเครื่องพิมพ์ วัสดุสิ้นเปลือง แสดงค่าประมาณของวัสดุสิ้นเปลือง แสดงค่าประมาณ * ไม่ต้องแสดงค่าประมาณ แสดงสถานะโดยประมาณของวัสดุสิ้นเปลือง การแจ้งเตือนตลับหมึก ปิด ครั้งเดียว * ต่อเนื่อง ตั้งค่าจำนวนครั้งที่เสียงเตือนดังขึ้นเมื่อผงหมึกเหลือน้อย การแจ้งเตือนลวดเย็บ ปิด * ครั้งเดียว ต่อเนื่อง ตั้งจำนวนครั้งที่เสียงเตือนดังขึ้นเมื่อตลับลวดเย็บว่างเปล่า รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บแล้วเท่านั้น การแจ้งเตือนอุปกรณ์ตอกรู ปิด * ครั้งเดียว ต่อเนื่อง ตั้งค่าจำนวนครั้งที่เสียงเตือนดังขึ้นเมื่อกล่องอุปกรณ์ตอกรูเต็มหรือขาดหาย รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบตอกลวดเย็บแล้วเท่านั้น การตั้งค่าการแจ้งเตือนทางอีเมล เกตเวย์ SMTP หลัก การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์ IP แอดเดรสหรือชื่อคอมพิวเตอร์แม่ข่ายของเซิร์ฟเวอร์ SMTP หลัก พอร์ตเกตเวย์ SMTP หลัก 1–65535  (25*) ป้อนหมายเลขพอร์ตของเซิร์ฟเวอร์ SMTP หลัก เกตเวย์ SMTP รอง การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์ IP แอดเดรสหรือชื่อโฮสต์ของเซิร์ฟเวอร์ SMTP รอง พอร์ตเกตเวย์ SMTP รอง 1–65535  (25*) ป้อนหมายเลขพอร์ตเซิร์ฟเวอร์ของเซิร์ฟเวอร์ SMTP รอง หมดเวลา SMTP 5–30 วินาที  (30*) ระบุเวลาที่เซิร์ฟเวอร์ SMTP รอก่อนที่จะหยุดพยายามส่งอีเมล แอดเดรสตอบกลับ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุแอดเดรสตอบกลับในอีเมล ใช้ค่าเริ่มต้นแอดเดรสตอบกลับของ SMTP เสมอ เปิด ปิด * ใช้แอดเดรสตอบกลับตามค่าเริ่มต้นในเซิร์ฟเวอร์ SMTP เสมอ ใช้ SSL/TLS ปิดใช้งานแล้ว * จัดการ จำเป็นต้องใช้ ส่งอีเมลโดยใช้ลิงก์ที่เข้ารหัส จำเป็นต้องมีใบรับรองที่เชื่อถือได้ เปิด * ปิด จำเป็นต้องใช้ใบรับรองที่เชื่อถือได้เมื่อเข้าใช้เซิร์ฟเวอร์ SMTP รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การตั้งค่าการแจ้งเตือนทางอีเมล การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ไม่ต้องมีการตรวจสอบความถูกต้อง * ลงชื่อเข้าใช้ / ธรรมดา NTLM CRAM-MD5 Digest-MD5 Kerberos 5 ตั้งประเภทการตรวจสอบความถูกต้องสำหรับเซิร์ฟเวอร์ SMTP อีเมลแบบเริ่มต้นโดยอุปกรณ์ ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ กำหนดว่าจำเป็นต้องใช้ข้อมูลการตรวจสอบสำหรับอีเมลแบบเริ่มต้นโดยอุปกรณ์หรือไม่ อีเมลแบบเริ่มต้นโดยผู้ใช้ ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ ใช้รหัสผู้ใช้และรหัสผ่านสำหรับเซสชั่น ใช้ที่อยู่อีเมลและรหัสผ่านสำหรับเซสชั่น แจ้งผู้ใช้ กำหนดว่าจำเป็นต้องใช้ข้อมูลการตรวจสอบสำหรับอีเมลแบบเริ่มต้นโดยผู้ใช้หรือไม่ ใช้ข้อมูลรับรองอุปกรณ์ของไดเรกทอรีที่ใช้งาน เปิด ปิด * เปิดใช้งานข้อมูลประจำตัวผู้ใช้และการกำหนดกลุ่มเพื่อเชื่อมต่อกับเซิร์ฟเวอร์ SMTP รหัสผู้ใช้ของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผู้ใช้เพื่อลงชื่อเข้าใช้เซิร์ฟเวอร์ SMTP รหัสผ่านของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านเพื่อลงชื่อเข้าใช้เซิร์ฟเวอร์ SMTP Kerberos 5 REALM การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุการตรวจสอบรหัสประจำตัวผู้ใช้สำหรับโปรโตคอลการตรวจสอบความถูกต้อง Kerberos 5 โดเมน NTLM การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อโดเมนสำหรับโปรโตคอลการรักษาความปลอดภัย NTLM ปิดใช้งานข้อผิดพลาด “ไม่ได้ตั้งค่า SMTP เซิร์ฟเวอร์” เปิด ปิด * ปิดใช้งานข้อความแจ้งข้อผิดพลาดเกี่ยวกับการตั้งค่าเซิร์ฟเวอร์ SMTP ตั้งค่ารายการอีเมลและการแจ้งเตือน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุที่อยู่อีเมลและเปิดใช้งานการแจ้งเตือนทางอีเมล จะแสดงรายการเมนูนี้ใน Embedded Web Server เท่านั้น การป้องกันข้อผิดพลาด ADF Multifeed Sensor ปิด เปิด * ตั้งค่าเครื่องพิมพ์ให้ตรวจจับเมื่อ ADF ดึงกระดาษมากกว่าหนึ่งแผ่นต่อครั้ง ดำเนินการต่ออัตโนมัติ ปิด เปิด * ปล่อยให้เครื่องพิมพ์ดำเนินการต่อหรือพิมพ์งานต่อโดยอัตโนมัติ หลังจากล้างเงื่อนไขบางรายการ เมื่อตั้งค่าเป็น เปิด  ค่าเริ่มต้นที่กำหนดไว้คือ 5 วินาที รีบูตอัตโนมัติ รีบูตเมื่อเครื่องว่าง รีบูตเสมอ * ไม่รีบูตเลย ตั้งให้เครื่องพิมพ์รีสตาร์ทเมื่อเกิดข้อผิดพลาด การรีบูตอัตโนมัติสูงสุด 1–20  (2*) ตั้งจำนวนการรีบูตอัตโนมัติที่เครื่องพิมพ์สามารถดำเนินการได้ รีบูตหน้าต่างอัตโนมัติ 1–525600  (720*) ตั้งจำนวนวินาทีก่อนที่เครื่องพิมพ์จะทำการรีบูตอัตโนมัติ รีบูตตัวนับอัตโนมัติ การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว ตั้งจำนวนการรีบูตอัตโนมัติที่เครื่องพิมพ์สามารถดำเนินการได้ แสดงข้อผิดพลาดของกระดาษแบบสั้น เปิด ล้างข้อมูลอัตโนมัติ * ตั้งให้เครื่องพิมพ์แสดงข้อความเมื่อเกิดข้อผิดพลาดของกระดาษแบบสั้น กระดาษแบบสั้นหมายถึงขนาดของกระดาษที่ป้อน การป้องกันหน้ากระดาษ ปิด * เปิด ตั้งให้เครื่องพิมพ์ประมวลผลทั้งหน้าในหน่วยความจำก่อนพิมพ์ การกู้คืนเนื้อหากระดาษติด การกู้คืนกระดาษติด ปิด เปิด อัตโนมัติ * ตั้งให้เครื่องพิมพ์พิมพ์หน้ากระดาษที่ติดอีกครั้ง การแก้ปัญหากระดาษติดในสแกนเนอร์ ระดับงาน ระดับหน้า * ระบุวิธีการรีสตาร์ทงานสแกนหลังจากที่แก้ปัญหากระดาษติดได้แล้ว เมนู การแจ้งเตือน"},{"UUID":"129c3789-11cf-48b8-91c3-39e3a2396355","title":"อุปกรณ์","link":"preferences-topic.html","desc":"การจัดการพลังงาน รายการเมนูและคำอธิบาย การจัดการพลังงาน รายการเมนู รายการเมนูย่อย","descFull":"การจัดการพลังงาน รายการเมนูและคำอธิบาย การจัดการพลังงาน รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน โปรไฟล์โหมดพักเครื่อง พิมพ์จากโหมดพักเครื่อง เปิดค้างไว้หลังจากพิมพ์งาน เข้าสู่โหมดพักเครื่องหลังจากพิมพ์ * ตั้งให้เครื่องพิมพ์เปิดค้างไว้ หรือเข้าสู่ โหมดพักเครื่อง หลังการพิมพ์ แตะเพื่อเริ่มการทำงานจากโหมดหลับลึก ปิด เปิด * เริ่มการทำงานของเครื่องพิมพ์จาก โหมดหลับลึก หมดเวลา โหมดพักเครื่อง 1–114 นาที  (15*) ตั้งเวลาที่ว่างก่อนที่เครื่องพิมพ์จะเริ่มทำงานใน โหมดพักเครื่อง หมดเวลาไฮเบอร์เนต ปิดใช้งานแล้ว 1 ชั่วโมง 2 ชั่วโมง 3 ชั่วโมง 6 ชั่วโมง 1 วัน 2 วัน 3 วัน * 1 สัปดาห์ 2 สัปดาห์ 1 เดือน ตั้งเวลาก่อนที่เครื่องพิมพ์จะปิด หมดเวลาไฮเบอร์เนตเมื่อมีการเชื่อมต่อ ไฮเบอร์เนต ไม่ต้องไฮเบอร์เนต * ตั้งให้  หมดเวลาไฮเบอร์เนต  ปิดเครื่องพิมพ์ขณะมีการเชื่อมต่ออีเทอร์เน็ต โหมดกำหนดเวลาเปิด-ปิดเครื่อง กำหนดเวลา เพิ่มกำหนดเวลาใหม่ กำหนดเวลาให้เครื่องพิมพ์เข้าสู่ โหมดพักเครื่อง หรือโหมด ไฮเบอร์เนต เมนู การจัดการพลังงาน"},{"UUID":"a3388ba0-c730-48c0-b7a4-a33fa81ec136","title":"อุปกรณ์","link":"preferences-topic.html","desc":"แชร์ข้อมูลกับ Lexmark แชร์ข้อมูลกับรายการเมนู Lexmark และคำอธิบาย","descFull":"แชร์ข้อมูลกับ Lexmark แชร์ข้อมูลกับรายการเมนู Lexmark และคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน แชร์ข้อมูลกับ Lexmark ใช่ ไม่ * ส่งข้อมูลการใช้งานเครื่องพิมพ์และประสิทธิภาพการทำงานไปยัง Lexmark เวลาส่งการแชร์ข้อมูล เวลาเริ่มต้น เวลาหยุด เลือกกรอบเวลาสำหรับการรวบรวมข้อมูลและการส่งข้อมูล เวลาส่งการแชร์ข้อมูล  จะปรากฏขึ้นก็ต่อเมื่อคุณเลือก  ใช่  ใน  แชร์ข้อมูลกับ Lexmark เมนู แชร์ข้อมูลกับ Lexmark"},{"UUID":"189360b5-548f-40e7-8451-12f128fd129b","title":"อุปกรณ์","link":"preferences-topic.html","desc":"การเข้าถึง รายการเมนูการเข้าถึงและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การเข้าถึง รายการเมนูการเข้าถึงและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ระยะการส่งคีย์ซ้ำกันติดต่อกัน 0.00–5.00  (0.00*) ตั้งค่าช่วงเวลาเป็นวินาทีในช่วงที่เครื่องพิมพ์ไม่สนใจการกดคีย์ซ้ำกันบนแป้นพิมพ์ที่เชื่อมต่ออยู่ การหน่วงอัตราการซ้ำแป้นพิมพ์เริ่มต้น 0.25–5.00  (1.00*) ตั้งค่าความยาวเริ่มต้นของการหน่วงเวลาเป็นวินาที ก่อนที่ปุ่มการทำซ้ำจะเริ่มทำซ้ำ อัตราการซ้ำแป้นพิมพ์ 0.5–30.0  (30.0*) ตั้งค่าจำนวนการกดต่อวินาทีสำหรับปุ่มการทำซ้ำ เพิ่มระยะเวลาของหน้าจอ ปิด * เปิด ให้ผู้ใช้อยู่ในตำแหน่งเดิมและรีเซ็ตตัวตั้งเวลา การหมดเวลาหน้าจอ เมื่อหมดเวลาแทนที่จะกลับไปยังหน้าจอหลัก ระดับเสียงหูฟัง 1–10  (5*) ปรับระดับเสียงหูฟัง เปิดใช้งานการแนะนำด้วยเสียงเมื่อต่อหูฟัง ปิด * เปิด เปิดใช้งานการแนะนำด้วยเสียงเมื่อเสียบหูฟังเข้ากับช่องเสียบหูฟัง พูดรหัสผ่าน/รหัส PIN ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้อ่านออกเสียงรหัสผ่านหรือ Personal Identification Number อัตราเสียงพูด ช้ามาก ช้า ปกติ * รวดเร็ว เร็วขึ้น เร็วขึ้นอีก เร็วมาก เร็วมากกว่า เร็วที่สุด ตั้งค่าอัตราเสียงพูดของการแนะนำด้วยเสียง เมนู การเข้าถึง"},{"UUID":"8e30d11f-fd86-4770-b55f-d58ebd51b670","title":"อุปกรณ์","link":"preferences-topic.html","desc":"คืนค่าเริ่มต้นจากโรงงาน รายการเมนูคืนค่าเริ่มต้นจากโรงงานนและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"คืนค่าเริ่มต้นจากโรงงาน รายการเมนูคืนค่าเริ่มต้นจากโรงงานนและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย คืนค่าที่ตั้งไว้ คืนค่าการตั้งค่าทั้งหมด คืนค่าการตั้งค่าเครื่องพิมพ์ คืนค่าการตั้งค่าเครือข่าย คืนค่าการตั้งค่าแฟกซ์ คืนค่าการตั้งค่าแอปพลิเคชัน คืนค่าการตั้งค่าเครื่องพิมพ์เริ่มต้นจากโรงงาน เมนู คืนค่าเริ่มต้นจากโรงงาน"},{"UUID":"14f67302-4a58-4c24-9488-90a07d86d3d0","title":"การดูแลรักษา","link":"preferences-topic.html","desc":"เมนูการกำหนดค่า รายการเมนูการกำหนดค่าและคำอธิบาย รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"เมนูการกำหนดค่า รายการเมนูการกำหนดค่าและคำอธิบาย รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การกำหนดค่า USB USB PnP 1 * 2 เปลี่ยนโหมดไดรเวอร์ USB ของเครื่องพิมพ์เพื่อปรับปรุงความเข้ากันได้กับคอมพิวเตอร์ส่วนบุคคล สแกนผ่าน USB ไปยังเครื่อง เปิด * ปิด กำหนดว่าจะแสดงไดรเวอร์อุปกรณ์ USB เป็นอุปกรณ์ USB Simple (อินเตอร์เฟซเดียว) หรือเป็นอุปกรณ์ USB Composite (อินเตอร์เฟซหลายชุด) ความเร็ว USB เต็ม อัตโนมัติ * ตั้งให้พอร์ต USB ทำงานที่ความเร็วสูงสุด และปิดการทำงานความเร็วสูง การกำหนดค่าถาด การใช้เซ็นเซอร์วัดขนาด ถาด  [x]  ใช้เซ็นเซอร์วัดขนาด  ( เปิด *) ตั้งค่าถาดเพื่อวัดขนาดกระดาษที่ใส่ลงในถาดโดยอัตโนมัติ การเชื่อมโยงถาด อัตโนมัติ * ปิด ตั้งให้เครื่องพิมพ์เชื่อมต่อกับถาดที่ได้รับการตั้งค่าประเภทกระดาษและขนาดกระดาษเหมือนกัน แสดงข้อความเกี่ยวกับถาดรองกระดาษ ปิด สำหรับขนาดที่ไม่รู้จักเท่านั้น * ทุกเมื่อ แสดงข้อความเพื่อให้ผู้ใช้เปลี่ยนแปลงการตั้งค่าขนาดและประเภทกระดาษหลังจากใส่ถาดกระดาษ แจ้งเตือนกระดาษ อัตโนมัติ * ตัวป้อนกระดาษอเนกประสงค์ กระดาษแบบป้อนด้วยตนเอง ตั้งแหล่งกระดาษที่ผู้ใช้ป้อนเมื่อปรากฏข้อความแจ้งให้ใส่กระดาษ เพื่อให้ ตัวป้อนกระดาษอเนกประสงค์ ปรากฏขึ้น ในเมนู กระดาษ  ให้ตั้ง กำหนดค่า MP  เป็น  Cassette ข้อความแจ้งเกี่ยวกับซองจดหมาย อัตโนมัติ * ตัวป้อนกระดาษอเนกประสงค์ ซองจดหมายแบบป้อนด้วยตนเอง ตั้งแหล่งกระดาษที่ผู้ใช้ป้อนเมื่อปรากฏข้อความแจ้งให้ใส่ซองจดหมาย เพื่อให้ ตัวป้อนกระดาษอเนกประสงค์ ปรากฏขึ้น ในเมนู กระดาษ  ให้ตั้ง กำหนดค่า MP  เป็น  Cassette การดำเนินการข้อความแจ้ง แจ้งผู้ใช้ * ดำเนินการต่อ ใช้ค่าปัจจุบัน ตั้งให้เครื่องพิมพ์แก้ไขข้อความแจ้งการเปลี่ยนแปลงเกี่ยวกับกระดาษหรือซองจดหมาย ขนาดยูนิเวอร์แซลหลายขนาด ปิด * เปิด ตั้งให้ถาดกระดาษรองรับขนาดกระดาษยูนิเวอร์แซลหลายขนาด รายงาน ไม่ใช้ หน้าการตั้งค่าเมนู บันทึกเหตุการณ์ สรุปบันทึกเหตุการณ์ พิมพ์รายงานเกี่ยวกับการตั้งค่าเมนู สถานะ และบันทึกเหตุการณ์ของเครื่องพิมพ์ การใช้วัสดุสิ้นเปลืองและตัวนับ ล้างประวัติการใช้วัสดุสิ้นเปลือง เริ่มต้น รีเซ็ตประวัติการใช้วัสดุสิ้นเปลืองให้เป็นค่าที่ได้รับจากโรงงาน รีเซ็ต ITM เริ่มต้น รีเซ็ตตัวนับหลังจากติดตั้งรายการวัสดุสิ้นเปลืองหรือชุดบำรุงรักษาใหม่ รีเซ็ตตัวนับตลับหมึกสีดำ เริ่มต้น รีเซ็ตตัวนับตลับหมึกสีน้ำเงินเขียว เริ่มต้น รีเซ็ตตัวนับตลับหมึกสีม่วงแดง เริ่มต้น รีเซ็ตตัวนับตลับหมึกสีเหลือง เริ่มต้น รีเซ็ตตัวนับชุดสร้างภาพสีขาวดำ เริ่มต้น รีเซ็ตตัวนับชุดสร้างภาพสี เริ่มต้น รีเซ็ตตัวนับชุดลูกกลิ้ง MPF เริ่มต้น รีเซ็ตตัวนับชุดลูกกลิ้ง 1500 แผ่น เริ่มต้น รีเซ็ตตัวนับชุดลูกกลิ้ง เริ่มต้น ช่วงระยะประเมินผงหมึกที่เหลือ เมตริกประเมินผงหมึกที่เหลือ  ( แสดง *) แสดงส่วนการเรียกเก็บเงินของระยะประเมินผงหมึกที่เหลือบนรายงานสถิติอุปกรณ์ ช่วงระยะประเมินผงหมึกที่เหลือ การปรับวัสดุพิมพ์ขนาดใหญ่ ปิด * เปิด ทำให้สามารถปรับได้เมื่อพิมพ์ในกระดาษหนาหรือขนาดใหญ่ การจำลองเครื่องพิมพ์ การจำลอง PPDS ปิด * เปิด ตั้งให้เครื่องพิมพ์ใช้งานร่วมกับและใช้สตรีมข้อมูล PPDS การจำลอง PS ปิด เปิด * ตั้งให้เครื่องพิมพ์ใช้งานร่วมกับและใช้สตรีมข้อมูล PS เปิดใช้ Formsmerge ปิด * เปิด เปิดใช้งาน Forms Merge จำเป็นต้องติดตั้งใบอนุญาต Formsmerge จำเป็นต้ิองติดตั้งหน่วยความจำแฟลชของผู้ใช้ เปิดใช้ Prescribe ปิด * เปิด เปิดใช้งานภาษาของเครื่องพิมพ์ PRESCRIBE จำเป็นต้องติดตั้งใบอนุญาต PRESCRIBE ความปลอดภัยของตัวจำลอง หมดเวลาของหน้านี้  (60*) ตั้งหมดเวลาของหน้านี้ระหว่างการจำลอง รีเซ็ตตัวจำลองใหม่หลังงาน  ( ปิด *) รีเซ็ตตัวจำลองหลังจากพิมพ์งาน ปิดใช้งานการเข้าใช้ข้อความบนเครื่องพิมพ์  ( เปิด *) ตรวจสอบว่าตัวจำลองสามารถเข้าถึงการตั้งค่าเครื่องพิมพ์ครั้งแรกได้หรือไม่ การกำหนดค่าแฟกซ์ การรองรับแฟกซ์แบบใช้พลังงานต่ำ ปิดใช้งานโหมดพักเครื่อง ใช้โหมดพักเครื่องได้ อัตโนมัติ * ตรวจสอบว่าเครื่องพิมพ์รองรับส่วนแฟกซ์ของสถาปัตยกรรมแบบใช้พลังงานต่ำหรือไม่ ตำแหน่งจัดเก็บแฟกซ์ ดิสก์ * NAND ตั้งค่าตำแหน่งการจัดเก็บสำหรับแฟกซ์ทั้งหมด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น การกำหนดค่าการพิมพ์ โหมดสีดำเท่านั้น ปิด * เปิด พิมพ์งานที่ไม่ได้ทำสำเนาเป็นโทนสีเทา การทำแทรปปิ้งสี ปิด 1 2 * 3 4 5 เพิ่มคุณภาพงานพิมพ์เพื่อชดเชยการลงทะเบียนผิดพลาดในเครื่องพิมพ์ การปรับฟอนต์ให้คมชัด 0–150  (24*) ตั้งขนาดจุดข้อความที่ด้านล่าง ซึ่งจะใช้หน้าจอความถี่สูงเมื่อพิมพ์ข้อมูลฟอนต์ ตัวอย่างเช่น หากมีค่าเป็น 24 ขนาดฟอนต์ทั้งหมดที่มีขนาด 24 หรือน้อยกว่าจะใช้หน้าจอความถี่สูง ใช้ฟอนต์ ISD แบบเนทีป เปิด * ปิด ให้ผู้ใช้เลือกว่าจะใช้ฟอนต์แบบอิสระที่อยู่ในไดรฟ์จัดเก็บข้อมูลอัจฉริยะ (ISD) หรือไม่ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้ง ISD แล้วเท่านั้น การทำงานของอุปกรณ์ โหมดเงียบ ปิด * เปิด ปรับระดับเสียงรบกวนที่มาจากเครื่องพิมพ์ การเปิดใช้งานการตั้งค่านี้จะทำให้ประสิทธิภาพการทำงานโดยรวมของเครื่องพิมพ์ลดลง เปิดใช้งานโหมดพิมพ์งานต่อเนื่อง เปิด * ปิด ตั้งค่าให้เครื่องพิมพ์เร่งความเร็วในการพิมพ์หนึ่งหน้า และหน้าแรกของงานพิมพ์แบบหลายหน้าเพื่อให้งานเสร็จสิ้นเร็วกว่าเดิม จะแสดงรายการเมนูนี้ในรุ่นเครื่องพิมพ์บางรุ่นเท่านั้น โหมดปลอดภัย ปิด * เปิด ตั้งให้เครื่องพิมพ์ทำงานในโหมดพิเศษ ซึ่งเครื่องพิมพ์จะพยายามดำเนินการฟังก์ชันการทำงานให้ได้มากที่สุดเท่าที่จะเป็นไปได้ แม้ว่าจะมีปัญหาที่ทราบแล้วก็ตาม ตัวอย่างเช่น เมื่อตั้งเป็น  เปิด  และมอเตอร์พิมพ์สองด้านไม่ทำงาน เครื่องพิมพ์จะพิมพ์เอกสารด้านเดียว แม้ว่างานที่พิมพ์จะเป็นการพิมพ์สองด้านก็ตาม การเปิดใช้งานการตั้งค่านี้จะทำให้สามารถพิมพ์จากตัวป้อนกระดาษอเนกประสงค์ได้เท่านั้น หน่วยความจำขั้นต่ำในการทำสำเนา 20 MB 30 MB 50 MB 80 MB * 100 MB ตั้งการจัดสรรหน่วยความจำขั้นต่ำสำหรับจัดเก็บงานทำสำเนา ล้างสถานะแบบกำหนดเอง เริ่มต้น ลบสตริงที่ผู้ใช้กำหนดสำหรับข้อความ  เริ่มต้น  หรือข้อความ  สำรอง  ที่กำหนดเอง ล้างข้อความการติดตั้งระยะไกลทั้งหมด เริ่มต้น ลบข้อความที่ติดตั้งระยะไกล แสดงหน้าจอข้อผิดพลาดโดยอัตโนมัติ ปิด เปิด * แสดงข้อความแสดงข้อผิดพลาดที่มีอยู่บนส่วนแสดงผลหลังจากที่เครื่องพิมพ์ไม่ได้ใช้งานบนหน้าจอหลักในระยะเวลาหนึ่ง จัดวางแนวกระดาษที่เส้นทางกระดาษสำเนาด่วน ปิด * เปิด เปิดใช้งานเครื่องพิมพ์เพื่อใช้การตั้งค่าแนวการพิมพ์ภายใต้เมนู  ทำสำเนา  เมื่อส่งงานทำสำเนาอย่างรวดเร็ว หน่วยความจำถาวรของบริการ สถานะการเข้ารหัส แสดงสถานะการเข้ารหัสของไดรฟ์จัดเก็บข้อมูล เข้ารหัสหน่วยความจำถาวรของบริการ เปิดใช้งานการเข้ารหัสแบบสะท้อนด้วยตนเอง การตั้งค่าเซ็นเซอร์ผงหมึก การกำหนดค่าความถี่ในการปรับเทียบ ปิดใช้งานแล้ว การปรับสีน้อยที่สุด การปรับสีน้อยลง ปกติ * ความแม่นยำของสีที่ดีกว่า ความแม่นยำของสีที่ดีที่สุด ตั้งให้เครื่องพิมพ์ใส่ปริมาณผงหมึกที่ถูกต้องเพื่อรักษาความสม่ำเสมอของสี การปรับเทียบโดยสมบูรณ์ เริ่มต้น เรียกใช้การปรับเทียบสีโดยสมบูรณ์ พิมพ์หน้าข้อมูล TPS เริ่มต้น พิมพ์หน้าการวินิจฉัยที่มีข้อมูลเกี่ยวกับการปรับเทียบเซ็นเซอร์ผงหมึก การกำหนดค่าแอปพลิเคชัน แอปพลิเคชัน LES ปิด เปิด * เปิดใช้งานแอปพลิเคชัน Lexmark Embedded Solutions (LES) การกำหนดค่าสแกนเนอร์ การลงทะเบียนสแกนเนอร์ด้วยตนเอง การทดสอบการพิมพ์แบบด่วน การลงทะเบียน ADF ด้านหน้า การลงทะเบียน ADF ด้านหลัง การลงทะเบียนแท่นสแกน ทดสอบการพิมพ์หน้าเป้าหมายแบบด่วน หรือลงทะเบียนแท่นสแกนและตัวป้อนเอกสารอัตโนมัติ (ADF) หลังจากเปลี่ยน ADF กระจกสแกนเนอร์ หรือบอร์ดตัวควบคุม เมื่อทดสอบการพิมพ์หน้าเป้าหมายแบบด่วน ตรวจสอบให้แน่ใจว่าขอบห่างบนหน้าเป้าหมายมีความสม่ำเสมอทั่วทั้งชิ้นงาน หากไม่ใช่ คุณต้องรีเซ็ตระยะขอบของเครื่องพิมพ์ รีเซ็ตตัวนับระยะการดูแลรักษา การรีเซ็ตตัวนับระยะการดูแลรักษา ADF  ( เริ่มต้น ) รีเซ็ตตัวนับหลังจากเปลี่ยนชุดบำรุงรักษา ADF ใหม่ ลบขอบ ลบขอบแท่นสแกน  (3*) ลบขอบ ADF  (3*) ตั้งขนาดเป็นหน่วยมิลลิเมตรสำหรับพื้นที่ที่ไม่มีการพิมพ์รอบ ADF หรืองานสแกนแท่นสแกน แก้ไขการบิดเบี้ยว ADF แก้ไขการบิดเบี้ยวอิเล็กทรอนิกส์ ADF  ( เปิด *) ลดการบิดเบี้ยวของเอกสารที่สแกนจาก ADF ปิดใช้งานสแกนเนอร์ ไม่ * ใช่ ADF เท่านั้น ปิดใช้งานสแกนเนอร์หากทำงานไม่ถูกต้อง ลำดับ Tiff ไบต์ ความสามารถของ CPU Little Endian Big Endian ตั้งลำดับไบต์ของเอาต์พุตการสแกนรูปแบบ TIFF จำนวนแถว TIFF ที่แน่นอนต่อแถบข้อมูล เปิด * ปิด ตั้งแท็ก RowsPerStrip ของเอาต์พุตการสแกนรูปแบบ TIFF เกณฑ์การทำความสะอาดกระจกสแกนเนอร์ 1000–30000  (10000*) กำหนดจำนวนงานสแกนก่อน ผู้ใช้จึงจะได้รับแจ้งให้ทำความสะอาดกระจกสแกนเนอร์ เมนู เมนูการกำหนดค่า"},{"UUID":"8ecf0323-0a3a-47bd-8486-773b2b190cf4","title":"การดูแลรักษา","link":"preferences-topic.html","desc":"การลบข้อมูลไม่สามารถใช้งานได้ รายการเมนูและคำอธิบาย การลบข้อมูลไม่สามารถใช้งานได้ รายการเมนู รายการเมนูย่อย","descFull":"การลบข้อมูลไม่สามารถใช้งานได้ รายการเมนูและคำอธิบาย การลบข้อมูลไม่สามารถใช้งานได้ รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย การลบข้อมูลไม่สามารถใช้งานได้ หน่วยความจำที่ผ่านการทำความสะอาดครั้งล่าสุด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงเมื่อมีการลบหน่วยความจำของเครื่องพิมพ์ครั้งล่าสุด ฮาร์ดดิสก์ที่ผ่านการทำความสะอาดครั้งล่าสุด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงเมื่อมีการลบฮาร์ดดิสก์ครั้งล่าสุด จะแสดงรายการเมนูนี้เมื่อติดตั้งฮาร์ดดิสก์แล้วเท่านั้น ISD ที่ลบล่าสุด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงเมื่อมีการลบไดรฟ์จัดเก็บข้อมูลอัจฉริยะ (ISD) ครั้งล่าสุด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้ง ISD แล้วเท่านั้น ทำความสะอาดข้อมูลทั้งหมดบนหน่วยความจำถาวร ลบการตั้งค่าเครือข่ายและเครื่องพิมพ์ทั้งหมด ลบการตั้งค่าแอปและแอปพลิเคชันทั้งหมด ลบการตั้งค่าทางลัดและทางลัดทั้งหมด ทำความสะอาดข้อมูลทั้งหมดบนหน่วยความจำถาวร ทำความสะอาดข้อมูลทั้งหมดบนฮาร์ดดิสก์ ลบการดาวน์โหลด (ลบมาโคร ฟอนต์ PFO และอื่นๆ ทั้งหมด) ลบงานที่บัฟเฟอร์ ลบงานที่ระงับไว้ ทำความสะอาดข้อมูลทั้งหมดบนฮาร์ดดิสก์ จะแสดงรายการเมนูนี้เมื่อติดตั้งฮาร์ดดิสก์แล้วเท่านั้น ลบไดรฟ์จัดเก็บข้อมูลอัจฉริยะ ลบ ทำความสะอาดข้อมูลทั้งหมดบน ISD รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้ง ISD แล้วเท่านั้น เมนู การลบข้อมูลไม่สามารถใช้งานได้"},{"UUID":"a0436777-e560-42af-8cb6-d28d5e3dad86","title":"อุปกรณ์","link":"preferences-topic.html","desc":"อัพเดตเฟิร์มแวร์ รายการเมนูและคำอธิบายอัพเดตเฟิร์มแวร์ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"อัพเดตเฟิร์มแวร์ รายการเมนูและคำอธิบายอัพเดตเฟิร์มแวร์ รายการเมนู การตั้งค่า คำอธิบาย เวอร์ชันปัจจุบัน การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงเวอร์ชันของเฟิร์มแวร์ปัจจุบันที่ติดตั้งในเครื่องพิมพ์ ตรวจสอบการอัพเดตตอนนี้ ติดตั้งตอนนี้ ติดตั้งในภายหลัง ตรวจสอบการอัพเดตเฟิร์มแวร์ ตรวจสอบการอัพเดตอัตโนมัติ เปิด ปิด * ตั้งให้เครื่องพิมพ์ตรวจสอบการอัพเดตเฟิร์มแวร์โดยอัตโนมัติ เมนู อัพเดตเฟิร์มแวร์"},{"UUID":"f179dcef-e245-483e-b649-4dfc8327f248","title":"อุปกรณ์","link":"preferences-topic.html","desc":"เกี่ยวกับเครื่องพิมพ์นี้ รายการเมนูและคำอธิบายเกี่ยวกับเครื่องพิมพ์นี้ รายการเมนู คำอธิบาย แท็กสินทรัพย์","descFull":"เกี่ยวกับเครื่องพิมพ์นี้ รายการเมนูและคำอธิบายเกี่ยวกับเครื่องพิมพ์นี้ รายการเมนู คำอธิบาย แท็กสินทรัพย์ ระบุข้อมูลประจำเครื่องพิมพ์ ตำแหน่งเครื่องพิมพ์ ระบุตำแหน่งเครื่องพิมพ์ ข้อมูลติดต่อ ระบุข้อมูลติดต่อสำหรับเครื่องพิมพ์ เวอร์ชันของเฟิร์มแวร์ แสดงเวอร์ชันของเฟิร์มแวร์ที่ติดตั้งในเครื่องพิมพ์ เอ็นจิ้น แสดงหมายเลขเอ็นจิ้นของเครื่องพิมพ์ หมายเลขประจำเครื่อง แสดงหมายเลขประจำเครื่องของเครื่องพิมพ์ ส่งออกไฟล์การกำหนดค่าไปยัง USB ส่งออกไฟล์การกำหนดค่าไปยังแฟลชไดร์ฟ ส่งออกบันทึกที่บีบอัดไปยัง USB ส่งออกไฟล์บันทึกแบบบีบอัดไปยังแฟลชไดร์ฟ ส่งบันทึก ส่งข้อมูลบันทึกของเครื่องพิมพ์ไปยัง Lexmark เมนู เกี่ยวกับเครื่องพิมพ์นี้"},{"UUID":"77cb1d58-1145-4c55-a3b7-6ac3f22d8462","title":"พิมพ์","link":"layout-topic.html","desc":"การจัดวาง รายการเมนูและคำอธิบายการจัดวาง รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การจัดวาง รายการเมนูและคำอธิบายการจัดวาง รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ด้าน 1 ด้าน 2 ด้าน * เลือกว่าจะพิมพ์บนกระดาษด้านเดียวหรือทั้งสองด้าน รูปแบบการพลิกกระดาษ ขอบยาว * ขอบสั้น กำหนดว่าจะเย็บกระดาษด้านใดเมื่อทำการพิมพ์สองด้าน หน้าว่าง พิมพ์ ไม่ต้องพิมพ์ * พิมพ์หน้าว่างที่รวมอยู่ในงานพิมพ์ เรียงหน้า ปิด (1,1,1,2,2,2) เปิด (1,2,1,2,1,2) * เรียงหน้างานพิมพ์ตามลำดับ โดยเฉพาะอย่างยิ่งเมื่อพิมพ์งานหลายสำเนา แผ่นคั่น ไม่มี * ระหว่างสำเนา ระหว่างงาน ระหว่างหน้า แทรกแผ่นคั่นเปล่าเมื่อพิมพ์ แหล่งกระดาษของแผ่นคั่น ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ระบุแหล่งกระดาษสำหรับแผ่นคั่น จำนวนหน้าต่อด้าน ปิด * 2 หน้าต่อหนึ่งด้าน 3 หน้าต่อหนึ่งด้าน 4 หน้าต่อหนึ่งด้าน 6 หน้าต่อหนึ่งด้าน 9 หน้าต่อหนึ่งด้าน 12 หน้าต่อหนึ่งด้าน 16 หน้าต่อหนึ่งด้าน พิมพ์ภาพของหน้าที่คุณต้องการหลายหน้าลงบนด้านเดียวของหน้ากระดาษ จำนวนหน้าต่อการเรียงลำดับด้านข้าง แนวนอน * แนวนอนกลับด้าน แนวตั้ง แนวตั้งกลับด้าน ระบุการวางตำแหน่งของภาพหลายหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน จำนวนหน้าต่อการวางแนวด้านข้าง อัตโนมัติ * แนวนอน แนวตั้ง ระบุแนวการพิมพ์ของภาพหลายหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน จำนวนหน้าต่อขอบด้านข้าง ไม่มี * พื้นทึบ พิมพ์ขอบล้อมรอบรูปของหน้ากระดาษแต่ละหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน สำเนา 1–9999  (1*) ระบุจำนวนสำเนาของงานพิมพ์แต่ละงาน บริเวณที่พิมพ์ ปกติ * พอดีกับหน้า ทั้งหน้า ตั้งบริเวณที่พิมพ์ได้ลงบนกระดาษแผ่นเดียว เมนู การจัดวาง"},{"UUID":"d7da5c0f-e0cd-471b-b823-58ce9c7fe50d","title":"พิมพ์","link":"layout-topic.html","desc":"การเย็บเล่ม รายการเมนูการเย็บเล่มและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การเย็บเล่ม รายการเมนูการเย็บเล่มและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน งานเย็บกระดาษ ปิด * เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายบน เย็บกระดาษ 2 ครั้ง ที่ด้านซ้าย เย็บกระดาษ 1 ครั้ง ที่มุมขวาบน เย็บกระดาษ 2 ครั้ง ที่ด้านบน เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านล่าง เย็บกระดาษ 1 ครั้ง ที่มุมขวาล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านขวา ระบุตำแหน่งลวดเย็บสำหรับงานพิมพ์ทั้งหมด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บแล้วเท่านั้น การทดสอบลวดเย็บ เริ่มต้น ตรวจสอบว่าอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บทำงานอย่างถูกต้องหรือไม่ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บแล้วเท่านั้น อุปกรณ์ตอกรู ปิด * เปิด เจาะรูตลอดแนวขอบงานพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบตอกลวดเย็บแล้วเท่านั้น โหมดอุปกรณ์ตอกรู 2 รู 3 รู 4 รู ตั้งค่าโหมดอุปกรณ์ตอกรูสำหรับงานพิมพ์ 3 รู  เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา  4 รู  เป็นการตั้งค่าเริ่มต้นจากโรงงานสากล รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งลวดเย็บ อุปกรณ์ตอกรู หรืออุปกรณ์เย็บเล่มแล้วเท่านั้น หน้าออฟเซต ไม่มี * ระหว่างสำเนา ระหว่างงาน ปรับค่าเอาต์พุตงานพิมพ์แต่ละงานหรืองานพิมพ์แต่ละสำเนา ระหว่างสำเนา จะปรับค่างานพิมพ์แต่ละสำเนาหากตั้งค่า เรียงหน้า ไว้ที่  เปิด [1,2,1,2,1,2]  หากตั้งค่า เรียงหน้า เป็น  ปิด [1,1,1,2,2,2]  หน้าที่พิมพ์แต่ละชุดจะถูกหักล้าง เช่น หน้าทั้งหมดที่กำหนดเป็น 1 และหน้าทั้งหมดที่กำหนดเป็น 2 ระหว่างงาน จะตั้งค่าตำแหน่งการปรับค่าเหมือนกันสำหรับงานพิมพ์ทั้งหมดโดยไม่คำนึงถึงจำนวนสำเนาที่พิมพ์ เมนู กำลังเสร็จสิ้น"},{"UUID":"e22639aa-4c0e-4b0a-8d67-8c570ecb96ca","title":"พิมพ์","link":"layout-topic.html","desc":"ตั้งค่า รายการเมนูตั้งค่าและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"ตั้งค่า รายการเมนูตั้งค่าและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ภาษาของเครื่องพิมพ์ การจำลอง PCL การจำลอง PS * ตั้งภาษาของเครื่องพิมพ์ การตั้งค่าภาษาของเครื่องพิมพ์เริ่มต้นไม่สามารถป้องกันไม่ให้โปรแกรมซอฟต์แวร์ส่งงานพิมพ์ที่ใช้ภาษาของเครื่องพิมพ์ภาษาอื่น งานที่รออยู่ ปิด * เปิด เก็บงานพิมพ์ที่ต้องใช้อุปกรณ์สิ้นเปลือง เพื่อให้พิมพ์งานที่ไม่ต้องใช้อุปกรณ์สิ้นเปลืองที่ไม่มีได้ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น หมดเวลาระงับงาน 0–255  (30*) ตั้งค่าเวลาที่เครื่องพิมพ์จะรอให้ผู้ใช้ดำเนินการเองเป็นวินาที ก่อนที่จะเก็บงานที่ต้องใช้ทรัพยากรที่ไม่สามารถใช้งานได้ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น เป้าหมายการดาวน์โหลด RAM * แฟลช ดิสก์ ระบุตำแหน่งที่จะบันทึกทรัพยากรถาวรทั้งหมดที่ได้ดาวน์โหลดลงในเครื่องพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น การใช้เครื่องพิมพ์ ความเร็วสูงสุด ผลลัพธ์สูงสุด * ตรวจสอบว่าฮาร์ดแวร์ดึงกลับหลุดออกหรือใช้งานชุดแม่เหล็กดึงหมึกสีระหว่างการพิมพ์หรือไม่ เมื่อตั้งค่าเป็น  ผลลัพธ์สูงสุด  ฮาร์ดแวร์จะยังคงใช้งานกับชุดแม่เหล็กดึงหมึกสีเมื่อเครื่องพิมพ์ไม่ได้ใช้งาน เมื่อตั้งค่าเป็น  ความเร็วสูงสุด  ฮาร์ดแวร์จะยังคงใช้งานกับชุดแม่เหล็กดึงหมึกสี โดยไม่เกี่ยวข้องว่างานจะมีเนื้อหาขาวดำหรือแบบสี การใช้เครื่องพิมพ์ความเร็วต่ำ ผลลัพธ์สูงสุด * ความเร็วสูงสุด ให้เครื่องพิมพ์สลับระหว่างผลลัพธ์สูง (เฉพาะโหมดขาวดำเท่านั้น) กับความเร็วสูง (โหมดสี) เมื่อใช้งานที่ความเร็วต่ำ การตั้งค่าจะเปลี่ยนแปลงลักษณะการทำงานของเครื่องพิมพ์ เมื่อเอ็นจิ้นการพิมพ์ทำงานที่ความเร็วในการประมวลผล 25 หน้าต่อนาที โดยไม่ส่งผลกระทบเมื่อเอ็นจิ้นการพิมพ์ทำงานที่ความเร็วในการประมวลผลเร็วขึ้น ประหยัดทรัพยากร ปิด * เปิด กำหนดว่าจะให้เครื่องพิมพ์ดำเนินการอย่างไรกับทรัพยากรที่ดาวน์โหลดไว้ เมื่อได้รับงานที่ต้องการหน่วยความจำมากกว่าที่มีอยู่ เมื่อตั้งเป็น  ปิด เครื่องพิมพ์จะเก็บทรัพยากรที่ดาวน์โหลดไว้จนกว่าจะต้องใช้หน่วยความจำเท่านั้น ทรัพยากรที่เกี่ยวข้องกับภาษาของเครื่องพิมพ์ที่ไม่ได้ใช้งานจะถูกลบออก เมื่อตั้งเป็น  เปิด เครื่องพิมพ์จะเก็บทรัพยากรแบบถาวรทั้งหมดที่ดาวน์โหลดไว้ในทุกภาษา หากจำเป็น เครื่องพิมพ์จะแสดงข้อความหน่วยความจำเต็ม แทนที่จะลบทรัพยากรถาวร พิมพ์คำสั่งทั้งหมด ตามลำดับตัวอักษร * ใหม่ที่สุดก่อน เก่าที่สุดก่อน ระบุลำดับเมื่อคุณเลือกที่จะพิมพ์งานที่ระงับไว้และงานที่เป็นความลับทั้งหมด การลบงานพิมพ์ที่ระงับชั่วคราวอัตโนมัติ ปิด * เปิด ตั้งค่าเครื่องพิมพ์เพื่อยกเลิกงานพิมพ์ที่อยู่ในคิวโดยอัตโนมัติ เนื่องจากถูกขัดจังหวะจากข้อผิดพลาดต่างๆ เช่น กระดาษติดและวัสดุสิ้นเปลืองขาดหายไป เมนู ตั้งค่า"},{"UUID":"a6467c0e-2297-4f72-a406-fc2edd9fc22c","title":"พิมพ์","link":"layout-topic.html","desc":"คุณภาพ รายการเมนูและคำอธิบายคุณภาพ รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"คุณภาพ รายการเมนูและคำอธิบายคุณภาพ รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน โหมดการพิมพ์ ไม่ใช้ สีขาว-ดำ สี * ตั้งค่าวิธีการสร้างเนื้อหาสีของเครื่องพิมพ์ ความละเอียดในการพิมพ์ ไม่ใช้ 4800 CQ * 1200 dpi ตั้งความละเอียดสำหรับงานพิมพ์ 4800 CQ  ให้งานพิมพ์คุณภาพสูงที่ความเร็วสูงสุด ความเข้มของหมึก ไม่ใช้ 1 ถึง 5  (4*) กำหนดความจางหรือความเข้มของรูปข้อความ ฮาล์ฟโทน ไม่ใช้ ปกติ * รายละเอียด เพิ่มความคมชัดของงานพิมพ์เพื่อให้ได้เส้นที่เรียบเนียนยิ่งขึ้นพร้อมขอบที่คมชัดขึ้น ตัวบันทึกสี ไม่ใช้ ปิด * เปิด ลดปริมาณผงหมึกที่ใช้พิมพ์ภาพกราฟิกและภาพ เมื่อตั้งเป็น  เปิด  การตั้งค่านี้จะแทนที่ค่าในการตั้งค่า  ความเข้มของหมึก ความสว่างของ RGB ไม่ใช้ ‑6 ถึง 6  (0*) ปรับความสว่างของ RGB และวัตถุสีเทาทั้งหมดในหน้า การตั้งค่านี้ไม่มีผลต่อไฟล์ที่ใช้ข้อกำหนดรายละเอียดสีมาตรฐาน CMYK ความเปรียบต่างของ RGB ไม่ใช้ 0 ถึง 5  (0*) ปรับความเปรียบต่างของ RGB และวัตถุสีเทาทั้งหมดในหน้า การตั้งค่านี้ไม่มีผลต่อไฟล์ที่ใช้ข้อกำหนดรายละเอียดสีมาตรฐาน CMYK ความอิ่มสีของ RGB ไม่ใช้ 0 ถึง 5  (0*) เก็บค่าสีขาว-ดำไว้ในระหว่างที่ปรับค่าสีของวัตถุทั้งหมดในหน้า การตั้งค่านี้ไม่มีผลต่อไฟล์ที่ใช้ข้อกำหนดรายละเอียดสีมาตรฐาน CMYK การสร้างภาพขั้นสูง ความสมดุลของสี สีน้ำเงินเขียว  (0*) สีม่วงแดง  (0*) สีเหลือง  (0*) สีดำ  (0*) ปรับปริมาณผงหมึกที่ใช้สำหรับแต่ละสี รีเซตค่าเริ่มต้น รีเซ็ตการตั้งค่าสีทั้งหมดเป็นค่าเริ่มต้น การปรับแก้สี ปิด อัตโนมัติ * ด้วยตนเอง แก้ไขการตั้งค่าสีที่ใช้พิมพ์เอกสาร ปิด —จะกำหนดให้เครื่องพิมพ์รับการปรับแก้สีจากซอฟต์แวร์ อัตโนมัติ —จะตั้งเครื่องพิมพ์ให้ใช้โปรไฟล์สีที่แตกต่างกันในวัตถุแต่ละชิ้นบนหน้าที่พิมพ์ ด้วยตนเอง —ช่วยให้สามารถปรับแต่งการแปลงค่าสีมาตรฐาน RGB หรือ CMYK ที่นำไปใช้กับวัตถุแต่ละชิ้นบนหน้าที่พิมพ์ได้ ตัวอย่างสี พิมพ์ตัวอย่างสี พิมพ์หน้าตัวอย่างสำหรับตารางการแปลงสี RGB และ CMYK แต่ละตารางที่ใช้ในเครื่องพิมพ์ ปรับสี ปรับสี ปรับเทียบเครื่องพิมพ์เพื่อปรับค่าความแตกต่างของสีในงานพิมพ์ การเปลี่ยนสีเฉพาะจุด ตั้งค่า CMYK แบบกำหนดเอง กำหนดค่า CMYK ที่ระบุให้กับสีพิเศษที่มีชื่อ 20 สี เมนู คุณภาพ"},{"UUID":"b2545b8f-0813-4f38-99dd-10720b47c026","title":"พิมพ์","link":"layout-topic.html","desc":"การทำบัญชีงาน รายการเมนูและคำอธิบายการทำบัญชีงาน รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การทำบัญชีงาน รายการเมนูและคำอธิบายการทำบัญชีงาน รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การทำบัญชีงาน ปิด * เปิด ตั้งให้เครื่องพิมพ์สร้างบันทึกของงานพิมพ์ที่ได้รับ ความถี่ของบันทึกข้อมูลบัญชีงาน ทุกวัน ทุกสัปดาห์ ทุกเดือน * ระบุความถี่ที่เครื่องพิมพ์จะสร้างไฟล์บันทึก การดำเนินการบันทึกเมื่อสิ้นสุดความถี่ ไม่มี * อีเมลบันทึกปัจจุบัน อีเมลและลบบันทึกปัจจุบัน โพสต์บันทึกปัจจุบัน โพสต์และลบบันทึกปัจจุบัน ระบุวิธีที่เครื่องพิมพ์จะดำเนินการเมื่อเกณฑ์ความถี่หมดอายุ ค่าที่กำหนดไว้ใน  ความถี่ของบันทึกข้อมูลบัญชีงาน  จะกำหนดว่าจะดำเนินการนี้เมื่อใด บันทึกใกล้ถึงระดับเต็ม เปิด * (5MB) ปิด ระบุขนาดสูงสุดของไฟล์บันทึกก่อนที่เครื่องพิมพ์จะดำเนินการ  บันทึกเมื่อใกล้เต็ม รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น การดำเนินการบันทึกเมื่อใกล้เต็ม ไม่มี * อีเมลบันทึกปัจจุบัน อีเมลและลบบันทึกปัจจุบัน อีเมลและลบบันทึกที่เก่าที่สุด โพสต์บันทึกปัจจุบัน โพสต์และลบบันทึกปัจจุบัน โพสต์และลบบันทึกที่เก่าที่สุด ลบบันทึกปัจจุบัน ลบบันทึกที่เก่าที่สุด ลบทั้งหมด ยกเว้นรายการปัจจุบัน ลบบันทึกทั้งหมด ระบุวิธีที่เครื่องพิมพ์จะดำเนินการเมื่อไดรฟ์จัดเก็บข้อมูลใกล้เต็ม ค่าที่กำหนดไว้ใน  บันทึกใกล้ถึงระดับเต็ม  จะกำหนดว่าจะดำเนินการนี้เมื่อใด การดำเนินการบันทึกเมื่อเต็ม ไม่มี * อีเมลและลบบันทึกปัจจุบัน อีเมลและลบบันทึกที่เก่าที่สุด โพสต์และลบบันทึกปัจจุบัน โพสต์และลบบันทึกที่เก่าที่สุด ลบบันทึกปัจจุบัน ลบบันทึกที่เก่าที่สุด ลบทั้งหมด ยกเว้นรายการปัจจุบัน ลบบันทึกทั้งหมด ระบุว่าเครื่องพิมพ์จะดำเนินการอย่างไรเมื่อการใช้งานไดรฟ์จัดเก็บข้อมูลถึงขีดจำกัดสูงสุด (100MB) URL ไปยังโพสต์ล็อก การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุตำแหน่งที่เครื่องพิมพ์จะโพสต์บันทึกการทำบัญชีงาน ที่อยู่อีเมลสำหรับส่งบันทึก การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุที่อยู่อีเมลที่เครื่องพิมพ์จะส่งบันทึกการทำบัญชีงาน รหัสนำหน้าไฟล์บันทึก การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุคำนำหน้าสำหรับไฟล์บันทึก จะใช้ชื่อคอมพิวเตอร์แม่ข่ายปัจจุบันที่กำหนดไว้ในเมนู TCP/IP เป็นคำนำหน้าของไฟล์บันทึกเริ่มต้น เมนู การทำบัญชีงาน"},{"UUID":"4bbc7cef-3e8f-42ec-a7e5-68088b5cb222","title":"พิมพ์","link":"layout-topic.html","desc":"PDF รายการเมนูและคำอธิบาย PDF รายการเมนู การตั้งค่า","descFull":"PDF รายการเมนูและคำอธิบาย PDF รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ปรับขนาดให้พอดี ปิด * เปิด ปรับขนาดเนื้อหาของหน้าให้พอดีกับขนาดกระดาษที่เลือก คำอธิบายประกอบ พิมพ์ ไม่ต้องพิมพ์ * ระบุว่าจะพิมพ์คำอธิบายประกอบใน PDF หรือไม่ พิมพ์ข้อผิดพลาด PDF ปิด เปิด * เปิดใช้งานการพิมพ์ข้อผิดพลาด PDF เมนู PDF"},{"UUID":"9bea8cd5-3262-4eb6-90c4-3ec1953284e7","title":"พิมพ์","link":"layout-topic.html","desc":"PostScript PostScript รายการเมนูและคำอธิบาย PostScript รายการเมนู","descFull":"PostScript PostScript รายการเมนูและคำอธิบาย PostScript รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน พิมพ์ข้อผิดพลาด PS ปิด * เปิด พิมพ์หน้าที่อธิบายข้อผิดพลาดการจำลองแบบของ PostScript® เมื่อเกิดข้อผิดพลาด การประมวลผลของงานจะหยุดทำงาน เครื่องพิมพ์จะพิมพ์ข้อความแจ้งข้อผิดพลาดและจะล้างข้อมูลงานพิมพ์ที่เหลือทั้งหมด ความกว้างเส้นขั้นต่ำ 1–30  (2*) ตั้งความกว้างของเส้นคั่นน้อยสุด งานที่พิมพ์ด้วยความละเอียด 1200 dpi จะใช้ค่าดังกล่าวโดยตรง ล็อคโหมดเริ่มต้น PS ปิด เปิด * ปิดใช้งานไฟล์ SysStart การเปิดใช้งานไฟล์ SysStart ทำให้เครื่องพิมพ์หรือเครือข่ายตกอยู่ในความเสี่ยงด้านความปลอดภัย การปรับภาพให้เรียบ ปิด * เปิด เพิ่มความเปรียบต่างและความคมชัดของภาพความละเอียดต่ำ การตั้งค่านี้ไม่มีผลกระทบต่อภาพที่มีความละเอียด 300 dpi หรือสูงกว่า ลำดับความสำคัญของฟอนต์ ฟอนต์ที่ติดมากับเครื่องพิมพ์ * แฟลช/ดิสก์ กำหนดลำดับการค้นหาฟอนต์ ฟอนต์ที่ติดมากับเครื่องพิมพ์ —ตั้งค่าให้เครื่องพิมพ์ค้นหาฟอนต์ที่ต้องการในหน่วยความจำ ก่อนที่จะค้นหาในไดรฟ์จัดเก็บข้อมูล แฟลช/ดิสก์ —จะกำหนดให้เครื่องพิมพ์ค้นหาฟอนต์ที่ต้องการจากไดรฟ์จัดเก็บข้อมูลก่อนที่จะทำการค้นหาในหน่วยความจำของเครื่องพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น หมดเวลารอ ปิด เปิด * เปิดใช้งานเครื่องพิมพ์เพื่อรอข้อมูลเพิ่มเติมก่อนยกเลิกงานพิมพ์ เมื่อตั้งค่าเป็น เปิด  ค่ามาตรฐานที่กำหนดมาจากโรงงานจะเท่ากับ 40 วินาที เมนู PostScript"},{"UUID":"eb9d62b2-8682-4936-bdd9-b19a104969bf","title":"พิมพ์","link":"layout-topic.html","desc":"PCL รายการเมนูและคำอธิบาย PCL รายการเมนู การตั้งค่า","descFull":"PCL รายการเมนูและคำอธิบาย PCL รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน แหล่งฟอนต์ ฟอนต์ที่ติดมากับเครื่องพิมพ์ * ดิสก์ ดาวน์โหลด แฟลช ฟอนต์การ์ด ทั้งหมด เลือกแหล่งที่มาที่มีการเลือกฟอนต์เริ่มต้น ดิสก์ —จะปรากฏขึ้นเมื่อมีการติดตั้งฮาร์ดดิสก์ที่มีฟอนต์และไม่มีข้อบกพร่อง ไม่มีการป้องกันการอ่าน/เขียนเท่านั้น ดาวน์โหลด —จะปรากฏขึ้นเมื่อมีฟอนต์ที่ดาวน์โหลดแล้วอยู่ในหน่วยความจำของเครื่องพิมพ์เท่านั้น แฟลช —จะปรากฏขึ้นเมื่อมีการติดตั้งหน่วยความจำแฟลชที่มีฟอนต์และไม่มีข้อบกพร่อง ไม่มีการป้องกันการอ่าน/เขียนเท่านั้น ฟอนต์การ์ด —จะปรากฏขึ้นเมื่อมีการติดตั้งฟอนต์การ์ดที่ถูกต้องหรือมีการกำหนดค่าไดรฟ์จัดเก็บข้อมูลอัจฉริยะเท่านั้น ชื่อฟอนต์ [รายการฟอนต์ที่มีอยู่] ( ผู้ส่งสาร *) เลือกฟอนต์จากแหล่งฟอนต์ที่ระบุ ชุดสัญลักษณ์ [รายการชุดสัญลักษณ์ที่มีอยู่] ( 10U PC‑8 *) ระบุชุดสัญลักษณ์สำหรับชื่อฟอนต์แต่ละชื่อ ชุดสัญลักษณ์คือชุดตัวอักษรและตัวเลข เครื่องหมายวรรคตอน และสัญลักษณ์พิเศษ ชุดสัญลักษณ์จะรองรับภาษาต่างๆ หรือโปรแกรมเฉพาะ เช่น สัญลักษณ์ทางคณิตศาสตร์สำหรับข้อความทางวิทยาศาสตร์ ระยะห่างตัวอักษร 0.08–100.00  (10.00*) ระบุระยะห่างตัวอักษรของฟอนต์ที่กำหนดตายตัวหรือฟอนต์ที่มีระยะห่างเล็กน้อย รายการเมนูนี้หมายถึงจำนวนของตัวอักษรที่มีระยะห่างคงที่ในการพิมพ์แนวนอน แนวการพิมพ์ แนวตั้ง * แนวนอน แนวตั้งกลับด้าน แนวนอนกลับด้าน ระบุการวางแนวของข้อความและกราฟิกบนหน้า บรรทัดต่อหน้า 1–255 ระบุจำนวนบรรทัดข้อความสำหรับแต่ละหน้าที่พิมพ์ผ่านสตรีมข้อมูล PCL® รายการเมนูนี้จะเปิดใช้งานการเว้นห่างตามแนวตั้งที่ทำให้พิมพ์จำนวนบรรทัดที่ร้องขอในระหว่างระยะขอบห่างตามค่าเริ่มต้นของหน้า 60 เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา 64 เป็นการตั้งค่าเริ่มต้นจากโรงงานสากล ความกว้างเส้นขั้นต่ำ PCL5 1–30  (2*) ตั้งค่าความกว้างของเส้นคั่นน้อยสุดของงานที่พิมพ์ด้วยความละเอียด 1200 dpi ผ่านแบบจำลองที่เกี่ยวข้อง ความกว้างเส้นขั้นต่ำ PCLXL 1–30  (2*) ความกว้าง A4 198 มม. * 203 มม. ตั้งความกว้างของหน้าเชิงตรรกะบนกระดาษขนาด A4 หน้าเชิงตรรกะคือพื้นที่ว่างบนหน้าจริงที่พิมพ์ข้อมูล CR อัตโนมัติหลังจาก LF เปิด ปิด * ตั้งให้เครื่องพิมพ์ขึ้นบรรทัดใหม่หลังคำสั่งควบคุมการเลื่อนบรรทัด การขึ้นบรรทัดใหม่เป็นกลไกที่สั่งให้เครื่องพิมพ์เลื่อนเคอร์เซอร์ไปยังตำแหน่งแรกในบรรทัดเดียวกัน LF อัตโนมัติหลังจาก CR เปิด ปิด * ตั้งให้เครื่องพิมพ์เลื่อนบรรทัดหลังคำสั่งควบคุมการขึ้นบรรทัดใหม่ กำหนดหมายเลขถาดใหม่ กำหนดตัวป้อนกระดาษ MP กำหนดถาด  [x] กำหนดกระดาษด้วยตนเอง กำหนดซองจดหมายด้วยตนเอง กำหนดค่าเครื่องพิมพ์ให้ทำงานร่วมกับไดรเวอร์การพิมพ์หรือแอปพลิเคชันแบบกำหนดเองอื่นๆ ซึ่งใช้การกำหนดแหล่งกระดาษชุดที่แตกต่างเพื่อร้องขอแหล่งกระดาษที่ระบุ เลือกจากตัวเลือกต่อไปนี้: ปิด *—เครื่องพิมพ์จะใช้แหล่งกระดาษที่เป็นค่าเริ่มต้นจากโรงงาน ไม่มี —แหล่งกระดาษจะไม่สนใจคำสั่งเลือกการป้อนกระดาษ 0–199 —เลือกค่าตัวเลขเพื่อกำหนดค่าที่กำหนดเองให้กับแหล่งกระดาษ ดูค่าเริ่มต้นจากโรงงาน แสดงค่าเริ่มต้นจากโรงงานที่กำหนดไว้สำหรับแหล่งกระดาษแต่ละแหล่ง นำค่ามาตรฐานกลับมาใช้ คืนค่ากำหนดหมายเลขถาดใหม่เป็นค่าเริ่มต้นจากโรงงาน หมดเวลาพิมพ์ ปิด เปิด * (90) ตั้งค่าเครื่องพิมพ์ให้สิ้นสุดงานพิมพ์หลังจากไม่มีการใช้งานตามระยะเวลาที่ระบุ เมนู PCL"},{"UUID":"f895431c-2296-414c-ae84-305727482fc6","title":"พิมพ์","link":"layout-topic.html","desc":"ภาพ รายการเมนูและคำอธิบายภาพ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"ภาพ รายการเมนูและคำอธิบายภาพ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ปรับขนาดให้พอดีอัตโนมัติ เปิด ปิด * เลือกการตั้งค่าขนาดและการวางแนวกระดาษที่ดีที่สุดสำหรับภาพ เมื่อตั้งเป็น  เปิด  รายการเมนูนี้จะแทนที่การตั้งค่าการปรับขนาดและการวางแนวสำหรับภาพ กลับด้าน ปิด * เปิด สลับภาพขาวดำ จะใช้รายการเมนูนี้ไม่ได้กับรูปภาพแบบ GIF หรือ JPEG การปรับขนาด พอดีที่สุด * ตรึงทางด้านซ้ายบน ตรึงกึ่งกลาง พอดีกับความสูง/ความกว้าง พอดีกับความสูง พอดีกับความกว้าง ปรับภาพให้พอดีกับพื้นที่ที่พิมพ์ได้ เมื่อตั้งให้  ปรับขนาดให้พอดีอัตโนมัติ  เป็น  เปิด ,  การปรับขนาด  จะถูกตั้งเป็น  พอดีที่สุด  โดยอัตโนมัติ แนวการพิมพ์ แนวตั้ง * แนวนอน แนวตั้งกลับด้าน แนวนอนกลับด้าน ระบุการวางแนวของข้อความและกราฟิกบนหน้า เมนู ภาพ"},{"UUID":"9a8bb478-6072-4468-9eff-ff46dfa7bc94","title":"กระดาษ","link":"tray-configuration-topic.html","desc":"การกำหนดค่าถาด การกำหนดค่าถาดรายการเมนูและคำอธิบาย รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"การกำหนดค่าถาด การกำหนดค่าถาดรายการเมนูและคำอธิบาย รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน แหล่งกระดาษเริ่มต้น ไม่ใช้ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ กระดาษแบบป้อนด้วยตนเอง ซองจดหมายแบบป้อนด้วยตนเอง ตั้งแหล่งกระดาษเริ่มต้นสำหรับงานพิมพ์ทั้งหมด ขนาด/ประเภทของกระดาษ ถาด  [x] ตัวป้อนกระดาษอเนกประสงค์ กระดาษแบบป้อนด้วยตนเอง ซองจดหมายแบบป้อนด้วยตนเอง ขนาด ประเภท ระบุขนาดหรือประเภทกระดาษที่ใส่ในแหล่งกระดาษแต่ละแหล่ง ขนาดที่ใช้แทน ไม่ใช้ ปิด Statement/A5 Letter/A4 11 x 17/A3 ที่แสดงรายการทั้งหมด ตั้งให้เครื่องพิมพ์ใช้ขนาดกระดาษที่กำหนดแทน หากไม่ได้ใส่ขนาดที่ต้องการในแหล่งกระดาษ ปิด —จะแจ้งให้ผู้ใช้ใส่ขนาดกระดาษที่ต้องการ ที่แสดงรายการทั้งหมด —จะอนุญาตให้แทนที่ได้ทั้งหมด กำหนดค่า MP ไม่ใช้ กลักกระดาษ * ด้วยตนเอง อันดับแรก กำหนดลักษณะการทำงานของตัวป้อนกระดาษอเนกประสงค์ กลักกระดาษ —กำหนดค่าตัวป้อนกระดาษอเนกประสงค์เป็นแหล่งกระดาษโดยอัตโนมัติ ด้วยตนเอง —จะตั้งค่าตัวป้อนกระดาษอเนกประสงค์สำหรับงานพิมพ์ที่ป้อนกระดาษด้วยตนเองเท่านั้น อันดับแรก —กำหนดค่าตัวป้อนกระดาษอเนกประสงค์เป็นแหล่งกระดาษหลัก เมนู การกำหนดค่าถาด"},{"UUID":"0457d700-40fc-42d3-805c-17706ed4f3ce","title":"กระดาษ","link":"tray-configuration-topic.html","desc":"การกำหนดค่าวัสดุพิมพ์ รายการเมนูและคำอธิบายการกำหนดค่าวัสดุพิมพ์ รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"การกำหนดค่าวัสดุพิมพ์ รายการเมนูและคำอธิบายการกำหนดค่าวัสดุพิมพ์ รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน หน่วยวัด ไม่ใช้ นิ้ว มิลลิเมตร ระบุหน่วยวัดสำหรับกระดาษยูนิเวอร์แซล นิ้ว  เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา  มิลลิเมตร  เป็นค่ามาตรฐานที่กำหนดมาจากโรงงานในต่างประเทศ การตั้งค่าแบบยูนิเวอร์แซล ถาดป้อนเอกสารทั้งหมด ความกว้างภาพแนวตั้ง ตั้งความกว้างภาพแนวตั้งของกระดาษยูนิเวอร์แซล ความสูงภาพแนวตั้ง ตั้งความสูงภาพแนวตั้งของกระดาษยูนิเวอร์แซล ทิศทางการป้อน  ( ขอบสั้น *) ตั้งให้เครื่องพิมพ์ดึงกระดาษจากขอบสั้นหรือขอบยาว จะปรากฏ  ขอบยาว  ขึ้นเมื่อขอบที่ยาวที่สุดสั้นกว่าความกว้างสูงสุดที่รองรับเท่านั้น ขนาดการสแกนแบบกำหนดเอง ชื่อขนาดการสแกน การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดชื่อสำหรับการสแกนแบบกำหนดเอง ความกว้าง 1.–8.5 นิ้ว  (8.5*) 25–215.9 มม.  (215.9*) ระบุความกว้างของเอกสารต้นฉบับ ความสูง 1–25 นิ้ว  (11*) 25–635 มม.  (279.4*) ระบุความสูงของเอกสารต้นฉบับ แนวการพิมพ์ แนวตั้ง * แนวนอน ระบุแนวการพิมพ์ของเนื้อหาในเอกสารต้นฉบับ สแกน 2 ครั้งต่อด้าน ปิด * เปิด ตั้งค่าหมายเลขเริ่มต้นของการสแกนที่แต่ละด้านของเครื่องพิมพ์ การตั้งค่าประเภทวัสดุพิมพ์ [รายการประเภทกระดาษ] พื้นผิว น้ำหนัก ทิศทางการใส่กระดาษ ส่งไปยังถาด ระบุพื้นผิว น้ำหนัก และการวางแนวกระดาษ เมนู การกำหนดค่าวัสดุพิมพ์"},{"UUID":"1182f712-3fdc-45c6-a3e0-a36c641eb1fd","title":"กระดาษ","link":"tray-configuration-topic.html","desc":"การกำหนดค่าถาด รายการเมนูและคำอธิบายการกำหนดค่าถาด รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การกำหนดค่าถาด รายการเมนูและคำอธิบายการกำหนดค่าถาด รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ถาดกระดาษออก ถาดมาตรฐาน * ถาด  [x] ระบุถาดกระดาษออกสำหรับงานของเครื่องพิมพ์ กำหนดค่าถาด เมลบ็อกซ์ * เชื่อมโยง เชื่อมโยงรายการที่เป็นทางเลือก การกำหนดประเภท กำหนดค่าโหมดการดำเนินงานสำหรับถาดกระดาษออก เมลบ็อกซ์ —ช่วยให้สามารถเลือกถาดมาตรฐานและถาดเสริมใด ๆ แบบทีละรายการได้ เชื่อมโยง —ช่วยให้ถาดกระดาษออกทั้งหมดเชื่อมโยงถึงกัน แม้จะเป็นถาดขนาดใหญ่ก็ตาม เชื่อมโยงรายการที่เป็นทางเลือก —จัดการถาดเสริมทั้งหมดเป็นถาดกระดาษออกขนาดใหญ่หนึ่งถาด การกำหนดประเภท —กำหนดประเภทกระดาษแต่ละประเภทในถาดหรือชุดถาดที่เชื่อมโยง ชื่อถาดแบบกำหนดเอง ถาดมาตรฐาน ถาด  [x] กำหนดชื่อสำหรับถาดแต่ละถาด เมนู การกำหนดค่าถาด"},{"UUID":"67c45efc-1e82-413c-8dbb-d885dbb9f4a6","title":"ทำสำเนา","link":"copy-defaults-topic.html","desc":"ค่าเริ่มต้นของการทำสำเนา รายการเมนูและคำอธิบายค่าเริ่มต้นของการทำสำเนา รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"ค่าเริ่มต้นของการทำสำเนา รายการเมนูและคำอธิบายค่าเริ่มต้นของการทำสำเนา รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ประเภทเนื้อหา ไม่ใช้ ข้อความ ข้อความ/ภาพถ่าย * ภาพถ่าย ภาพกราฟิก ปรับปรุงผลลัพธ์เอาต์พุตตามเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา ไม่ใช้ เลเซอร์ขาว-ดำ เลเซอร์สี * อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ปรับปรุงผลลัพธ์เอาต์พุตตามแหล่งข้อมูลของเอกสารต้นฉบับ ด้าน ไม่ใช้ 1 ด้านเป็น 1 ด้าน * 1 ด้านเป็น 2 ด้าน 2 ด้านเป็น 1 ด้าน 2 ด้านเป็น 2 ด้าน ระบุลักษณะการสแกนตามเอกสารต้นฉบับ แผ่นคั่น ไม่ใช้ ไม่มี * ระหว่างสำเนา ระหว่างงาน ระหว่างหน้า ระบุว่าจะแทรกแผ่นคั่นเปล่าเมื่อพิมพ์หรือไม่ แหล่งกระดาษของแผ่นคั่น ไม่ใช้ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ระบุแหล่งกระดาษสำหรับแผ่นคั่น สี ไม่ใช้ ปิด เปิด * อัตโนมัติ ตั้งค่าเครื่องพิมพ์เพื่อสร้างงานพิมพ์สีจากงานสแกน จำนวนหน้าต่อด้าน ไม่ใช้ ปิด * 2 หน้าแนวตั้ง 4 หน้าแนวตั้ง 2 หน้าแนวนอน 4 หน้าแนวนอน ระบุจำนวนของหน้าที่คุณต้องการพิมพ์ลงบนด้านเดียวของหน้ากระดาษ พิมพ์ขอบหน้ากระดาษ ไม่ใช้ ปิด * เปิด วางเส้นขอบรอบแต่ละภาพเมื่อพิมพ์หลายหน้าลงบนหน้าเดียว เรียงหน้า ไม่ใช้ ปิด [1,1,1,2,2,2] เปิด [1,2,1,2,1,2] * พิมพ์สำเนาหลายชุดตามลำดับ หน้าออฟเซต ไม่ใช้ ไม่มี * ระหว่างสำเนา ระหว่างงาน ปรับค่าเอาต์พุตงานพิมพ์แต่ละงานหรืองานพิมพ์แต่ละสำเนา ระหว่างสำเนา —จะปรับค่างานพิมพ์แต่ละสำเนาหากตั้งค่า เรียงหน้า ไว้ที่  เปิด [1,2,1,2,1,2]  หากตั้งค่า เรียงหน้า เป็น  ปิด [1,1,1,2,2,2]  หน้าที่พิมพ์แต่ละชุดจะถูกหักล้าง เช่น หน้าที่ 1 และหน้าที่ 2 ทั้งหมด ระหว่างงาน —จะตั้งค่าตำแหน่งการปรับค่าเหมือนกันสำหรับงานพิมพ์ทั้งหมดโดยไม่คำนึงถึงจำนวนสำเนาที่พิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เรียงกระดาษออฟเซ็ต หรืออุปกรณ์เย็บเล่มแบบตอกลวดเย็บแล้วเท่านั้น ลวดเย็บ ไม่ใช้ ปิด * เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายบน เย็บกระดาษ 2 ครั้ง ที่ด้านซ้าย เย็บกระดาษ 1 ครั้ง ที่มุมขวาบน เย็บกระดาษ 2 ครั้ง ที่ด้านบน เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านล่าง เย็บกระดาษ 1 ครั้ง ที่มุมขวาล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านขวา เย็บกระดาษ 4 ครั้ง ระบุตำแหน่งลวดเย็บสำหรับงานพิมพ์ทั้งหมด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บแล้วเท่านั้น เจาะรู ไม่ใช้ ปิด * 2 รู 3 รู 4 รู เจาะรูบนงานพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งลวดเย็บ อุปกรณ์ตอกรู หรืออุปกรณ์เย็บเล่มแล้วเท่านั้น ขนาด “คัดลอกจาก” [รายการขนาดกระดาษ] ตั้งขนาดกระดาษของเอกสารต้นฉบับ Letter  เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา A4  เป็นการตั้งค่าเริ่มต้นจากโรงงานสากล แหล่ง “คัดลอกไปยัง” ไม่ใช้ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ปรับขนาดให้เข้ากันอัตโนมัติ ระบุแหล่งกระดาษสำหรับงานทำสำเนา อุณหภูมิ ไม่ใช้ ‑4 ถึง 4  (0*) ระบุว่าจะสร้างเอาต์พุตที่เย็นกว่าหรืออุ่นกว่า ความเข้ม ไม่ใช้ 1 ถึง 9  (5*) ปรับความเข้มของภาพที่สแกน จำนวนสำเนา ไม่ใช้ 1–9999  (1*) ระบุจำนวนสำเนา ส่วนหัว/ส่วนท้าย ไม่ใช้ ส่วนหัวด้านซ้าย ส่วนหัวตรงกลาง ส่วนหัวด้านขวา ส่วนท้ายด้านซ้าย ส่วนท้ายตรงกลาง ส่วนท้ายด้านขวา ระบุข้อมูลส่วนหัวหรือส่วนท้ายของภาพที่สแกน การวางซ้อน ไม่ใช้ เป็นความลับ ทำสำเนา ร่าง ด่วน กำหนดเอง ปิด * ระบุข้อความแบบวางซ้อนที่จะพิมพ์บนแต่ละสำเนา การวางซ้อนแบบกำหนดเอง ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์ข้อความสำหรับตัวเลือก กำหนดเอง ในเมนู การวางซ้อน การสร้างภาพขั้นสูง ความสมดุลของสี สีน้ำเงินเขียว ‑ สีแดง  (0*) สีม่วงแดง - สีเขียว  (0*) สีเหลือง - สีน้ำเงิน  (0*) ปรับความเข้มของสีสำหรับสีน้ำเงิน แดง และเหลือง การลบสี การลบสี  ( ไม่มี *) เกณฑ์สีแดงเริ่มต้น  (128*) เกณฑ์สีเขียวเริ่มต้น  (128*) เกณฑ์สีน้ำเงินเริ่มต้น  (128*) ระบุสีที่จะลบระหว่างการสแกน และปรับการตั้งค่าการลบของสีดังกล่าว ตรวจสอบสีอัตโนมัติ ความไวสี  (5*) ความไวของพื้นที่  (5*) กำหนดค่าการตั้งค่าการตรวจสอบสีอัตโนมัติ ความเปรียบต่าง เหมาะกับเนื้อหาที่สุด * 0–5 ระบุความเปรียบต่างของสีสำหรับภาพที่สแกน การนำพื้นหลังออก การตรวจจับพื้นหลัง  ( ใช้เนื้อหาเป็นฐาน *) ระดับ  (0*) ลบสีพื้นหลังหรือสัญญาณรบกวนภาพออกจากเอกสารต้นฉบับ ใช้เนื้อหาเป็นฐาน —จะลบสีพื้นหลังออกจากเอกสารต้นฉบับ แบบตายตัว —จะลบสัญญาณรบกวนภาพออกจากภาพถ่าย กึ่งกลางอัตโนมัติ ปิด * เปิด จัดแนวเนื้อหาที่ตรงกลางของหน้า ภาพสะท้อน ปิด * เปิด สร้างภาพสะท้อนของเอกสารต้นฉบับ ภาพเนกาทีฟ ปิด * เปิด สร้างภาพเนกาทีฟของเอกสารต้นฉบับ รายละเอียดในส่วนมืด ‑4 ถึง 4  (0*) ปรับรายละเอียดในส่วนมืดของเอกสารต้นฉบับ สแกนแบบจรดขอบ ปิด * เปิด สแกนเอกสารต้นฉบับจากขอบหนึ่งไปยังอีกขอบหนึ่ง ความคมชัด 1–5  (3*) ปรับความคมชัดของภาพที่สแกน ส่วนควบคุมของผู้ดูแล ใช้การทำสำเนาสีได้ ปิด เปิด * พิมพ์สำเนาเป็นสี ใช้การทำสำเนาเป็นหลักได้ ปิด เปิด * ขัดจังหวะงานพิมพ์เพื่อทำสำเนา การสแกนงานแบบกำหนดเอง ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้สแกนเอกสารต้นฉบับชุดแรกโดยใช้การตั้งค่าที่ระบุ จากนั้นสแกนชุดถัดไปด้วยการตั้งค่าเดียวกันหรือต่างกัน บันทึกเป็นทางลัดได้ ปิด เปิด * บันทึกการตั้งค่าการทำสำเนาเป็นทางลัด สำเนาตัวอย่าง ปิด * เปิด พิมพ์สำเนาตัวอย่างเพื่อตรวจสอบคุณภาพก่อนพิมพ์สำเนาที่เหลือ เมนู ค่าเริ่มต้นของการทำสำเนา"},{"UUID":"815d8f66-6b5a-4f3e-87b2-5555f8644731","title":"ค่าเริ่มต้นของแฟกซ์","link":"fax-defaults-subgroup.html","desc":"โหมดแฟกซ์ รายการเมนูและคำอธิบาย โหมดแฟกซ์ รายการเมนู การตั้งค่า","descFull":"โหมดแฟกซ์ รายการเมนูและคำอธิบาย โหมดแฟกซ์ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน โหมดแฟกซ์ แฟกซ์ * เซิร์ฟเวอร์แฟกซ์ ปิดใช้งานแล้ว เลือกโหมดแฟกซ์ เมนู โหมดแฟกซ์"},{"UUID":"0ddd740a-3c69-49d0-9cf9-7ad8cc00e0b6","title":"ค่าเริ่มต้นของแฟกซ์","link":"fax-defaults-subgroup.html","desc":"การตั้งค่าแฟกซ์ รายการเมนูและคำอธิบายการตั้งค่าแฟกซ์ทั่วไป รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"การตั้งค่าแฟกซ์ รายการเมนูและคำอธิบายการตั้งค่าแฟกซ์ทั่วไป รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การตั้งค่าแฟกซ์ทั่วไป ชื่อแฟกซ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุหมายเลขแฟกซ์ของคุณ หมายเลขแฟกซ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุหมายเลขแฟกซ์ของคุณ หมายเลขแฟกซ์ ชื่อแฟกซ์ หมายเลขแฟกซ์ * กำหนดหมายเลขแฟกซ์เพื่อใช้ในระหว่างการตรวจสอบแฟกซ์ เปิดใช้การแฟกซ์ด้วยตนเอง ปิด * เปิด เปิดฟังก์ชันการแฟกซ์ด้วยตนเองในเครื่องพิมพ์ รายการเมนูนี้จำเป็นต้องใช้ตัวแยกสัญญาณสายโทรศัพท์และชุดหูฟังของโทรศัพท์ ใช้สายโทรศัพท์ปกติเพื่อรับแฟกซ์ที่เข้ามารวมถึงโทรออกไปยังหมายเลขแฟกซ์ หากต้องการไปที่ฟังก์ชันการแฟกซ์ด้วยตนเองโดยตรง ให้แตะที่  #   และ  0  บนแผงปุ่มกด การใช้หน่วยความจำ รับทั้งหมด ได้รับเป็นส่วนใหญ่ เท่ากับ * ส่งเป็นส่วนใหญ่ ส่งทั้งหมด ตั้งจำนวนหน่วยความจำภายในของเครื่องพิมพ์ที่จัดสรรไว้สำหรับแฟกซ์ รายการเมนูนี้ป้องกันเงื่อนไขบัฟเฟอร์หน่วยความจำและแฟกซ์ที่ล้มเหลว ยกเลิกแฟกซ์ อนุญาต * ไม่อนุญาต ยกเลิกแฟกซ์ขาออกหรือแฟกซ์ขาเข้า การปกปิดหมายเลขแฟกซ์ ปิด * จากซ้าย จากขวา ระบุรูปแบบสำหรับการซ่อนหมายเลขแฟกซ์ขาออก การตั้งค่าแฟกซ์ทั่วไป หลักตัวเลขที่จะปกปิด 0–58  (0*) ระบุจำนวนหลักตัวเลขที่จะปกปิดในหมายเลขแฟกซ์ที่ส่งออก เปิดใช้งานการตรวจจับการเชื่อมต่อแบบสาย ปิด เปิด * ตรวจสอบว่าสายโทรศัพท์เชื่อมต่อกับเครื่องพิมพ์หรือไม่ พบเหตุการณ์ทันที เปิดใช้งานการตรวจจับการเชื่อมต่อแจ็คที่ไม่ถูกต้อง ปิด เปิด * ตรวจสอบว่าสายโทรศัพท์เชื่อมต่อเข้ากับพอร์ตที่ถูกต้องของเครื่องพิมพ์หรือไม่ พบเหตุการณ์ทันที เปิดใช้งานการสนับสนุนการใช้งานส่วนขยาย ปิด เปิด * ตรวจสอบว่าอุปกรณ์อื่นใช้สายโทรศัพท์อยู่หรือไม่ เช่น โทรศัพท์อีกเครื่องบนสายโทรศัพท์เดียวกัน พบเหตุการณ์ทันที ปรับการใช้งานแฟกซ์ร่วมกันให้ดีขึ้น การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดค่าฟังก์ชันแฟกซ์ของเครื่องพิมพ์เพื่อให้สามารถใช้งานร่วมกับเครื่องแฟกซ์อื่นๆ ได้อย่างเหมาะสม การส่งแฟกซ์ T.38 อนาล็อก G.711 etherFAX ตั้งค่าวิธีการส่งแฟกซ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อมีการติดตั้งชุดใบอนุญาต etherFAX หรือ Fax Over IP (FoIP) ในเครื่องพิมพ์เท่านั้น การตั้งค่าแฟกซ์ HTTPS เมนูนี้จะปรากฏขึ้นเมื่อตั้งค่า การส่งแฟกซ์ เป็น  etherFAX  เท่านั้น URL บริการ HTTPS การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ URL บริการ etherFAX พร็อกซี่ HTTPS การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ URL ของพร็อกซี่เซิร์ฟเวอร์ ผู้ใช้พร็อกซี่ HTTPS การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อผู้ใช้และรหัสผ่านสำหรับพร็อกซี่่่่่่่่เซิร์ฟเวอร์ รหัสผ่านพร็อกซี่ HTTPS ส่งแฟกซ์การเข้ารหัส ปิดใช้งานแล้ว เปิดใช้งานแล้ว * จำเป็นต้องใช้ เปิดใช้งานการเข้ารหัสสำหรับข้อความแฟกซ์ขาออก รับแฟกซ์การเข้ารหัส ปิดใช้งานแล้ว เปิดใช้งานแล้ว * จำเป็นต้องใช้ เปิดใช้งานการเข้ารหัสสำหรับข้อความแฟกซ์ขาเข้า สถานะแฟกซ์ HTTPS การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการสื่อสาร etherFAX การตั้งค่าการส่งแฟกซ์ ความละเอียด มาตรฐาน * ละเอียด ละเอียดสูง ละเอียดเป็นพิเศษ ตั้งความละเอียดของภาพที่สแกน ความละเอียดที่สูงขึ้นจะเพิ่มเวลาในการส่งแฟกซ์และต้องใช้หน่วยความจำมากขึ้น ขนาดต้นฉบับ [รายการขนาดกระดาษ] ( คละขนาด *) ระบุขนาดของเอกสารต้นฉบับ แนวการพิมพ์ แนวตั้ง * แนวนอน ระบุแนวการพิมพ์ของเอกสารต้นฉบับ ด้าน ปิด * ขอบสั้น ขอบยาว ระบุแนวการพิมพ์ของเอกสารต้นฉบับเมื่อสแกนทั้งสองด้านของเอกสาร ประเภทเนื้อหา ข้อความ * ข้อความ/ภาพถ่าย ภาพถ่าย ภาพกราฟิก ปรับปรุงผลลัพธ์เอาต์พุตตามเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา เลเซอร์ขาว-ดำ เลเซอร์สี * อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ปรับปรุงผลลัพธ์เอาต์พุตตามแหล่งข้อมูลของเอกสารต้นฉบับ ความเข้ม 1–9  (5*) ปรับความเข้มของภาพที่สแกน หลัง PABX เปิด ปิด * ตั้งเครื่องพิมพ์ให้โทรออกหมายเลขแฟกซ์โดยไม่ต้องรอสัญญาณโทรออก Private Automated Branch Exchange (PABX) เป็นเครือข่ายโทรศัพท์ที่อนุญาตให้การเข้าใช้หมายเลขเดียวมีสายหลายสายเพื่อติดต่อระหว่างผู้โทรจากภายนอก โหมดการโทรออก เสียง *. พัลส์ ระบุโหมดการโทรออกสำหรับแฟกซ์ขาเข้าหรือขาออก การสร้างภาพขั้นสูง ความสมดุลของสี สีน้ำเงินเขียว ‑ สีแดง  (0*) สีม่วงแดง - สีเขียว  (0*) สีเหลือง - สีน้ำเงิน  (0*) ปรับความเข้มของสีระหว่างการสแกน การลบสี เหมาะกับเนื้อหาที่สุด * 0 1 2 3 4 5 ตั้งความเปรียบต่างของงานพิมพ์ ภาพสะท้อน ปิด * เปิด สร้างภาพสะท้อนของเอกสารต้นฉบับ รายละเอียดในส่วนมืด ‑4 ถึง 4  (0*) ปรับรายละเอียดในส่วนมืดที่มองเห็นบนภาพที่สแกน สแกนแบบจรดขอบ ปิด เปิด * อนุญาตให้สแกนแบบจรดขอบของเอกสารต้นฉบับ ความคมชัด 1–5  (3*) ปรับความคมชัดของภาพที่สแกน อุณหภูมิ ‑4 ถึง 4  (0*) ระบุว่าจะสร้างเอาต์พุตที่เย็นกว่าหรืออุ่นกว่า ส่วนควบคุมของผู้ดูแล การโทรซ้ำอัตโนมัติ 0–9  (5*) ระบุจำนวนครั้งของความพยายามที่เครื่องพิมพ์โทรซ้ำก่อนจะยกเลิกการส่งแฟกซ์ไปยังปลายทางที่ระบุ ความถี่ในการโทรซ้ำ 1–200  นาที (3*) เพิ่มเวลาระหว่างการพยายามโทรซ้ำเพื่อเพิ่มโอกาสในการส่งแฟกซ์ให้สำเร็จ เปิดใช้งาน ECM เปิด * ปิด เปิดใช้งานโหมดการแก้ไขข้อผิดพลาด (ECM) สำหรับงานแฟกซ์ ECM จะตรวจจับและแก้ไขข้อผิดพลาดในกระบวนการส่งแฟกซ์ที่เกิดจากสัญญาณรบกวนในสายโทรศัพท์และความเข้มสัญญาณไม่ดี เปิดใช้การสแกนแฟกซ์ เปิด * ปิด สร้างแฟกซ์โดยใช้สแกนเนอร์ของเครื่องพิมพ์ ไดรเวอร์สำหรับแฟกซ์ เปิด * ปิด อนุญาตให้ไดรเวอร์การพิมพ์ส่งแฟกซ์ บันทึกเป็นทางลัดได้ เปิด * ปิด บันทึกหมายเลขแฟกซ์เป็นทางลัดในเครื่องพิมพ์ ความเร็วสูงสุด 33600 * 14400 9600 4800 2400 ตั้งความเร็วสูงสุดสำหรับการส่งแฟกซ์ การสแกนงานแบบกำหนดเอง ปิด * เปิด เปิดการสแกนงานที่กำหนดเองตามค่าเริ่มต้น ตัวอย่างการสแกน ปิด * เปิด แสดงตัวอย่างการสแกนบนส่วนแสดงผล ปรับตั้งค่า ADF Skew ปิด เปิด * แก้ไขการบิดเบี้ยวเล็กน้อยในภาพที่สแกน เปิดใช้การสแกนแฟกซ์สี ปิดตามค่าเริ่มต้น * เปิดตามค่าเริ่มต้น ไม่ใช้เลย ใช้เสมอ เปิดใช้งานการสแกนสีสำหรับแฟกซ์ แปลงแฟกซ์สีเป็นแฟกซ์ขาวดำโดยอัตโนมัติ เปิด * ปิด แปลงแฟกซ์สีที่ส่งออกทั้งหมดให้เป็นแฟกซ์ขาวดำ ยืนยันหมายเลขแฟกซ์ ปิด * เปิด ขอให้ผู้ใช้ยืนยันหมายเลขแฟกซ์ หมายเลขนำหน้าการโทรออก การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งหมายเลขนำหน้าการโทรออก กฎหมายเลขนำหน้าการโทรออก การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดกฎหมายเลขนำหน้าการโทรออก การตั้งค่าการรับแฟกซ์ งานแฟกซ์ที่รออยู่ ไม่มี * หมึก หมึกและวัสดุสิ้นเปลือง ลบงานแฟกซ์ที่ร้องขอทรัพยากรเฉพาะที่ไม่พร้อมให้ใช้งานออกจากคิวการพิมพ์ เสียงเรียกเข้าเพื่อให้รับสาย 1–25  (3*) ตั้งจำนวนครั้งของเสียงเรียกเข้าที่จำเป็นก่อนที่เครื่องพิมพ์จะตอบรับสายขาเข้า การย่อขนาดอัตโนมัติ เปิด * ปิด ปรับขนาดแฟกซ์ที่ได้รับให้พอดีกับหน้ากระดาษ แหล่งกระดาษ ถาด  [x] อัตโนมัติ * ตั้งแหล่งกระดาษสำหรับการพิมพ์แฟกซ์ขาเข้า ด้าน เปิด ปิด * พิมพ์ลงบนหน้ากระดาษทั้งสองด้าน แผ่นคั่น ไม่มี * ก่อนเริ่มงาน หลังเสร็จงาน ระบุว่าจะแทรกแผ่นคั่นเปล่าเมื่อพิมพ์หรือไม่ แหล่งกระดาษของแผ่นคั่น ถาด  [x] (1*) ระบุแหล่งกระดาษสำหรับแผ่นคั่น ถาดกระดาษออก ถาดมาตรฐาน ระบุถาดกระดาษออกสำหรับแฟกซ์ที่รับ ส่วนท้ายของแฟกซ์ เปิด ปิด * พิมพ์ข้อมูลการส่งที่ด้านล่างของแต่ละหน้าจากแฟกซ์ที่ได้รับ ลงเวลาที่ส่วนท้ายของแฟกซ์ รับ * พิมพ์ พิมพ์ประทับเวลาที่ด้านล่างของแต่ละหน้าจากแฟกซ์ที่ได้รับ การระงับแฟกซ์ โหมดแฟกซ์ที่ระงับไว้  (ปิด*) ระงับแฟกซ์ที่รับไม่ให้มีการพิมพ์จนกว่าจะปล่อย กำหนดเวลาการระงับแฟกซ์ กำหนดเวลาสำหรับการระงับแฟกซ์ รายการเมนูนี้จะปรากฏขึ้นหากตั้ง โหมดแฟกซ์ที่ระงับไว้  เป็น กำหนดเวลาแล้ว เท่านั้น ส่วนควบคุมของผู้ดูแล เปิดใช้การรับแฟกซ์ เปิด * ปิด ตั้งเครื่องพิมพ์เพื่อรับแฟกซ์ เปิดใช้การรับแฟกซ์สี เปิด * ปิด ตั้งเครื่องพิมพ์เพื่อรับแฟกซ์เป็นสี เปิดใช้งานหมายเลขเรียกเข้า เปิด ปิด * แสดงข้อมูลหมายเลขเรียกเข้าของสายขาเข้าบนส่วนแสดงผลของเครื่องพิมพ์ บล็อคแฟกซ์ที่ไม่มีชื่อ เปิด ปิด * บล็อคแฟกซ์ขาเข้าที่ไม่มีหมายเลขแฟกซ์ รายการแฟกซ์ที่ปิดกั้น เพิ่มแฟกซ์ที่ปิดกั้น ระบุหมายเลขโทรศัพท์ที่คุณต้องการบล็อค เปิดการรับสาย เสียงเรียกเข้าทั้งหมด * เสียงเรียกเข้าครั้งเดียวเท่านั้น เสียงเรียกเข้าสองครั้งเท่านั้น เสียงเรียกเข้าสามครั้งเท่านั้น เสียงเรียกเข้าครั้งเดียวหรือสองครั้งเท่านั้น เสียงเรียกเข้าครั้งเดียวหรือสามครั้งเท่านั้น เสียงเรียกเข้าสองครั้งหรือสามครั้งเท่านั้น ตั้งรูปแบบเสียงเรียกเข้าเฉพาะสำหรับแฟกซ์ขาเข้า รับสายอัตโนมัติ เปิด * ปิด ตั้งเครื่องพิมพ์ให้รับแฟกซ์โดยอัตโนมัติ รหัสการรับสายด้วยตนเอง 0–9  (9*) ป้อนรหัสด้วยตนเองบนแผงหมายเลขโทรศัพท์เพื่อเริ่มต้นรับแฟกซ์ จะปรากฏรายการเมนูนี้ขึ้นเมื่อเครื่องพิมพ์ใช้สายโทรศัพท์ร่วมกับโทรศัพท์เท่านั้น จะปรากฏรายการเมนูนี้ขึ้นเมื่อคุณตั้งให้เครื่องพิมพ์รับแฟกซ์ด้วยตนเองเท่านั้น การส่งต่อแฟกซ์ พิมพ์ * พิมพ์และส่งต่อ ส่งต่อ ระบุว่าจะส่งต่อแฟกซ์ที่ได้รับหรือไม่ ส่งต่อไปยัง ปลายทาง 1 ปลายทาง 2 ระบุว่าจะส่งต่อแฟกซ์ที่ได้รับไปที่ใด จะปรากฏรายการเมนูนี้เมื่อตั้งให้  การส่งต่อแฟกซ์  เป็น  พิมพ์และส่งต่อ  หรือ  ส่งต่อ เท่านั้น ความเร็วสูงสุด 33600 * 14400 9600 4800 2400 ตั้งความเร็วสูงสุดสำหรับการส่งแฟกซ์ ใบปะหน้าแฟกซ์ ใบปะหน้าแฟกซ์ ปิดตามค่าเริ่มต้น * เปิดตามค่าเริ่มต้น ไม่ใช้เลย ใช้เสมอ กำหนดค่าการตั้งค่าสำหรับใบปะหน้าแฟกซ์ รวมช่อง “ถึง” ปิด * เปิด รวมช่อง “จาก” ปิด * เปิด จาก การตั้งค่านี้กำหนดโดยผู้ใช้ รวมช่อง “ข้อความ” ปิด * เปิด ข้อความ: การตั้งค่านี้กำหนดโดยผู้ใช้ รวมโลโก้ ปิด * เปิด รวมส่วนท้าย [x] ปิด * เปิด ส่วนท้าย [x] การตั้งค่านี้กำหนดโดยผู้ใช้ การตั้งค่าบันทึกแฟกซ์ ความถี่การบันทึกการส่งข้อมูล ทุกเมื่อ * ไม่เลย สำหรับข้อผิดพลาดเท่านั้น ระบุความถี่ที่เครื่องพิมพ์จะสร้างบันทึกการส่งข้อมูล การดำเนินการบันทึกการส่งข้อมูล พิมพ์  ( เปิด *) อีเมล  ( ปิด *) พิมพ์หรือส่งอีเมลบันทึกการส่งแฟกซ์หรือความผิดพลาดในการส่งที่สำเร็จ รับบันทึกข้อผิดพลาด ไม่พิมพ์เลย * พิมพ์เมื่อมีข้อผิดพลาด พิมพ์บันทึกการรับแฟกซ์ล้มเหลว พิมพ์บันทึกอัตโนมัติ เปิด * ปิด พิมพ์การใช้งานแฟกซ์ทั้งหมด บันทึกแหล่งกระดาษ ถาด  [x] (1*) ระบุแหล่งกระดาษสำหรับการพิมพ์บันทึก การแสดงบันทึก ชื่อแฟกซ์ระยะไกล หมายเลขที่โทรออก ระบุผู้ส่งด้วยชื่อแฟกซ์หรือหมายเลขแฟกซ์ระยะไกล เปิดใช้บันทึกงาน เปิด * ปิด ดูข้อมูลสรุปของงานแฟกซ์ทั้งหมด เปิดใช้บันทึกการโทร เปิด * ปิด ดูข้อมูลสรุปของประวัติการโทรหมายเลขแฟกซ์ ถาดกระดาษออกสำหรับบันทึก ถาดมาตรฐาน * ถาด  [x] ระบุถาดกระดาษออกสำหรับบันทึกที่พิมพ์ การตั้งค่าลำโพง โหมดลำโพง ปิดเสมอ * เปิดเสมอ เปิดจนกว่าจะเชื่อมต่อ ตั้งโหมดลำโพงแฟกซ์ ระดับเสียงลำโพง ต่ำ * สูง ปรับระดับเสียงลำโพงแฟกซ์ ระดับเสียงเรียกเข้า ปิด * เปิด เปิดใช้งานระดับเสียงเรียกเข้า การตั้งค่า VoIP โปรโตคอล VoIP SIP * H.323 กำหนดโปรโตคอลของ Voice over Internet Protocol (VoIP) เซิร์ฟเวอร์ STUN การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุเซิร์ฟเวอร์ STUN เพื่อตรวจสอบไฟร์วอล์ บังคับโหมดแฟกซ์ ปิด เปิด * สลับเกตเวย์ VoIP จากอนาล็อกเป็น T.38 เมื่อเริ่มการติดต่อทางแฟกซ์ เลื่อนเวลาการบังคับโหมดแฟกซ์ 0–15  (7*) ตั้งค่าการเลื่อนเวลาเป็นหน่วยวินาทีขณะที่ส่งคำเชิญอื่นของ บังคับโหมดแฟกซ์ การตั้งค่า SIP พร็อกซี่่่่่่่่ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ IP แอดเดรสของระบบที่แปลงหมายเลขโทรศัพท์เป็น IP แอดเดรสที่ส่งแฟกซ์ถึง ระบบทะเบียน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อหรือ IP แอดเดรสของระบบที่จัดการการลงทะเบียนของเครื่องลูกข่าย Session Initiation Protocol (SIP) ผู้ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อของผู้ใช้สำหรับ SIP รหัสผ่าน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านที่ใช้ในการลงทะเบียนกับระบบทะเบียน SIP Auth ID การตั้งค่านี้กำหนดโดยผู้ใช้ ชื่อผู้ใช้ที่ใช้ขณะลงทะเบียน หากไม่มีการกำหนดการตั้งค่า  Auth ID  ระบบตั้งค่าจะใช้ชื่อผู้ใช้ของช่อง ผู้ใช้ แทน การส่งสำหรับการลงทะเบียน UDP * TCP ตั้งค่าประเภทการส่ง SIP สำหรับการลงทะเบียน การส่งสำหรับสายขาเข้า UDP * TCP UDP และ TCP ตั้งค่าประเภทการส่ง SIP สำหรับสายขาเข้า การส่งสำหรับสายขาออก UDP * TCP ตั้งค่าประเภทการส่ง SIP สำหรับสายขาออก พร็อกซี่่่่่่่่ขาออก การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุพร็อกซี่่่่่่่่ขาออกเพื่อส่งต่อการสื่อสาร SIP ทั้งหมด ข้อมูลติดต่อ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อผู้ติดต่อสำหรับ SIP Realm การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อ Realm สำหรับ SIP หากไม่มีการกำหนดการตั้งค่า Realm ระบบตั้งค่าจะใช้ชื่อของ ผู้ติดต่อ แทน สถานะการลงทะเบียน SIP การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการลงทะเบียน SIP การตั้งค่า H.323 เกตเวย์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ IP แอดเดรสของเกตเวย์ H.323 Gatekeeper การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ H.323 Gatekeeper ผู้ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อผู้ใช้ที่ใช้กับเกตเวย์ H.323 รหัสผ่าน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านสำหรับเกตเวย์ H.323 เปิดใช้งานการเริ่มต้นด่วน ปิด * เปิด เปิดใช้งานการเริ่มต้นด่วน ปิดใช้งาน H.245 Tunneling ปิด * เปิด ปิดใช้งาน H.323 Tunneling ปิดใช้งาน Gatekeeper Discovery ปิด เปิด * ปิดใช้งาน H.323 Gatekeeper Discovery การตั้งค่า T.38 การใช้ไฟแสดงสถานะซ้ำซ้อน 0–5  (3*) กำหนดจำนวนครั้งที่ไฟแสดงสถานะของแฟกซ์ถูกใช้ซ้ำในการสื่อสาร T.38 การใช้ข้อมูลความเร็วต่ำซ้ำซ้อน 0–5  (3*) กำหนดจำนวนครั้งที่ข้อมูลความเร็วต่ำถูกใช้ซ้ำในการสื่อสาร T.38 การใช้ข้อมูลความเร็วสูงซ้ำซ้อน 0–5  (1*) กำหนดจำนวนครั้งที่ข้อมูลความเร็วสูงถูกใช้ซ้ำในการสื่อสาร T.38 เมนู การตั้งค่าแฟกซ์"},{"UUID":"e1f5e66c-bdd7-47c6-a1aa-e2f1736c66e3","title":"ค่าเริ่มต้นของแฟกซ์","link":"fax-defaults-subgroup.html","desc":"การตั้งค่าเซิร์ฟเวอร์แฟกซ์ การตั้งค่าแฟกซ์ทั่วไป รายการเมนูและคำอธิบายการตั้งค่าแฟกซ์ทั่วไป รายการเมนู การตั้งค่า","descFull":"การตั้งค่าเซิร์ฟเวอร์แฟกซ์ การตั้งค่าแฟกซ์ทั่วไป รายการเมนูและคำอธิบายการตั้งค่าแฟกซ์ทั่วไป รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เพื่อฟอร์แมต ไม่ใช้ ระบุผู้รับแฟกซ์ หากท่านต้องการใช้หมายเลขแฟกซ์ ให้พิมพ์เครื่องหมายหมายเลข (#) ก่อนหมายเลข แอดเดรสตอบกลับ ไม่ใช้ ระบุแอดเดรสตอบกลับสำหรับการส่งแฟกซ์ เรื่อง ไม่ใช้ ระบุหัวเรื่องแฟกซ์และข้อความ ข้อความ ไม่ใช้ เปิดใช้งานการรับแบบอนาล็อก ปิด * เปิด ตั้งเครื่องพิมพ์เพื่อรับแฟกซ์อนาล็อก การตั้งค่าอีเมลสำหรับเซิร์ฟเวอร์แฟกซ์ รายการเมนูและคำอธิบาย การตั้งค่าอีเมลสำหรับเซิร์ฟเวอร์แฟกซ์ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ใช้อีเมลบนเซิร์ฟเวอร์ SMTP เปิด ปิด * ใช้การตั้งค่า Simple Mail Transfer Protocol (SMTP) สำหรับอีเมลในการรับและส่งแฟกซ์ เมื่อตั้งค่าเป็น  เปิด  การตั้งค่าอื่นๆ ทั้งหมดของเมนู  การตั้งค่าอีเมลสำหรับเซิร์ฟเวอร์แฟกซ์  จะไม่ปรากฏขึ้น เกตเวย์ SMTP หลัก ไม่ใช้ พิมพ์ IP แอดเดรสหรือชื่อคอมพิวเตอร์แม่ข่ายของเซิร์ฟเวอร์ SMTP หลัก พอร์ตเกตเวย์ SMTP หลัก 1-65535 (25*) ป้อนหมายเลขพอร์ตของเซิร์ฟเวอร์ SMTP หลัก เกตเวย์ SMTP รอง ไม่ใช้ พิมพ์ IP แอดเดรสของเซิร์ฟเวอร์หรือชื่อคอมพิวเตอร์แม่ข่ายของเซิร์ฟเวอร์ SMTP รองหรือสำรอง พอร์ตเกตเวย์ SMTP รอง 1-65535 (25*) ป้อนหมายเลขพอร์ตเซิร์ฟเวอร์ของเซิร์ฟเวอร์ SMTP รองหรือสำรอง หมดเวลา SMTP 5-30 (30*) ตั้งเวลาก่อนที่เครื่องพิมพ์จะหมดเวลาหากเซิร์ฟเวอร์ SMTP ไม่ตอบสนอง แอดเดรสตอบกลับ ไม่ใช้ ระบุแอดเดรสตอบกลับสำหรับการส่งแฟกซ์ ใช้ SSL/TLS ปิดใช้งานแล้ว * จัดการ จำเป็นต้องใช้ ระบุว่าจะส่งแฟกซ์โดยใช้ลิงก์ที่เข้ารหัสหรือไม่ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิด เปิด * ระบุใบรับรองที่เชื่อถือได้เมื่อเข้าใช้เซิร์ฟเวอร์ SMTP การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ไม่ต้องมีการตรวจสอบความถูกต้อง * ลงชื่อเข้าใช้ / ธรรมดา NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 ตั้งประเภทการตรวจสอบความถูกต้องสำหรับเซิร์ฟเวอร์ SMTP อีเมลแบบเริ่มต้นโดยอุปกรณ์ ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ ระบุว่าจำเป็นต้องใช้ข้อมูลประจำตัวสำหรับอีเมลแบบเริ่มต้นโดยอุปกรณ์หรือไม่ อีเมลแบบเริ่มต้นโดยผู้ใช้ ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ ใช้รหัสผู้ใช้และรหัสผ่านสำหรับเซสชั่น ใช้ที่อยู่อีเมลและรหัสผ่านสำหรับเซสชั่น แจ้งผู้ใช้ ระบุว่าจำเป็นต้องใช้ข้อมูลประจำตัวสำหรับอีเมลแบบเริ่มต้นโดยผู้ใช้หรือไม่ ใช้ข้อมูลรับรองอุปกรณ์ของไดเรกทอรีที่ใช้งาน ปิด * เปิด เปิดใช้งานข้อมูลประจำตัวผู้ใช้และปลายทางกลุ่มเพื่อเชื่อมต่อกับเซิร์ฟเวอร์ SMTP รหัสผู้ใช้ของอุปกรณ์ ไม่ใช้ ระบุ ID ผู้ใช้และรหัสผ่านเพื่อเชื่อมต่อกับเซิร์ฟเวอร์ SMTP รหัสผ่านของอุปกรณ์ ไม่ใช้ Kerberos 5 REALM ไม่ใช้ ระบุการตรวจสอบรหัสประจำตัวผู้ใช้สำหรับโปรโตคอลการตรวจสอบความถูกต้อง Kerberos 5 โดเมน NTLM ไม่ใช้ ระบุชื่อโดเมนสำหรับโปรโตคอลการรักษาความปลอดภัย NTLM ปิดใช้งานข้อผิดพลาด “ไม่ได้ตั้งค่า SMTP เซิร์ฟเวอร์” ปิด * เปิด ซ่อนข้อความแสดงข้อผิดพลาด “ยังไม่มีการตั้งค่าเซิร์ฟเวอร์ SMTP” การตั้งค่าสแกนสำหรับเซิร์ฟเวอร์แฟกซ์ รายการเมนูและคำอธิบาย การตั้งค่าสแกนสำหรับเซิร์ฟเวอร์แฟกซ์ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน รูปแบบภาพ TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) ระบุรูปแบบไฟล์สำหรับภาพที่สแกน ประเภทเนื้อหา ข้อความ * ข้อความ/ภาพถ่าย ภาพถ่าย ภาพกราฟิก ปรับปรุงผลลัพธ์เอาต์พุตตามเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา เลเซอร์ขาว-ดำ เลเซอร์สี * อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ปรับปรุงผลลัพธ์เอาต์พุตตามแหล่งข้อมูลของเอกสารต้นฉบับ ความละเอียดของแฟกซ์ มาตรฐาน * ละเอียด ละเอียดสูง ละเอียดเป็นพิเศษ กำหนดความละเอียดของแฟกซ์ ด้าน ปิด * ขอบสั้น ขอบยาว ระบุแนวการพิมพ์ของเอกสารต้นฉบับเมื่อสแกนทั้งสองด้านของเอกสาร ความเข้ม 1-9 (5*) ตั้งความเข้มของงานพิมพ์ แนวการพิมพ์ แนวตั้ง * แนวนอน ระบุการวางแนวของข้อความและกราฟิกบนหน้า ขนาดต้นฉบับ [รายการขนาดกระดาษ] ตั้งขนาดกระดาษของเอกสารต้นฉบับ คละขนาด  เป็นการตั้งค่าเริ่มต้นจากโรงงานของสหรัฐอเมริกา  A4  เป็นการตั้งค่าเริ่มต้นจากโรงงานสากล การตั้งค่านี้อาจแตกต่างกันไปขึ้นอยู่กับรุ่นเครื่องพิมพ์ของคุณ ใช้ TIFF แบบหลายหน้า ปิด เปิด * เลือกระหว่างไฟล์ TIFF หน้าเดียวและหลายหน้า เมนู การตั้งค่าเซิร์ฟเวอร์แฟกซ์"},{"UUID":"999deae9-9532-4971-a888-93386d4756ae","title":"อีเมล","link":"email-setup-topic.html","desc":"การตั้งค่าอีเมล รายการเมนูการตั้งค่าอีเมลและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การตั้งค่าอีเมล รายการเมนูการตั้งค่าอีเมลและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เกตเวย์ SMTP หลัก การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์ IP แอดเดรสหรือชื่อคอมพิวเตอร์แม่ข่ายของเซิร์ฟเวอร์ SMTP หลักสำหรับการส่งอีเมล พอร์ตเกตเวย์ SMTP หลัก 1–65535 (25*) ป้อนหมายเลขพอร์ตของเซิร์ฟเวอร์ SMTP หลัก เกตเวย์ SMTP รอง การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์ IP แอดเดรสของเซิร์ฟเวอร์หรือชื่อคอมพิวเตอร์แม่ข่ายของเซิร์ฟเวอร์ SMTP รองหรือสำรอง พอร์ตเกตเวย์ SMTP รอง 1–65535  (25*) ป้อนหมายเลขพอร์ตเซิร์ฟเวอร์ของเซิร์ฟเวอร์ SMTP รองหรือสำรอง หมดเวลา SMTP 5–30 วินาที  (30*) ตั้งเวลาก่อนที่เครื่องพิมพ์จะหมดเวลาหากเซิร์ฟเวอร์ SMTP ไม่ตอบสนอง แอดเดรสตอบกลับ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุแอดเดรสตอบกลับในอีเมล ใช้ค่าเริ่มต้นแอดเดรสตอบกลับของ SMTP เสมอ เปิด ปิด * ใช้แอดเดรสตอบกลับตามค่าเริ่มต้นในเซิร์ฟเวอร์ SMTP เสมอ ใช้ SSL/TLS ปิดใช้งานแล้ว * จัดการ จำเป็นต้องใช้ ระบุว่าจะส่งอีเมลโดยใช้ลิงก์ที่เข้ารหัสหรือไม่ จำเป็นต้องมีใบรับรองที่เชื่อถือได้ ปิด เปิด * จำเป็นต้องใช้ใบรับรองที่เชื่อถือได้เมื่อเข้าใช้เซิร์ฟเวอร์ SMTP การตรวจสอบความถูกต้องของเซิร์ฟเวอร์ SMTP ไม่ต้องมีการตรวจสอบความถูกต้อง * ลงชื่อเข้าใช้ / ธรรมดา NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 ตั้งประเภทการตรวจสอบความถูกต้องสำหรับเซิร์ฟเวอร์ SMTP อีเมลแบบเริ่มต้นโดยอุปกรณ์ ไม่มี * ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ ระบุว่าจำเป็นต้องใช้ข้อมูลประจำตัวสำหรับอีเมลแบบเริ่มต้นโดยอุปกรณ์หรือไม่ อีเมลแบบเริ่มต้นโดยผู้ใช้ ไม่มี * ใช้ข้อมูลรับรอง SMTP ของอุปกรณ์ ใช้รหัสผู้ใช้และรหัสผ่านสำหรับเซสชั่น ใช้ที่อยู่อีเมลและรหัสผ่านสำหรับเซสชั่น แจ้งผู้ใช้ ระบุว่าจำเป็นต้องใช้ข้อมูลประจำตัวสำหรับอีเมลแบบเริ่มต้นโดยผู้ใช้หรือไม่ ใช้ข้อมูลรับรองอุปกรณ์ของไดเรกทอรีที่ใช้งาน ปิด * เปิด ระบุว่าจำเป็นต้องใช้ข้อมูลประจำตัวสำหรับอีเมลแบบเริ่มต้นโดยผู้ใช้หรือไม่ รหัสผู้ใช้ของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ ID ผู้ใช้และรหัสผ่านเพื่อเชื่อมต่อกับเซิร์ฟเวอร์ SMTP รหัสผ่านของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ Kerberos 5 REALM การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุการตรวจสอบรหัสประจำตัวผู้ใช้สำหรับโปรโตคอลการตรวจสอบความถูกต้อง Kerberos 5 โดเมน NTLM การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อโดเมนสำหรับโปรโตคอลการรักษาความปลอดภัย NTLM ปิดใช้งานข้อผิดพลาด “ไม่ได้ตั้งค่า SMTP เซิร์ฟเวอร์” ปิด * เปิด ซ่อนข้อความแสดงข้อผิดพลาด “ยังไม่มีการตั้งค่าเซิร์ฟเวอร์ SMTP” เมนู การตั้งค่าอีเมล"},{"UUID":"d1185528-ce09-4758-9eea-8d1f6c0eab3a","title":"อีเมล","link":"email-setup-topic.html","desc":"ค่าเริ่มต้นของอีเมล รายการเมนูและคำอธิบายค่าเริ่มต้นของอีเมล รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"ค่าเริ่มต้นของอีเมล รายการเมนูและคำอธิบายค่าเริ่มต้นของอีเมล รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เรื่อง: ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุหัวเรื่องอีเมลและข้อความ ข้อความ: ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ชื่อไฟล์ ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อไฟล์สำหรับเอกสารที่สแกน รูปแบบ ไม่ใช้ JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) ระบุรูปแบบไฟล์ของเอกสารที่สแกน รายการเมนูนี้อาจแตกต่างกันขึ้นอยู่กับรุ่นเครื่องพิมพ์ของคุณ การตั้งค่า OCR แบบสากล ภาษาที่รู้จัก [รายการภาษา] กำหนดการตั้งค่าสำหรับการพิสูจน์ตัวอักษรจากภาพ (OCR) จะแสดงรายการเมนูนี้เมื่อคุณซื้อและติดตั้งโซลูชัน OCR แล้วเท่านั้น หมุนอัตโนมัติ ปิด * เปิด ลบรอย ปิด * เปิด ปรับความเปรียบต่างอัตโนมัติ ปิด * เปิด การตั้งค่า PDF เวอร์ชัน PDF 1.3 1.4 1.5 * 1.6 1.7 กำหนดการตั้งค่า PDF ของภาพที่สแกน เวอร์ชันของเอกสารสำคัญ และ เอกสารสำคัญ (PDF/A)  รองรับเฉพาะเมื่อ เวอร์ชัน PDF  ได้รับการตั้งค่าเป็น 1.4 หรือ 1.7 เท่านั้น บีบอัดขั้นสูง  จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ความปลอดภัย รองรับเฉพาะเมื่อ เวอร์ชัน PDF  ได้รับการตั้งค่าเป็น 1.4 หรือสูงกว่าเท่านั้น เอกสารสำคัญ (PDF/A) ปิด * เปิด เวอร์ชันของเอกสารสำคัญ A‑1a * A‑1b A‑2u บีบอัดขั้นสูง ปิด * เปิด ความปลอดภัย ปิด * เปิด ค้นหาได้ ปิด * เปิด แยกงานตามหน้า 0 * ประเภทเนื้อหา ไม่ใช้ ข้อความ ข้อความ/ภาพถ่าย * ภาพถ่าย ภาพกราฟิก ระบุเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา ไม่ใช้ เลเซอร์ขาว-ดำ * เลเซอร์สี อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ระบุที่มาของเอกสารต้นฉบับ สี ไม่ใช้ สีขาว-ดำ สีเทา สี * อัตโนมัติ ระบุวิธีการบันทึกเอกสารต้นฉบับ ความละเอียด ไม่ใช้ 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi ตั้งความละเอียดของภาพที่สแกน ความเข้ม ไม่ใช้ 1–9  (5*) ปรับความเข้มของภาพที่สแกน แนวการพิมพ์ ไม่ใช้ แนวตั้ง * แนวนอน ระบุแนวการพิมพ์ของเอกสารต้นฉบับ ขนาดต้นฉบับ ไม่ใช้ คละขนาด * ตั้งขนาดกระดาษของเอกสารต้นฉบับ ด้าน ไม่ใช้ ปิด * ขอบสั้น ขอบยาว ระบุแนวการพิมพ์ของเอกสารต้นฉบับเมื่อสแกนทั้งสองด้านของเอกสาร การสร้างภาพขั้นสูง รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ความสมดุลของสี สีน้ำเงินเขียว สีม่วงแดง สีเหลือง ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) ปรับความเข้มของสีสำหรับสีน้ำเงิน แดง และเหลือง การลบสี การลบสี ไม่มี * สีแดง สีเขียว สีน้ำเงิน ระบุสีที่จะลบระหว่างการสแกน และปรับการตั้งค่าการลบของสีดังกล่าว เกณฑ์สีแดงเริ่มต้น 0–255  (128*) เกณฑ์สีเขียวเริ่มต้น 0–255  (128*) เกณฑ์สีน้ำเงินเริ่มต้น 0–255  (128*) ตรวจสอบสีอัตโนมัติ ความไวสี 1–9  (5*) กำหนดค่าการตั้งค่าการตรวจสอบสีอัตโนมัติ ความไวของพื้นที่ 1–9  (5*) ความลึกของบิตอีเมล 1 บิต * 8 บิต ความละเอียดต่ำสุดในการสแกน 75 dpi 150 dpi 200 dpi 300 dpi * คุณภาพ JPEG ไม่ใช้ เหมาะกับเนื้อหาที่สุด * 5–95 ตั้งค่าคุณภาพ JPEG ของภาพที่สแกน ความเปรียบต่าง ไม่ใช้ เหมาะกับเนื้อหาที่สุด * 0–5 ระบุความเปรียบต่างของสีสำหรับภาพที่สแกน การนำพื้นหลังออก การตรวจจับพื้นหลัง ใช้เนื้อหาเป็นฐาน * แบบตายตัว ระดับ  ‑4 ถึง 4  (0*) ลบสีพื้นหลังหรือสัญญาณรบกวนภาพออกจากเอกสารต้นฉบับ ภาพสะท้อน ไม่ใช้ ปิด * เปิด สร้างภาพสะท้อนของเอกสารต้นฉบับ ภาพเนกาทีฟ ไม่ใช้ ปิด * เปิด สร้างภาพเนกาทีฟของเอกสารต้นฉบับ รายละเอียดในส่วนมืด ไม่ใช้ ‑4 ถึง 4  (0*) ปรับรายละเอียดในส่วนมืดของภาพที่สแกน สแกนแบบจรดขอบ ไม่ใช้ ปิด * เปิด สแกนเอกสารต้นฉบับจากขอบหนึ่งไปยังอีกขอบหนึ่ง ความคมชัด ไม่ใช้ 1–5  (3*) ปรับความคมชัดในภาพที่สแกน อุณหภูมิ ไม่ใช้ ‑4 ถึง 4  (0*) สร้างงานพิมพ์ที่มีสีฟ้าหรือสีแดงมากขึ้นกว่าเอกสารต้นฉบับ หน้าว่าง ลบหน้าว่างออก ห้ามลบ * นำออก นำหน้าว่างออกจากเอกสารต้นฉบับ ความไวหน้าว่าง 1–9  (5*) ตั้งค่าความไวของการสแกนให้สัมพันธ์กับหน้าว่างในเอกสารต้นฉบับ ส่วนควบคุมของผู้ดูแล รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ขนาดอีเมลสูงสุด 0–65535  (0*) ตั้งขนาดไฟล์ที่อนุญาตสำหรับอีเมลแต่ละฉบับ ข้อความแสดงข้อผิดพลาดเกี่ยวกับขนาด การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุข้อความแจ้งข้อผิดพลาดที่เครื่องพิมพ์จะส่งเมื่ออีเมลมีขนาดไฟล์เกินกว่าที่อนุญาต คุณสามารถพิมพ์ได้สูงสุด 1024 อักขระ จำกัดปลายทาง การตั้งค่านี้กำหนดโดยผู้ใช้ จำกัดการส่งอีเมลเฉพาะในรายการชื่อโดเมนที่ระบุเท่านั้น ใช้เครื่องหมายจุลภาคเพื่อคั่นแต่ละโดเมน ส่งสำเนาให้ฉัน ไม่แสดงเลย * เปิดตามค่าเริ่มต้น ปิดตามค่าเริ่มต้น เปิดเสมอ ส่งสำเนาอีเมลถึงตัวคุณเอง อนุญาตให้ส่งอีเมลด้วยตนเองเท่านั้น ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งอีเมลถึงตัวคุณเองเท่านั้น ใช้ cc:/bcc: ปิด * เปิด เปิดใช้งานการทำสำเนาและสำเนาลับสำหรับอีเมล ใช้ TIFF แบบหลายหน้า ปิด * เปิด เปิดใช้การสแกนภาพ TIFF แบบหลายภาพในไฟล์ TIFF ไฟล์เดียว การบีบอัด TIFF JPEG LZW * ระบุประเภทการบีบอัดสำหรับไฟล์ TIFF ค่าเริ่มต้นของข้อความ 5–95  (75*) ตั้งค่าคุณภาพข้อความของเนื้อหาที่จะสแกน ค่าเริ่มต้นของข้อความ/ภาพถ่าย 5–95  (75*) ตั้งค่าคุณภาพของข้อความและภาพถ่ายของเนื้อหาที่จะสแกน ค่าเริ่มต้นของภาพถ่าย 5–95  (50*) ตั้งค่าคุณภาพภาพถ่ายของเนื้อหาที่จะสแกน ปรับตั้งค่า ADF Skew ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ปรับภาพที่เอียงจากเอกสารที่สแกนจาก ADF บันทึกการส่งข้อมูล บันทึกการพิมพ์ * ไม่ต้องพิมพ์บันทึก พิมพ์เฉพาะเมื่อมีข้อผิดพลาด พิมพ์บันทึกการส่งข้อมูลสำหรับการสแกนอีเมล บันทึกแหล่งกระดาษ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ระบุแหล่งกระดาษสำหรับการพิมพ์บันทึก การสแกนงานแบบกำหนดเอง ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้สแกนเอกสารต้นฉบับชุดแรกโดยใช้การตั้งค่าที่ระบุ จากนั้นสแกนชุดถัดไปด้วยการตั้งค่าเดียวกันหรือต่างกัน รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ตัวอย่างการสแกน ปิด เปิด * แสดงตัวอย่างการสแกนของเอกสารต้นฉบับ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น บันทึกเป็นทางลัดได้ ปิด เปิด * บันทึกที่อยู่อีเมลเป็นทางลัด ส่งภาพในอีเมลเป็น ไฟล์แนบ * เว็บลิงก์ ระบุวิธีส่งภาพที่อยู่ในอีเมล รีเซ็ตข้อมูลอีเมลหลังจากส่งออก ปิด เปิด * รีเซ็ตค่า ส่งถึง หัวเรื่อง ข้อความ และชื่อไฟล์ให้เป็นค่าเริ่มต้นหลังจากส่งอีเมล เมนู ค่าเริ่มต้นของอีเมล"},{"UUID":"b9837ecf-87f8-4e0a-a13a-c085d36fbd0b","title":"อีเมล","link":"email-setup-topic.html","desc":"การตั้งค่าเว็บลิงก์ รายการเมนูและคำอธิบายการตั้งค่าเว็บลิงก์ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การตั้งค่าเว็บลิงก์ รายการเมนูและคำอธิบายการตั้งค่าเว็บลิงก์ รายการเมนู การตั้งค่า คำอธิบาย เซิร์ฟเวอร์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุข้อมูลประจำตัวของเซิร์ฟเวอร์ที่โฮสต์ภาพที่รวมอยู่ในอีเมล ลงชื่อเข้าใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ รหัสผ่าน การตั้งค่านี้กำหนดโดยผู้ใช้ พาธ การตั้งค่านี้กำหนดโดยผู้ใช้ ชื่อไฟล์ การตั้งค่านี้กำหนดโดยผู้ใช้ เว็บลิงก์ การตั้งค่านี้กำหนดโดยผู้ใช้ เมนู การตั้งค่าเว็บลิงก์"},{"UUID":"6c4b971c-5f8e-492c-9293-770d43012d03","title":"FTP","link":"ftp-defaults-topic.html","desc":"ค่าเริ่มต้นของ FTP รายการเมนูและคำอธิบายค่าเริ่มต้นของ FTP รายการเมนู","descFull":"ค่าเริ่มต้นของ FTP รายการเมนูและคำอธิบายค่าเริ่มต้นของ FTP รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน รูปแบบ ไม่ใช้ JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) ระบุรูปแบบไฟล์สำหรับภาพที่สแกน การตั้งค่า OCR แบบสากล ภาษาที่รู้จัก [รายการภาษา] กำหนดการตั้งค่าสำหรับการพิสูจน์ตัวอักษรจากภาพ (OCR) จะแสดงเมนูนี้เมื่อคุณซื้อและติดตั้งโซลูชัน OCR แล้วเท่านั้น หมุนอัตโนมัติ ปิด * เปิด ลบรอย ปิด * เปิด ปรับความเปรียบต่างอัตโนมัติ ปิด * เปิด การตั้งค่า PDF เวอร์ชัน PDF 1.3 1.4 1.5 * 1.6 1.7 กำหนดการตั้งค่า PDF สำหรับภาพที่สแกน เวอร์ชันของเอกสารสำคัญ และ เอกสารสำคัญ (PDF/A)  รองรับเฉพาะเมื่อ เวอร์ชัน PDF  ได้รับการตั้งค่าเป็น 1.4 หรือ 1.7 เท่านั้น บีบอัดขั้นสูง  จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ความปลอดภัย รองรับเฉพาะเมื่อ เวอร์ชัน PDF  ได้รับการตั้งค่าเป็น 1.4 หรือสูงกว่าเท่านั้น เอกสารสำคัญ (PDF/A) ปิด * เปิด เวอร์ชันของเอกสารสำคัญ A‑1a * A‑1b A‑2u บีบอัดขั้นสูง ปิด * เปิด ความปลอดภัย ปิด * เปิด ค้นหาได้ ปิด * เปิด แยกงานตามหน้า 0 * ประเภทเนื้อหา ไม่ใช้ ข้อความ ข้อความ/ภาพถ่าย * ภาพกราฟิก ภาพถ่าย ปรับปรุงผลลัพธ์เอาต์พุตตามประเภทเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา ไม่ใช้ เลเซอร์ขาว-ดำ เลเซอร์สี * อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ปรับปรุงผลลัพธ์เอาต์พุตตามแหล่งเนื้อหาของเอกสารต้นฉบับ สี ไม่ใช้ สีขาว-ดำ สีเทา สี * อัตโนมัติ ตั้งค่าเครื่องพิมพ์ให้บันทึกเนื้อหาไฟล์เป็นสีหรือขาวดำ ความละเอียด ไม่ใช้ 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi ตั้งความละเอียดของภาพที่สแกน ความเข้ม ไม่ใช้ 1–9  (5*) ปรับความเข้มของภาพที่สแกน แนวการพิมพ์ ไม่ใช้ แนวตั้ง * แนวนอน ระบุแนวการพิมพ์ของเอกสารต้นฉบับ ขนาดต้นฉบับ ไม่ใช้ คละขนาด * ตั้งขนาดกระดาษของเอกสารต้นฉบับ ด้าน ไม่ใช้ ปิด * ขอบยาว ขอบสั้น ระบุการวางแนวเมื่อสแกนทั้งสองด้านของเอกสาร ชื่อไฟล์ ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อไฟล์ของภาพที่สแกน การสร้างภาพขั้นสูง รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ความสมดุลของสี สีน้ำเงินเขียว สีม่วงแดง สีเหลือง ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) ปรับความเข้มของสีสำหรับสีน้ำเงิน แดง และเหลือง การลบสี การลบสี ไม่มี * สีแดง สีเขียว สีน้ำเงิน ระบุสีที่จะลบระหว่างการสแกน และปรับการตั้งค่าการลบของสีดังกล่าว เกณฑ์สีแดงเริ่มต้น 0–255  (128*) เกณฑ์สีเขียวเริ่มต้น 0–255  (128*) เกณฑ์สีน้ำเงินเริ่มต้น 0–255  (128*) ตรวจสอบสีอัตโนมัติ ความไวสี 1–9  (5*) กำหนดค่าการตั้งค่าการตรวจสอบสีอัตโนมัติ ความไวของพื้นที่ 1–9  (5*) ความลึกของบิตอีเมล 1 บิต * 8 บิต ความละเอียดต่ำสุดในการสแกน 75 dpi 150 dpi 200 dpi 300 dpi * คุณภาพ JPEG ไม่ใช้ เหมาะกับเนื้อหาที่สุด * 5–95 ตั้งค่าคุณภาพ JPEG ของภาพที่สแกน ความเปรียบต่าง ไม่ใช้ เหมาะกับเนื้อหาที่สุด * 0–5 ระบุความเปรียบต่างของสีสำหรับภาพที่สแกน การนำพื้นหลังออก การตรวจจับพื้นหลัง ใช้เนื้อหาเป็นฐาน * แบบตายตัว ระดับ  ‑4 ถึง 4  (0*) ลบสีพื้นหลังหรือสัญญาณรบกวนภาพออกจากเอกสารต้นฉบับ ภาพสะท้อน ไม่ใช้ ปิด * เปิด สร้างภาพสะท้อนของเอกสารต้นฉบับ ภาพเนกาทีฟ ไม่ใช้ ปิด * เปิด สร้างภาพเนกาทีฟของเอกสารต้นฉบับ รายละเอียดในส่วนมืด ไม่ใช้ ‑4 ถึง 4  (0*) ปรับรายละเอียดในส่วนมืดของภาพที่สแกน สแกนแบบจรดขอบ ไม่ใช้ ปิด * เปิด สแกนเอกสารต้นฉบับจากขอบหนึ่งไปยังอีกขอบหนึ่ง ความคมชัด ไม่ใช้ 1–5  (3*) ปรับความคมชัดในภาพที่สแกน อุณหภูมิ ไม่ใช้ ‑4 ถึง 4  (0*) สร้างงานพิมพ์ที่มีสีฟ้าหรือสีแดงมากขึ้นกว่าเอกสารต้นฉบับ หน้าว่าง ลบหน้าว่างออก ห้ามลบ * นำออก นำหน้าว่างออกจากเอกสารต้นฉบับ ความไวหน้าว่าง 1–9  (5*) ตั้งค่าความไวของการสแกนให้สัมพันธ์กับหน้าว่างในเอกสารต้นฉบับ ส่วนควบคุมของผู้ดูแล รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ค่าเริ่มต้นของข้อความ 5–95  (75*) ตั้งค่าคุณภาพของข้อความในภาพที่สแกน ค่าเริ่มต้นของข้อความ/ภาพถ่าย 5–95  (75*) ตั้งค่าคุณภาพของข้อความและภาพถ่ายในภาพที่สแกน ค่าเริ่มต้นของภาพถ่าย 5–95  (50*) กำหนดคุณภาพของภาพถ่ายบนภาพที่สแกน ใช้ TIFF แบบหลายหน้า เปิด * ปิด เปิดใช้การสแกนภาพ TIFF แบบหลายภาพในไฟล์ TIFF ไฟล์เดียว การบีบอัด TIFF LZW * JPEG ระบุประเภทการบีบอัดสำหรับไฟล์ TIFF บันทึกการส่งข้อมูล บันทึกการพิมพ์ * ไม่ต้องพิมพ์บันทึก พิมพ์เฉพาะเมื่อมีข้อผิดพลาด พิมพ์บันทึกการส่งข้อมูลสำหรับการสแกน FTP บันทึกแหล่งกระดาษ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ระบุแหล่งกระดาษสำหรับพิมพ์บันทึก FTP การสแกนงานแบบกำหนดเอง ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้สแกนเอกสารต้นฉบับชุดแรกโดยใช้การตั้งค่าที่ระบุ จากนั้นสแกนชุดถัดไปด้วยการตั้งค่าเดียวกันหรือต่างกัน รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ตัวอย่างการสแกน ปิด เปิด * แสดงตัวอย่างของเอกสารต้นฉบับ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น บันทึกเป็นทางลัดได้ ปิด เปิด * บันทึกที่อยู่ FTP เป็นทางลัด เมนู ค่าเริ่มต้นของ FTP"},{"UUID":"359a0384-5249-4fbd-ae86-9b2fcb963b23","title":"ไดรฟ์ USB","link":"flash-drive-scan-topic.html","desc":"การสแกนแฟลชไดรฟ์ รายการเมนูและคำอธิบายการสแกนแฟลชไดรฟ์ รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"การสแกนแฟลชไดรฟ์ รายการเมนูและคำอธิบายการสแกนแฟลชไดรฟ์ รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน รูปแบบ ไม่ใช้ JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) * DOCX (.doc) XLSX (.xlsx) CSV (.csv) ระบุรูปแบบไฟล์สำหรับภาพที่สแกน TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  และ  CSV (.csv)  จะปรากฏขึ้นเฉพาะเมื่อคุณซื้อและติดตั้งโซลูชัน Optical Character Recognition (OCR) การตั้งค่า OCR แบบสากล ภาษาที่รู้จัก [รายการภาษา] กำหนดค่าการตั้งค่าสำหรับ OCR จะแสดงเมนูนี้เมื่อคุณซื้อและติดตั้งโซลูชัน OCR แล้วเท่านั้น หมุนอัตโนมัติ ปิด * เปิด ลบรอย ปิด * เปิด ปรับความเปรียบต่างอัตโนมัติ ปิด * เปิด การตั้งค่า PDF เวอร์ชัน PDF 1.3 1.4 1.5 * 1.6 1.7 กำหนดการตั้งค่า PDF ของภาพที่สแกน เอกสารสำคัญ (PDF/A) และ เวอร์ชันของเอกสารสำคัญ —รองรับเฉพาะเมื่อ เวอร์ชัน PDF  ได้รับการตั้งค่าเป็น 1.4 หรือ 1.7 เท่านั้น บีบอัดขั้นสูง —จะปรากฏขึ้นเมื่อติดตั้งฮาร์ดดิสก์แล้วเท่านั้น ความปลอดภัย —รองรับเฉพาะเมื่อ  PDF Version  ได้รับการตั้งค่าเป็น 1.4 หรือสูงกว่าเท่านั้น เอกสารสำคัญ (PDF/A) ปิด * เปิด เวอร์ชันของเอกสารสำคัญ A‑1a * A‑1b A‑2u บีบอัดขั้นสูง ปิด * เปิด ความปลอดภัย ปิด * เปิด ค้นหาได้ ปิด * เปิด ประเภทเนื้อหา ไม่ใช้ ข้อความ ข้อความ/ภาพถ่าย * ภาพถ่าย ภาพกราฟิก ปรับปรุงผลลัพธ์เอาต์พุตตามประเภทเนื้อหาของเอกสารต้นฉบับ แหล่งเนื้อหา ไม่ใช้ เลเซอร์ขาว-ดำ เลเซอร์สี * อิงค์เจ็ต ภาพถ่าย/ฟิล์ม นิตยสาร หนังสือพิมพ์ สิ่งพิมพ์ อื่นๆ ปรับปรุงผลลัพธ์เอาต์พุตตามแหล่งเนื้อหาของเอกสารต้นฉบับ สี ไม่ใช้ สีขาว-ดำ สีเทา สี * อัตโนมัติ ตั้งค่าเครื่องพิมพ์ให้บันทึกเนื้อหาไฟล์เป็นสีหรือขาวดำ ความละเอียด ไม่ใช้ 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi ตั้งความละเอียดของภาพที่สแกน ความเข้ม ไม่ใช้ 1–9  (5*) ปรับความเข้มของภาพที่สแกน แนวการพิมพ์ ไม่ใช้ แนวตั้ง * แนวนอน ระบุแนวการพิมพ์ของเอกสารต้นฉบับ ขนาดต้นฉบับ ไม่ใช้ คละขนาด * ตั้งขนาดกระดาษของเอกสารต้นฉบับ ด้าน ไม่ใช้ ปิด * ขอบสั้น ขอบยาว ระบุแนวการพิมพ์ของเอกสารต้นฉบับเมื่อสแกนทั้งสองด้านของเอกสาร ชื่อไฟล์ ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อไฟล์ของภาพที่สแกน การสร้างภาพขั้นสูง ความสมดุลของสี สีน้ำเงินเขียว  (0*) สีม่วงแดง  (0*) สีเหลือง  (0*) ปรับความเข้มของสีสำหรับสีน้ำเงิน แดง และเหลือง การลบสี การลบสี  ( ไม่มี *) เกณฑ์สีแดงเริ่มต้น  (128*) เกณฑ์สีเขียวเริ่มต้น  (128*) เกณฑ์สีน้ำเงินเริ่มต้น  (128*) ระบุสีที่จะลบระหว่างการสแกน และปรับการตั้งค่าการลบของสีดังกล่าว ตรวจสอบสีอัตโนมัติ ความไวสี  (5*) ความไวของพื้นที่  (5*) สแกนความลึกของบิต  (1 บิต*) ความละเอียดต่ำสุดในการสแกน  (300 dpi*) กำหนดค่าการตั้งค่าการตรวจสอบสีอัตโนมัติ คุณภาพ JPEG เหมาะกับเนื้อหาที่สุด * 5–95 ตั้งค่าคุณภาพ JPEG ของภาพที่สแกน ความเปรียบต่าง เหมาะกับเนื้อหาที่สุด * 0–5 ระบุความเปรียบต่างของสีสำหรับภาพที่สแกน การนำพื้นหลังออก การตรวจจับพื้นหลัง  ( ใช้เนื้อหาเป็นฐาน *) ระดับ  (0*) ลบสีพื้นหลังหรือสัญญาณรบกวนภาพออกจากเอกสารต้นฉบับ ภาพสะท้อน ปิด * เปิด สร้างภาพสะท้อนของเอกสารต้นฉบับ รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การสร้างภาพขั้นสูง ภาพเนกาทีฟ ปิด * เปิด สร้างภาพเนกาทีฟของเอกสารต้นฉบับ รายละเอียดในส่วนมืด ‑4 ถึง 4  (0*) ปรับรายละเอียดในส่วนมืดของภาพที่สแกน สแกนแบบจรดขอบ ปิด * เปิด สแกนเอกสารต้นฉบับจากขอบหนึ่งไปยังอีกขอบหนึ่ง ความคมชัด 1–5  (3*) ปรับความคมชัดในภาพที่สแกน อุณหภูมิ ‑4 ถึง 4  (0*) สร้างงานพิมพ์ที่มีสีฟ้าหรือสีแดงมากขึ้นกว่าเอกสารต้นฉบับ หน้าว่าง การลบหน้าว่าง  ( ห้ามลบ *) ความไวหน้าว่าง  (5*) ตั้งค่าความไวของการสแกนให้สัมพันธ์กับหน้าว่างในเอกสารต้นฉบับ ส่วนควบคุมของผู้ดูแล ค่าเริ่มต้นของข้อความ 5–95  (75*) ตั้งค่าคุณภาพของข้อความในภาพที่สแกน ค่าเริ่มต้นของข้อความ/ภาพถ่าย 5–95  (75*) ตั้งค่าคุณภาพของข้อความและภาพถ่ายในภาพที่สแกน ค่าเริ่มต้นของภาพถ่าย 5–95  (50*) กำหนดคุณภาพของภาพถ่ายบนภาพที่สแกน ใช้ TIFF แบบหลายหน้า ปิด เปิด * เปิดใช้การสแกนภาพ TIFF แบบหลายภาพในไฟล์ TIFF ไฟล์เดียว การบีบอัด TIFF JPEG LZW * ระบุประเภทการบีบอัดสำหรับไฟล์ TIFF การสแกนงานแบบกำหนดเอง ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้สแกนเอกสารต้นฉบับชุดแรกโดยใช้การตั้งค่าที่ระบุ จากนั้นสแกนชุดถัดไปด้วยการตั้งค่าเดียวกันหรือต่างกัน รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ตัวอย่างการสแกน ปิด * เปิด แสดงตัวอย่างการสแกนของเอกสารต้นฉบับ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น ปรับตั้งค่า ADF Skew ปิด เปิด * ตั้งค่าเครื่องพิมพ์ให้ปรับภาพที่เอียงจากเอกสารที่สแกนจากตัวป้อนเอกสารอัตโนมัติ เมนู การสแกนแฟลชไดรฟ์"},{"UUID":"7eba7010-e9e9-4044-b64c-7fa47c31a94e","title":"ไดรฟ์ USB","link":"flash-drive-scan-topic.html","desc":"การพิมพ์แฟลชไดรฟ์ รายการเมนูและคำอธิบายการพิมพ์แฟลชไดร์ฟ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การพิมพ์แฟลชไดรฟ์ รายการเมนูและคำอธิบายการพิมพ์แฟลชไดร์ฟ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน จำนวนสำเนา 1–9999  (1*) ตั้งค่าจำนวนสำเนาของงานพิมพ์ แหล่งกระดาษ ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ กระดาษแบบป้อนด้วยตนเอง ซองจดหมายแบบป้อนด้วยตนเอง กำหนดแหล่งกระดาษสำหรับงานพิมพ์ สี ปิด เปิด * พิมพ์แฟลชไดรฟ์เป็นสี เรียงหน้า ปิด [1,1,1,2,2,2] เปิด [1,2,1,2,1,2] * เรียงหน้างานพิมพ์ตามลำดับ โดยเฉพาะอย่างยิ่งเมื่อพิมพ์งานหลายสำเนา ด้าน 1 ด้าน * 2 ด้าน เลือกว่าจะพิมพ์บนกระดาษด้านเดียวหรือทั้งสองด้าน ลวดเย็บ ปิด * เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายบน เย็บกระดาษ 2 ครั้ง ที่ด้านซ้าย เย็บกระดาษ 1 ครั้ง ที่มุมขวาบน เย็บกระดาษ 2 ครั้ง ที่ด้านบน เย็บกระดาษ 1 ครั้ง ที่มุมซ้ายล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านล่าง เย็บกระดาษ 1 ครั้ง ที่มุมขวาล่าง เย็บกระดาษ 2 ครั้ง ที่ด้านขวา ระบุตำแหน่งลวดเย็บสำหรับงานพิมพ์ทั้งหมด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บแล้วเท่านั้น อุปกรณ์ตอกรู ปิด * 2 รู 3 รู 4 รู ตั้งค่าโหมดการเจาะรูสำหรับงานพิมพ์ทั้งหมด รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งลวดเย็บ อุปกรณ์ตอกรู หรืออุปกรณ์เย็บเล่มแล้วเท่านั้น หน้าออฟเซต ไม่มี * ระหว่างสำเนา ระหว่างงาน ปรับค่าเอาต์พุตงานพิมพ์แต่ละงานหรืองานพิมพ์แต่ละสำเนา ระหว่างสำเนา —จะปรับค่างานพิมพ์แต่ละสำเนาหากตั้งค่า เรียงหน้า ไว้ที่  เปิด [1,2,1,2,1,2]  หากตั้งค่า เรียงหน้า —เป็น  ปิด [1,1,1,2,2,2]  หน้าที่พิมพ์แต่ละชุดจะถูกหักล้าง เช่น หน้าทั้งหมดที่กำหนดเป็น 1 และหน้าทั้งหมดที่กำหนดเป็น 2 ระหว่างงาน —จะตั้งค่าตำแหน่งการปรับค่าเหมือนกันสำหรับงานพิมพ์ทั้งหมดโดยไม่คำนึงถึงจำนวนสำเนาที่พิมพ์ รูปแบบการพลิกกระดาษ ขอบยาว * ขอบสั้น กำหนดว่าจะเย็บกระดาษด้านใดเมื่อทำการพิมพ์สองด้าน จำนวนหน้าต่อด้าน ปิด * 2 หน้าต่อหนึ่งด้าน 3 หน้าต่อหนึ่งด้าน 4 หน้าต่อหนึ่งด้าน 6 หน้าต่อหนึ่งด้าน 9 หน้าต่อหนึ่งด้าน 12 หน้าต่อหนึ่งด้าน 16 หน้าต่อหนึ่งด้าน พิมพ์ภาพของหน้าที่คุณต้องการหลายหน้าลงบนด้านเดียวของหน้ากระดาษ จำนวนหน้าต่อการเรียงลำดับด้านข้าง แนวนอน * แนวนอนกลับด้าน แนวตั้งกลับด้าน แนวตั้ง ระบุการวางตำแหน่งของภาพหลายหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน จำนวนหน้าต่อการวางแนวด้านข้าง อัตโนมัติ * แนวนอน แนวตั้ง ระบุแนวการพิมพ์ของภาพหลายหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน จำนวนหน้าต่อขอบด้านข้าง ไม่มี * พื้นทึบ พิมพ์ขอบล้อมรอบรูปของหน้ากระดาษแต่ละหน้าเมื่อใช้เมนูพิมพ์ หลายหน้าต่อด้าน แผ่นคั่น ปิด * ระหว่างสำเนา ระหว่างงาน ระหว่างหน้า แทรกแผ่นคั่นเปล่าเมื่อพิมพ์ แหล่งกระดาษของแผ่นคั่น ถาด  [x] (1*) ตัวป้อนกระดาษอเนกประสงค์ ระบุแหล่งกระดาษสำหรับแผ่นคั่น หน้าว่าง ไม่ต้องพิมพ์ * พิมพ์ พิมพ์หน้าว่างในงานพิมพ์ เมนู การพิมพ์แฟลชไดรฟ์"},{"UUID":"74ef7c7f-834c-49e1-9ae2-4a96c198ac08","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"ภาพรวมเครือข่าย รายการเมนูและคำอธิบาย ภาพรวมเครือข่าย รายการเมนู การตั้งค่า","descFull":"ภาพรวมเครือข่าย รายการเมนูและคำอธิบาย ภาพรวมเครือข่าย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน อะแดปเตอร์ที่ใช้งาน อัตโนมัติ * เครือข่ายมาตรฐาน แบบไร้สาย ระบุชนิดของการเชื่อมต่อเครือข่าย ไร้สาย จะสามารถใช้ได้เฉพาะเมื่อเครื่องพิมพ์เชื่อมต่อกับเครือข่ายแบบไร้สายเท่านั้น สถานะเครือข่าย การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการเชื่อมต่อของเครือข่ายเครื่องพิมพ์ แสดงสถานะเครือข่ายบนเครื่องพิมพ์ ปิด เปิด * แสดงสถานะเครือข่ายบนส่วนแสดงผล ความเร็ว, การพิมพ์สองด้าน การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงความเร็วของการ์ดเครือข่ายที่กำลังใช้งานอยู่ IPv4 การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดง IPv4 แอดเดรส IPv6 แอดเดรสทั้งหมด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดง IPv6 แอดเดรสทั้งหมด รีเซ็ตเซิร์ฟเวอร์พิมพ์ เริ่มต้น รีเซ็ตการเชื่อมต่อเครือข่ายที่ใช้งานอยู่ทั้งหมดบนเครื่องพิมพ์ การตั้งค่านี้จะลบการตั้งค่าการกำหนดเครือข่ายทั้งหมด หมดเวลางานสำหรับเครือข่าย ปิด เปิด * (90 วินาที) ตั้งเวลาก่อนที่เครื่องพิมพ์จะยกเลิกงานพิมพ์ในเครือข่าย หน้าป้ายประกาศ ปิด เปิด * พิมพ์หน้าป้ายประกาศ สแกนไปยังช่วงพอร์ตโฟโต้คอนดักเตอร์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุช่วงพอร์ตที่ถูกต้องสำหรับเครื่องพิมพ์ที่ใช้ไฟร์วอล์ที่บล็อคพอร์ต เปิดใช้งานการเชื่อมต่อเครือข่าย ปิด เปิด * เปิดใช้งานเครื่องพิมพ์เพื่อเชื่อมต่อกับเครือข่าย เปิดใช้งาน LLDP ปิด * เปิด แสดงสถานะเครือข่ายบนหน้าจอหลัก เมนู ภาพรวมเครือข่าย"},{"UUID":"7a13ec17-8863-4211-a33c-809a82b1ec07","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"แบบไร้สาย เมนูนี้จะใช้ได้เฉพาะในเครื่องพิมพ์ที่เชื่อมต่อกับเครือข่าย Wi-Fi หรือเครื่องพิมพ์ที่มีอะแดปเตอร์เครือข่ายแบบไร้สาย รายการเมนูและคำอธิบาย","descFull":"แบบไร้สาย เมนูนี้จะใช้ได้เฉพาะในเครื่องพิมพ์ที่เชื่อมต่อกับเครือข่าย Wi-Fi หรือเครื่องพิมพ์ที่มีอะแดปเตอร์เครือข่ายแบบไร้สาย รายการเมนูและคำอธิบาย ไร้สาย รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย ตั้งค่าบนแผงเครื่องพิมพ์ เลือกเครือข่าย [รายการเครือข่ายแบบไร้สายที่มีอยู่] กำหนดเครือข่ายแบบไร้สายที่เครื่องพิมพ์เชื่อมต่อ เพิ่มเครือข่าย Wi-Fi ชื่อเครือข่าย โหมดเครือข่าย  ( โครงสร้างพื้นฐาน *) โหมดรักษาความปลอดภัยไร้สาย  ( ปิดใช้งาน *) ป้อนชื่อเครือข่ายและประเภทเครือข่ายด้วยตนเอง Wi‑Fi Protected Setup ไม่ใช้ เริ่มต้นวิธีการกดปุ่ม วิธีรหัส PIN เริ่มต้น สร้างเครือข่าย Wi ‑ Fi และเปิดใช้งานการรักษาความปลอดภัยของเครือข่าย เริ่มต้นวิธีการกดปุ่ม จะเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi เมื่อกดปุ่มทั้งบนเครื่องพิมพ์และจุดเข้าใช้งาน (เราเตอร์แบบไร้สาย) ภายในเวลาที่กำหนด วิธีรหัส PIN เริ่มต้น จะเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi เมื่อป้อน PIN บนเครื่องพิมพ์เข้าในการตั้งค่าแบบไร้สายของจุดเข้าใช้งาน โหมดเครือข่าย ไม่ใช้ ประเภท BSS โครงสร้างพื้นฐาน * ระบุโหมดเครือข่าย ความเข้ากันได้ ไม่ใช้ 802.11b/g/n (2.4GHz) * 802.11a/b/g/n/ac (2.4GHz/5GHz) 802.11a/n/ac (5GHz) ระบุมาตรฐานสำหรับเครือข่าย Wi-Fi 802.11a/b/g/n/ac (2.4GHz/5GHz)  และ  802.11a/n/ac (5GHz)  จะปรากฏขึ้นเมื่อติดตั้งตัวเลือก Wi-Fi เท่านั้น โหมดรักษาความปลอดภัยไร้สาย ไม่ใช้ ปิดใช้งานแล้ว * WPA2/WPA-ส่วนตัว WPA2-ส่วนตัว WPA3/WPA-ส่วนตัว WPA3-ส่วนตัว 802.1x - RADIUS ตั้งค่าโหมดการรักษาความปลอดภัยสำหรับการเชื่อมต่อเครื่องพิมพ์กับอุปกรณ์ Wi-Fi WPA2/WPA ส่วนตัว ไม่ใช้ AES ใช้งานการรักษาความปลอดภัย Wi-Fi ผ่าน Wi-Fi Protected Access (WPA) รายการเมนูนี้จะปรากฏขึ้นเมื่อตั้งค่า โหมดการรักษาความปลอดภัยไร้สาย  เป็น  WPA2/WPA-Personal  เท่านั้น ตั้งค่า PSK ไม่ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งค่ารหัสผ่านสำหรับการเชื่อมต่อ Wi‑Fi ที่ปลอดภัย WPA2-ส่วนตัว ไม่ใช้ AES เปิดใช้การรักษาความปลอดภัย Wi-Fi ผ่าน WPA2 รายการเมนูนี้จะปรากฏขึ้นเมื่อตั้งค่า โหมดการรักษาความปลอดภัยไร้สาย  เป็น  WPA2-Personal  เท่านั้น โหมดเข้ารหัส 802.1x ไม่ใช้ WPA+ WPA2 * เปิดใช้การรักษาความปลอดภัย Wi-Fi ผ่านมาตรฐาน 802.1x รายการเมนูนี้จะปรากฏขึ้นเมื่อตั้งค่า โหมดการรักษาความปลอดภัยไร้สาย  เป็น  802.1x-RADIUS  เท่านั้น คุณสามารถกำหนดค่า  802.1x - RADIUS  ได้จาก Embedded Web Server เท่านั้น IPv4 เปิดใช้งาน DHCP เปิด * ปิด เปิดใช้งานและกำหนดค่าการตั้งค่า IPv4 ในเครื่องพิมพ์ ตั้งค่า IP แอดเดรสแบบคงที่ IP แอดเดรส เน็ตมาสก์ เกตเวย์ IPv6 เปิดใช้งาน IPv6 เปิด * ปิด เปิดใช้งานและกำหนดค่าการตั้งค่า IPv6 ในเครื่องพิมพ์ เปิดใช้งาน DHCPv6 เปิด ปิด * การกำหนดค่าแอดเดรสแบบไม่มีสถานะอัตโนมัติ เปิด * ปิด DNS เซิร์ฟเวอร์แอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ IPv6 แอดเดรสที่กำหนดด้วยตนเอง การตั้งค่านี้กำหนดโดยผู้ใช้ เราเตอร์ IPv6 ที่กำหนดด้วยตนเอง การตั้งค่านี้กำหนดโดยผู้ใช้ หมายเลขนำหน้าแอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ IPv6 แอดเดรสทั้งหมด การตั้งค่านี้กำหนดโดยผู้ใช้ IPv6 แอดเดรสเราเตอร์ทั้งหมด การตั้งค่านี้กำหนดโดยผู้ใช้ แอดเดรสเครือข่าย ไม่ใช้ UAA LAA ดูแอดเดรสเครือข่าย PCL SmartSwitch ไม่ใช้ ปิด เปิด * ตั้งให้เครื่องพิมพ์สลับเป็นการจำลอง PCL โดยอัตโนมัติเมื่อจำเป็น โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ หาก  PCL SmartSwitch  ถูกตั้งค่าเป็น  ปิด  เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเริ่มต้นของเครื่องพิมพ์ที่ระบุไว้ในเมนู  การตั้งค่า PS SmartSwitch ไม่ใช้ ปิด เปิด * ตั้งให้เครื่องพิมพ์สลับเป็นการจำลอง PS โดยอัตโนมัติเมื่อจำเป็น โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ หาก  PS SmartSwitch  ถูกตั้งค่าเป็น  ปิด  เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเริ่มต้นของเครื่องพิมพ์ที่ระบุไว้ในเมนู  การตั้งค่า การบัฟเฟอร์งาน ไม่ใช้ เปิด ปิด * จัดเก็บงานพิมพ์ไว้ในไดรฟ์จัดเก็บข้อมูลชั่วคราวก่อนพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น Mac ค่าไบนารี PS ไม่ใช้ อัตโนมัติ * เปิด ปิด ตั้งให้เครื่องพิมพ์ประมวลผลงานพิมพ์การจำลองแบบ PostScript แบบไบนารีของ Macintosh เปิด  จะประมวลผลงานพิมพ์การจำลองแบบ PostScript แบบไบนารีแบบ Raw ปิด  จะกรองงานพิมพ์โดยใช้โปรโตคอลมาตรฐาน เมนู แบบไร้สาย"},{"UUID":"44af44ce-1121-422d-8672-3c5dff944ca1","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"Wi‑Fi Direct รายการเมนู Wi-Fi Direct","descFull":"Wi‑Fi Direct รายการเมนู Wi-Fi Direct และคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เปิดใช้งาน Wi-Fi Direct เปิด ปิด * ตั้งค่าเครื่องพิมพ์เพื่อเชื่อมต่อกับอุปกรณ์ Wi-Fi โดยตรง ชื่อ Wi‑Fi Direct การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อเครือข่าย Wi‑Fi Direct รหัสผ่าน Wi-Fi Direct การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งค่ารหัสผ่านเพื่อตรวจสอบความถูกต้องและตรวจสอบสิทธิ์ของผู้ใช้ในการเชื่อมต่อ Wi-Fi แสดงรหัสผ่านในหน้าการตั้งค่า ปิด เปิด * แสดง รหัสผ่าน Wi-Fi Direct  ใน หน้าการตั้งค่าเครือข่าย หมายเลขช่องที่ต้องการ 1–11 อัตโนมัติ * ตั้งค่าช่องสัญญาณที่ต้องการของเครือข่าย Wi ‑ Fi IP แอดเดรสของเจ้าของกลุ่ม การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ IP แอดเดรสของเจ้าของกลุ่ม: ยอมรับการร้องขอปุ่มกดโดยอัตโนมัติ ปิด * เปิด ยอมรับคำขอการเชื่อมต่อกับเครือข่ายโดยอัตโนมัติ การยอมรับเครื่องลูกข่ายโดยอัตโนมัติไม่ปลอดภัย เมนู Wi-Fi Direct"},{"UUID":"f9d9ba08-5432-4ec0-9a72-80b08f635ac9","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"การจัดการบริการบนโทรศัพท์มือถือ รายการเมนูการจัดการบริการบนโทรศัพท์มือถือและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การจัดการบริการบนโทรศัพท์มือถือ รายการเมนูการจัดการบริการบนโทรศัพท์มือถือและคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เปิดใช้งาน IPP Print เปิด * ปิด เปิดใช้งานเครื่องพิมพ์บนเครือข่ายเพื่อพิมพ์งานโดยใช้ Internet Printing Protocol (IPP) เปิดใช้งาน IPP Fax เปิด * ปิด เปิดใช้งานเครื่องพิมพ์ USB เพื่อส่งงานแฟกซ์โดยใช้ IPP เปิดใช้งาน IPP Over USB เปิด * ปิด เปิดใช้งานเครื่องพิมพ์ USB เพื่อพิมพ์งานโดยใช้ IPP โดยปกติ IPP จะได้รับการออกแบบสำหรับใช้กับเครื่องพิมพ์บนเครือข่าย เปิดใช้งานการสแกน เปิด * ปิด เปิดใช้งานเครื่องพิมพ์บนเครือข่ายเพื่อพิมพ์งานโดยใช้โปรโตคอล eSCL เปิดใช้งาน Mopria Discovery เปิด * ปิด เปิดใช้งานอุปกรณ์มือถือเพื่อสืบค้นเครื่องพิมพ์ที่ผ่านการรับรอง Mopria™ เมนู การจัดการบริการบนโทรศัพท์มือถือ"},{"UUID":"ab44f8f5-e43a-4f8d-a37e-6db15f3a9f0e","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"อีเทอร์เน็ต รายการเมนูและคำอธิบายอีเทอร์เน็ต รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"อีเทอร์เน็ต รายการเมนูและคำอธิบายอีเทอร์เน็ต รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ความเร็วเครือข่าย ไม่ใช้ การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงความเร็วของอะแดปเตอร์เครือข่ายที่ใช้งาน IPv4 เปิดใช้งาน DHCP เปิด * ปิด กำหนดค่าการตั้งค่า IPv4 การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งค่า IP แอดเดรสแบบคงที่ IP แอดเดรส เน็ตมาสก์ เกตเวย์ IPv6 เปิดใช้งาน IPv6 เปิด * ปิด กำหนดค่าการตั้งค่า IPv6 เปิดใช้งาน DHCPv6 ปิด * เปิด การกำหนดค่าแอดเดรสแบบไม่มีสถานะอัตโนมัติ เปิด * ปิด DNS เซิร์ฟเวอร์แอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ IPv6 แอดเดรสที่กำหนดด้วยตนเอง การตั้งค่านี้กำหนดโดยผู้ใช้ เราเตอร์ IPv6 ที่กำหนดด้วยตนเอง การตั้งค่านี้กำหนดโดยผู้ใช้ หมายเลขนำหน้าแอดเดรส (64*) 0–128  (64*) IPv6 แอดเดรสทั้งหมด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว IPv6 แอดเดรสเราเตอร์ทั้งหมด การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แอดเดรสเครือข่าย ไม่ใช้ UAA LAA ระบุแอดเดรสเครือข่าย PCL SmartSwitch ไม่ใช้ ปิด เปิด * ตั้งให้เครื่องพิมพ์สลับเป็นการจำลอง PCL โดยอัตโนมัติเมื่อจำเป็น โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ เมื่อปิดใช้งานการตั้งค่านี้ เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเครื่องพิมพ์เริ่มต้นที่ระบุในเมนู  การตั้งค่า PS SmartSwitch ไม่ใช้ ปิด เปิด * ตั้งค่าเครื่องพิมพ์ให้สลับเป็นการจำลองแบบ PostScript โดยอัตโนมัติเมื่อจำเป็น โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ เมื่อปิดใช้งานการตั้งค่านี้ เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเครื่องพิมพ์เริ่มต้นที่ระบุในเมนู  การตั้งค่า การบัฟเฟอร์งาน ไม่ใช้ ปิด * เปิด จัดเก็บงานไว้ในไดรฟ์จัดเก็บข้อมูลชั่วคราวก่อนพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น Mac ค่าไบนารี PS ไม่ใช้ อัตโนมัติ * ปิด เปิด ตั้งให้เครื่องพิมพ์ประมวลผลงานพิมพ์การจำลองแบบ PostScript แบบไบนารีของ Macintosh อัตโนมัติ  จะประมวลผลงานพิมพ์จากคอมพิวเตอร์ที่ใช้ระบบปฏิบัติการ Windows หรือ Macintosh ปิด  จะกรองงานพิมพ์การจำลองแบบ PostScript โดยใช้โปรโตคอลมาตรฐาน อีเทอร์เน็ตประหยัดพลังงาน ไม่ใช้ เปิด ปิด อัตโนมัติ * ลดการใช้พลังงานเมื่อเครื่องพิมพ์ไม่ได้รับข้อมูลจากเครือข่ายอีเทอร์เน็ต เมนู อีเทอร์เน็ต"},{"UUID":"49929b70-53de-4f06-90d3-a5f07163cc57","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"TCP/IP จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย TCP/IP รายการเมนู","descFull":"TCP/IP จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย TCP/IP รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ตั้งชื่อโฮสต์ การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งชื่อคอมพิวเตอร์แม่ข่าย TCP/IP ปัจจุบัน ชื่อโดเมน การตั้งค่านี้กำหนดโดยผู้ใช้ ตั้งชื่อโดเมน อนุญาตให้ DHCP/BOOTP อัพเดตเซิร์ฟเวอร์ NTP เปิด * ปิด อนุญาตให้เครื่องลูกข่าย Dynamic Host Configuration Protocol (DHCP) และ BOOTstrap Protocol (BOOTP) อัพเดตการตั้งค่า NTP ของเครื่องพิมพ์ ชื่อการกำหนดค่าเป็นศูนย์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อบริการสำหรับเครือข่ายการกำหนดค่าเป็นศูนย์ เปิดใช้งาน IP อัตโนมัติ ปิด เปิด * กำหนด IP แอดเดรสโดยอัตโนมัติ DNS เซิร์ฟเวอร์แอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุเซิร์ฟเวอร์แอดเดรส Domain Name System (DNS) ปัจจุบัน สำรองข้อมูล DNS เซิร์ฟเวอร์แอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุเซิร์ฟเวอร์แอดเดรส DNS สำรอง สำรองข้อมูล DNS เซิร์ฟเวอร์แอดเดรส 2 สำรองข้อมูล DNS เซิร์ฟเวอร์แอดเดรส 3 ลำดับการค้นหาโดเมน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรายชื่อโดเมนเพื่อค้นหาเครื่องพิมพ์และทรัพยากรที่อยู่ในโดเมนอื่นบนเครือข่าย เปิดใช้งาน DDNS ปิด * เปิด อัพเดตการตั้งค่า DNS แบบไดนามิก DDNS TTL การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุการตั้งค่า DDNS ปัจจุบัน TTL เริ่มต้น เวลารีเฟรช DDNS เปิดใช้งาน mDNS ปิด เปิด * อัปเดตการตั้งค่า DNS แบบหลายผู้รับ WINS เซิร์ฟเวอร์แอดเดรส การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุเซิร์ฟเวอร์แอดเดรสสำหรับ Windows Internet Name Service (WINS) เปิดใช้งาน BOOTP ปิด * เปิด อนุญาตให้ BOOTP ระบุ IP แอดเดรสของเครื่องพิมพ์ รายการเซิร์ฟเวอร์ที่จำกัด การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุ IP แอดเดรสที่ได้รับอนุญาตให้สื่อสารกับเครื่องพิมพ์ผ่าน TCP/IP ใช้เครื่องหมายจุลภาคคั่นระหว่างแต่ละ IP แอดเดรส คุณสามารถเพิ่ม IP แอดเดรสได้สูงสุด 50 รายการ ตัวเลือกรายการเซิร์ฟเวอร์ที่จำกัด บล็อคทุกพอร์ต * บล็อคการพิมพ์เท่านั้น บล็อคการพิมพ์และ HTTP เท่านั้น ระบุตัวเลือกการเข้าใช้สำหรับ IP แอดเดรสที่ไม่อยู่ในรายการ MTU 256–1500 อีเธอร์เน็ต  (1500*) ระบุพารามิเตอร์ยูนิตการส่งข้อมูลสูงสุด (MTU) สำหรับการเชื่อมต่อ TCP พอร์ตพิมพ์แบบ Raw 1–65535  (9100*) ระบุหมายเลขพอร์ต Raw สำหรับเครื่องพิมพ์ที่เชื่อมต่อบนเครือข่าย ความเร็วสูงสุดของการรับส่งข้อมูลขาออก ปิด * เปิด ตั้งอัตราการถ่ายโอนสูงสุดของเครื่องพิมพ์ เมื่อเปิดใช้งาน ตัวเลือกสำหรับการตั้งค่านี้คือ 100–1000000 กิโลบิต/วินาที การรองรับ TLS เปิดใช้งาน TLSv1.0  ( ปิด *) เปิดใช้งาน TLSv1.1  ( ปิด *) เปิดใช้งาน TLSv1.2  ( เปิด *) เปิดใช้งานโปรโตคอล Transport Layer Security รายการการเข้ารหัส SSL การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุอัลกอริธึมการเข้ารหัสที่จะใช้สำหรับการเชื่อมต่อ SSL หรือ TLS รายการการเข้ารหัส TLSv1.3 SSL เมนู TCP/IP"},{"UUID":"22ebedae-e2cf-4f16-bbab-9343d4d52df3","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"SNMP จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย SNMP รายการเมนู","descFull":"SNMP จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย SNMP รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน SNMP เวอร์ชัน 1 และ 2c เปิดใช้งานแล้ว ปิด เปิด * กำหนดค่า Simple Network Management Protocol (SNMP) เวอร์ชัน 1 และ 2c เพื่อติดตั้งไดรเวอร์การพิมพ์และแอปพลิเคชัน ตั้งค่า SNMP ได้ ปิด เปิด * เปิดใช้งาน PPM MIB ปิด เปิด * SNMP Community การตั้งค่านี้กำหนดโดยผู้ใช้ SNMP เวอร์ชัน 3 เปิดใช้งานแล้ว ปิด เปิด * เปิดใช้งาน SNMP เวอร์ชัน 3 เพื่อติดตั้งและอัปเดตความปลอดภัยของเครื่องพิมพ์ ชื่อบริบท การตั้งค่านี้กำหนดโดยผู้ใช้ ป้อนชื่อบริบท ตั้งข้อมูลรับรองแบบอ่าน/เขียน ชื่อผู้ใช้ รหัสผ่านการตรวจสอบความถูกต้อง รหัสผ่านความเป็นส่วนตัว ป้อนข้อมูลรับรองแบบอ่านและเขียนสำหรับ SNMP เวอร์ชัน 3 ตั้งค่าข้อมูลรับรองแบบอ่านอย่างเดียว ชื่อผู้ใช้ รหัสผ่านการตรวจสอบความถูกต้อง รหัสผ่านความเป็นส่วนตัว ป้อนข้อมูลรับรองแบบอ่านอย่างเดียวสำหรับ SNMP เวอร์ชัน 3 แฮชการตรวจสอบความถูกต้อง MD5 SHA1 * ตั้งค่าแฮชการตรวจสอบความถูกต้องที่เกี่ยวข้อง ระดับการตรวจสอบความถูกต้องต่ำสุด ไม่มีการตรวจสอบความถูกต้อง ไม่มีการรักษาความเป็นส่วนตัว มีการตรวจสอบความถูกต้อง ไม่มีการรักษาความเป็นส่วนตัว มีการตรวจสอบความถูกต้อง มีการรักษาความเป็นส่วนตัว * ตั้งค่าระดับการตรวจสอบความถูกต้องขั้นต่ำที่เกี่ยวข้อง อัลกอริธึมความเป็นส่วนตัว DES มาตรฐานการเข้ารหัสขั้นสูง AES‑128 * ตั้งค่าอัลกอริทึมความเป็นส่วนตัวที่เกี่ยวข้อง เมนู SNMP"},{"UUID":"d1682e81-a1bb-40ec-ba44-2287f9f01bb2","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"IPSec จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนู IPSec และคำอธิบาย","descFull":"IPSec จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนู IPSec และคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เปิดใช้งาน IPSec ปิด * เปิด เปิดใช้งาน Internet Protocol Security (IPSec) การกำหนดค่าฐาน ค่าเริ่มต้น * ความเข้ากันได้ ความปลอดภัย ตั้งการกำหนดค่าฐาน IPSec จะปรากฏรายการเมนูนี้เมื่อตั้ง  เปิดใช้งาน IPSec  เป็น  เปิด  เท่านั้น ข้อเสนอกลุ่ม DH (Diffie-Hellman) modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) ตั้งการกำหนดค่าฐาน IPSec จะแสดงรายการเมนูนี้เมื่อตั้ง  การกำหนดค่าฐาน  เป็น  ความเข้ากันได้  เท่านั้น วิธีการเข้ารหัสที่เสนอ 3DES มาตรฐานการเข้ารหัสขั้นสูง AES * ตั้งวิธีการเข้ารหัส จะแสดงรายการเมนูนี้เมื่อตั้ง  การกำหนดค่าฐาน  เป็น  ความเข้ากันได้  เท่านั้น วิธีการตรวจสอบความถูกต้องที่เสนอ SHA1 SHA256 * SHA512 ตั้งวิธีการตรวจสอบความถูกต้อง จะแสดงรายการเมนูนี้เมื่อตั้ง  การกำหนดค่าฐาน  เป็น  ความเข้ากันได้  เท่านั้น อายุการใช้งานของ IKE SA (ชั่วโมง) 1 2 4 8 24 * ระบุระยะเวลาหมดอายุ IKE SA จะปรากฏรายการเมนูนี้เมื่อตั้ง  การกำหนดค่าฐาน  เป็น  ความปลอดภัย  เท่านั้น อายุการใช้งานของ IPSec SA (ชั่วโมง) 1 2 4 8 24 * ระบุระยะเวลาหมดอายุ IPSec SA จะปรากฏรายการเมนูนี้เมื่อตั้ง  การกำหนดค่าฐาน  เป็น  ความปลอดภัย  เท่านั้น ใบรับรองอุปกรณ์ IPSec ค่าเริ่มต้น * ระบุใบรับรอง IPSec จะปรากฏรายการเมนูนี้เมื่อตั้ง  เปิดใช้งาน IPSec  เป็น  เปิด  เท่านั้น การเชื่อมต่อคีย์ที่แบ่งปันล่วงหน้าที่ได้รับการรับรองความถูกต้อง โฮสต์  [x] กำหนดค่าการเชื่อมต่อที่ได้รับการตรวจสอบความถูกต้องของเครื่องพิมพ์ จะปรากฏรายการเมนูเหล่านี้เมื่อตั้ง  เปิดใช้งาน IPSec  เป็น  เปิด  เท่านั้น ใบรับรองการเชื่อมต่อที่ได้รับการตรวจสอบความถูกต้อง โฮสต์  [x]  แอดเดรส[/ซับเน็ต] เมนู IPSec"},{"UUID":"a55c3db5-cb32-4364-8390-728fb5af3760","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"802.1x 802.1x จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย 802.1x","descFull":"802.1x 802.1x จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบาย 802.1x รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ใช้งานอยู่ ไม่ใช้ ปิด * เปิด ให้เครื่องพิมพ์เชื่อมต่อเครือข่ายที่ต้องมีการตรวจสอบสิทธิ์ก่อนอนุญาตการเข้าถึง การตรวจสอบความถูกต้องของ 802.1x ชื่อล็อกอินของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อล็อกอินที่ไม่ซ้ำกัน รหัสผ่านล็อกอินของอุปกรณ์ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านที่ไม่ซ้ำกัน ตรวจสอบใบรับรองเซิร์ฟเวอร์ เปิด * ปิด เปิดใช้งานตัวเลือกนี้เพื่อให้สามารถตรวจสอบใบรับรองการรักษาความปลอดภัยบนเซิร์ฟเวอร์ตรวจสอบความถูกต้อง เปิดใช้การบันทึกเหตุการณ์ เปิด ปิด * เปิดใช้งานเครื่องพิมพ์เพื่อบันทึกในบันทึกการเชื่อมต่อ ใบรับรองอุปกรณ์ 802.1x ค่าเริ่มต้น * เลือกใบรับรองดิจิตอลที่คุณต้องการใช้ หากมีการติดตั้งใบรับรองเพียงรายการเดียว จะมีเพียงตัวเลือก  ค่าเริ่มต้น  เท่านั้นที่ปรากฏขึ้น กลไกการตรวจสอบความถูกต้อง EAP ‑ MD5 เปิด * ปิด เปิดใช้งานเฟรมเวิร์ก Extensible Authentication Protocol (EAP) MD5 EAP - MSCHAPv2 เปิด * ปิด เปิดใช้งานวิธีการตรวจสอบความถูกต้อง EAP Microsoft Challenge Handshake Authentication Protocol (MSCHAP) เวอร์ชัน 2 LEAP เปิด * ปิด เปิดใช้งาน Lightweight Extensible Authentication Protocol (LEAP) ซึ่งเป็นเวอร์ชันที่ได้รับการแก้ไขของ MSCHAP PEAP เปิด * ปิด เปิดใช้งาน Protected Extensible Authentication Protocol (PEAP) ซึ่งเป็นวิธีการที่ให้การตรวจสอบความถูกต้องที่ปลอดภัยมากขึ้นสำหรับ 802.11 WLAN PEAP รองรับการควบคุมการเข้าถึงพอร์ต 802.1x EAP - TLS เปิด * ปิด เปิดใช้งาน EAP Transport Layer Security (TLS) ซึ่งเป็นโปรโตคอลที่เครื่องลูกข่ายและเซิร์ฟเวอร์ตรวจสอบความถูกต้องซึ่งกันและกันโดยใช้ใบรับรองดิจิตอล EAP - TTLS เปิด * ปิด เปิดใช้งาน EAP tunneled Transport Layer Security (TLS) ซึ่งเป็นโปรโตคอลที่คล้ายคลึงกับ EAP_TLS ยกเว้นรายการที่เซิร์ฟเวอร์มีเพียงใบรับรองที่ตรวจสอบความถูกต้องกับเครื่องลูกข่ายก่อนเท่านั้น วิธีการตรวจสอบความถูกต้องของ TTLS CHAP MSCHAP MSCHAPv2 * PAP เลือกวิธีการ EAP TTLS ที่ใช้สำหรับอุปกรณ์ของคุณ เมนู 802.1x"},{"UUID":"8fb85da5-ad57-4d60-95df-a9bfcc48fed8","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"การกำหนดค่า LPD จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบายการกำหนดค่า LPD","descFull":"การกำหนดค่า LPD จะปรากฏเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น รายการเมนูและคำอธิบายการกำหนดค่า LPD รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน หมดเวลา LPD 0–65535 วินาที  (90*) ตั้งค่าการหมดเวลาเพื่อหยุดเซิร์ฟเวอร์ Line Printer Daemon (LPD) ไม่ให้รองานพิมพ์ที่ค้างหรือไม่ถูกต้องอย่างไม่จำกัดเวลา หน้าป้ายประกาศ LPD ปิด * เปิด พิมพ์หน้าป้ายประกาศสำหรับงานพิมพ์ LPD ทั้งหมด หน้าป้ายประกาศคือหน้าแรกของงานพิมพ์ที่ใช้เป็นตัวแยกงานพิมพ์และระบุผู้สร้างคำของานพิมพ์ หน้าท้ายของ LPD ปิด * เปิด พิมพ์หน้าท้ายสำหรับงานพิมพ์ LPD ทั้งหมด หน้าท้ายคือหน้าสุดท้ายของงานพิมพ์ การแปลงค่าการปัดแคร่ของ LPD ปิด * เปิด เปิดใช้งานการเลื่อนไปบรรทัดใหม่ การขึ้นบรรทัดใหม่เป็นกลไกที่สั่งให้เครื่องพิมพ์เลื่อนเคอร์เซอร์ไปยังตำแหน่งแรกในบรรทัดเดียวกัน เมนู การกำหนดค่า LPD"},{"UUID":"dacf9a17-0156-42cb-9c68-42c93e17f0aa","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"การตั้งค่า HTTP/FTP รายการเมนูและคำอธิบายการตั้งค่า HTTP/FTP รายการเมนู","descFull":"การตั้งค่า HTTP/FTP รายการเมนูและคำอธิบายการตั้งค่า HTTP/FTP รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน พร็อกซี่่่่่่่่ IP แอดเดรสของพร็อกซี่ HTPP การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดค่าการตั้งค่าเซิร์ฟเวอร์ HTTP พอร์ต IP เริ่มต้นของ HTTP การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดค่าแอดเดรสของพอร์ต IP เริ่มต้นของ HTTP พอร์ตเริ่มต้นของโรงงานสำหรับ HTTP คือ 80 IP แอดเดรสของพร็อกซี่ FTP การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดค่าการตั้งค่า FTP พอร์ต IP เริ่มต้นของ FTP การตั้งค่านี้กำหนดโดยผู้ใช้ กำหนดค่าแอดเดรสของพอร์ต IP เริ่มต้นของ FTP พอร์ตเริ่มต้นของโรงงานสำหรับ HTTP คือ 21 การตรวจสอบความถูกต้อง ไม่มี อัตโนมัติ * พื้นฐาน Digest NTLM ระบุข้อมูลรับรองสำหรับการตรวจสอบความถูกต้อง ชื่อผู้ใช้ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อผู้ใช้ที่ไม่ซ้ำกัน รหัสผ่าน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุรหัสผ่านที่ไม่ซ้ำกัน โดเมนภายใน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุชื่อโดเมนสำหรับเซิร์ฟเวอร์ HTTP และ FTP การตั้งค่าอื่นๆ เปิดใช้งานเซิร์ฟเวอร์ HTTP เปิด * ปิด เข้าใช้ Embedded Web Server เพื่อตรวจสอบและจัดการเครื่องพิมพ์ เปิดใช้งาน HTPPS เปิด * ปิด เปิดใช้ Hypertext Transfer Protocol Secure (HTTPS) เพื่อเข้ารหัสการถ่ายโอนข้อมูลระหว่างเซิร์ฟเวอร์พิมพ์ บังคับการเชื่อมต่อ HTTPS เปิด ปิด * บังคับให้เครื่องพิมพ์ใช้การเชื่อมต่อ HTTPS เปิดใช้งาน FTP/TFTP เปิด * ปิด ส่งไฟล์โดยใช้ FTP/TFTP ใบรับรองอุปกรณ์ HTTPS ค่าเริ่มต้น * ดูใบรับรองอุปกรณ์ HTTP ที่ใช้กับเครื่องพิมพ์ หมดเวลาสำหรับคำขอ HTTP/FTP 1–299 วินาที  (30*) ระบุระยะเวลาก่อนที่การเชื่อมต่อเซิร์ฟเวอร์จะหยุดลง ลองอีกครั้งสำหรับคำขอ HTTP/FTP 1–299 วินาที  (3*) ตั้งจำนวนครั้งที่จะลองใหม่เพื่อเชื่อมต่อกับเซิร์ฟเวอร์ HTTP/FTP เมนู การตั้งค่า HTTP/FTP"},{"UUID":"18d5216e-d98c-4c60-bc78-2f3a4124c7d6","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"ThinPrint รายการเมนู ThinPrint และคำอธิบาย รายการเมนู","descFull":"ThinPrint รายการเมนู ThinPrint และคำอธิบาย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เปิดใช้งาน ThinPrint ปิด * เปิด พิมพ์โดยใช้ ThinPrint หมายเลขพอร์ต 4000–4999  (4000*) ตั้งค่าหมายเลขพอร์ตสำหรับเซิร์ฟเวอร์ ThinPrint แบนด์วิดท์ (บิต/วินาที) 100–1000000  (0*) ตั้งค่าความเร็วการส่งข้อมูลในสภาพแวดล้อม ThinPrint ขนาดแพ็คเกต (kbytes) 0–64000  (0*) ตั้งค่าขนาดแพ็คเกตสำหรับการส่งข้อมูล เมนู ThinPrint"},{"UUID":"9179d8e5-1c4f-4ff8-b8b6-8b10b83bc038","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"USB รายการเมนูและคำอธิบายUSB รายการเมนู การตั้งค่า คำอธิบาย","descFull":"USB รายการเมนูและคำอธิบายUSB รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน PCL SmartSwitch ปิด เปิด * ตั้งให้เครื่องพิมพ์สลับเป็นการจำลอง PCL เมื่อจำเป็นสำหรับงานพิมพ์ที่รับผ่านพอร์ต USB โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ เมื่อปิดใช้งานการตั้งค่านี้ เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเครื่องพิมพ์เริ่มต้นที่ระบุในเมนู  การตั้งค่า PS SmartSwitch ปิด เปิด * ตั้งค่าเครื่องพิมพ์ให้สลับเป็นการจำลองแบบ PostScript เมื่อจำเป็นสำหรับงานพิมพ์ที่ได้รับผ่านพอร์ต USB โดยไม่คำนึงถึงภาษาเริ่มต้นของเครื่องพิมพ์ เมื่อปิดใช้งานการตั้งค่านี้ เครื่องพิมพ์จะไม่ตรวจสอบข้อมูลที่เข้ามา และใช้ภาษาเครื่องพิมพ์เริ่มต้นที่ระบุในเมนู  การตั้งค่า การบัฟเฟอร์งาน ปิด * เปิด จัดเก็บงานไว้ในไดรฟ์จัดเก็บข้อมูลชั่วคราวก่อนพิมพ์ รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น Mac ค่าไบนารี PS อัตโนมัติ * เปิด ปิด ตั้งให้เครื่องพิมพ์ประมวลผลงานพิมพ์การจำลองแบบ PostScript แบบไบนารีของ Macintosh อัตโนมัติ  จะประมวลผลงานพิมพ์จากคอมพิวเตอร์ที่ใช้ระบบปฏิบัติการ Windows หรือ Macintosh ปิด  จะกรองงานพิมพ์การจำลองแบบ PostScript โดยใช้โปรโตคอลมาตรฐาน เปิดใช้งานพอร์ต USB ปิด เปิด * เปิดใช้งานพอร์ตไดร์ฟ USB ด้านหน้าและด้านหลัง เมนู USB"},{"UUID":"612b680a-7b85-4d8b-97c2-2c99706892d3","title":"เครือข่าย/พอร์ต","link":"network-overview-topic.html","desc":"จำกัดการเข้าถึงจากเครือข่ายภายนอก รายการเมนูและคำอธิบายของจำกัดการเข้าถึงจากเครือข่ายภายนอก รายการเมนู การตั้งค่า คำอธิบาย","descFull":"จำกัดการเข้าถึงจากเครือข่ายภายนอก รายการเมนูและคำอธิบายของจำกัดการเข้าถึงจากเครือข่ายภายนอก รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน จำกัดการเข้าถึงจากเครือข่ายภายนอก ปิด * เปิด จำกัดการเข้าถึงไซต์เครือข่าย ที่อยู่เครือข่ายภายนอก การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุแอดเดรสเครือข่ายที่จำกัดการเข้าถึง ที่อยู่อีเมลสำหรับการแจ้งเตือน การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุที่อยู่อีเมลเพื่อส่งการแจ้งเตือนเหตุการณ์ที่บันทึกไว้ ความถี่ค่า Ping 1–300  (10*) ระบุช่วงเวลาการสืบค้นเครือข่ายเป็นวินาที เรื่อง การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุหัวเรื่องและข้อความการแจ้งเตือนทางอีเมล ข้อความ เมนู จำกัดการเข้าถึงจากเครือข่ายภายนอก"},{"UUID":"a200c080-30a5-44ac-a00c-556fb2aee40a","title":"วิธีลงชื่อเข้าใช้","link":"login-methods-subgroup.html","desc":"จัดการการอนุญาต รายการเมนูและคำอธิบายการจัดการการอนุญาต รายการเมนู การตั้งค่า คำอธิบาย","descFull":"จัดการการอนุญาต รายการเมนูและคำอธิบายการจัดการการอนุญาต รายการเมนู การตั้งค่า คำอธิบาย การเข้าถึงฟังก์ชัน เข้าถึงสมุดที่อยู่ในแอปพลิเคชัน แก้ไขสมุดที่อยู่ จัดการทางลัด สร้างโปรไฟล์ จัดการบุ๊คมาร์ค การพิมพ์แฟลชไดรฟ์ การพิมพ์สีจากแฟลชไดรฟ์ การสแกนแฟลชไดรฟ์ ฟังก์ชันทำสำเนา การพิมพ์แบบทำสำเนาสี การลบสี ฟังก์ชันอีเมล ฟังก์ชันแฟกซ์ ฟังก์ชัน FTP ปล่อยแฟกซ์ที่ระงับไว้ การเข้าถึงงานที่ระงับไว้ ใช้โปรไฟล์ ยกเลิกงานที่อุปกรณ์ เปลี่ยนภาษา โปรโตคอลการพิมพ์ทางอินเทอร์เน็ต (IPP) เริ่มการสแกนระยะไกล พิมพ์ขาวดำ พิมพ์สี โฟลเดอร์เครือข่าย - สแกน ฮาร์ดดิสก์ - พิมพ์ ฮาร์ดดิสก์ - พิมพ์สี ฮาร์ดดิสก์ - สแกน ระบุฟังก์ชันของเครื่องพิมพ์ที่ผู้้ใช้สามารถเข้าถึงได้ รายการเมนูบางอย่างจะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น เมนูด้านการดูแลระบบ เมนูการรักษาความปลอดภัย เมนูเครือข่าย/พอร์ต เมนูกระดาษ เมนูรายงาน เมนูการกำหนดค่าฟังก์ชัน เมนูวัสดุสิ้นเปลือง เมนูการ์ดตัวเลือก เมนู SE เมนูอุปกรณ์ ระบุเมนูของเครื่องพิมพ์ที่ผู้้ใช้สามารถเข้าถึงได้ การจัดการอุปกรณ์ การจัดการระยะไกล การอัพเดตเฟิร์มแวร์ การกำหนดค่าแอปพลิเคชัน การล็อคแผงควบคุม การเข้าถึง Embedded Web Server นำเข้า / ส่งออกการตั้งค่าทั้งหมด การลบข้อมูลไม่สามารถใช้งานได้ การลงทะเบียนบริการระบบคลาวด์ ระบุฟังก์ชัน การจัดการอุปกรณ์ ที่ผู้ใช้สามารถเข้าถึงได้ แอปพลิเคชัน แอปพลิเคชันใหม่ การแสดงสไลด์ เปลี่ยนภาพพื้นหลัง ภาพพักหน้าจอ Card Copy ศูนย์การสแกน ศูนย์การสแกนแบบกำหนดเอง  [x] ควบคุมการเข้าใช้งานแอปพลิเคชันเครื่องพิมพ์ เมนู จัดการการอนุญาต"},{"UUID":"432e348a-7ada-477e-a08d-7ef214ae129f","title":"วิธีลงชื่อเข้าใช้","link":"login-methods-subgroup.html","desc":"บัญชีในเครื่อง รายการเมนูและคำอธิบายบัญชีในเครื่อง รายการเมนู รายการเมนูย่อย การตั้งค่า","descFull":"บัญชีในเครื่อง รายการเมนูและคำอธิบายบัญชีในเครื่อง รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย จัดการกลุ่ม/การอนุญาต เพิ่มกลุ่ม การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุกลุ่มที่สามารถเข้าถึงฟังก์ชันต่างๆ ของเครื่องพิมพ์ เมนูด้านการดูแลระบบ ตัวเลือกการจัดการเครื่องพิมพ์ และแอปพลิเคชันต่างๆ ผู้ใช้ทั้งหมด นำเข้าส่วนควบคุมการเข้าใช้งาน นำเข้าส่วนควบคุมการเข้าใช้งานจากบัญชีที่ลงทะเบียนในเครื่องพิมพ์ เพิ่มผู้ใช้ ชื่อผู้ใช้/รหัสผ่าน ชื่อผู้ใช้ รหัสผ่าน PIN การตั้งค่านี้กำหนดโดยผู้ใช้ เพิ่มผู้ใช้และระบุวิธีลงชื่อเข้าใช้เครื่องพิมพ์ เมนู บัญชีในเครื่อง"},{"UUID":"f4067d07-fd6e-47d6-860a-0e981add83d1","title":"วิธีลงชื่อเข้าใช้","link":"login-methods-subgroup.html","desc":"วิธีลงชื่อเข้าใช้เริ่มต้น เมนูนี้จะปรากฏขึ้นก็ต่อเมื่อกำหนดค่าเมนู บัญชีในเครื่อง แล้ว รายการเมนูและคำอธิบายวิธีลงชื่อเข้าใช้เริ่มต้น","descFull":"วิธีลงชื่อเข้าใช้เริ่มต้น เมนูนี้จะปรากฏขึ้นก็ต่อเมื่อกำหนดค่าเมนู บัญชีในเครื่อง แล้ว รายการเมนูและคำอธิบายวิธีลงชื่อเข้าใช้เริ่มต้น รายการเมนู การตั้งค่า คำอธิบาย แผงควบคุม ชื่อผู้ใช้/รหัสผ่าน ชื่อผู้ใช้ รหัสผ่าน PIN ระบุวิธีลงชื่อเข้าใช้เริ่มต้นเพื่อเข้าถึงแผงควบคุม เครื่องมือค้นหา ชื่อผู้ใช้/รหัสผ่าน ชื่อผู้ใช้ รหัสผ่าน PIN ระบุวิธีลงชื่อเข้าใช้เริ่มต้นเพื่อเข้าถึงบราวเซอร์ เมนู วิธีลงชื่อเข้าใช้เริ่มต้น"},{"UUID":"d2edd235-1886-47e5-b806-85ad99e36148","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"กำหนดเวลาอุปกรณ์ USB รายการเมนูและคำอธิบายกำหนดเวลาอุปกรณ์ USB รายการเมนู","descFull":"กำหนดเวลาอุปกรณ์ USB รายการเมนูและคำอธิบายกำหนดเวลาอุปกรณ์ USB รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย กำหนดเวลา เพิ่มกำหนดเวลาใหม่ บันทึกกำหนดเวลา การดำเนินการ วัน เวลา กำหนดเวลาการเข้าถึงพอร์ต USB ด้านหน้า เมนู กำหนดเวลาอุปกรณ์ USB"},{"UUID":"6fa8200a-c1ad-45de-beab-4261fa206602","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"บันทึกการตรวจประเมินความปลอดภัย รายการเมนูและคำอธิบายบันทึกการตรวจประเมินความปลอดภัย รายการเมนู การตั้งค่า คำอธิบาย","descFull":"บันทึกการตรวจประเมินความปลอดภัย รายการเมนูและคำอธิบายบันทึกการตรวจประเมินความปลอดภัย รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน เปิดใช้การตรวจประเมิน ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้บันทึกเหตุการณ์ในบันทึกการตรวจประเมินความปลอดภัยและ Syslog ระยะไกล เปิดใช้งาน Syslog ระยะไกล ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งบันทึกการตรวจประเมินไปยังเซิร์ฟเวอร์ระยะไกล เซิร์ฟเวอร์ Syslog ระยะไกล การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุเซิร์ฟเวอร์ Syslog ระยะไกล พอร์ต Syslog ระยะไกล 1–65535  (514*) ระบุพอร์ตที่เครื่องพิมพ์ใช้เมื่อส่งบันทึกเหตุการณ์ไปยังเซิร์ฟเวอร์ระยะไกล วิธีการ Syslog ระยะไกล UDP ปกติ * Stunnel ระบุโปรโตคอลที่เครื่องพิมพ์ใช้เมื่อส่งบันทึกเหตุการณ์ไปยังเซิร์ฟเวอร์ระยะไกล สิ่งอำนวยความสะดวก Syslog ระยะไกล 0 ‑ ข้อความเคอร์เนล 1 ‑ ข้อความระดับผู้ใช้ 2 ‑ ระบบเมล 3 ‑ ดีมอนระบบ 4 ‑ ข้อความการรักษาความปลอดภัย/การอนุญาต * 5 ‑ ข้อความที่ Syslogd สร้างขึ้นภายใน 6 ‑ ระบบย่อยของ Line Printer 7 ‑ ระบบย่อยของข่าวบนเครือข่าย 8 ‑ ระบบย่อย UUCP 9 ‑ ดีมอนดำเนินคำสั่งตามเวลา 10 ‑ ข้อความเกี่ยวกับความปลอดภัย/การอนุญาต 11 ‑ ดีมอน FTP 12 ‑ ระบบย่อย NTP 13 ‑ การตรวจประเมินบันทึก 14 ‑ การแจ้งเตือนบันทึก 15 ‑ ดีมอนดำเนินคำสั่งตามเวลา 16 ‑ การใช้งานในพื้นที่ 0 (local0) 17‑ การใช้งานในพื้นที่ 1 (local1) 18 ‑ การใช้งานในพื้นที่ 2 (local2) 19 ‑ การใช้งานในพื้นที่ 3 (local3) 20 ‑ การใช้งานในพื้นที่ 4 (local4) 21 ‑ การใช้งานในพื้นที่ 5 (local5) 22 ‑ การใช้งานในพื้นที่ 6 (local6) 23 ‑ การใช้งานในพื้นที่ 7 (local7) ระบุรหัสอุปกรณ์ที่เครื่องพิมพ์ใช้เมื่อส่งบันทึกเหตุการณ์ไปยังเซิร์ฟเวอร์ syslog ระยะไกล ความรุนแรงของเหตุการณ์ที่จะบันทึก 0 ‑ ฉุกเฉิน 1 ‑ การแจ้งเตือน 2 ‑ สำคัญมาก 3 ‑ ข้อผิดพลาด 4 ‑ คำเตือน * 5 ‑ ประกาศ 6 ‑ แจ้งให้ทราบ 7 ‑ ดีบัก ระบุค่าความรุนแรงของแต่ละเหตุการณ์ เหตุการณ์ที่ไม่ได้บันทึก Syslog ระยะไกล ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งเหตุการณ์ที่เกี่ยวข้องใดๆ ที่อยู่อีเมลของผู้ดูแลระบบ การตั้งค่านี้กำหนดโดยผู้ใช้ ระบุที่อยู่อีเมลของผู้ดูแลระบบเครื่องพิมพ์ที่ได้รับแจ้งถึงเหตุการณ์ในบันทึกบางอย่าง ส่งอีเมลการแจ้งเตือนการล้างบันทึก ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งอีเมลไปยังผู้ดูแลระบบทุกครั้งที่มีการลบบันทึก ส่งอีเมลการแจ้งเตือนการปิดทับบันทึก ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งอีเมลถึงผู้ดูแลระบบเมื่อมีการปิดทับรายการบันทึก บันทึกลักษณะการทำงานทั้งหมด ปิดทับรายการที่เก่าที่สุด * ส่งบันทึกอีเมล แล้วลบรายการทั้งหมด กำหนดวิธีการแก้ไขปัญหาที่จัดเก็บบันทึกของเครื่องพิมพ์เมื่อบันทึกเต็มหน่วยความจำที่จัดไว้ การแจ้งเตือน % เต็มของอีเมล ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งอีเมลถึงผู้ดูแลระบบเมื่อบันทึกเต็มหน่วยความจำที่จัดไว้ ระดับการแจ้งเตือน % เต็ม 1–99  (90*) ตรวจสอบว่าพื้นที่ว่างที่มีในบันทึกเท่ากันหรือเกินกว่าค่าของระดับการแจ้งเตือนเต็ม ส่งอีเมลการแจ้งเตือนการส่งบันทึกออกแล้ว ปิด * เปิด ส่งการแจ้งเตือนทางอีเมลไปยังผู้ดูแลระบบเมื่อมีการส่งออกบันทึก ส่งอีเมลการแจ้งเตือนการเปลี่ยนแปลงการตั้งค่าบันทึก ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ส่งอีเมลถึงผู้ดูแลระบบเมื่อค่าของเมนู เปิดใช้การตรวจประเมิน เปลี่ยนแปลง การสิ้นสุดบรรทัดของบันทึก LF (\\n) * CR (\\r) CRLF (\\r\\n) กำหนดวิธีการจัดการการสิ้นสุดบรรทัดของเครื่องพิมพ์ในไฟล์บันทึก โดยขึ้นอยู่กับระบบปฏิบัติการที่ไฟล์ถูกแยกวิเคราะห์หรือดู การส่งออกลายเซ็นแบบดิจิทัล ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ลงนามในบันทึกการรักษาความปลอดภัยที่ส่งออกโดยอัตโนมัติ ล้างบันทึก การตั้งค่านี้กำหนดโดยผู้ใช้ ลบบันทึกการตรวจสอบทั้งหมด ส่งออกบันทึก Syslog (RFC 5424) Syslog (RFC 3164) CSV ส่งออกบันทึกจากเครื่องพิมพ์หรือแฟลชไดรฟ์ เมนู บันทึกการตรวจประเมินความปลอดภัย"},{"UUID":"659ff4df-67c8-48cb-8ee9-2426f50bf1c2","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"ข้อจำกัดการลงชื่อเข้าใช้ รายการเมนูและคำอธิบายข้อจำกัดการลงชื่อเข้าใช้ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"ข้อจำกัดการลงชื่อเข้าใช้ รายการเมนูและคำอธิบายข้อจำกัดการลงชื่อเข้าใช้ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน การลงชื่อเข้าใช้ล้มเหลว 1–10  (3*) ระบุจำนวนครั้งของความพยายามในการลงชื่อเข้าใช้ที่ล้มเหลวก่อนที่ผู้ใช้จะถูกล็อกเอาต์ ช่วงระยะเวลาล้มเหลว 1–60 นาที  (5*) ระบุช่วงเวลาที่อนุญาตให้มีการลงชื่อเข้าใช้ที่ล้มเหลวได้ก่อนที่ผู้ใช้จะถูกล็อกเอาต์ เวลาล็อกเอาต์ 1–60 นาที  (5*) ระบุระยะเวลาที่ไม่อนุญาตให้ทำการลงชื่อเข้าใช้ หมดเวลาลงชื่อเข้าใช้เว็บ 1–120 นาที  (10*) ระบุระยะเวลาที่อินเตอร์เฟซระยะไกล เช่น เว็บเพจ ยังคงสามารถไม่ทำงานได้ก่อนที่ผู้ใช้จะถูกให้ออกจากระบบโดยอัตโนมัติ เมนู ข้อจำกัดการลงชื่อเข้าใช้"},{"UUID":"de415446-b541-4116-a69d-cf96e6adbee5","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"การตั้งค่างานพิมพ์เอกสารที่เป็นความลับ รายการเมนูและคำอธิบาย การตั้งค่าการพิมพ์ข้อมูลที่เป็นความลับ รายการเมนู การตั้งค่า","descFull":"การตั้งค่างานพิมพ์เอกสารที่เป็นความลับ รายการเมนูและคำอธิบาย การตั้งค่าการพิมพ์ข้อมูลที่เป็นความลับ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน รหัส PIN ไม่ถูกต้องจำนวนสูงสุด 2–10 ตั้งขีดจำกัดสำหรับการป้อน PIN ไม่่ถูกต้อง เมื่อถึงขีดจำกัด งานพิมพ์สำหรับชื่อผู้ใช้นั้นจะถูกลบออก การหมดอายุของงานลับ ปิด * 1 ชั่วโมง 4 ชั่วโมง 24 ชั่วโมง 72 ชั่วโมง 1 สัปดาห์ ตั้งค่าเวลาการหมดอายุทีละรายการสำหรับงานที่ระงับไว้แต่ละประเภทก่อนที่เครื่องพิมพ์จะลบออกจากหน่วยความจำโดยอัตโนมัติ ประเภทของงานที่ระงับไว้คือ  เป็นความลับ ,  ทำซ้ำ ,  สำรอง  และ ตรวจสอบงาน หากเปลี่ยนการตั้งค่าเวลาหมดอายุนี้ขณะที่งานพิมพ์เอกสารที่เป็นความลับอยู่ในหน่วยความจำของเครื่องพิมพ์หรือฮาร์ดดิสก์ของเครื่องพิมพ์ เวลาหมดอายุสำหรับงานพิมพ์เหล่านั้นจะไม่เปลี่ยนเป็นค่าเริ่มต้นใหม่ หากปิดเครื่องพิมพ์ งานที่เป็นความลับทั้งหมดในหน่วยความจำเครื่องพิมพ์จะถูกลบ ทำซ้ำการหมดอายุของงาน ปิด * 1 ชั่วโมง 4 ชั่วโมง 24 ชั่วโมง 72 ชั่วโมง 1 สัปดาห์ ตั้งเวลาหมดอายุสำหรับงานพิมพ์ที่คุณต้องการทำซ้ำ ตรวจสอบการหมดอายุของงาน ปิด * 1 ชั่วโมง 4 ชั่วโมง 24 ชั่วโมง 72 ชั่วโมง 1 สัปดาห์ ตั้งค่าเวลาหมดอายุสำหรับการพิมพ์สำเนาของงานเพื่อให้คุณตรวจสอบคุณภาพก่อนพิมพ์สำเนาที่เหลือ กำหนดการหมดอายุของงาน ปิด * 1 ชั่วโมง 4 ชั่วโมง 24 ชั่วโมง 72 ชั่วโมง 1 สัปดาห์ ตั้งเวลาหมดอายุสำหรับงานที่คุณต้องการจัดเก็บไว้ในเครื่องพิมพ์เพื่อพิมพ์ในภายหลัง จำเป็นต้องระงับงานทั้งหมด ปิด * เปิด ตั้งเครื่องพิมพ์ให้ระงับงานพิมพ์ทั้งหมด เก็บเอกสารที่ซ้ำกัน ปิด * เปิด ตั้งให้เครื่องพิมพ์เก็บรักษาเอกสารทั้งหมดที่มีชื่อไฟล์เหมือนกันไว้ เมนู การตั้งค่างานพิมพ์เอกสารที่เป็นความลับ"},{"UUID":"9b04f935-2dd9-4806-a56f-2a491f84feef","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"การเข้ารหัส รายการเมนูและคำอธิบายของการเข้ารหัส รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การเข้ารหัส รายการเมนูและคำอธิบายของการเข้ารหัส รายการเมนู การตั้งค่า คำอธิบาย พื้นที่จัดเก็บภายใน การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการเข้ารหัสของพื้นที่จัดเก็บภายใน ฮาร์ดดิสก์ การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการเข้ารหัสของฮาร์ดดิสก์ จะแสดงรายการเมนูนี้เมื่อติดตั้งฮาร์ดดิสก์แล้วเท่านั้น ไดรฟ์จัดเก็บข้อมูลอัจฉริยะ การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว แสดงสถานะการเข้ารหัสของไดรฟ์จัดเก็บข้อมูลอัจฉริยะ (ISD) รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้ง ISD แล้วเท่านั้น เมนู การเข้ารหัส"},{"UUID":"6c0e76e4-cee5-443f-9f5b-e897a689a015","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"ลบไฟล์ข้อมูลชั่วคราว รายการเมนูและคำอธิบายลบไฟล์ข้อมูลชั่วคราว รายการเมนู การตั้งค่า คำอธิบาย","descFull":"ลบไฟล์ข้อมูลชั่วคราว รายการเมนูและคำอธิบายลบไฟล์ข้อมูลชั่วคราว รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน จัดเก็บบนหน่วยความจำออนบอร์ด ปิด * เปิด ตั้งค่าเครื่องพิมพ์ให้ลบข้อมูลทั้งหมดของงานจากหน่วยความจำหลังจากเสร็จสิ้นงานแล้ว จัดเก็บในฮาร์ดดิสก์ ลบแบบ 1 พาส * ลบแบบ 3 พาส ลบแบบ 7 พาส ระบุวิธีที่เครื่องพิมพ์ใช้เพื่อลบข้อมูลทั้งหมดของงานจากฮาร์ดดิสก์หลังจากเสร็จสิ้นงานแล้ว จะแสดงรายการเมนูนี้เมื่อติดตั้งฮาร์ดดิสก์ของเครื่องพิมพ์เท่านั้น เมนู ลบไฟล์ข้อมูลชั่วคราว"},{"UUID":"a12cb4f9-bbcc-4756-ab35-399875bd55ca","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"การตั้งค่าโซลูชั่น LDAP รายการเมนูและคำอธิบายการตั้งค่าโซลูชั่น LDAP รายการเมนู","descFull":"การตั้งค่าโซลูชั่น LDAP รายการเมนูและคำอธิบายการตั้งค่าโซลูชั่น LDAP รายการเมนู การตั้งค่า คำอธิบาย ทำตามกระบวนการอ้างอิง LDAP ปิด * เปิด ค้นหาเซิร์ฟเวอร์อื่นๆ ในโดเมนสำหรับบัญชีผู้ใช้ที่เข้าสู่ระบบ การตรวจสอบใบรับรอง LDAP ใช่ ไม่ * เปิดใช้งานการตรวจสอบใบรับรอง LDAP เมนู การตั้งค่าโซลูชั่น LDAP"},{"UUID":"9daa8e7a-4ea6-4dbb-8ece-ea02c6f9c3a2","title":"การรักษาความปลอดภัย","link":"login-methods-subgroup.html","desc":"อื่นๆ รายการเมนูและคำอธิบายอื่นๆ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"อื่นๆ รายการเมนูและคำอธิบายอื่นๆ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน คุณสมบัติที่มีการป้องกัน แสดง * ซ่อน แสดงคุณสมบัติทั้งหมดที่การควบคุมการเข้าใช้ฟังก์ชัน (FAC) ให้การป้องกันไม่ว่าผู้ใช้จะมีสิทธิ์ความปลอดภัยเท่าใดก็ตาม ซ่อน  จะแสดงเฉพาะคุณสมบัติ FAC‑ที่ป้องกันเท่านั้นที่ผู้ใช้สามารถเข้าถึง สิทธิในการพิมพ์ ปิด * เปิด บังคับให้ผู้ใช้ลงชื่อเข้าใช้ก่อนพิมพ์ การลงชื่อเข้าใช้สิทธิในการพิมพ์เริ่มต้น ชื่อผู้ใช้/รหัสผ่าน * ชื่อผู้ใช้ ตั้งการลงชื่อเข้าใช้เริ่มต้นสำหรับ สิทธิ์ในการพิมพ์ จัมเปอร์รีเซ็ตการรักษาความปลอดภัย เปิดใช้งานการเข้าถึงแบบ “ผู้เข้าชม” * ไม่มีผลกระทบ ระบุการเข้าถึงเครื่องพิมพ์ของผู้ใช้ เปิดใช้งานการเข้าถึงแบบ “ผู้เข้าชม”  จะช่วยให้บุคคลอื่นสามารถเข้าใช้งานเครื่องพิมพ์ได้ทุกด้าน ไม่มีผลกระทบ  อาจทำให้ไม่สามารถเข้าถึงเครื่องพิมพ์ได้เมื่อไม่มีข้อมูลการรักษาความปลอดภัยที่จำเป็น ใช้ไดรฟ์จัดเก็บข้อมูลอัจฉริยะสำหรับข้อมูลผู้ใช้ ปิด เปิด * เปิดใช้งานไดรฟ์จัดเก็บข้อมูลอัจฉริยะเพื่อจัดเก็บข้อมูลผู้ใช้ รายการเมนูนี้ถูกปิดการใช้งานเมื่อติดตั้งฮาร์ดดิสก์แล้ว ความยาวรหัสผ่านขั้นต่ำ 0–32  (0*) ระบุความยาวรหัสผ่านขั้นต่ำที่ใช้สำหรับบัญชีภายในต่างๆ เช่น บัญชี รหัสผ่าน  และ ชื่อผู้ใช้/รหัสผ่าน เปิดใช้งานมองเห็นรหัสผ่าน/รหัส PIN ปิด เปิด * แสดงรหัสผ่านหรือ Personal Identification Number อนุญาตการเข้ารหัสหน่วยความจำถาวรของบริการ ปิด * เปิด เปิดใช้งานการเข้ารหัสหน่วยความจำถาวรของบริการในอุปกรณ์ของคุณ การตั้งค่านี้จะสามารถใช้งานได้ หากปิดใช้งาน เข้ารหัสหน่วยความจำถาวรของบริการ เมนู อื่นๆ"},{"UUID":"e4ab9923-3f2b-4113-8239-b93a3aea82d7","title":"บริการระบบคลาวด์","link":"cloud-services-enrollment-topic.html","desc":"การลงทะเบียนบริการระบบคลาวด์ รายการเมนูและคำอธิบายการลงทะเบียนบริการระบบคลาวด์ รายการเมนู การตั้งค่า คำอธิบาย","descFull":"การลงทะเบียนบริการระบบคลาวด์ รายการเมนูและคำอธิบายการลงทะเบียนบริการระบบคลาวด์ รายการเมนู การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน ดูข้อมูลเพิ่มเติม การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว ดูข้อมูลเพิ่มเติมเกี่ยวกับการใช้ Lexmark Cloud Services เปิดใช้งานการสื่อสารกับ Lexmark Cloud Services ปิด * เปิด เปิดใช้งานการสื่อสารกับบริการระบบคลาวด์ของ Lexmark ของเครื่องพิมพ์ ดูสถานะปัจจุบัน การตั้งค่านี้เป็นข้อมูลแบบอ่านอย่างเดียว ดูสถานะการเชื่อมต่อระหว่างเครื่องพิมพ์กับบริการระบบคลาวด์ของ Lexmark เมนู การลงทะเบียนบริการระบบคลาวด์"},{"UUID":"d44d0701-3239-4208-82c6-9bf34657d011","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"หน้าการตั้งค่าเมนู รายการเมนูและคำอธิบาย หน้าการตั้งค่าเมนู รายการเมนู คำอธิบาย","descFull":"หน้าการตั้งค่าเมนู รายการเมนูและคำอธิบาย หน้าการตั้งค่าเมนู รายการเมนู คำอธิบาย หน้าการตั้งค่าเมนู พิมพ์รายงานที่มีเมนูเครื่องพิมพ์ เมนู หน้าการตั้งค่าเมนู"},{"UUID":"79227258-9b66-4a81-8f65-80ee5121f15a","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"อุปกรณ์ รายการเมนูและคำอธิบายอุปกรณ์ รายการเมนู คำอธิบาย ข้อมูลอุปกรณ์","descFull":"อุปกรณ์ รายการเมนูและคำอธิบายอุปกรณ์ รายการเมนู คำอธิบาย ข้อมูลอุปกรณ์ พิมพ์รายงานที่มีข้อมูลเกี่ยวกับเครื่องพิมพ์ สถิติของอุปกรณ์ พิมพ์รายงานเกี่ยวกับสถานะของวัสดุสิ้นเปลือง จำนวนกระดาษ ข้อมูลงาน และอื่นๆ รายการโปรไฟล์ พิมพ์รายการโปรไฟล์ที่จัดเก็บไว้ในเครื่องพิมพ์ รายงานสินทรัพย์ พิมพ์เครื่องมือวินิจฉัยสำหรับปัญหาเกี่ยวกับการพิมพ์ เพื่อหลีกเลี่ยงปัญหาเนื้อหาบางส่วนสูญหาย ให้พิมพ์รายงานบนกระดาษขนาด Letter หรือ A4 เมนู อุปกรณ์"},{"UUID":"db6ef6d3-c641-440e-933e-4024b5642944","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"พิมพ์ รายการเมนูและคำอธิบาย พิมพ์ รายการเมนู การตั้งค่า","descFull":"พิมพ์ รายการเมนูและคำอธิบาย พิมพ์ รายการเมนู การตั้งค่า คำอธิบาย ฟอนต์สำหรับพิมพ์ ฟอนต์ PCL ฟอนต์ PS พิมพ์ตัวอย่างและข้อมูลเกี่ยวกับฟอนต์ที่มีอยู่ในภาษาของเครื่องพิมพ์แต่ละภาษา ตัวอย่างการพิมพ์ หน้าตัวอย่าง พิมพ์เครื่องมือวินิจฉัยสำหรับปัญหาเกี่ยวกับการพิมพ์ เพื่อหลีกเลี่ยงปัญหาเนื้อหาบางส่วนสูญหาย ให้พิมพ์รายงานบนกระดาษขนาด Letter หรือ A4 รายการเมนูนี้จะปรากฏขึ้นเมื่อเครื่องพิมพ์มีหน้าตัวอย่างติดตั้งไว้เท่านั้น ไดเรกทอรีการพิมพ์ การตั้งค่านี้กำหนดโดยผู้ใช้ พิมพ์รายงานที่แสดงทรัพยากรที่จัดเก็บไว้ในแฟลชไดรฟ์หรือฮาร์ดดิสก์ของเครื่องพิมพ์ เมนู พิมพ์"},{"UUID":"958bd033-fd10-4f8a-a097-380aad7e283c","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"ทางลัด รายการเมนูและคำอธิบายทางลัด รายการเมนู คำอธิบาย ทางลัดทั้งหมด","descFull":"ทางลัด รายการเมนูและคำอธิบายทางลัด รายการเมนู คำอธิบาย ทางลัดทั้งหมด พิมพ์รายงานที่แสดงทางลัดที่จัดเก็บไว้ในเครื่องพิมพ์ ทางลัดแฟกซ์  ปรากฏขึ้นก็ต่อเมื่อติดตั้ง แฟกซ์ แล้ว ทางลัดแฟกซ์ ทางลัดสำเนา ทางลัดอีเมล ทางลัด FTP ทางลัดโฟลเดอร์เครือข่าย เมนู ทางลัด"},{"UUID":"35830630-7b02-4778-9c27-6aa798053a80","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"แฟกซ์ เมนูนี้จะแสดงขึ้นก็ต่อเมื่อกำหนดค่าแฟกซ์ และตั้ง  เปิดใช้บันทึกงาน","descFull":"แฟกซ์ เมนูนี้จะแสดงขึ้นก็ต่อเมื่อกำหนดค่าแฟกซ์ และตั้ง  เปิดใช้บันทึกงาน  ให้เป็น  เปิด  แล้วเท่านั้น รายการเมนูและคำอธิบายแฟกซ์ รายการเมนู คำอธิบาย บันทึกงานแฟกซ์ พิมพ์รายงานเกี่ยวกับงานแฟกซ์ที่เสร็จสมบูรณ์ 200 งานล่าสุด บันทึกการติดต่อทางแฟกซ์ พิมพ์รายงานเกี่ยวกับการโทร 100 ครั้งที่ผ่านมาของสายที่พยายามโทร สายที่ได้รับ และสายที่บล็อก เมนู แฟกซ์"},{"UUID":"a32cf774-431e-47ed-a10e-c1d81392d057","title":"รายงาน","link":"menu-settings-page-topic.html","desc":"เครือข่าย รายการเมนูและคำอธิบายของเครือข่าย รายการเมนู คำอธิบาย หน้าการตั้งค่าเครือข่าย","descFull":"เครือข่าย รายการเมนูและคำอธิบายของเครือข่าย รายการเมนู คำอธิบาย หน้าการตั้งค่าเครือข่าย พิมพ์หน้าที่แสดงการกำหนดค่าเครือข่ายและการตั้งค่าไร้สายในเครื่องพิมพ์ จะปรากฏรายการเมนูนี้เฉพาะในเครื่องพิมพ์บนเครือข่ายหรือเครื่องพิมพ์ที่เชื่อมต่อกับเซิร์ฟเวอร์พิมพ์เท่านั้น เครื่องลูกข่ายที่เชื่อมต่อ Wi-Fi Direct พิมพ์หน้าที่แสดงรายการอุปกรณ์ที่เชื่อมต่อกับเครื่องพิมพ์โดยใช้ Wi-Fi Direct จะปรากฏรายการเมนูนี้ขึ้นหากตั้งให้  เปิดใช้งาน Wi-Fi Direct  เป็น  เปิด เท่านั้น เมนู เครือข่าย"},{"UUID":"87470bfb-0fe0-4041-b31c-0b40f0d67ca8","title":"เมนูเครื่องพิมพ์","link":"troubleshooting-menu-topic.html","desc":"การแก้ไขปัญหา รายการเมนูและคำอธิบายการแก้ไขปัญหา รายการเมนู คำอธิบาย หน้าทดสอบคุณภาพการพิมพ์","descFull":"การแก้ไขปัญหา รายการเมนูและคำอธิบายการแก้ไขปัญหา รายการเมนู คำอธิบาย หน้าทดสอบคุณภาพการพิมพ์ พิมพ์หน้าตัวอย่างเพื่อระบุและแก้ไขข้อบกพร่องคุณภาพการพิมพ์ การทำความสะอาดสแกนเนอร์ พิมพ์คำแนะนำวิธีการทำความสะอาดสแกนเนอร์ เมนู การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ การทำความสะอาดสแกนเนอร์"},{"UUID":"491b3004-a975-417a-b5b7-b632b9c87187","title":"เมนูเครื่องพิมพ์","link":"forms-merge-topic.html","desc":"Forms Merge รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น รายการเมนูและคำอธิบาย Forms","descFull":"Forms Merge รายการเมนูนี้จะปรากฏขึ้นเมื่อติดตั้งไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น รายการเมนูและคำอธิบาย Forms Merge รายการเมนู รายการเมนูย่อย การตั้งค่า คำอธิบาย เครื่องหมายดอกจัน (*) ถัดจากค่าจะแสดงถึงการตั้งค่าเริ่มต้นจากโรงงาน โหมด Merge ไม่ใช้ พิมพ์ * การบันทึกข้อมูล ปิดใช้งานแล้ว ระบุโหมดการดำเนินการสำหรับ Forms Merge เป้าหมายการบันทึกข้อมูล ไม่ใช้ แฟลช * กำหนดปลายทางเป้าหมายที่ส่งต่อข้อมูลที่บันทึก จะปรากฏรายการเมนูนี้ขึ้นเมื่อตั้งค่า โหมด Merge  เป็น  การบันทึกข้อมูล เท่านั้น พอร์ตพิมพ์และการตั้งค่าตัวกรอง พอร์ตเครือข่าย เปิด * ปิด เปิดใช้ Forms Merge เพื่อประมวลผลข้อมูลทั้งหมดที่ส่งไปยังพอร์ตเครือข่าย ตัวกรองเครือข่าย ปิดใช้งานแล้ว * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF ระบุตัวกรองเครือข่ายสำหรับข้อมูลทั้งหมดที่ส่งไปยังเครื่องพิมพ์ พอร์ต USB เปิด * ปิด เปิดใช้ Forms Merge เพื่อประมวลผลข้อมูลทั้งหมดที่ส่งไปยังพอร์ต USB ตัวกรอง USB ปิดใช้งานแล้ว * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF ระบุตัวกรอง USB สำหรับข้อมูลทั้งหมดที่ส่งไปยังเครื่องพิมพ์ หมดเวลาพอร์ตของเครื่อง 1–100  (10*) ระบุค่าหมดเวลาสำหรับงาน Forms Merge ที่ส่งไปยังพอร์ตของเครื่อง อื่นๆ พิมพ์แบบฟอร์มทั้งหมด เริ่มต้น พิมพ์ชุดแบบฟอร์มทั้งหมดที่จัดเก็บไว้ในไดรฟ์จัดเก็บข้อมูลอัจฉริยะหรือฮาร์ดดิสก์ พิมพ์หน้าแสดงข้อผิดพลาด เปิด * ปิด เปิดใช้การพิมพ์หน้าแสดงข้อผิดพลาดเมื่อพบข้อผิดพลาดในงาน Forms Merge เมนู Forms Merge"},{"UUID":"de489798-c24a-479f-81ab-10103d3dc0d2","title":"เมนูเครื่องพิมพ์","link":"printing-menu-settings-page-topic.html","desc":"การพิมพ์  หน้าการตั้งค่าเมนู จากแผงควบคุม ไปที่","descFull":"การพิมพ์  หน้าการตั้งค่าเมนู จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เลือก หน้าการตั้งค่าเมนู การพิมพ์ หน้าการตั้งค่าเมนู หน้าการตั้งค่าเมนู การพิมพ์ เมนูเครื่องพิมพ์"},{"UUID":"724c5935-0df0-4651-8f34-007687851707","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์","link":"using-staple-finisher-topic.html","desc":"การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การเย็บเล่มโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว","descFull":"การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การเย็บเล่มโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  กระดาษ/การเย็บเล่ม  แล้วกำหนดค่าการตั้งค่า  กระดาษ ในเมนู  เย็บเล่ม  เลือกการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้เลือก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนู  ตัวเลือกการเย็บเล่ม  เลือก  ใช้การเย็บเล่ม ตัวเลือกเครื่องพิมพ์ คลิก  เย็บเล่ม  แล้วเลือกการตั้งค่า คลิกที่  พิมพ์ การเย็บเล่มโดยใช้แผงควบคุม จากแผงควบคุม ให้เลือก  พิมพ์  แล้วเลือกแหล่งกระดาษสำหรับงานพิมพ์ เลือกเอกสาร เลือก  การตั้งค่าเพิ่มเติม  แล้วเลือก  ตัวเลือกการเย็บเล่ม เลือก  เย็บเล่ม  แล้วเลือกการตั้งค่า พิมพ์เอกสาร อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การใช้ การเย็บกระดาษ แผ่นเอกสารที่พิมพ์ การเย็บกระดาษ เอกสารสำเนา"},{"UUID":"2f4abfbb-e40d-4ab0-81bf-98d9ae275ccc","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์","link":"using-staple-hole-punch-finisher-topic.html","desc":"การใช้อุปกรณ์เย็บเล่มตอกรู การใช้อุปกรณ์เย็บเล่มตอกรู การเย็บเล่มหรือการเจาะรูกระดาษโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows","descFull":"การใช้อุปกรณ์เย็บเล่มตอกรู การใช้อุปกรณ์เย็บเล่มตอกรู การเย็บเล่มหรือการเจาะรูกระดาษโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  กระดาษ/การเย็บเล่ม  แล้วกำหนดค่าการตั้งค่า  กระดาษ เลือกการตั้งค่าสำหรับ  ลวดเย็บ  หรือ  อุปกรณ์ตอกรู  โดยขึ้นอยู่กับการเย็บเล่มที่คุณต้องการ คุณสามารถเลือกการตั้งค่าสำหรับทั้งสองรายการ หากคุณต้องการเย็บเล่มและเจาะรูวัสดุที่พิมพ์ คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนู  ตัวเลือกการเย็บเล่ม  เลือก  ใช้การเย็บเล่ม ตัวเลือกเครื่องพิมพ์ คลิก  เย็บเล่ม  หรือ  เจาะรู  แล้วเลือกการตั้งค่า คลิกที่  พิมพ์ การเย็บเล่มหรือการเจาะรูกระดาษโดยใช้แผงควบคุม จากแผงควบคุม ให้เลือก  พิมพ์  แล้วเลือกแหล่งกระดาษสำหรับงานพิมพ์ เลือกเอกสาร เลือก  การตั้งค่าเพิ่มเติม  แล้วเลือก  ตัวเลือกการเย็บเล่ม เลือกการตั้งค่าสำหรับ  ลวดเย็บ  หรือ  อุปกรณ์ตอกรู  โดยขึ้นอยู่กับการเย็บเล่มที่คุณต้องการ คุณสามารถเลือกการตั้งค่าสำหรับทั้งสองรายการ หากคุณต้องการเย็บเล่มและเจาะรูวัสดุที่พิมพ์ พิมพ์เอกสาร การเย็บกระดาษแผ่นเอกสารที่พิมพ์ การเจาะรู ในแผ่นเอกสารที่พิมพ์ อุปกรณ์เย็บเล่มตอกรู การใช้"},{"UUID":"b64c5d19-5c5c-46da-9737-ef3fb7369c5e","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์","link":"using-offset-stacker-topic.html","desc":"การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต การเรียงกระดาษออฟเซ็ตโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว","descFull":"การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต การเรียงกระดาษออฟเซ็ตโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  กระดาษ/การเย็บเล่ม  แล้วกำหนดค่าการตั้งค่า  กระดาษ ในเมนู  ออฟเซ็ต  เลือกการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนู  ตัวเลือกการเย็บเล่ม  เลือก  ใช้การเย็บเล่ม ตัวเลือกเครื่องพิมพ์ คลิก  ออฟเซ็ต  แล้วเลือกการตั้งค่า คลิกที่  พิมพ์ การเรียงกระดาษออฟเซ็ตโดยใช้แผงควบคุม ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เพื่อหลีกเลี่ยงรูปภาพถูกตัด ตรวจสอบให้แน่ใจว่าเอกสารต้นฉบับและงานพิมพ์มีขนาดกระดาษเท่ากัน จากแผงควบคุม ให้เลือก  ทำสำเนา  แล้วระบุจำนวนสำเนา เลือก  การตั้งค่าเพิ่มเติม  แล้วเลือก  หน้าออฟเซ็ต เปิดใช้งานเมนู แล้วเลือกการตั้งค่า พิมพ์เอกสาร อุปกรณ์เรียงกระดาษออฟเซ็ต การใช้ การเรียงกระดาษออฟเซ็ต"},{"UUID":"50258958-6b5a-4b38-b29c-9a08556be887","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์","link":"using-booklet-finisher-topic.html","desc":"การใช้อุปกรณ์เย็บเล่ม ก่อนสร้าง Booklet ให้ป้อนกระดาษโดยให้ขอบสั้นหันไปทางด้านขวาของถาด การสร้าง","descFull":"การใช้อุปกรณ์เย็บเล่ม ก่อนสร้าง Booklet ให้ป้อนกระดาษโดยให้ขอบสั้นหันไปทางด้านขวาของถาด การสร้าง Booklet โดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า เลือก  Booklet คลิก  กระดาษ/การเย็บเล่ม  แล้วกำหนดค่าการตั้งค่ากระดาษ ในเมนู  พับทบ  เลือกการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนู  ตัวเลือกการเย็บเล่ม  เลือก  ใช้การเย็บเล่ม ตัวเลือกเครื่องพิมพ์ เลือก  Booklet  แล้วเลือกการตั้งค่า  พับทบ คลิก  ตกลง การสร้าง Booklet โดยใช้แผงควบคุม ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เพื่อหลีกเลี่ยงรูปภาพถูกตัด ตรวจสอบให้แน่ใจว่าเอกสารต้นฉบับและงานพิมพ์มีขนาดกระดาษเท่ากัน จากแผงควบคุม ให้เลือก  ทำสำเนา  แล้วกำหนดค่าการตั้งค่า เลือก  การตั้งค่าเพิ่มเติม  แล้วเลือก  สร้าง Booklet เปิดใช้งาน  การเย็บเล่มแบบ Booklet  แล้วเลือกการตั้งค่า ทำสำเนาเอกสาร การสร้าง Booklet การทำ Booklet อุปกรณ์เย็บเล่ม การใช้"},{"UUID":"4c6de0db-1fc2-4895-881e-b819273a80ba","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์","link":"using-hptfu-topic.html","desc":"การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การพับกระดาษโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว","descFull":"การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การพับกระดาษโดยใช้ไดรเวอร์การพิมพ์ สำหรับผู้ใช้ Windows เมื่อเปิดเอกสารแล้ว ให้คลิก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์แล้วคลิกที่  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  กระดาษ/การเย็บเล่ม  แล้วกำหนดค่าการตั้งค่ากระดาษ ในเมนู  พับทบ  เลือกการตั้งค่า คลิก  ตกลง  แล้วคลิก  พิมพ์ . สำหรับผู้ใช้ Macintosh เมื่อเปิดเอกสารแล้ว ให้เลือก  ไฟล์ พิมพ์ เลือกเครื่องพิมพ์ จากเมนู  ตัวเลือกการเย็บเล่ม  เลือก  ใช้การเย็บเล่ม ตัวเลือกเครื่องพิมพ์ คลิก  พับทบ  แล้วเลือกการตั้งค่า คลิกที่  พิมพ์ การพับกระดาษโดยใช้แผงควบคุม ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ เพื่อหลีกเลี่ยงรูปภาพถูกตัด ตรวจสอบให้แน่ใจว่าเอกสารต้นฉบับและงานพิมพ์มีขนาดกระดาษเท่ากัน จากแผงควบคุม ให้เลือก  ทำสำเนา  แล้วระบุจำนวนสำเนา เลือก  การตั้งค่าเพิ่มเติม  แล้วเลือก  ตัวเลือกการเย็บเล่ม เลือก  พับทบ  แล้วเลือกการตั้งค่า ทำสำเนาเอกสาร อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การใช้ สำเนาฉบับพิมพ์แบบพับทบ เอกสารสำเนาแบบพับทบ"},{"UUID":"eb60c340-cf4c-43d8-abdf-b5d7000c69f1","title":"ดูแลรักษาเครื่องพิมพ์","link":"checking-supplies-status-topic.html","desc":"การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง จากมุมขวาบนของแผงควบคุม เลือก ","descFull":"การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง จากมุมขวาบนของแผงควบคุม เลือก  ดูสถานะของชิ้นส่วนและวัสดุสิ้นเปลืองต่างๆ ของเครื่องพิมพ์ คุณยังสามารถเลือก   เพื่อตรวจสอบการแจ้งเตือนที่ผู้ใช้จำเป็นต้องดำเนินการ การตรวจสอบ สถานะวัสดุสิ้นเปลือง สถานะวัสดุสิ้นเปลือง การตรวจสอบ สถานะชิ้นส่วนเครื่องพิมพ์ การตรวจสอบ"},{"UUID":"4315a9e3-8daf-4670-a76c-c57296553cec","title":"ดูแลรักษาเครื่องพิมพ์","link":"configuring-supply-notifications-topic.html","desc":"การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส","descFull":"การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า อุปกรณ์ การแจ้งเตือน คลิก  การแจ้งเตือนอุปกรณ์สิ้นเปลืองแบบกำหนดเอง เลือกการแจ้งเตือนสำหรับรายการวัสดุสิ้นเปลืองแต่ละรายการ ใช้การเปลี่ยนแปลง การแจ้งเตือนวัสดุสิ้นเปลือง การกำหนดค่า การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง"},{"UUID":"a86a152a-b6fd-4689-9cc3-ebd579a9bd3f","title":"ดูแลรักษาเครื่องพิมพ์","link":"setting-up-email-alert-topic.html","desc":"การตั้งค่าการแจ้งเตือนทางอีเมล การตั้งค่าการแจ้งเตือนทางอีเมล เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส","descFull":"การตั้งค่าการแจ้งเตือนทางอีเมล การตั้งค่าการแจ้งเตือนทางอีเมล เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  การตั้งค่า อุปกรณ์ การแจ้งเตือน คลิก  การตั้งค่าการแจ้งเตือนทางอีเมล  จากนั้นกำหนดค่าการตั้งค่า สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการตั้งค่า SMTP โปรดติดต่อผู้ให้บริการอีเมลของคุณ ใช้การเปลี่ยนแปลง คลิก  ตั้งค่ารายการอีเมลและการแจ้งเตือน  จากนั้นกำหนดค่าการตั้งค่า ใช้การเปลี่ยนแปลง การแจ้งเตือนทางอีเมล การตั้งค่า การตั้งค่าการแจ้งเตือนทางอีเมล"},{"UUID":"a886c618-e370-45a3-a11f-b4fcd20461ce","title":"ดูแลรักษาเครื่องพิมพ์","link":"generating-reports-and-logs-topic.html","desc":"การสร้างรายงานและบันทึก การสร้างรายงานและบันทึก จากแผงควบคุม ไปที่ ","descFull":"การสร้างรายงานและบันทึก การสร้างรายงานและบันทึก จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เลือกรายงานหรือบันทึกที่คุณต้องการพิมพ์ หน้าการตั้งค่าเมนู —แสดงค่ากำหนด การตั้งค่า และการกำหนดค่าของเครื่องพิมพ์ปัจจุบัน อุปกรณ์ ข้อมูลอุปกรณ์ —แสดงหมายเลขประจำเครื่องของเครื่องพิมพ์ โซลูชันที่ติดตั้ง และแฟกซ์ สถิติของอุปกรณ์ —แสดงสถานะวัสดุสิ้นเปลือง แผ่นเอกสารที่พิมพ์ และข้อมูลงานของเครื่องพิมพ์ รายการโปรไฟล์ —แสดงรายการโปรไฟล์หรือทางลัดที่จัดเก็บไว้ในเครื่องพิมพ์ รายงานสินทรัพย์ —แสดงรายงานที่มีข้อมูลสินทรัพย์เครื่องพิมพ์ เช่น หมายเลขประจำเครื่อง และชื่อรุ่น พิมพ์ ฟอนต์สำหรับพิมพ์ —แสดงฟอนต์ที่มีอยู่ในภาษาของเครื่องพิมพ์แต่ละภาษา ตัวอย่างการพิมพ์ —แสดงไฟล์ตัวอย่างที่มีอยู่ในเฟิร์มแวร์ ตัวเลือกการส่งผ่าน และตัวเลือกดิสก์ ไดเรกทอรีการพิมพ์ —แสดงทรัพยากรที่จัดเก็บไว้บนแฟลชไดรฟ์ ฮาร์ดดิสก์ หรือไดรฟ์จัดเก็บข้อมูลอัจฉริยะ (ISD) รายงานนี้จะแสดงขึ้นเมื่อติดตั้งแฟลชไดรฟ์ ฮาร์ดดิสก์ของเครื่องพิมพ์ หรือ ISD แล้วเท่านั้น ทางลัด ทางลัดทั้งหมด —แสดงรายการทางลัดทั้งหมดที่จัดเก็บไว้บนเครื่องพิมพ์ ทางลัดแฟกซ์ —แสดงรายการทางลัดแฟกซ์ที่จัดเก็บไว้บนเครื่องพิมพ์ ทางลัดการทำสำเนา —แสดงรายการทางลัดการทำสำเนาที่จัดเก็บไว้บนเครื่องพิมพ์ ทางลัดอีเมล —แสดงรายการทางลัดอีเมลที่จัดเก็บไว้บนเครื่องพิมพ์ ทางลัด FTP —แสดงรายการทางลัด File Transfer Protocol (FTP) ที่จัดเก็บไว้บนเครื่องพิมพ์ ทางลัดโฟลเดอร์เครือข่าย —แสดงรายการทางลัดโฟลเดอร์เครือข่ายที่จัดเก็บไว้บนเครื่องพิมพ์ แฟกซ์ บันทึกงานแฟกซ์ —แสดงรายการงานแฟกซ์ที่เสร็จสมบูรณ์ 200 งานล่าสุด รายงานจะปรากฏเฉพาะเมื่อเปิดใช้งาน เปิดใช้บันทึกงาน เท่านั้น บันทึกการติดต่อทางแฟกซ์ —แสดงทรัพยากรที่จัดเก็บไว้บนแฟลชไดรฟ์หรือไดรฟ์จัดเก็บข้อมูล รายงานนี้จะปรากฏขึ้นเมื่อติดตั้งแฟลชไดร์ฟหรือไดรฟ์จัดเก็บข้อมูลแล้วเท่านั้น เครือข่าย หน้าการตั้งค่าเครือข่าย —แสดงการกำหนดค่าเครือข่ายและการตั้งค่าไร้สายบนเครื่องพิมพ์ รายงานนี้จะปรากฏเฉพาะในเครื่องพิมพ์บนเครือข่ายและเครื่องพิมพ์ที่เชื่อมต่อเซิร์ฟเวอร์พิมพ์เท่านั้น เครื่องลูกข่ายที่เชื่อมต่อ Wi-Fi Direct —แสดงรายการอุปกรณ์ที่เชื่อมต่อกับเครื่องพิมพ์โดยใช้ Wi-Fi Direct รายงานนี้จะปรากฏขึ้นก็ต่อเมื่อตั้งให้  เปิดใช้งาน Wi-Fi Direct  เป็น  เปิด เท่านั้น รายงานการพิมพ์ บันทึกการพิมพ์ การดูรายงานและบันทึก การอ่านมิเตอร์ การดูมิเตอร์ แผ่นกระดาษที่พิมพ์ การดู"},{"UUID":"9886432e-7e79-409a-bcb5-4cc0a9b5d32b","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"หากต้องการสั่งซื้อวัสดุสิ้นเปลืองในประเทศสหรัฐอเมริกา โปรดติดต่อ Lexmark ที่ 1-800-539-6275","descFull":"หากต้องการสั่งซื้อวัสดุสิ้นเปลืองในประเทศสหรัฐอเมริกา โปรดติดต่อ Lexmark ที่ 1-800-539-6275 สำหรับข้อมูลเกี่ยวกับตัวแทนจำหน่ายวัสดุสิ้นเปลืองที่ได้รับอนุญาตของ Lexmark ในพื้นที่ของคุณ ในประเทศหรือพื้นที่อื่น ให้ไปที่  www.lexmark.com  หรือติดต่อสถานที่ที่คุณซื้อเครื่องพิมพ์ สำหรับการสั่งซื้อวัสดุสิ้นเปลือง โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ การประเมินอายุการใช้งานทั้งหมดของวัสดุสิ้นเปลืองสำหรับเครื่องพิมพ์คำนวณจากการพิมพ์บนกระดาษธรรมดาขนาด Letter หรือ A4 การไม่รักษาประสิทธิภาพการทำงานของเครื่องพิมพ์ให้ดีที่สุด หรือเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง อาจทำให้เครื่องพิมพ์ชำรุดเสียหาย ชิ้นส่วนและวัสดุสิ้นเปลืองของแท้"},{"UUID":"70a6e972-8bad-43aa-965f-44505b967b8c","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"ใช้ชิ้นส่วนและวัสดุสิ้นเปลืองของแท้จาก Lexmark เครื่องพิมพ์ Lexmark ของคุณถูกออกแบบมาให้ทำงานได้ดีที่สุดกับอุปกรณ์สิ้นเปลืองและชิ้นส่วนของแท้จาก","descFull":"ใช้ชิ้นส่วนและวัสดุสิ้นเปลืองของแท้จาก Lexmark เครื่องพิมพ์ Lexmark ของคุณถูกออกแบบมาให้ทำงานได้ดีที่สุดกับอุปกรณ์สิ้นเปลืองและชิ้นส่วนของแท้จาก Lexmark การใช้อุปกรณ์สิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจมีผลต่อประสิทธิภาพ ความน่าเชื่อถือ หรืออายุการใช้งานของเครื่องพิมพ์และส่วนประกอบ Imaging และยังมีผลต่อความคุ้มครองในการรับประกันอีกด้วย ความเสียหายที่เกิดจากการใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจไม่อยู่ภายใต้ความคุ้มครองจากการรับประกัน ไฟแสดงอายุการใช้งานทั้งหมดได้รับการออกแบบมาเพื่อทำงานร่วมกับชิ้นส่วนและวัสดุสิ้นเปลืองของ Lexmark และอาจไม่สามารถคาดการณ์ได้หากมีการใช้ชิ้นส่วนและวัสดุสิ้นเปลืองของบุคคลที่สาม การใช้ส่วนประกอบการสร้างภาพเกินอายุการใช้งานที่กำหนดอาจทำให้เครื่องพิมพ์ Lexmark หรือส่วนประกอบที่เกี่ยวข้องเสียหาย วัสดุสิ้นเปลืองและชิ้นส่วนที่ไม่มีข้อกำหนดข้อตกลงของโครงการส่งคืนอาจถูกรีเซ็ตและนำมาผลิตใหม่ อย่างไรก็ตาม การรับประกันโดยผู้ผลิตไม่ครอบคลุมความเสียหายใดๆ ที่เกิดจากวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของแท้ การรีเซ็ตตัวนับชิ้นส่วนหรือวัสดุสิ้นเปลืองที่ไม่ได้รับการผลิตใหม่อย่างเหมาะสมอาจทำให้เครื่องพิมพ์ชำรุดเสียหายได้ หลังจากรีเซ็ตวัสดุสิ้นเปลืองหรือตัวนับชิ้นส่วนแล้ว เครื่องพิมพ์อาจแสดงข้อผิดพลาดเพื่อระบุว่ามีรายการที่รีเซ็ต การใช้ชิ้นส่วนและวัสดุสิ้นเปลืองของแท้ของ Lexmark ชิ้นส่วนและวัสดุสิ้นเปลืองของแท้ของ Lexmark"},{"UUID":"f562f527-df43-4209-8467-a8efde06d6bc","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อตลับหมึก การสั่งซื้อตลับหมึก ปริมาณการพิมพ์ต่อตลับโดยประมาณของตลับหมึกจะอิงตามมาตรฐาน ISO/IEC 19798","descFull":"การสั่งซื้อตลับหมึก การสั่งซื้อตลับหมึก ปริมาณการพิมพ์ต่อตลับโดยประมาณของตลับหมึกจะอิงตามมาตรฐาน ISO/IEC 19798 หากมีการพิมพ์ปริมาณน้อยมากเป็นระยะเวลานานอาจส่งผลในทางลบต่อการใช้งานจริงได้ สำหรับการสั่งซื้อตลับหมึก โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ ตลับหมึกในโครงการส่งคืน Lexmark CX833, CX961, CX962, CX963 รายการ สหรัฐอเมริกา แคนาดา ออสเตรเลีย และนิวซีแลนด์ สหภาพยุโรป เขตเศรษฐกิจยุโรป ไอซ์แลนด์ ลิกเตนสไตน์ นอร์เวย์ สวิตเซอร์แลนด์ ประเทศอื่นๆ ในเอเชียแปซิฟิก ละตินอเมริกา เปอร์โตริโก และเม็กซิโก ประเทศอื่นๆ ในยุโรป ตะวันออกกลาง แอฟริกา ยุโรปตะวันออกกลาง เครือรัฐเอกราช สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 สีม่วงแดง 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 สีเหลือง 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 สีดำ 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 กลักหมึกพิมพ์ในโครงการส่งคืนที่ให้ปริมาณสูง Lexmark CX833 รายการ สหรัฐอเมริกา แคนาดา ออสเตรเลีย และนิวซีแลนด์ สหภาพยุโรป เขตเศรษฐกิจยุโรป ไอซ์แลนด์ ลิกเตนสไตน์ นอร์เวย์ สวิตเซอร์แลนด์ ประเทศอื่นๆ ในเอเชียแปซิฟิก ละตินอเมริกา เปอร์โตริโก และเม็กซิโก ประเทศอื่นๆ ในยุโรป ตะวันออกกลาง แอฟริกา ยุโรปตะวันออกกลาง เครือรัฐเอกราช สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 สีม่วงแดง 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 สีเหลือง 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 สีดำ 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961, CX962, CX963 รายการ สหรัฐอเมริกา แคนาดา ออสเตรเลีย และนิวซีแลนด์ สหภาพยุโรป เขตเศรษฐกิจยุโรป ไอซ์แลนด์ ลิกเตนสไตน์ นอร์เวย์ สวิตเซอร์แลนด์ ประเทศอื่นๆ ในเอเชียแปซิฟิก ละตินอเมริกา เปอร์โตริโก และเม็กซิโก ประเทศอื่นๆ ในยุโรป ตะวันออกกลาง แอฟริกา ยุโรปตะวันออกกลาง เครือรัฐเอกราช สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 สีม่วงแดง 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 สีเหลือง 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 สีดำ 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 รายการ สหรัฐอเมริกา แคนาดา ออสเตรเลีย นิวซีแลนด์ ประเทศอื่นๆ ในยุโรป ตะวันออกกลาง และแอฟริกา สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 24B7574 24B7582 สีม่วงแดง 24B7575 24B7583 สีเหลือง 24B7576 24B7584 สีดำ 24B7577 24B7585 Lexmark XC9635, XC9645, XC9655 รายการ สหรัฐอเมริกา แคนาดา ออสเตรเลีย และนิวซีแลนด์ ประเทศอื่นๆ ในยุโรป ตะวันออกกลาง และแอฟริกา สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 24B7570 24B7578 สีม่วงแดง 24B7571 24B7579 สีเหลือง 24B7572 24B7580 สีดำ 24B7573 24B7581 กลักหมึกทั่วไปที่ให้ปริมาณสูง Lexmark CX833 รายการ ทั่วโลก สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 77L0H20 สีม่วงแดง 77L0H30 สีเหลือง 77L0H40 สีดำ 77L0H10 Lexmark CX961, CX962, CX963 รายการ ทั่วโลก สำหรับข้อมูลเพิ่มเติมเกี่ยวกับประเทศที่อยู่ในแต่ละภูมิภาค ให้ไปที่  www.lexmark.com/regions สีน้ำเงินเขียว 79L0H20 สีม่วงแดง 79L0H30 สีเหลือง 79L0H40 สีดำ 79L0H10 การสั่งซื้อวัสดุสิ้นเปลือง ตลับหมึก ตลับหมึก การสั่งซื้อ"},{"UUID":"a8e0506b-a16c-4690-8c2f-307ac466500d","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อชุดสร้างภาพขาวดำ การสั่งซื้อชุดสร้างภาพขาวดำ สำหรับการสั่งซื้อชุดสร้างภาพขาวดำ โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ ชุดสร้างภาพขาวดำและหมายเลขชิ้นส่วน","descFull":"การสั่งซื้อชุดสร้างภาพขาวดำ การสั่งซื้อชุดสร้างภาพขาวดำ สำหรับการสั่งซื้อชุดสร้างภาพขาวดำ โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ ชุดสร้างภาพขาวดำและหมายเลขชิ้นส่วน รายการ หมายเลขชิ้นส่วน ชุดสร้างภาพขาวดำในโครงการส่งคืน 77L0ZK0 ชุดสร้างภาพขาวดำ 77L0Z10 ชุดสร้างภาพขาวดำ การสั่งซื้อ การสั่งซื้อวัสดุสิ้นเปลือง ชุดสร้างภาพขาวดำ"},{"UUID":"40cb5082-649e-4d25-bd73-318ce8c0fd07","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อชุดสร้างภาพสี สำหรับการสั่งซื้อชุดสร้างภาพสี โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ รายการ หมายเลขชิ้นส่วน","descFull":"การสั่งซื้อชุดสร้างภาพสี สำหรับการสั่งซื้อชุดสร้างภาพสี โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ รายการ หมายเลขชิ้นส่วน ชุดสร้างภาพสีในโครงการส่งคืน 77L0ZV0 ชุดสร้างภาพสีปกติ 77L0Z50 ชุดสร้างภาพสี การสั่งซื้อ การสั่งซื้อวัสดุสิ้นเปลือง ชุดสร้างภาพสี"},{"UUID":"dc4482b7-059a-40e3-a824-d68d25ff810e","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อขวดผงหมึกสำหรับทิ้ง การสั่งซื้อขวดผงหมึกสำหรับทิ้ง สำหรับการสั่งซื้อขวดผงหมึกสำหรับทิ้ง โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ หมายเลขชิ้นส่วนของขวดผงหมึกสำหรับทิ้ง","descFull":"การสั่งซื้อขวดผงหมึกสำหรับทิ้ง การสั่งซื้อขวดผงหมึกสำหรับทิ้ง สำหรับการสั่งซื้อขวดผงหมึกสำหรับทิ้ง โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ หมายเลขชิ้นส่วนของขวดผงหมึกสำหรับทิ้ง รายการ หมายเลขชิ้นส่วน ขวดผงหมึกสำหรับทิ้ง 77L0W00 การสั่งซื้อวัสดุสิ้นเปลือง ขวดผงหมึกสำหรับทิ้ง ขวดผงหมึกสำหรับทิ้ง การสั่งซื้อ"},{"UUID":"7472f38d-5d04-46dd-beb9-3603126a2f5c","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อตลับลวดเย็บ สำหรับการสั่งซื้อตลับลวดเย็บ โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ ตลับลวดเย็บและหมายเลขชิ้นส่วน รายการ","descFull":"การสั่งซื้อตลับลวดเย็บ สำหรับการสั่งซื้อตลับลวดเย็บ โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ ตลับลวดเย็บและหมายเลขชิ้นส่วน รายการ หมายเลขชิ้นส่วน 1  ใช้ได้กับตัวทำ Booklet เท่านั้น 2  ใช้ได้กับอุปกรณ์เย็บเล่ม อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ และอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บและตัวตอกรู ตลับลวดเย็บ (4 แพ็ค) 1 20L7500 ตลับลวดเย็บ (3 แพ็ค) 2 25A0013 ตลับลวดเย็บ การสั่งซื้อ การสั่งซื้อวัสดุสิ้นเปลือง ตลับลวดเย็บ"},{"UUID":"ab0e52b2-f141-4618-bded-6ad732c38ef4","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง","link":"ordering-parts-and-supplies-group.html","desc":"การสั่งซื้อชุดบำรุงรักษา การสั่งซื้อชุดบำรุงรักษา สำหรับการสั่งซื้อชุดบำรุงรักษา โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ ตรวจสอบชุดบำรุงรักษาให้ตรงกับแรงดันไฟฟ้าของเครื่องพิมพ์","descFull":"การสั่งซื้อชุดบำรุงรักษา การสั่งซื้อชุดบำรุงรักษา สำหรับการสั่งซื้อชุดบำรุงรักษา โปรดติดต่อร้านค้าที่ท่านซื้อเครื่องพิมพ์ ตรวจสอบชุดบำรุงรักษาให้ตรงกับแรงดันไฟฟ้าของเครื่องพิมพ์ การใช้กระดาษบางประเภทอาจทำให้ต้องเปลี่ยนชุดบำรุงรักษาบ่อยขึ้น ชุดบำรุงรักษาประกอบด้วยฟิวเซอร์และลูกยางกลิ้งกระดาษ ชิ้นส่วนเหล่านี้สามารถสั่งซื้อแยกต่างหากและเปลี่ยนได้หากจำเป็น ชุดบำรุงรักษาที่แนะนำและหมายเลขชิ้นส่วน รายการ หมายเลขชิ้นส่วน เฉพาะช่างซ่อมบำรุงที่ได้รับอนุญาตเท่านั้นที่สามารถเปลี่ยนชุดบำรุงรักษาได้ ติดต่อผู้ให้บริการของคุณ 100 ชุดบำรุงรักษาของฟิวเซอร์ในโครงการส่งคืน V ประเภท 02 41X5654 110-120 ชุดบำรุงรักษาของฟิวเซอร์ในโครงการส่งคืน V ประเภท 00 41X5655 220-240 ชุดบำรุงรักษาของฟิวเซอร์ในโครงการส่งคืน V ประเภท 01 41X5656 100 ชุดบำรุงรักษาของฟิวเซอร์ปกติ V ประเภท 12 41X6053 110-120 ชุดบำรุงรักษาของฟิวเซอร์ปกติ V ประเภท 10 41X6051 220-240 ชุดบำรุงรักษาของฟิวเซอร์ปกติ V ประเภท 11 41X6052 การสั่งซื้อวัสดุสิ้นเปลือง ชุดบำรุงรักษาฟิวเซอร์ ชุดบำรุงรักษาฟิวเซอร์ การสั่งซื้อ"},{"UUID":"15808935-af70-4749-a010-66876ecfda29","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนตลับหมึก การเปลี่ยนตลับหมึก เปิดฝาด้านหน้า นำตลับหมึกที่ใช้แล้วออก นำตลับหมึกใหม่ออกจากบรรจุภัณฑ์","descFull":"การเปลี่ยนตลับหมึก การเปลี่ยนตลับหมึก เปิดฝาด้านหน้า นำตลับหมึกที่ใช้แล้วออก นำตลับหมึกใหม่ออกจากบรรจุภัณฑ์ ใส่กลักหมึกใหม่เข้าไปให้มีเสียง คลิก เข้าที่ ปิดฝา ตลับหมึก การเปลี่ยน การเปลี่ยนวัสดุสิ้นเปลือง ตลับหมึก"},{"UUID":"f6a23d2e-33cb-446c-a2b2-368b1addb919","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนชุดสร้างภาพขาวดำ เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก","descFull":"การเปลี่ยนชุดสร้างภาพขาวดำ เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง นำชุดสร้างภาพออก อย่าให้ชุดสร้างภาพถูกแสงโดยตรง การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต วางชุดสร้างภาพแบบตั้งตรงไว้บนพื้นผิวเรียบที่สะอาดเพื่อหลีกเลี่ยงไม่ให้เกิดรอยขีดข่วนหรือทำให้ดรัมของโฟโต้คอนดักเตอร์เสียหาย ปลดล็อคชุดสร้างภาพขาวดำที่ใช้แล้ว นำชุดสร้างภาพขาวดำที่ใช้แล้วออก นำชุดสร้างภาพขาวดำใหม่ออกจากบรรจุภัณฑ์ ใส่ชุดสร้างภาพขาวดำใหม่ ล็อคชุดสร้างภาพขาวดำใหม่ให้เข้าที่ ใส่ชุดสร้างภาพลงไปจนเข้าที่ ใส่ขวดผงหมึกสำหรับทิ้งให้มีเสียง คลิก เข้าที่ ค่อย ๆ ดันตัวเช็ดหัวพิมพ์ออก แล้วทำความสะอาดเลนส์หัวพิมพ์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการทำความสะอาดเลนส์หัวพิมพ์ โปรดดู  ใส่กลักหมึก ปิดฝา ชุดสร้างภาพขาวดำ การเปลี่ยน การเปลี่ยนวัสดุสิ้นเปลือง ชุดสร้างภาพขาวดำ"},{"UUID":"89e7a95d-cbcb-4742-9ff7-2895e12cc1d3","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนชุดสร้างภาพสี เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก","descFull":"การเปลี่ยนชุดสร้างภาพสี เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง ถอดชุดสร้างภาพที่ใช้แล้วออก วางชุดสร้างภาพแบบตั้งตรงไว้บนพื้นผิวเรียบที่สะอาดเพื่อหลีกเลี่ยงไม่ให้เกิดรอยขีดข่วนหรือทำให้ดรัมของโฟโต้คอนดักเตอร์เสียหาย ปลดล็อคชุดสร้างภาพ นำชุดสร้างภาพขาวดำออก อย่าทิ้งชุดสร้างภาพขาวดำ เนื่องจากจะติดตั้งกับชุดสร้างภาพใหม่ นำชุดสร้างภาพใหม่ออกจากกล่อง ชุดสร้างภาพประกอบด้วยถาดชุดสร้างภาพและชุดแม่เหล็กดึงหมึกสีน้ำเงินเขียว สีม่วงแดง และสีเหลือง อย่าให้ชุดสร้างภาพถูกแสงโดยตรง การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำเข้ากับชุดสร้างภาพใหม่ ล็อคชุดสร้างภาพขาวดำให้เข้าที่ ใส่ชุดสร้างภาพใหม่ลงไปจนเข้าที่ ใส่ขวดผงหมึกสำหรับทิ้งให้มีเสียง คลิก เข้าที่ ค่อย ๆ ดันตัวเช็ดหัวพิมพ์ออก แล้วทำความสะอาดเลนส์หัวพิมพ์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการทำความสะอาดเลนส์หัวพิมพ์ โปรดดู  ใส่กลักหมึก ปิดฝา ชุดสร้างภาพสี การเปลี่ยน การเปลี่ยนวัสดุสิ้นเปลือง ชุดสร้างภาพสี"},{"UUID":"84470c2a-ca55-418f-81d2-cb2d6bed60d1","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนขวดผงหมึกสำหรับทิ้ง การเปลี่ยนขวดผงหมึกสำหรับทิ้ง เปิดฝาด้านหน้า นำขวดผงหมึกสำหรับทิ้งที่ใช้แล้วออก เพื่อหลีกเลี่ยงการทำหมึกหก","descFull":"การเปลี่ยนขวดผงหมึกสำหรับทิ้ง การเปลี่ยนขวดผงหมึกสำหรับทิ้ง เปิดฝาด้านหน้า นำขวดผงหมึกสำหรับทิ้งที่ใช้แล้วออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง นำขวดผงหมึกสำหรับทิ้งขวดใหม่ออกมาจากบรรจุภัณฑ์ ใส่ขวดผงหมึกสำหรับทิ้งจนมีเสียง คลิก เข้าที่ แล้วจึงปิดฝา การเปลี่ยนวัสดุสิ้นเปลือง ขวดผงหมึกสำหรับทิ้ง ขวดผงหมึกสำหรับทิ้ง การเปลี่ยน"},{"UUID":"ebfe0792-3ad8-455f-bfb0-5e4e8c33d0ba","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนฟิวเซอร์ การเปลี่ยนฟิวเซอร์ ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์","descFull":"การเปลี่ยนฟิวเซอร์ การเปลี่ยนฟิวเซอร์ ปิดเครื่องพิมพ์ ถอดปลั๊กสายไฟของแหล่งจ่ายไฟออกจากเต้าเสียบ แล้วจึงปลดออกจากเครื่องพิมพ์ เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน เพื่อลดความเสี่ยงต่อการบาดเจ็บจากชิ้นส่วนที่ร้อน ควรปล่อยให้พื้นผิวเย็นลงก่อนสัมผัส ปลดล็อค แล้วนำฟิวเซอร์ที่ใช้แล้วออก ปลดล็อคฟิวเซอร์ใหม่ ใส่ฟิวเซอร์ใหม่จนกว่าจะมีเสียง คลิก เข้าที่ แล้วจึงทำการล็อค ปิดฝาปิด B เสียบปลายด้านหนึ่งของสายไฟเข้ากับเครื่องพิมพ์ และอีกด้านหนึ่งเข้ากับเต้าเสียบ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟไหม้หรือไฟฟ้าช็อต เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย เปิดเครื่องพิมพ์ ฟิวเซอร์ การเปลี่ยน การเปลี่ยนชิ้นส่วน ฟิวเซอร์"},{"UUID":"4054fb30-3692-454b-a8b6-140860acff87","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนถาดรองกระดาษ การเปลี่ยนถาดรองกระดาษ ดึงถาดรองกระดาษที่ใช้แล้วออก นำถาดรองกระดาษใหม่ออกจากบรรจุภัณฑ์ ใส่ถาดรองกระดาษใหม่","descFull":"การเปลี่ยนถาดรองกระดาษ การเปลี่ยนถาดรองกระดาษ ดึงถาดรองกระดาษที่ใช้แล้วออก นำถาดรองกระดาษใหม่ออกจากบรรจุภัณฑ์ ใส่ถาดรองกระดาษใหม่ ถาดรองกระดาษ การเปลี่ยน การเปลี่ยนชิ้นส่วน ถาดรองกระดาษ"},{"UUID":"bd030793-065b-4b89-81ba-279924857a3d","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนตัวนำกระดาษด้านข้างในถาดเสริม 550 แผ่น การเปลี่ยนตัวนำกระดาษด้านข้างในถาดเสริม 550","descFull":"การเปลี่ยนตัวนำกระดาษด้านข้างในถาดเสริม 550 แผ่น การเปลี่ยนตัวนำกระดาษด้านข้างในถาดเสริม 550 แผ่น ดึงถาดออกมา นำตัวนำกระดาษด้านข้างที่ใช้แล้วออก นำตัวนำกระดาษด้านข้างใหม่ออกจากบรรจุภัณฑ์ ใส่ตัวนำกระดาษด้านข้างใหม่จนกระทั่งมีเสียง คลิก เข้าที่ ใส่ถาดกระดาษ ตัวนำขนาดกระดาษ การเปลี่ยน การเปลี่ยนชิ้นส่วน ตัวนำขนาดกระดาษ"},{"UUID":"2fa89a6e-5482-481a-888c-4345b8349571","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนฝาครอบในถาดเสริม 550 แผ่น การเปลี่ยนฝาครอบในถาดเสริม 550","descFull":"การเปลี่ยนฝาครอบในถาดเสริม 550 แผ่น การเปลี่ยนฝาครอบในถาดเสริม 550 แผ่น ถอดฝาครอบถาดที่ใช้แล้วออก นำฝาครอบถาดใหม่ออกจากบรรจุภัณฑ์ ใส่ฝาครอบถาดใหม่ให้มีเสียงคลิกเข้าที่ การเปลี่ยนชิ้นส่วน ฝาครอบถาด ฝาครอบถาด การเปลี่ยน ฝาครอบถาด 550 แผ่น"},{"UUID":"c383a5c7-4d06-439d-acd9-306480690f8a","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนส่วนขยายถาดด้านบนอุปกรณ์เย็บเล่ม นำส่วนขยายถาดด้านบนที่ใช้แล้วออก นำส่วนขยายถาดด้านบนใหม่ออกจากบรรจุภัณฑ์ ใส่ส่วนขยายถาดด้านบนใหม่เข้าไป การเปลี่ยนชิ้นส่วน","descFull":"การเปลี่ยนส่วนขยายถาดด้านบนอุปกรณ์เย็บเล่ม นำส่วนขยายถาดด้านบนที่ใช้แล้วออก นำส่วนขยายถาดด้านบนใหม่ออกจากบรรจุภัณฑ์ ใส่ส่วนขยายถาดด้านบนใหม่เข้าไป การเปลี่ยนชิ้นส่วน ส่วนขยายถาดด้านบนอุปกรณ์เย็บเล่ม ส่วนขยายถาดด้านบนอุปกรณ์เย็บเล่ม การเปลี่ยน"},{"UUID":"c2b85489-8c11-4044-a68c-67f2ee3be084","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนกล่องอุปกรณ์ตอกรู ลักษณะภายนอกของกล่องอุปกรณ์ตอกรูอาจแตกต่างกันไป ขึ้นอยู่กับถาดรับงานพิมพ์ที่ติดตั้ง เปิดฝาปิดถาดรับงานพิมพ์ นำกล่องอุปกรณ์ตอกรูที่ใช้แล้วออก","descFull":"การเปลี่ยนกล่องอุปกรณ์ตอกรู ลักษณะภายนอกของกล่องอุปกรณ์ตอกรูอาจแตกต่างกันไป ขึ้นอยู่กับถาดรับงานพิมพ์ที่ติดตั้ง เปิดฝาปิดถาดรับงานพิมพ์ นำกล่องอุปกรณ์ตอกรูที่ใช้แล้วออก นำกล่องอุปกรณ์ตอกรูใหม่ออกจากบรรจุภัณฑ์ ใส่กล่องอุปกรณ์ตอกรูใหม่เข้าไป ปิดฝาถาดรับงานพิมพ์ การเปลี่ยนชิ้นส่วน กล่องอุปกรณ์ตอกรู กล่องอุปกรณ์ตอกรู การเปลี่ยน"},{"UUID":"d6dde3da-0140-438f-80d4-8a7be9ab1c77","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนถาดมาตรฐาน การเปลี่ยนถาดมาตรฐาน นำถาดมาตรฐานที่ใช้แล้วออก นำถาดมาตรฐานใหม่ออกจากบรรจุภัณฑ์ ติดถาดมาตรฐานใหม่","descFull":"การเปลี่ยนถาดมาตรฐาน การเปลี่ยนถาดมาตรฐาน นำถาดมาตรฐานที่ใช้แล้วออก นำถาดมาตรฐานใหม่ออกจากบรรจุภัณฑ์ ติดถาดมาตรฐานใหม่ การเปลี่ยนชิ้นส่วน ถาดมาตรฐาน ถาดมาตรฐาน การเปลี่ยน"},{"UUID":"cef45407-8315-4dc6-92ad-f8ebd01ed0a1","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนฝาครอบพัดลม ถอดฝาครอบพัดลมที่ใช้แล้วออก นำฝาครอบใหม่ออกจากบรรจุภัณฑ์ ใส่ฝาครอบใหม่ให้มีเสียง คลิก","descFull":"การเปลี่ยนฝาครอบพัดลม ถอดฝาครอบพัดลมที่ใช้แล้วออก นำฝาครอบใหม่ออกจากบรรจุภัณฑ์ ใส่ฝาครอบใหม่ให้มีเสียง คลิก เข้าที่ การเปลี่ยนชิ้นส่วน ฝาครอบพัดลม ฝาครอบพัดลม การเปลี่ยน"},{"UUID":"b47cf24a-e01e-4260-b9c6-5f2114597074","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนฝาครอบด้านขวา ถอดฝาครอบด้านขวาที่ใช้แล้วออก นำฝาครอบใหม่ออกจากบรรจุภัณฑ์ ใส่ฝาครอบใหม่ให้มีเสียง คลิก","descFull":"การเปลี่ยนฝาครอบด้านขวา ถอดฝาครอบด้านขวาที่ใช้แล้วออก นำฝาครอบใหม่ออกจากบรรจุภัณฑ์ ใส่ฝาครอบใหม่ให้มีเสียง คลิก เข้าที่ การเปลี่ยนชิ้นส่วน ฝาครอบด้านขวา ฝาครอบด้านขวา การเปลี่ยน"},{"UUID":"6b817d53-83a0-4561-a8c9-254d09bf47cc","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนเครื่องมือทำความสะอาดกระจก เปิดฝาครอบสแกนเนอร์ นำเครื่องมือทำความสะอาดกระจกที่ใช้แล้วออก นำเครื่องมือทำความสะอาดกระจกใหม่ออกจากบรรจุภัณฑ์ ใส่เครื่องมือทำความสะอาดกระจกใหม่","descFull":"การเปลี่ยนเครื่องมือทำความสะอาดกระจก เปิดฝาครอบสแกนเนอร์ นำเครื่องมือทำความสะอาดกระจกที่ใช้แล้วออก นำเครื่องมือทำความสะอาดกระจกใหม่ออกจากบรรจุภัณฑ์ ใส่เครื่องมือทำความสะอาดกระจกใหม่ ปิดฝาครอบสแกนเนอร์ การเปลี่ยนชิ้นส่วน เครื่องมือทำความสะอาดกระจก เครื่องมือทำความสะอาดกระจก การเปลี่ยน"},{"UUID":"74ab22e9-f5b6-4a66-9bf4-3a067c153c80","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ การเปลี่ยนฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ นำถาดมาตรฐานออก นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษที่ใช้แล้วออก นำฝาครอบจุดเชื่อมต่อใหม่ออกจากบรรจุภัณฑ์","descFull":"การเปลี่ยนฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ การเปลี่ยนฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ นำถาดมาตรฐานออก นำฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษที่ใช้แล้วออก นำฝาครอบจุดเชื่อมต่อใหม่ออกจากบรรจุภัณฑ์ ติดฝาครอบจุดเชื่อมต่อใหม่จนมีเสียง คลิก เข้าที่ ติดถาดมาตรฐาน การเปลี่ยนชิ้นส่วน ฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ ฝาครอบจุดเชื่อมต่ออุปกรณ์ส่งกระดาษ การเปลี่ยน"},{"UUID":"acff053d-262e-4d22-a4b3-761967551e57","title":"การเปลี่ยนชุดตลับลวดเย็บ","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ จับที่จับ F แล้วเลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บไปทางซ้าย นำตลับใส่ลวดเย็บกระดาษออก","descFull":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ จับที่จับ F แล้วเลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บไปทางซ้าย นำตลับใส่ลวดเย็บกระดาษออก นำตลับลวดเย็บที่ว่างออก ใส่ตลับลวดเย็บใหม่เข้าไปให้มีเสียง คลิก เข้าที่ ใส่ที่ใส่ตลับลวดเย็บเข้าไปให้มีเสียง คลิก เข้าที่ เลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บไปทางขวา การเปลี่ยนวัสดุสิ้นเปลือง ตลับลวดเย็บ ตลับลวดเย็บ การเปลี่ยน"},{"UUID":"dd4a65b5-69a4-4c53-8294-0f24af82bd28","title":"การเปลี่ยนชุดตลับลวดเย็บ","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่มแบบตอกลวดเย็บ เปิดฝาปิด H ดึงตัวจับสีเขียวออก แล้วนำที่ใส่ตลับลวดเย็บออก","descFull":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่มแบบตอกลวดเย็บ เปิดฝาปิด H ดึงตัวจับสีเขียวออก แล้วนำที่ใส่ตลับลวดเย็บออก นำตลับลวดเย็บที่ว่างออก นำตลับลวดเย็บใหม่ออกมาจากบรรจุภัณฑ์ ใส่ตลับลวดเย็บใหม่เข้าไปให้มีเสียง คลิก เข้าที่ ใส่ที่ใส่ตลับลวดเย็บเข้าไปให้มีเสียง คลิก เข้าที่ ปิดฝาปิด H การเปลี่ยนวัสดุสิ้นเปลือง ตลับลวดเย็บ ตลับลวดเย็บ การเปลี่ยน"},{"UUID":"12fcbeb9-1e73-4290-9287-d6aadd7fafec","title":"การเปลี่ยนชุดตลับลวดเย็บ","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่ม เปิดฝาปิด H ดึงตัวจับสีเขียวออก แล้วนำที่ใส่ตลับลวดเย็บออก","descFull":"การเปลี่ยนตลับลวดเย็บในอุปกรณ์เย็บเล่ม เปิดฝาปิด H ดึงตัวจับสีเขียวออก แล้วนำที่ใส่ตลับลวดเย็บออก นำตลับลวดเย็บที่ว่างออก นำตลับลวดเย็บใหม่ออกมาจากบรรจุภัณฑ์ ใส่ตลับลวดเย็บใหม่เข้าไปให้มีเสียง คลิก เข้าที่ ใส่ที่ใส่ตลับลวดเย็บเข้าไปให้มีเสียง คลิก เข้าที่ ปิดฝาปิด H การเปลี่ยนวัสดุสิ้นเปลือง ตลับลวดเย็บ ตลับลวดเย็บ การเปลี่ยน"},{"UUID":"7a1a6305-8c67-4db9-9a35-49aa68305851","title":"การเปลี่ยนชุดตลับลวดเย็บ","link":"replacing-toner-cartridge-topic.html","desc":"การเปลี่ยนที่ใส่ตลับลวดเย็บในอุปกรณ์เย็บเล่ม เปิดฝาปิดถาดรับงานพิมพ์ ดึงตัวทำ Booklet ออก","descFull":"การเปลี่ยนที่ใส่ตลับลวดเย็บในอุปกรณ์เย็บเล่ม เปิดฝาปิดถาดรับงานพิมพ์ ดึงตัวทำ Booklet ออก แล้วนำที่ใส่ตลับลวดเย็บที่ใช้แล้วออก นำที่ใส่ตลับลวดเย็บใหม่ออกมาจากบรรจุภัณฑ์ ใส่ที่ใส่ตลับลวดเย็บใหม่เข้าไป ใส่ตัวทำ Booklet แล้วปิดฝาปิดถาดรับงานพิมพ์ การเปลี่ยนชิ้นส่วน ที่ใส่ตลับลวดเย็บ ที่ใส่ตลับลวดเย็บ การเปลี่ยน"},{"UUID":"4f0f7660-f8d3-4b9c-89a1-4fdf0285e29c","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง","link":"replacing-toner-cartridge-topic.html","desc":"การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง จากแผงควบคุม ไปที่ ","descFull":"การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การใช้วัสดุสิ้นเปลืองและตัวนับ เลือกตัวนับที่คุณต้องการรีเซ็ต วัสดุสิ้นเปลืองและชิ้นส่วนที่ไม่มีข้อกำหนดข้อตกลงของโครงการส่งคืนอาจถูกรีเซ็ตและนำมาผลิตใหม่ อย่างไรก็ตาม การรับประกันโดยผู้ผลิตไม่ครอบคลุมความเสียหายใดๆ ที่เกิดจากวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของแท้ การรีเซ็ตตัวนับชิ้นส่วนหรือวัสดุสิ้นเปลืองที่ไม่ได้รับการผลิตใหม่อย่างเหมาะสมอาจทำให้เครื่องพิมพ์ชำรุดเสียหายได้ หลังจากรีเซ็ตวัสดุสิ้นเปลืองหรือตัวนับชิ้นส่วนแล้ว เครื่องพิมพ์อาจแสดงข้อผิดพลาดเพื่อระบุว่ามีรายการที่รีเซ็ต วัสดุสิ้นเปลืองและชิ้นส่วนที่ไม่มีข้อกำหนดข้อตกลงของโครงการใช้งานและส่งคืนอาจถูกรีเซ็ตและนำมาผลิตใหม่ อย่างไรก็ตาม การรับประกันโดยผู้ผลิตไม่ครอบคลุมความเสียหายใดๆ ที่เกิดจากวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของแท้ การรีเซ็ตตัวนับชิ้นส่วนหรือวัสดุสิ้นเปลืองที่ไม่ได้รับการผลิตใหม่อย่างเหมาะสมอาจทำให้เครื่องพิมพ์ชำรุดเสียหายได้ หลังจากรีเซ็ตวัสดุสิ้นเปลืองหรือตัวนับชิ้นส่วนแล้ว เครื่องพิมพ์อาจแสดงข้อผิดพลาดเพื่อระบุว่ามีรายการที่รีเซ็ต ตัวนับการใช้วัสดุสิ้นเปลือง การรีเซต การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง"},{"UUID":"6857e0b3-8a43-4814-93a7-7a777aa73068","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์","link":"cleaning-printer-topic.html","desc":"การทำความสะอาดเครื่องพิมพ์ การทำความสะอาดเครื่องพิมพ์ เพื่อป้องกันความเสี่ยงต่อการเกิดไฟฟ้าช็อตในระหว่างการทำความสะอาดภายนอกของเครื่องพิมพ์ ให้ถอดปลั๊กสายไฟออกจากเต้าเสียบและปลดการเชื่อมต่อสายเคเบิลทั้งหมดที่เชื่อมต่อจากเครื่องพิมพ์ก่อนเริ่มดำเนินงาน ควรทำสิ่งนี้ทุกสองถึงสามเดือน","descFull":"การทำความสะอาดเครื่องพิมพ์ การทำความสะอาดเครื่องพิมพ์ เพื่อป้องกันความเสี่ยงต่อการเกิดไฟฟ้าช็อตในระหว่างการทำความสะอาดภายนอกของเครื่องพิมพ์ ให้ถอดปลั๊กสายไฟออกจากเต้าเสียบและปลดการเชื่อมต่อสายเคเบิลทั้งหมดที่เชื่อมต่อจากเครื่องพิมพ์ก่อนเริ่มดำเนินงาน ควรทำสิ่งนี้ทุกสองถึงสามเดือน การรับประกันเครื่องพิมพ์ไม่ครอบคลุมความเสียหายต่อเครื่องพิมพ์ที่เกิดจากการใช้งานที่ไม่ถูกต้อง ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบ นำกระดาษออกจากถาดมาตรฐานและตัวป้อนกระดาษอเนกประสงค์ ขจัดฝุ่น เศษใยผ้า และเศษกระดาษรอบๆ เครื่องพิมพ์โดยใช้แปรงขนนุ่มหรือเครื่องดูดฝุ่น ใช้ผ้านุ่มไม่มีขนชุบน้ำหมาดๆ เช็ดทำความสะอาดภายนอกเครื่องพิมพ์ อย่าใช้น้ำยาทำความสะอาดหรือผงซักฟอก เนื่องจากอาจทำให้พื้นผิวของเครื่องพิมพ์เสียหายได้ ตรวจสอบให้แน่ใจว่าพื้นที่ทั้งหมดของเครื่องพิมพ์แห้งสนิทหลังทำความสะอาด เชื่อมต่อสายไฟเข้ากับเต้าเสียบ แล้วจึงเปิดเครื่องพิมพ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย การทำความสะอาดเครื่องพิมพ์ เครื่องพิมพ์ การทำความสะอาด"},{"UUID":"e80c5635-17bb-4b01-831f-b23d7edfbdbc","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์","link":"cleaning-printer-topic.html","desc":"การทำความสะอาดหน้าจอสัมผัส การทำความสะอาดหน้าจอสัมผัส เพื่อป้องกันความเสี่ยงต่อการเกิดไฟฟ้าช็อตในระหว่างการทำความสะอาดภายนอกของเครื่องพิมพ์ ให้ถอดปลั๊กสายไฟออกจากเต้าเสียบและปลดการเชื่อมต่อสายเคเบิลทั้งหมดที่เชื่อมต่อจากเครื่องพิมพ์ก่อนเริ่มดำเนินงาน ปิดเครื่องพิมพ์","descFull":"การทำความสะอาดหน้าจอสัมผัส การทำความสะอาดหน้าจอสัมผัส เพื่อป้องกันความเสี่ยงต่อการเกิดไฟฟ้าช็อตในระหว่างการทำความสะอาดภายนอกของเครื่องพิมพ์ ให้ถอดปลั๊กสายไฟออกจากเต้าเสียบและปลดการเชื่อมต่อสายเคเบิลทั้งหมดที่เชื่อมต่อจากเครื่องพิมพ์ก่อนเริ่มดำเนินงาน ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบ ใช้ผ้านุ่มไม่มีขนชุบน้ำหมาดๆ เช็ดทำความสะอาดหน้าจอสัมผัส อย่าใช้น้ำยาทำความสะอาดหรือผงซักฟอก เนื่องจากอาจทำให้หน้าจอสัมผัสเสียหายได้ ตรวจสอบให้แน่ใจว่าหน้าจอสัมผัสแห้งหลังจากทำความสะอาด เชื่อมต่อสายไฟเข้ากับเต้าเสียบ แล้วจึงเปิดเครื่องพิมพ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟไหม้หรือไฟฟ้าช็อต เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย หน้าจอสัมผัส การทำความสะอาด การทำความสะอาดหน้าจอสัมผัส"},{"UUID":"19281e30-6faf-4a4a-a31a-e40e1a2b0c1b","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์","link":"cleaning-printer-topic.html","desc":"การทำความสะอาดสแกนเนอร์ เปิดฝาครอบสแกนเนอร์ นำเครื่องมือทำความสะอาดกระจกออก เปิดฝาปิด A1","descFull":"การทำความสะอาดสแกนเนอร์ เปิดฝาครอบสแกนเนอร์ นำเครื่องมือทำความสะอาดกระจกออก เปิดฝาปิด A1 ใช้เครื่องมือเช็ดกระจก ADF ปิดฝาปิด A1 ใช้ผ้านุ่มไม่มีขนชุบน้ำหมาดๆ เช็ดทำความสะอาดบริเวณต่อไปนี้: แผ่นกระจก ADF แผ่นกระจกสแกนเนอร์ กระจกสแกนเนอร์ ใช้เครื่องมือเช็ดกระจก ADF นำเครื่องมือกลับติดตั้งกลับเข้าที่ ปิดฝาครอบสแกนเนอร์ สแกนเนอร์ การทำความสะอาด คุณภาพการพิมพ์ การทำความสะอาดสแกนเนอร์ การทำความสะอาดสแกนเนอร์"},{"UUID":"ec3a5d78-67cd-449a-ae1e-ced95bb49d75","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์","link":"cleaning-printer-topic.html","desc":"การทำความสะอาดเลนส์หัวพิมพ์ เปิดฝาด้านหน้า นำกลักหมึกออก ค่อยๆ ดึงตัวเช็ดออกจนกว่าจะหยุด","descFull":"การทำความสะอาดเลนส์หัวพิมพ์ เปิดฝาด้านหน้า นำกลักหมึกออก ค่อยๆ ดึงตัวเช็ดออกจนกว่าจะหยุด ตัวเช็ดไม่หลุดออกจากเครื่องพิมพ์ ผลักตัวเช็ดกลับเข้าไปในหัวพิมพ์จนกว่าจะหยุด ทำซ้ำ ขั้นตอนที่ 3  และ ขั้นตอนที่ 4  สามครั้งสำหรับหัวพิมพ์แต่ละอัน ใส่กลักหมึก ปิดฝาด้านหน้า เลนส์หัวพิมพ์ การทำความสะอาด การทำความสะอาดเลนส์หัวพิมพ์"},{"UUID":"d0c9bcdd-eed3-4a9f-8dde-0df386557984","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์","link":"cleaning-printer-topic.html","desc":"การทำให้กล่องอุปกรณ์ตอกรูว่าง ลักษณะภายนอกของกล่องอุปกรณ์ตอกรูอาจแตกต่างกันไป ขึ้นอยู่กับถาดรับงานพิมพ์ที่ติดตั้ง เปิดฝาปิดถาดรับงานพิมพ์ ถอดออกแล้วทำให้กล่องอุปกรณ์ตอกรูว่าง","descFull":"การทำให้กล่องอุปกรณ์ตอกรูว่าง ลักษณะภายนอกของกล่องอุปกรณ์ตอกรูอาจแตกต่างกันไป ขึ้นอยู่กับถาดรับงานพิมพ์ที่ติดตั้ง เปิดฝาปิดถาดรับงานพิมพ์ ถอดออกแล้วทำให้กล่องอุปกรณ์ตอกรูว่าง ใส่กล่องอุปกรณ์ตอกรูเข้าไป ปิดฝาถาดรับงานพิมพ์ กล่องอุปกรณ์ตอกรู การทำให้ว่าง การทำให้กล่องอุปกรณ์ตอกรูว่าง"},{"UUID":"49386d41-fe7e-4d61-b9f0-72ffdf43849f","title":"การประหยัดพลังงานและกระดาษ","link":"configuring-power-save-mode-settings-topic.html","desc":"การกำหนดการตั้งค่าโหมดประหยัดพลังงาน การกำหนดการตั้งค่าโหมดประหยัดพลังงาน โหมดพักเครื่อง จากแผงควบคุม ไปที่","descFull":"การกำหนดการตั้งค่าโหมดประหยัดพลังงาน การกำหนดการตั้งค่าโหมดประหยัดพลังงาน โหมดพักเครื่อง จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การจัดการพลังงาน หมดเวลา โหมดพักเครื่อง กำหนดระยะเวลาที่เครื่องพิมพ์อยู่ในสถานะไม่มีการใช้งานก่อนที่จะเข้าสู่  โหมดพักเครื่อง โหมดไฮเบอร์เนต จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การจัดการพลังงาน หมดเวลา หมดเวลาไฮเบอร์เนต กำหนดระยะเวลาที่เครื่องพิมพ์อยู่ในสถานะไม่มีการใช้งานก่อนที่จะเข้าสู่โหมดไฮเบอร์เนต เพื่อให้  หมดเวลาไฮเบอร์เนต  ทำงาน ให้ตั้ง  หมดเวลาไฮเบอร์เนตเมื่อมีการเชื่อมต่อ  เป็น  ไฮเบอร์เนต จะใช้งาน Embedded Web Server ไม่ได้เมื่อเครื่องพิมพ์อยู่ในโหมดไฮเบอร์เนต โหมดพักเครื่อง การกำหนดค่า โหมดไฮเบอร์เนต การกำหนดค่า โหมดประหยัดพลังงาน การกำหนดค่า"},{"UUID":"d470982d-77ed-45a4-b957-7faf3b495f3b","title":"การประหยัดพลังงานและกระดาษ","link":"configuring-power-save-mode-settings-topic.html","desc":"การปรับความสว่างของส่วนแสดงผล การปรับความสว่างของส่วนแสดงผล จากแผงควบคุม ไปที่ ","descFull":"การปรับความสว่างของส่วนแสดงผล การปรับความสว่างของส่วนแสดงผล จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ ค่ากำหนด ในเมนู  ความสว่างของหน้าจอ  ให้ปรับการตั้งค่า ความสว่างของส่วนแสดงผล การปรับ การปรับความสว่าง"},{"UUID":"04f355f9-4c08-496c-a7d0-8b470a67d2e6","title":"การประหยัดพลังงานและกระดาษ","link":"configuring-power-save-mode-settings-topic.html","desc":"การประหยัดวัสดุสิ้นเปลือง พิมพ์ลงบนหน้ากระดาษทั้งสองด้าน การพิมพ์สองด้านคือการตั้งค่าเริ่มต้นในเครื่องพิมพ์ พิมพ์หลายหน้าบนกระดาษแผ่นเดียว ใช้คุณสมบัติดูตัวอย่างเพื่อดูลักษณะของเอกสารก่อนพิมพ์","descFull":"การประหยัดวัสดุสิ้นเปลือง พิมพ์ลงบนหน้ากระดาษทั้งสองด้าน การพิมพ์สองด้านคือการตั้งค่าเริ่มต้นในเครื่องพิมพ์ พิมพ์หลายหน้าบนกระดาษแผ่นเดียว ใช้คุณสมบัติดูตัวอย่างเพื่อดูลักษณะของเอกสารก่อนพิมพ์ พิมพ์สำเนาเอกสารหนึ่งชุดเพื่อตรวจสอบเนื้อหาและรูปแบบของเอกสารเพื่อความถูกต้อง การประหยัดวัสดุสิ้นเปลือง วัสดุสิ้นเปลือง การประหยัด"},{"UUID":"49d3953f-906a-4582-a536-de47c7dff055","title":"ดูแลรักษาเครื่องพิมพ์","link":"moving-printer-topic.html","desc":"การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20 กก.","descFull":"การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น หากเครื่องพิมพ์มีน้ำหนักมากกว่า 20 กก. (44 ปอนด์) อาจต้องใช้คนสองคนขึ้นไปยกเครื่องพิมพ์อย่างปลอดภัย เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้ใช้สายไฟที่มาพร้อมกับผลิตภัณฑ์นี้หรือสายไฟที่ใช้แทนกันได้ที่ได้รับการรับรองจากผู้ผลิตเท่านั้น เมื่อเคลื่อนย้ายเครื่องพิมพ์ ให้ทำตามคำแนะนำเหล่านี้เพื่อหลีกเลี่ยงการได้รับบาดเจ็บหรือเครื่องพิมพ์เสียหาย: ตรวจสอบว่าปิดฝาและถาดทั้งหมดอยู่ ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบ ถอดสายไฟและสายอื่นๆ ออกจากเครื่องพิมพ์ หากเครื่องพิมพ์มีถาดเสริมหรือตัวเลือกเอาต์พุตที่วางบนพื้นแยกต่างหากติดอยู่ ให้ถอดออกก่อนเคลื่อนย้ายเครื่องพิมพ์ หากเครื่องพิมพ์มีฐานแบบมีล้อเลื่อน ให้ค่อยๆ เคลื่อนไปยังตำแหน่งใหม่ ใช้ความระมัดระวังเมื่อผ่านธรณีประตูและรอยแยกบนพื้น หากเครื่องพิมพ์ไม่มีฐานแบบมีล้อเลื่อน แต่มีการติดตั้งถาดหรืออุปกรณ์เสริมสำหรับรองรับสำเนา ให้ถอดอุปกรณ์เสริมออกและยกเครื่องพิมพ์ออกจากถาด อย่าพยายามยกเครื่องพิมพ์และอุปกรณ์เสริมใดๆ พร้อมกัน ใช้ที่จับบนเครื่องพิมพ์เพื่อยกเสมอ รถเข็นที่ใช้เคลื่อนย้ายเครื่องพิมพ์ต้องมีพื้นผิวที่สามารถรองรับพื้นที่ทั้งหมดของเครื่องพิมพ์ได้ รถเข็นที่ใช้ในการเคลื่อนย้ายเครื่องต้องมีพื้นที่สามารถรองรับอุปกรณ์เสริมได้ด้วย ให้เครื่องพิมพ์อยู่ในตำแหน่งตั้งตรงตลอดเวลา หลีกเลี่ยงการเคลื่อนไหวที่รุนแรง ตรวจสอบให้แน่ใจว่านิ้วมือของคุณไม่อยู่ใต้เครื่องพิมพ์เมื่อคุณวางลง ตรวจสอบให้แน่ใจว่ามีพื้นที่ว่างเพียงพอรอบเครื่องพิมพ์ การรับประกันเครื่องพิมพ์ไม่ครอบคลุมถึงความเสียหายของเครื่องพิมพ์ที่เกิดจากการเคลื่อนย้ายอย่างไม่ถูกต้อง การเคลื่อนย้ายเครื่องพิมพ์"},{"UUID":"0336c561-95d1-4814-92a5-0f75cab5bde6","title":"การแก้ไขปัญหา","link":"print-quality-problems-topic.html","desc":"","descFull":"ปัญหาคุณภาพการพิมพ์ ค้นหารูปที่มีลักษณะคล้ายกับปัญหาคุณภาพการพิมพ์ที่คุณกำลังประสบอยู่ จากนั้นคลิกลิงก์ด้านล่างเพื่ออ่านขั้นตอนการแก้ไขปัญหา"},{"UUID":"891b4b03-9670-4b58-9c63-f6ba731eb87c","title":"การแก้ไขปัญหา","link":"printer-error-codes-topic.html","desc":"รหัสข้อผิดพลาดของเครื่องพิมพ์ รหัสข้อผิดพลาดและวิธีแก้ไขปัญหา รหัสข้อผิดพลาด ข้อความแจ้งข้อผิดพลาด วิธีแก้ไขปัญหา","descFull":"รหัสข้อผิดพลาดของเครื่องพิมพ์ รหัสข้อผิดพลาดและวิธีแก้ไขปัญหา รหัสข้อผิดพลาด ข้อความแจ้งข้อผิดพลาด วิธีแก้ไขปัญหา 2.01 จำเป็นต้องมีวัสดุสิ้นเปลือง เลือก  ยกเลิกงาน  และสั่งซื้อวัสดุสิ้นเปลืองที่จำเป็น โปรดดูข้อมูลเพิ่มเติมที่  3.01 ถาดกระดาษออกมาตรฐานเต็ม นำกระดาษออกจากถาด แล้วเลือก  ดำเนินการต่อ 3.02, 3.03, 3.04 นำกระดาษออกจากถาด [x] นำกระดาษออกจากถาด แล้วเลือก  ดำเนินการต่อ 7.13, 7.23, 7.33,7.43 ใส่ถาด [x] ใส่ถาดที่ระบุ 8.01 ปิดฝาด้านหน้า ปิดฝาด้านหน้าไว้ ยกเว้นเมื่อดำเนินการดูแลรักษา 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 ปิดฝาปิด [x] ปิดฝาที่ระบุไว้ ยกเว้นเมื่อดำเนินการดูแลรักษา 8.06 ติดถาด 1500 แผ่นใหม่ ตรวจสอบว่าถาดติดเข้ากับเครื่องพิมพ์อย่างเหมาะสม 8.07 ติดอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บใหม่ ตรวจสอบว่าอุปกรณ์เย็บเล่มติดกับเครื่องพิมพ์อย่างเหมาะสม 8.08 ปิดฝาครอบอุปกรณ์ส่งกระดาษ F ปิดฝาครอบไว้ ยกเว้นเมื่อดำเนินการดูแลรักษา 8.09 ปิดฝาครอบอุปกรณ์ส่งกระดาษ G 9 เครื่องพิมพ์ต้องรีสตาร์ท งานล่าสุดอาจไม่สมบูรณ์ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 โหลด <source/> ที่เป็น <type/> <size/> ใส่กระดาษในถาดที่ระบุ โปรดดูข้อมูลเพิ่มเติมที่  11.12, 11.22, 11.32, 11.42, 11.82, 11.92 โหลด <source/> ที่เป็น <type/> <size/> <orientation/> 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 เปลี่ยน <source/> เป็น <type/> <size/>  เปิดถาดที่ระบุ นำกระดาษออก แล้วใส่ประเภทและขนาดกระดาษที่ถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  12.12, 12.22, 12.32, 12.4212.92 เปลี่ยน <source/> เป็น <type/> <size/> <orientation/>  31.00 กล่องอุปกรณ์ตอกรูขาดหายหรือเต็ม เปิดฝาปิด H นำกล่องอุปกรณ์ตอกรูออก หากกล่องอุปกรณ์ตอกรูเต็ม ให้ทำให้ว่างเปล่า ใส่กล่องอุปกรณ์ตอกรูเข้าไป ปิดฝาปิด H 31.35, 31.35A, 31.35B ติดตั้งขวดผงหมึกสำหรับทิ้งที่ขาดหายหรือไม่ตอบสนองใหม่ เปิดฝาด้านหน้า นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง ใส่ขวดผงหมึกสำหรับทิ้ง ปิดฝาด้านหน้า 31.40z, 31.41z, 31.42z, 31.43z ติดตั้งกลักหมึก [สี] ที่ขาดหายหรือไม่ตอบสนองใหม่ เปิดฝาด้านหน้า นำตลับหมึกออก ใส่ตลับหมึก ปิดฝาด้านหน้า 31.60z ติดตั้งชุดสร้างภาพขาวดำที่ขาดหายหรือไม่ตอบสนองใหม่ เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง นำชุดสร้างภาพออก อย่าให้ชุดสร้างภาพถูกแสงโดยตรง การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ปลดล็อคแล้วถอดชุดสร้างภาพขาวดำ ใส่ชุดสร้างภาพขาวดำ แล้วล็อคให้เข้าที่ ใส่ชุดสร้างภาพลงไปจนเข้าที่ ใส่ขวดผงหมึกสำหรับทิ้ง ใส่กลักหมึก ปิดฝาด้านหน้า 31.64z ติดตั้งชุดสร้างภาพสีที่ขาดหาย ไม่ได้เสียบปลั๊ก หรือไม่ตอบสนองใหม่ เปิดฝาด้านหน้า นำกลักหมึกออก นำขวดผงหมึกสำหรับทิ้งออก เพื่อหลีกเลี่ยงการทำหมึกหก ให้วางขวดตั้งตรง นำชุดสร้างภาพออก อย่าให้ชุดสร้างภาพถูกแสงโดยตรง การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพลงไปจนเข้าที่ ใส่ขวดผงหมึกสำหรับทิ้ง ใส่กลักหมึก ปิดฝาด้านหน้า 31.80z ติดตั้งฟิวเซอร์ที่ขาดหายหรือไม่ตอบสนองใหม่ เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน เพื่อลดความเสี่ยงต่อการบาดเจ็บจากชิ้นส่วนที่ร้อน ควรปล่อยให้พื้นผิวเย็นลงก่อนสัมผัส ปลดล็อคแล้วนำฟิวเซอร์ออก ใส่ฟิวเซอร์แล้วล็อคให้เข้าที่ ปิดฝาปิด B 32.40z, 32.41z, 32.42z, 32.43z เปลี่ยนกลักหมึก [สี] ที่ไม่รองรับใหม่ โปรดดูข้อมูลเพิ่มเติมที่  32.60z เปลี่ยนชุดสร้างภาพขาวดำที่ไม่รองรับ โปรดดูข้อมูลเพิ่มเติมที่  32.65z เปลี่ยนชุดสร้างภาพสีที่ไม่รองรับ โปรดดูข้อมูลเพิ่มเติมที่  33.40z, 33.41z, 33.42z, 33.43z ตลับหมึก [สี] ปกติที่เติมแล้ว โปรดดูข้อมูลเพิ่มเติมที่  33.60z สำหรับชุดสร้างภาพขาวดำที่ไม่ใช่ของแท้ โปรดดูคู่มือการใช้ โปรดดูข้อมูลเพิ่มเติมที่  33.64z สำหรับชุดสร้างภาพสีที่ไม่ใช่ของแท้ โปรดดูคู่มือการใช้ 34.00 กระดาษสั้นเกินไป ตั้งค่าขนาดกระดาษให้ตรงกับกระดาษที่ใส่ในถาด จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่า ถาด ขนาด/ประเภทกระดาษ 34.10, 34.20, 34.30, 34.40, 34.50 ตรวจสอบ [แหล่งที่มา] ปรับตัวนำและแนวกระดาษ ดึงถาดที่ระบุออก แล้วตรวจสอบให้แน่ใจว่าใส่กระดาษอย่างถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  34.90 ตรวจสอบตัวป้อนกระดาษอเนกประสงค์ ปรับตัวนำและแนวกระดาษ ตรวจสอบให้แน่ใจว่าใส่กระดาษถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  37.1 หน่วยความจำไม่เพียงพอสำหรับงานเรียงหน้า ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: แตะที่  ดำเนินการต่อ  เพื่อพิมพ์ส่วนของงานที่จัดเก็บและเริ่มเรียงหน้าส่วนที่เหลือของงานพิมพ์ ยกเลิกงานพิมพ์ปัจจุบัน 37.3 หน่วยความจำไม่เพียงพอ งานที่ระงับไว้บางส่วนถูกลบออก เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ 38.1 หน่วยความจำเต็ม ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ยกเลิกงานพิมพ์ปัจจุบัน ติดตั้งหน่วยความจำของเครื่องพิมพ์เพิ่มเติม ลดจำนวนหน้าในงานพิมพ์ 39.1 หน้าที่ซับซ้อน ระบบอาจไม่พิมพ์ข้อมูลบางอย่าง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ยกเลิกงานพิมพ์ปัจจุบัน ติดตั้งหน่วยความจำของเครื่องพิมพ์เพิ่มเติม ลดความซับซ้อนและขนาดของงานพิมพ์ก่อนส่งพิมพ์อีกครั้ง ลดจำนวนหน้าในงานพิมพ์ ลดจำนวนและขนาดฟอนต์ที่ดาวน์โหลด ลบฟอนต์หรือมาโครที่ไม่จำเป็นจากงานพิมพ์ ลดจำนวนกราฟิกในงานพิมพ์ 42.yyC, 42.yyK, 42.yyM, 42.yyY เปลี่ยนกลักหมึก [สี] พื้นที่เครื่องพิมพ์ไม่ตรงกัน โปรดดูข้อมูลเพิ่มเติมที่  43.40Y, 43.41Y, 43.42Y, 43.43Y ติดตั้งกลักหมึก [สี] ใหม่ เปิดฝาด้านหน้า นำตลับหมึกออก ใส่ตลับหมึก ปิดฝาด้านหน้า 43.40Z, 43.41Z, 43.42Z, 43.43Z เปลี่ยนกลักหมึก [สี] ใหม่ โปรดดูข้อมูลเพิ่มเติมที่  50 ข้อผิดพลาดฟอนต์ PPDS ติดตั้งฟอนต์ PPDS ที่ระบุในงานพิมพ์ แล้วเลือก  ดำเนินการต่อ  เพื่อให้เครื่องพิมพ์ค้นหาฟอนต์ทดแทน 51 ตรวจพบแฟลชที่มีข้อบกพร่อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เปลี่ยนหน่วยความจำแฟลชใหม่ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ยกเลิกงานพิมพ์ปัจจุบัน 52 พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ลบฟอนต์ มาโคร และข้อมูลอื่นๆ ที่เก็บอยู่ในหน่วยความจำแฟลช ติดตั้งไดรฟ์จัดเก็บข้อมูล ฟอนต์และมาโครที่ดาวน์โหลดที่ไม่ได้จัดเก็บไว้ในหน่วยความจำแฟลชก่อนหน้านี้จะถูกลบ 58.4 การกำหนดค่าตัวเลือกถาดกระดาษออกไม่ถูกต้อง ปิดเครื่องพิมพ์ แล้วติดตั้งถาดหรืออุปกรณ์เย็บเล่มที่ถูกต้อง 61 นำดิสก์ที่มีข้อบกพร่องออก เปลี่ยนไดรฟ์จัดเก็บข้อมูลที่มีข้อบกพร่องใหม่ 62 ดิสก์เต็ม ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ลบฟอนต์ มาโคร และข้อมูลอื่นๆ ที่เก็บอยู่ในไดรฟ์จัดเก็บข้อมูล ติดตั้งไดรฟ์จัดเก็บข้อมูล 63 ฟอร์แมตดิสก์ การฟอร์แมตตอนนี้จะล้างข้อมูลทั้งหมดออกจากไดรฟ์จัดเก็บข้อมูล หากต้องการฟอร์แมตดิสก์ โปรดดำเนินการต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา การลบข้อมูลไม่สามารถใช้งานได้ . เลือก ทำความสะอาดข้อมูลทั้งหมดบนฮาร์ดดิสก์ แล้วเลือก ลบ 71.01 ไม่ได้ตั้งค่าชื่อสถานีแฟกซ์ติดต่อผู้ดูแลระบบ โปรดดูข้อมูลเพิ่มเติมที่  71.02 ไม่ได้ตั้งค่าหมายเลขสถานีแฟกซ์ติดต่อผู้ดูแลระบบ 71.03 ไม่มีสายโทรศัพท์แบบอนาล็อกที่เชื่อมต่อกับโมเด็ม แฟกซ์ถูกปิดใช้งานอยู่ ตรวจสอบสัญญาณจากจุดเชื่อมต่อและสายโทรศัพท์ โปรดดูข้อมูลเพิ่มเติมที่  71.04 สายโทรศัพท์แบบอนาล็อกเชื่อมต่อกับพอร์ตที่ไม่ถูกต้อง ถอดปลั๊กสายโทรศัพท์แล้วเชื่อมต่อกับพอร์ต LINE 71.06 ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์แฟกซ์ HTTPS ได้ การเชื่อมต่อกับเซิร์ฟเวอร์แฟกซ์ HTTPS ถูกตัดการเชื่อมต่อ ตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของเครื่องพิมพ์ 71.07 เครื่องพิมพ์ไม่ได้ลงทะเบียนกับเซิร์ฟเวอร์แฟกซ์ HTTPS ตรวจสอบให้แน่ใจว่าได้เพิ่มเครื่องพิมพ์ไปยังรายการอุปกรณ์ในพอร์ทัลเซิร์ฟเวอร์แฟกซ์ HTTPS ติดต่อผู้ดูแลระบบ 71.11 พาร์ติชันของแฟกซ์ พาร์ติชันของแฟกซ์ไม่ทำงาน ติดต่อผู้ดูแลระบบ 71.12 หน่วยความจำเต็ม ไม่สามารถพิมพ์แฟกซ์ได้ แตะที่  พิมพ์ทั้งหมด  เพื่อพิมพ์แฟกซ์ให้ได้มากที่สุดตามที่บันทึกไว้ 71.13 หน่วยความจำเต็ม ไม่สามารถส่งแฟกซ์ ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: ดำเนินการต่อและลองส่งแฟกซ์อีกครั้ง สแกนเอกสารต้นฉบับครั้งละหนึ่งหน้า กดหมายเลขแฟกซ์ แล้วส่งแฟกซ์เอกสาร 71.4 เวลาของเครื่องพิมพ์ไม่ถูกต้อง กำหนดค่าเวลาของเครื่องพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ ค่ากำหนด วันที่และเวลา กำหนดค่า 72.01 ไม่ได้ตั้งค่าเซิร์ฟเวอร์ SMTP ของอีเมลติดต่อผู้ดูแลระบบ ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: ตั้งค่าการทำงานของอีเมล โปรดดูข้อมูลเพิ่มเติมที่  ปิดใช้ข้อความแสดงข้อผิดพลาด โปรดดูข้อมูลเพิ่มเติมที่  72.02 ไม่ได้ตั้งค่าเซิร์ฟเวอร์เว็บลิงก์ติดต่อผู้ดูแลระบบ ติดต่อผู้ดูแลระบบของคุณ 72.04 ไม่ได้ตั้งค่าเซิร์ฟเวอร์แฟกซ์เพื่อฟอร์แมตติดต่อผู้ดูแลระบบ ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: กำหนดค่า  เพื่อฟอร์แมต  จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าเซิร์ฟเวอร์แฟกซ์ การตั้งค่าแฟกซ์ทั่วไป ติดต่อผู้ดูแลระบบของคุณ 75.01 ตรวจพบองค์ประกอบที่ปลอดภัย ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ใช้องค์ประกอบที่ปลอดภัยที่ติดตั้งไว้ เครื่องพิมพ์จะลบใบรับรองที่มีอยู่ทั้งหมดและยังอาจลบและฟอร์แมตไดรฟ์จัดเก็บข้อมูลใหม่ ปิดเครื่องพิมพ์ แล้วนำองค์ประกอบที่ปลอดภัยออก 75.02 ไม่จดจำองค์ประกอบที่ปลอดภัย 75.03 ข้อผิดพลาดการสื่อสารกับองค์ประกอบที่ปลอดภัย ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: หยุดใช้องค์ประกอบที่ปลอดภัย เครื่องพิมพ์จะลบใบรับรองที่มีอยู่ทั้งหมดและยังอาจลบและฟอร์แมตไดรฟ์จัดเก็บข้อมูลใหม่ ปิดเครื่องพิมพ์ นำออก แล้วติดตั้งองค์ประกอบที่ปลอดภัย 75.11 การอัพเดตองค์ประกอบที่ปลอดภัยล้มเหลว ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ลองอัพเดตอีกครั้ง ยกเลิกการอัพเดต เครื่องพิมพ์อาจลบใบรับรองและเนื้อหาในไดรฟ์จัดเก็บข้อมูลที่มีอยู่ทั้งหมด 75.12 การอัพเดตองค์ประกอบที่ปลอดภัยไม่สมบูรณ์ ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: รีสตาร์ทเครื่องพิมพ์ รอ 10 วินาทีเพื่อทำการอัพเดตให้เสร็จสมบูรณ์ ยกเลิกการอัพเดต เครื่องพิมพ์อาจลบใบรับรองและเนื้อหาในไดรฟ์จัดเก็บข้อมูลที่มีอยู่ทั้งหมด 80.01, 80.09 ชุดบำรุงรักษาใกล้เหลือน้อย เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 80.11, 80.19 ชุดบำรุงรักษาเหลือน้อย 80.21, 80.29 ชุดบำรุงรักษาเหลือน้อยมาก 80.31 เปลี่ยนชุดบำรุงรักษาเพื่อทำการพิมพ์ต่อ โปรดดูข้อมูลเพิ่มเติมที่  80.31 เปลี่ยนชุดบำรุงรักษาใหม่ เนื่องจากเกินอายุการใช้งานที่แนะนำ 81.11 ชุดลูกกลิ้งถาด 1500 แผ่นเหลือน้อย เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 81.31 เปลี่ยนชุดลูกกลิ้งถาด 1500 แผ่น เนื่องจากเกินอายุการใช้งานที่แนะนำ หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า 82.00, 82.02, 82.09 ขวดผงหมึกสำหรับทิ้งใกล้เต็ม โปรดดูข้อมูลเพิ่มเติมที่  82.3, 82.32, 82.33, 82.39 เปลี่ยนขวดผงหมึกสำหรับทิ้ง 83.1y โมดูลถ่ายโอนภาพต่ำ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 83.3y เปลี่ยนโมดูลถ่ายโอนภาพใหม่ เนื่องจากเกินอายุการใช้งานที่แนะนำ หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า 83.4y เปลี่ยนโมดูลถ่ายโอนภาพ 83.20 ตลับลวดเย็บต่ำ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 83.20 ด้านในลวดเย็บ S2 ต่ำ 83.20 ด้านนอกลวดเย็บ S2 ต่ำ 83.30 ตลับลวดเย็บว่างเปล่าหรือขาดหาย ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: นำออก แล้วใส่ตลับลวดเย็บลงไป การเปลี่ยนตลับลวดเย็บ สำหรับข้อมูลเพิ่มเติม โปรดดูที่  หรือ  83.30 ตลับลวดเย็บ S1 ว่างเปล่าหรือขาดหาย ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: นำออก แล้วใส่ตลับลวดเย็บลงไป การเปลี่ยนตลับลวดเย็บ โปรดดูข้อมูลเพิ่มเติมที่  83.30 ตลับลวดเย็บด้านใน S2 ว่างเปล่าหรือขาดหาย ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: นำออก แล้วใส่ตลับลวดเย็บลงไป การเปลี่ยนตลับลวดเย็บ โปรดดูข้อมูลเพิ่มเติมที่  83.30 ตลับลวดเย็บด้านนอก S2 ว่างเปล่าหรือขาดหาย 84.01K, 84.03K, 84.09K ชุดสร้างภาพขาวดำใกล้ต่ำ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 84.11K, 84.13K, 84.19K ชุดสร้างภาพขาวดำต่ำ 84.21C, 84.03C, 84.09C ชุดสร้างภาพขาวดำต่ำมาก 84.01C, 84.03C, 84.09C ชุดสร้างภาพสีใกล้ต่ำ 84.11C, 84.13C, 84.19C ชุดสร้างภาพสีต่ำ 84.21C, 84.23C, 84.29C ชุดสร้างภาพสีต่ำมาก 84.31, 84.33 เปลี่ยนชุดสร้างภาพขาวดำใหม่ เนื่องจากเกินอายุการใช้งานที่แนะนำ โปรดดูข้อมูลเพิ่มเติมที่  84.31, 84.33 เปลี่ยนชุดสร้างภาพสีใหม่ เนื่องจากเกินอายุการใช้งานที่แนะนำ โปรดดูข้อมูลเพิ่มเติมที่  84.41, 84.43, 84.48 เปลี่ยนชุดสร้างภาพขาวดำใหม่เพื่อพิมพ์ต่อ โปรดดูข้อมูลเพิ่มเติมที่  84.41, 84.43, 84.48 เปลี่ยนชุดสร้างภาพสีใหม่เพื่อพิมพ์ต่อ โปรดดูข้อมูลเพิ่มเติมที่  86.23 จำเป็นต้องดูแลรักษาสแกนเนอร์เร็วๆ นี้ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 86.33 เปลี่ยนชุด ADF ใหม่ เนื่องจากเกินอายุการใช้งานที่แนะนำ หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า 88.00[x], 88.07[x], 88.08[x], 88.09[x] กลักหมึก [สี] ใกล้ต่ำ เลือก  ดำเนินการต่อ  เพื่อล้างข้อความ 88.10[x], 88.17[x], 88.18[x], 88.19[x] กลักหมึก [สี] ต่ำ 88.20[x], 88.27[x], 88.28[x], 88.29[x] กลักหมึก [สี] ต่ำมาก 88.30[x], 88.37[x], 88.38[x] เปลี่ยนกลักหมึก [สี] ใหม่ เหลืออีกประมาณ <NUM/> หน้า โปรดดูข้อมูลเพิ่มเติมที่  88.30[x], 88.37[x], 88.38[x] เปลี่ยนกลักหมึก [สี] ใหม่ 88.40[x], 88.47[x], 88.48[x] เปลี่ยนกลักหมึก [สี] ใหม่ เหลืออีก 0 หน้า 88.40[x], 88.47[x], 88.48[x] เปลี่ยนกลักหมึก [สี] ใหม่ 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  240.06 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  241.16, 241.82, 241.83, 241.84, 661.13, 661.84 ข้อผิดพลาดการป้อนกระดาษใน [LOCATION/] เปิดถาด 1 นำออกแล้วปรับปึกกระดาษใหม่ หากจำเป็น ให้ปรับตัวนำกระดาษ ใส่กระดาษในถาด 1 ใหม่ ปิดถาด 1 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 กระดาษติดใน [LOCATION/] หากต้องการข้อมูลเพิ่มเติม โปรดดูที่ส่วนใดส่วนหนึ่งต่อไปนี้: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K เปลี่ยนต้นฉบับทั้งหมด หากเริ่มทำงานใหม่ ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: เริ่มทำงานใหม่ ยกเลิกงาน 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q เปลี่ยนกระดาษต้นฉบับที่ติด หากทำงานต่อ ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: สแกนจากกระจกสแกนเนอร์ สแกนจากตัวป้อนเอกสารอัตโนมัติ ทำงานให้เสร็จสิ้นโดยไม่สแกนเพิ่มเติม ยกเลิกงาน 280.06 ใส่ต้นฉบับใน ADF ใหม่และเริ่มทำงานใหม่ 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 กระดาษติดในสแกนเนอร์ โปรดดูข้อมูลเพิ่มเติมที่  291.06 ปิดฝาครอบแท่นสแกนและใส่ต้นฉบับ หากเริ่มทำงานใหม่ ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: สแกนจากกระจกสแกนเนอร์ สแกนจากตัวป้อนเอกสารอัตโนมัติ ทำงานให้เสร็จสิ้นโดยไม่สแกนเพิ่มเติม ยกเลิกงาน 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15, 508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 กระดาษติดใน [LOCATION/] โปรดดูข้อมูลเพิ่มเติมที่  602.29, 662.23 ข้อผิดพลาดการป้อนกระดาษในถาด 2 โปรดดูข้อมูลเพิ่มเติมที่  602.39, 663.33 ข้อผิดพลาดการป้อนกระดาษในถาด 3 หากต้องการข้อมูลเพิ่มเติม โปรดดูที่ส่วนใดส่วนหนึ่งต่อไปนี้: 602.49, 664.43 ข้อผิดพลาดการป้อนกระดาษในถาด 4 โปรดดูข้อมูลเพิ่มเติมที่  รหัสข้อผิดพลาดของเครื่องพิมพ์ รหัสข้อผิดพลาด ข้อความเกี่ยวกับเครื่องพิมพ์ ข้อความแสดงข้อผิดพลาด"},{"UUID":"4b0b390e-2021-47c6-a9ca-a64fc8f2fa7a","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"หน้าว่างหรือสีขาว ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"หน้าว่างหรือสีขาว ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้นำวัสดุบรรจุภัณฑ์ทั้งหมดออกจากชุดสร้างภาพ หน่วยสร้างภาพ และกลักหมึก ตรวจสอบว่าเครื่องพิมพ์ใช้ตลับหมึก Lexmark ของแท้และรองรับหรือไม่ ตรวจสอบว่าเครื่องพิมพ์ใช้ตลับหมึกของแท้และรองรับหรือไม่ หากเครื่องไม่รองรับตลับหมึกดังกล่าว ให้ติดตั้งตลับหมึกที่รองรับ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ หน้าสีขาว ปัญหาคุณภาพการพิมพ์ หน้าว่าง หน้าว่าง หน้าสีขาว"},{"UUID":"84a61f34-a419-49ac-b821-d742dcc0286a","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"งานพิมพ์มีสีเข้ม ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"งานพิมพ์มีสีเข้ม ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ปรับสี ลดความเข้มของหมึกจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า การพิมพ์ คุณภาพ ความเข้มของหมึก ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่ากระดาษไม่มีเนื้อผิวหยาบหรือเนื้อผิวไม่เรียบ ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ งานพิมพ์มีสีเข้ม งานพิมพ์มีสีเข้ม"},{"UUID":"3b48a2fa-74f2-4232-b81a-cd030e7ea4db","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ภาพจาง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"ภาพจาง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ป้อนกระดาษประเภทและน้ำหนักที่ถูกต้องลงในถาด ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ปรับสี หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ภาพจาง ภาพจาง"},{"UUID":"0df00733-7fdf-4d0f-ba67-932859852acb","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"พื้นหลังเป็นสีเทาหรือสี ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"พื้นหลังเป็นสีเทาหรือสี ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เพิ่มความเข้มของหมึกจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า การพิมพ์ คุณภาพ ความเข้มของหมึก จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ปรับสี ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ พื้นหลังเป็นสีเทาหรือสี พื้นหลังสีเทาในงานพิมพ์ พื้นหลังที่มีสีในงานพิมพ์"},{"UUID":"07767573-2e75-4cac-b804-15492feb5515","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ขอบห่างไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปรับตัวนำกระดาษในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ป้อนเข้าไป ให้ระบุขนาดของกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ","descFull":"ขอบห่างไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปรับตัวนำกระดาษในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ป้อนเข้าไป ให้ระบุขนาดของกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ขอบห่างไม่ถูกต้อง ขอบห่างไม่ถูกต้อง"},{"UUID":"2ae269de-46d8-4637-bbec-06713eac37c7","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"งานพิมพ์สีจาง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"งานพิมพ์สีจาง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้นำวัสดุบรรจุภัณฑ์ทั้งหมดออกจากชุดสร้างภาพ หน่วยสร้างภาพ และกลักหมึก จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ปรับสี เพิ่มความเข้มของหมึกจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า การพิมพ์ คุณภาพ ความเข้มของหมึก จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ  แล้วปิด  ตัวบันทึกสี ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่ากระดาษไม่มีเนื้อผิวหยาบหรือเนื้อผิวไม่เรียบ ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ งานพิมพ์สีจาง งานพิมพ์สีจาง"},{"UUID":"e4adab2a-6578-4026-854f-9060e88fc396","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"สีขาดหายไป ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"สีขาดหายไป ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้นำวัสดุบรรจุภัณฑ์ทั้งหมดออกจากชุดสร้างภาพ หน่วยสร้างภาพ และกลักหมึก ถอดชุดแม่เหล็กดึงหมึกของสีที่หายไปออก นำชุดสร้างภาพออก อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต นำออกแล้วใส่ชุดแม่เหล็กดึงหมึกของสีที่หายไป ใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ สีขาดหายไป สีขาดหายไป"},{"UUID":"7e83b27b-7e99-4d55-ab91-092981836301","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม","descFull":"งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบเครื่องพิมพ์เพื่อหาการปนเปื้อนจากหมึกที่รั่ว ตรวจสอบว่าการตั้งค่าขนาดกระดาษและประเภทกระดาษนั้นตรงกับกระดาษที่ป้อนหรือไม่ จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่ากระดาษไม่มีเนื้อผิวหยาบหรือเนื้อผิวไม่เรียบ ให้ระบุขนาดของกระดาษและประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด งานพิมพ์ไม่สม่ำเสมอและเป็นรอยจุด จุดบนหน้าที่พิมพ์"},{"UUID":"13cf3dee-5b0d-4fe4-8548-3251a97109f5","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"การพิมพ์เบี้ยวหรือเอียง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"การพิมพ์เบี้ยวหรือเอียง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ เปิดถาดแล้วนำกระดาษออก ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ ปรับตัวนำกระดาษในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ป้อนเข้าไป ตรวจสอบว่าคุณกำลังพิมพ์งานบนกระดาษที่รองรับ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ งานพิมพ์บิดเบี้ยว ปัญหาคุณภาพการพิมพ์ งานพิมพ์เอียง งานพิมพ์เอียง งานพิมพ์บิดเบี้ยว"},{"UUID":"e596506c-ecc8-4c4c-ba83-cd82936ea746","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ภาพสีทึบหรือภาพสีดำ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"ภาพสีทึบหรือภาพสีดำ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ภาพสีทึบหรือภาพสีดำ สีทึบ ภาพสีดำ"},{"UUID":"217b9e1f-a442-4b9a-927f-d0bb38b01e3c","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ข้อความหรือรูปภาพถูกตัดออก ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"ข้อความหรือรูปภาพถูกตัดออก ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้นำวัสดุบรรจุภัณฑ์ทั้งหมดออกจากชุดสร้างภาพ หน่วยสร้างภาพ และกลักหมึก ปรับตัวนำกระดาษในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ป้อนเข้าไป ให้ระบุขนาดของกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ข้อความหรือรูปภาพถูกตัดออก ข้อความที่ถูกตัดออกในการพิมพ์ ภาพที่ถูกตัดออกในการพิมพ์"},{"UUID":"402c68d7-b4ef-4093-a2e4-ac3564d22fe0","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"หมึกเช็ดออกง่าย ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่","descFull":"หมึกเช็ดออกง่าย ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ลองดำเนินการอย่างใดอย่างหนึ่งต่อไปนี้: ตรวจสอบว่าเสียบปลั๊กสายไฟของเครื่องพิมพ์เข้ากับสายไฟที่ต่อลงดินอย่างเหมาะสมและมีการจัดระดับที่เหมาะสม ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป กำหนดค่าประเภทกระดาษจากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ หมึกเช็ดออกง่าย หมึกเช็ดออกง่าย"},{"UUID":"962d0195-8af8-4d2d-a48c-484feaeb56b3","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ความเข้มในการพิมพ์ไม่สม่ำเสมอ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"ความเข้มในการพิมพ์ไม่สม่ำเสมอ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เปิดฝาปิด B แล้วตรวจสอบให้แน่ใจว่าลูกกลิ้งส่งกระดาษที่สองล็อคเข้าที่ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ความเข้มในการพิมพ์ไม่สม่ำเสมอ ความเข้มในการพิมพ์ไม่สม่ำเสมอ"},{"UUID":"4d1ad110-b8b2-42a8-bf75-81da866f37d7","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"เส้นสีเข้มแนวนอน ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"เส้นสีเข้มแนวนอน ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง หากเส้นสีเข้มแนวนอนยังคงปรากฏบนงานพิมพ์ ให้ดูที่  ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่ากระดาษไม่มีเนื้อผิวหยาบหรือเนื้อผิวไม่เรียบ ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ เส้นสีเข้มแนวนอน เส้นสีเข้มแนวนอน"},{"UUID":"d2beb98f-e795-4aa4-819e-b82f23046a62","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"เส้นสีเข้มแนวตั้ง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"เส้นสีเข้มแนวตั้ง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่ากระดาษไม่มีเนื้อผิวหยาบหรือเนื้อผิวไม่เรียบ ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ มีแถบเส้นสีเข้มแนวตั้งปรากฏในงานพิมพ์ เส้นสีเข้มแนวตั้งบนงานพิมพ์"},{"UUID":"e452fd2e-c01a-4d2f-96d4-c1bcc7bacdaf","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"เส้นสีขาวแนวนอน ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"เส้นสีขาวแนวนอน ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง หากเส้นสีขาวแนวนอนยังคงปรากฏบนงานพิมพ์ ให้ดูที่  ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ป้อนแหล่งกระดาษที่กำหนดด้วยประเภทกระดาษที่แนะนำ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ดรัมโฟโต้คอนดักเตอร์ถูกแสงโดยตรง การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ เส้นสีขาวแนวนอน เส้นสีขาวแนวนอน"},{"UUID":"a9592c0c-8a8b-49ed-bbc8-e6d79dc0dd06","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"เส้นสีขาวแนวตั้ง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"เส้นสีขาวแนวตั้ง ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไปในถาด คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบว่าคุณกำลังใช้ประเภทกระดาษที่แนะนำหรือไม่ ตรวจสอบว่าได้ป้อนแหล่งกระดาษที่กำหนดด้วยประเภทกระดาษที่แนะนำ ตรวจสอบให้แน่ใจว่าชุดสร้างภาพและชุดสร้างภาพขาวดำได้รับการติดตั้งอย่างเหมาะสม ถอดชุดสร้างภาพออก แล้วถอดชุดสร้างภาพขาวดำ อย่าให้ชุดสร้างภาพและชุดสร้างภาพขาวดำถูกแสงโดยตรงนานกว่า 10 นาที การรับแสงเป็นเวลานานอาจทำให้เกิดปัญหาคุณภาพการพิมพ์ได้ ห้ามสัมผัสกับลูกดรัมโฟโต้คอนดักเตอร์ใต้ชุดสร้างภาพและชุดสร้างภาพขาวดำ การกระทำดังกล่าวอาจส่งผลต่อคุณภาพของงานพิมพ์ในอนาคต ใส่ชุดสร้างภาพขาวดำ แล้วใส่ชุดสร้างภาพ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ เส้นสีขาวแนวตั้ง เส้นสีขาวแนวตั้ง"},{"UUID":"e77af116-d23e-4da4-a0fd-74c3703ea50b","title":"คุณภาพการพิมพ์ไม่ดี","link":"solving-printing-problems.html","desc":"ข้อบกพร่องที่เกิดซ้ำๆ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่","descFull":"ข้อบกพร่องที่เกิดซ้ำๆ ก่อนจะแก้ไขปัญหา ให้พิมพ์หน้าทดสอบคุณภาพการพิมพ์ จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ใช้ถาด 1 เพื่อพิมพ์หน้าตัวอย่างและตรวจสอบให้แน่ใจว่าได้ใส่กระดาษในแนวการพิมพ์แนวตั้ง ตรวจสอบจำนวนสีที่มีข้อบกพร่อง วัดระยะห่างระหว่างข้อบกพร่องที่เกิดซ้ำๆ บนหน้าสีที่ได้รับผลกระทบ ใช้ไม้บรรทัดระบุข้อบกพร่องเพื่อการดูแลรักษา เพื่อวัดระยะห่างระหว่างข้อบกพร่องที่เกิดซ้ำๆ บนหน้าสีที่ได้รับผลกระทบ เปลี่ยนรายการวัสดุสิ้นเปลืองหรือส่วนที่ตรงกับค่าที่วัดได้บนหน้าสีที่ได้รับผลกระทบ ชุดสร้างภาพสีหรือชุดสร้างภาพขาวดำ 94.5 มม. (3.72 นิ้ว) 19.9 มม. (1.18 นิ้ว) 23.2 มม. (0.19 นิ้ว) ชุดแม่เหล็กดึงหมึก 43.6 มม. (1.72 นิ้ว) 45.0 มม. (1.77 นิ้ว) ฟิวเซอร์ 95 มม. (3.74 นิ้ว) 110 มม. (4.33 นิ้ว) หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ข้อบกพร่องในงานพิมพ์ที่เกิดซ้ำๆ ข้อบกพร่องในงานพิมพ์ที่เกิดซ้ำๆ"},{"UUID":"12b1059f-5560-4e17-be89-2aea2c1a0196","title":"ปัญหาเกี่ยวกับการพิมพ์","link":"solving-printing-problems.html","desc":"งานพิมพ์ไม่พิมพ์ออกมา ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากเอกสารที่คุณกำลังพยายามพิมพ์ ให้เปิดค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ จากนั้นตรวจสอบว่าคุณเลือกเครื่องพิมพ์ที่ถูกต้องหรือไม่","descFull":"งานพิมพ์ไม่พิมพ์ออกมา ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากเอกสารที่คุณกำลังพยายามพิมพ์ ให้เปิดค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ จากนั้นตรวจสอบว่าคุณเลือกเครื่องพิมพ์ที่ถูกต้องหรือไม่ ตรวจสอบว่าเครื่องพิมพ์เปิดอยู่หรือไม่ แล้วแก้ไขปัญหาจากข้อความแจ้งข้อผิดพลาดใดๆ ที่ปรากฏบนส่วนแสดงผล ตรวจสอบว่าพอร์ตกำลังทำงานหรือไม่ และสายเคเบิลเชื่อมต่อกับคอมพิวเตอร์และเครื่องพิมพ์แน่นดีแล้วหรือไม่ หากต้องการข้อมูลเพิ่มเติม โปรดดูเอกสารประกอบการติดตั้งที่ให้มาพร้อมกับเครื่องพิมพ์ของคุณ ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ นำออก แล้วติดตั้งไดรเวอร์การพิมพ์ใหม่อีกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการพิมพ์ งานพิมพ์ไม่พิมพ์ออกมา ไม่พิมพ์งานพิมพ์ งานพิมพ์ไม่พิมพ์ออกมา"},{"UUID":"1c414be9-6a35-4aac-8010-f2df93baa00e","title":"ปัญหาเกี่ยวกับการพิมพ์","link":"solving-printing-problems.html","desc":"ไม่พิมพ์เอกสารที่เป็นความลับและเอกสารอื่นๆ ที่ระงับไว้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ให้ตรวจสอบว่ามีเอกสารปรากฏอยู่ในรายการ","descFull":"ไม่พิมพ์เอกสารที่เป็นความลับและเอกสารอื่นๆ ที่ระงับไว้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ให้ตรวจสอบว่ามีเอกสารปรากฏอยู่ในรายการ  งานที่ระงับไว้  หรือไม่ ถ้าไม่มีเอกสารในรายการ ให้พิมพ์เอกสารโดยใช้ตัวเลือกพิมพ์และระงับ แก้ไขข้อผิดพลาดการจัดรูปแบบที่เป็นไปได้หรือข้อมูลที่ไม่ถูกต้องในงานพิมพ์ ลบงานพิมพ์แล้วส่งอีกครั้ง สำหรับไฟล์ PDF ให้สร้างไฟล์ใหม่แล้วพิมพ์เอกสาร หากคุณกำลังพิมพ์จากอินเตอร์เน็ต เครื่องพิมพ์อาจอ่านชื่องานหลายรายการซ้ำกัน สำหรับผู้ใช้ Windows ตรวจสอบให้แน่ใจว่าได้เลือก  เก็บเอกสารที่ซ้ำกัน ในค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ สำหรับผู้ใช้ Macintosh ให้ตั้งชื่องานแต่ละรายการ ลบงานที่ระงับไว้บางงานเพื่อเพิ่มหน่วยความจำเครื่องพิมพ์ ติดตั้งหน่วยความจำของเครื่องพิมพ์เพิ่มเติม หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ ไม่พิมพ์เอกสารที่เป็นความลับและเอกสารอื่นๆ ที่ระงับไว้ ไม่พิมพ์เอกสารที่เป็นความลับ ไม่ต้องพิมพ์เอกสารที่ระงับไว้"},{"UUID":"48c0b9cc-c201-4a2e-9fbc-74d189123d66","title":"ปัญหาเกี่ยวกับการพิมพ์","link":"solving-printing-problems.html","desc":"งานพิมพ์จากถาดที่ไม่ถูกต้องหรือบนกระดาษที่ไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าคุณกำลังพิมพ์งานบนกระดาษที่ถูกต้อง ให้ระบุขนาดของกระดาษและประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ","descFull":"งานพิมพ์จากถาดที่ไม่ถูกต้องหรือบนกระดาษที่ไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าคุณกำลังพิมพ์งานบนกระดาษที่ถูกต้อง ให้ระบุขนาดของกระดาษและประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบว่าถาดเชื่อมโยงกันแล้วหรือไม่ โปรดดูข้อมูลเพิ่มเติมที่  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการพิมพ์ งานพิมพ์จากถาดที่ไม่ถูกต้อง ปัญหาการพิมพ์ งานพิมพ์บนกระดาษที่ไม่ถูกต้อง งานพิมพ์จากถาดที่ไม่ถูกต้อง งานพิมพ์บนกระดาษที่ไม่ถูกต้อง"},{"UUID":"979d3bbc-41da-46df-b3e0-d4b11f3d77e2","title":"ปัญหาเกี่ยวกับการพิมพ์","link":"solving-printing-problems.html","desc":"การพิมพ์ช้า ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าสายเคเบิลของเครื่องพิมพ์เชื่อมต่อกับเครื่องพิมพ์ คอมพิวเตอร์ เซิร์ฟเวอร์พิมพ์","descFull":"การพิมพ์ช้า ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าสายเคเบิลของเครื่องพิมพ์เชื่อมต่อกับเครื่องพิมพ์ คอมพิวเตอร์ เซิร์ฟเวอร์พิมพ์ ตัวเลือก และอุปกรณ์เครือข่ายอื่นๆ อย่างแน่นดีแล้ว ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์ไม่อยู่ใน  โหมดเงียบ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การทำงานของอุปกรณ์ โหมดเงียบ ระบุความละเอียดของเอกสารที่คุณต้องการพิมพ์ เข้าถึงค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตั้งให้ความละเอียดเป็น  4800 CQ คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมได้เช่นกัน ไปที่  การตั้งค่า พิมพ์ คุณภาพ ความละเอียดในการพิมพ์ ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ กระดาษที่หนากว่าจะพิมพ์ได้ช้ากว่านี้ กระดาษที่แคบกว่าขนาดจดหมาย, A4 และ Legal อาจพิมพ์ได้ช้ากว่า ตรวจสอบให้แน่ใจว่าการตั้งค่าเครื่องพิมพ์สำหรับพื้นผิวและน้ำหนักตรงกับกระดาษที่ป้อน จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าวัสดุพิมพ์ ประเภทวัสดุพิมพ์ พื้นผิวกระดาษแบบหยาบและกระดาษหนาอาจทำให้พิมพ์ช้าลง นำงานที่ระงับไว้ออก ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์ไม่ร้อนเกิน ให้เครื่องพิมพ์เย็นลงหลังจากพิมพ์งานเป็นเวลานาน ตรวจสอบอุณหภูมิแวดล้อมที่แนะนำสำหรับเครื่องพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการพิมพ์ การพิมพ์ช้า การพิมพ์ช้า"},{"UUID":"f96fc4f2-4903-4274-9a0a-9250db285996","title":"การแก้ไขปัญหา","link":"trb-printer-not-responding-topic.html","desc":"เครื่องพิมพ์ไม่ตอบสนอง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าได้เสียบสายไฟเข้ากับเต้าเสียบหรือไม่ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย","descFull":"เครื่องพิมพ์ไม่ตอบสนอง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าได้เสียบสายไฟเข้ากับเต้าเสียบหรือไม่ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย ตรวจสอบว่าไม่มีการปิดเต้าเสียบไฟด้วยสวิตช์หรือเบรกเกอร์หรือไม่ ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เปิดอยู่ ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์ไม่อยู่ในโหมดพักเครื่อง หรือโหมดไฮเบอร์เนต ตรวจสอบว่ามีการต่อสายเคเบิลที่เชื่อมต่อเครื่องพิมพ์และคอมพิวเตอร์เข้ากับพอร์ตที่ถูกต้อง ปิดเครื่องพิมพ์ ติดตั้งตัวเลือกฮาร์ดแวร์แล้วเปิดเครื่องพิมพ์ หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับตัวเลือก ติดตั้งไดรเวอร์การพิมพ์ที่ถูกต้อง ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการพิมพ์ เครื่องพิมพ์ไม่ตอบสนอง เครื่องพิมพ์ไม่ตอบสนอง"},{"UUID":"13e98367-0684-43b8-b409-fd16df992d2e","title":"การแก้ไขปัญหา","link":"trb-unable-to-read-flash-drive-topic.html","desc":"ไม่สามารถอ่านแฟลชไดรฟ์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์ไม่ได้กำลังประมวลผลงานหลายงาน ตรวจสอบว่าได้เสียบแฟลชไดรฟ์เข้ากับพอร์ต USB","descFull":"ไม่สามารถอ่านแฟลชไดรฟ์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์ไม่ได้กำลังประมวลผลงานหลายงาน ตรวจสอบว่าได้เสียบแฟลชไดรฟ์เข้ากับพอร์ต USB ด้านหน้า แฟลชไดรฟ์ไม่ทำงานเมื่อเสียบเข้ากับพอร์ต USB ด้านหลัง ตรวจสอบว่าเครื่องรองรับแฟลชไดรฟ์ โปรดดูข้อมูลเพิ่มเติมที่  นำออก แล้วเสียบแฟลชไดรฟ์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ไม่สามารถอ่านแฟลชไดรฟ์ได้ ปัญหาการพิมพ์ ไม่สามารถอ่านแฟลชไดรฟ์ได้"},{"UUID":"d9c9ee20-9dd5-45d9-a5c5-2581e5ef4f5f","title":"การแก้ไขปัญหา","link":"enabling-usb-port-topic.html","desc":"การเปิดใช้งานพอร์ต USB จากแผงควบคุม ไปที่ ","descFull":"การเปิดใช้งานพอร์ต USB จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต USB เลือก เปิดใช้งานพอร์ต USB พอร์ต USB การเปิดใช้งาน การเปิดใช้งานพอร์ต USB การตั้งค่าพอร์ต USB"},{"UUID":"dd58ec8a-1f1c-443e-99cc-2a9a1dbd9f9e","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"การหลีกเลี่ยงปัญหากระดาษติด ป้อนกระดาษอย่างถูกต้อง ตรวจสอบให้แน่ใจว่ากระดาษวางราบอยู่ในถาด การป้อนกระดาษที่ถูกต้องและไม่ถูกต้อง การป้อนกระดาษที่ถูกต้อง","descFull":"การหลีกเลี่ยงปัญหากระดาษติด ป้อนกระดาษอย่างถูกต้อง ตรวจสอบให้แน่ใจว่ากระดาษวางราบอยู่ในถาด การป้อนกระดาษที่ถูกต้องและไม่ถูกต้อง การป้อนกระดาษที่ถูกต้อง การป้อนกระดาษไม่ถูกต้อง อย่าใส่หรือถอดถาดขณะที่เครื่องพิมพ์กำลังพิมพ์ อย่าป้อนกระดาษมากเกินไป ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด อย่าเลื่อนกระดาษเข้าไปในถาด ป้อนกระดาษตามที่แสดงในภาพ ตรวจสอบให้แน่ใจว่าตัวนำกระดาษอยู่ในตำแหน่งที่ถูกต้อง และไม่ได้กดให้แนบจนแน่นเกินไปกับกระดาษหรือซองจดหมาย ดันถาดเข้าไปในเครื่องพิมพ์ให้แน่นหลังจากป้อนกระดาษ ใช้กระดาษที่แนะนำ ใช้กระดาษหรือวัสดุพิมพ์ชนิดพิเศษที่แนะนำเท่านั้น อย่าป้อนกระดาษที่ยับ มีรอยพับ ชื้น งอหรือม้วนงอ งอ คลี่และจัดแนวขอบกระดาษก่อนป้อนกระดาษ ห้ามใช้กระดาษที่ถูกตัดหรือเล็มด้วยมือ อย่าป้อนกระดาษที่มีขนาด น้ำหนัก หรือประเภทมากกว่าหนึ่งชนิดเข้าไปในถาดเดียวกัน ตรวจสอบให้แน่ใจว่าตั้งค่าขนาดและประเภทกระดาษอย่างถูกต้องบนคอมพิวเตอร์หรือแผงควบคุมของเครื่องพิมพ์ จัดเก็บกระดาษตามคำแนะนำของผู้ผลิต กระดาษติด การหลีกเลี่ยง ติด, กระดาษ การหลีกเลี่ยง หลีกเลี่ยงไม่ให้กระดาษติด"},{"UUID":"9bc3c605-3d40-4c18-acfc-3a5f7f138c73","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"การระบุตำแหน่งที่กระดาษติด เมื่อตั้งให้  ตัวช่วยเมื่อมีกระดาษติด ","descFull":"การระบุตำแหน่งที่กระดาษติด เมื่อตั้งให้  ตัวช่วยเมื่อมีกระดาษติด  เป็น  เปิด  เครื่องพิมพ์จะล้างหน้าว่าง หรือหน้าที่พิมพ์บางส่วนออกหลังจากที่นำกระดาษที่ติดออก ตรวจสอบงานพิมพ์ของคุณว่ามีหน้าว่างหรือไม่ เมื่อตั้งให้  การกู้คืนกระดาษติด  เป็น  เปิด  หรือ  อัตโนมัติ  เครื่องพิมพ์จะพิมพ์หน้าที่ติดอีกครั้ง ตำแหน่งที่กระดาษติด ตำแหน่งที่กระดาษติด 1 ฝาปิด B 2 ตัวป้อนกระดาษอเนกประสงค์ 3 ถาดมาตรฐาน 4 ถาดมาตรฐาน 5 ตัวป้อนเอกสารอัตโนมัติ 6 อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ 7 ถาดเสริม 550 แผ่น 8 ถาด 550 แผ่น 2 ถาด 9 ถาด 1500 แผ่น 10 อุปกรณ์เย็บเล่มตอกรู 11 อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ 12 ถาดบรรจุคู่ 2000 แผ่น 13 อุปกรณ์เย็บเล่ม กระดาษติด การค้นหา ตำแหน่งที่กระดาษติด การระบุ"},{"UUID":"026452b1-a6e2-46fd-83f1-31ea85a701d0","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาดกระดาษมาตรฐาน กระดาษติดในถาดกระดาษมาตรฐาน ดึงถาดกระดาษมาตรฐานออกมา นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว","descFull":"กระดาษติดในถาดกระดาษมาตรฐาน กระดาษติดในถาดกระดาษมาตรฐาน ดึงถาดกระดาษมาตรฐานออกมา นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ใส่ถาดกระดาษ การแก้ไขกระดาษติด ในถาดมาตรฐาน การนำกระดาษที่ติดออก ในถาดมาตรฐาน กระดาษติดในถาดกระดาษมาตรฐาน"},{"UUID":"293d79ba-525c-4b99-82aa-643d9e055e1e","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาดเสริม 550 แผ่น เปิดฝาปิด D","descFull":"กระดาษติดในถาดเสริม 550 แผ่น เปิดฝาปิด D นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝา ดึงถาดเสริม 550 แผ่นออก นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ใส่ถาดกระดาษ การแก้ไขกระดาษติด ในถาด 550 แผ่น การนำกระดาษที่ติดออก ในถาด 550 แผ่น กระดาษติดในถาด 550 แผ่น"},{"UUID":"a2ed0444-e076-467f-b30e-d062c3b006d4","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในตัวป้อนเอกสารอัตโนมัติ กระดาษติดในฝา A เปิดฝาปิด A","descFull":"กระดาษติดในตัวป้อนเอกสารอัตโนมัติ กระดาษติดในฝา A เปิดฝาปิด A นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด A กระดาษติดในฝาปิด A1 เปิดฝาครอบสแกนเนอร์ กดสลักสีเขียวเพื่อเปิดฝา A1 หมุนปุ่มสีเขียวใกล้ฝา A1 ไปทางขวา แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝา A1 แล้วปิดฝาครอบสแกนเนอร์ กระดาษติดในถาดตัวป้อนเอกสารอัตโนมัติ นำกระดาษออกจากถาดตัวป้อนเอกสารอัตโนมัติ นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว การแก้ไขกระดาษติด ในตัวป้อนเอกสารอัตโนมัติ กระดาษติด ในตัวป้อนเอกสารอัตโนมัติ การนำกระดาษที่ติดออก ในตัวป้อนเอกสารอัตโนมัติ"},{"UUID":"c2801f17-9583-4f08-93dd-9b4ce2a49d3e","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดขัดในตัวป้อนกระดาษอเนกประสงค์ นำกระดาษออกจากตัวป้อนกระดาษอเนกประสงค์ นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว การแก้ไขกระดาษติด","descFull":"กระดาษติดขัดในตัวป้อนกระดาษอเนกประสงค์ นำกระดาษออกจากตัวป้อนกระดาษอเนกประสงค์ นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว การแก้ไขกระดาษติด ในตัวป้อนกระดาษอเนกประสงค์ การนำกระดาษที่ติดออก ในตัวป้อนกระดาษอเนกประสงค์ กระดาษติดในตัวป้อนกระดาษอเนกประสงค์"},{"UUID":"11efc191-8420-4b6d-915c-6dc40b0a80f8","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาด 550 แผ่น 2 ถาด","descFull":"กระดาษติดในถาด 550 แผ่น 2 ถาด เปิดฝาปิด E นำกระดาษที่ติดอยู่ภายในฝาปิด E ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด E ดึงถาด 3 ออก นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ใส่ถาด 3 ทำซ้ำ ขั้นตอนที่ 4  จนถึง ขั้นตอนที่ 6  สำหรับถาด 4 การแก้ไขกระดาษติด ถาด 550 แผ่น 2 ถาด การนำกระดาษที่ติดออก ถาด 550 แผ่น 2 ถาด กระดาษติด ถาด 550 แผ่น 2 ถาด"},{"UUID":"5fc8979a-b086-41d3-aaf6-43ee63fca4af","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาดบรรจุคู่ 2000 แผ่น เปิดฝาปิด E","descFull":"กระดาษติดในถาดบรรจุคู่ 2000 แผ่น เปิดฝาปิด E นำกระดาษที่ติดอยู่ภายในฝาปิด E ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด E การแก้ไขกระดาษติด ในถาดบรรจุคู่ 2000 แผ่น การนำกระดาษที่ติดออก ในถาดบรรจุคู่ 2000 แผ่น กระดาษติด ในถาด 2000 แผ่น"},{"UUID":"3798e6be-89c3-4266-9f0c-ac0c3b0aeaaf","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาด 1500 แผ่น เปิดฝาปิด K","descFull":"กระดาษติดในถาด 1500 แผ่น เปิดฝาปิด K นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด K จับที่จับ J แล้วเลื่อนถาดไปทางขวา นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เลื่อนถาดกลับเข้าที่ การแก้ไขกระดาษติด ในถาด 1500 แผ่น การนำกระดาษที่ติดออก ในถาด 1500 แผ่น กระดาษติด ในถาด 1500 แผ่น"},{"UUID":"01c0eaec-75f2-4e6b-a91e-570fe0514f41","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในฝาปิด B เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน","descFull":"กระดาษติดในฝาปิด B เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน เพื่อลดความเสี่ยงต่อการบาดเจ็บจากชิ้นส่วนที่ร้อน ควรปล่อยให้พื้นผิวเย็นลงก่อนสัมผัส เพื่อป้องกันความเสียหายจากการคายประจุไฟฟ้าสถิต ให้สัมผัสกรอบโลหะของเครื่องพิมพ์ก่อนเข้าถึงหรือสัมผัสกับบริเวณภายในของเครื่องพิมพ์ นำกระดาษที่ติดในบริเวณใดๆ ต่อไปนี้ออก: ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เหนือฟิวเซอร์ ในฟิวเซอร์ ข้างใต้ฟิวเซอร์ ใต้ลูกกลิ้งทางออกถาดมาตรฐาน ในอุปกรณ์สำหรับการพิมพ์สองด้าน ปิดฝาปิด B กระดาษติดในฝาปิด B กระดาษติดในฟิวเซอร์ กระดาษติดในอุปกรณ์สำหรับการพิมพ์สองด้าน การแก้ไขกระดาษติด ในฟิวเซอร์ การแก้ไขกระดาษติด ในอุปกรณ์สำหรับการพิมพ์สองด้าน การนำกระดาษที่ติดออก ในฟิวเซอร์ การนำกระดาษที่ติดออก ในอุปกรณ์สำหรับการพิมพ์สองด้าน"},{"UUID":"7c98b9de-2eaa-4fcc-86c6-5704fbddd849","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในถาดมาตรฐาน นำกระดาษออกจากถาดมาตรฐาน นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว การแก้ไขกระดาษติด","descFull":"กระดาษติดในถาดมาตรฐาน นำกระดาษออกจากถาดมาตรฐาน นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว การแก้ไขกระดาษติด ในถาดมาตรฐาน การนำกระดาษที่ติดออก ในถาดมาตรฐาน กระดาษติดในถาดมาตรฐาน"},{"UUID":"9a125720-dfb3-44f3-bc35-8c84a65f8d65","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ นำกระดาษที่ติดในถาดอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว จับที่จับ F","descFull":"กระดาษติดในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ นำกระดาษที่ติดในถาดอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว จับที่จับ F แล้วเลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บไปทางซ้าย เปิดฝาปิด R1 แล้วหมุนปุ่ม R2 ไปในทิศทางตามเข็มนาฬิกา นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด R1 นำกระดาษที่ติดในลูกกลิ้งทางออกถาดมาตรฐานออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เลื่อนอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บกลับเข้าที่ การแก้ไขกระดาษติด ในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ การนำกระดาษที่ติดออก ในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ กระดาษติด ในอุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ"},{"UUID":"e6a79274-6c2e-49dc-9d2d-6ab54f7dfea9","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด F","descFull":"กระดาษติดในอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด F ยกที่จับ N4 ขึ้น ยกที่จับ N5 ขึ้น นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดที่จับ N5 แล้วปิดที่จับ N4 ดันที่จับ N1 ลง หมุนปุ่ม N2 ไปในทิศทางทวนเข็มนาฬิกา นำกระดาษที่ติดออก เพื่อป้องกันไม่ให้เกิดความเสียหายกับเครื่องพิมพ์ ให้ถอดอุปกรณ์เสริมใด ๆ ออกก่อนจะนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ดันที่จับ N1 กลับเข้าที่ ปิดฝาปิด F การแก้ไขกระดาษติด ในอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ การนำกระดาษที่ติดออก ในอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ กระดาษติด ในอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ"},{"UUID":"0f2bcec3-9ff5-428e-a5e7-fc1045b5e22a","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในอุปกรณ์เย็บเล่มตอกรู หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาด 1","descFull":"กระดาษติดในอุปกรณ์เย็บเล่มตอกรู หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว อย่านำหน้ากระดาษที่พิมพ์ซึ่งอยู่ในเครื่องเย็บเล่มออกเพื่อหลีกเลี่ยงไม่ให้มีหน้าที่ขาดหาย นำกระดาษที่ติดในถาดมาตรฐานของอุปกรณ์เย็บเล่มออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 2 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาครอบอุปกรณ์ส่งกระดาษ G แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาครอบอุปกรณ์ส่งกระดาษ G เปิดปิด l เปิดฝาปิด R1 แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด R1 แล้วปิดฝาปิด l เปิดฝาครอบอุปกรณ์ส่งกระดาษ F เปิดฝาปิด H ยกที่จับ R4 ขึ้น หมุนปุ่ม R3 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว หมุนปุ่ม R2 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดในฝาครอบอุปกรณ์ส่งกระดาษ F ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาครอบอุปกรณ์ส่งกระดาษ F หมุนที่จับ R4 กลับไปยังตำแหน่งเริ่มต้น ปิดฝาปิด H หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว อย่านำหน้ากระดาษที่พิมพ์ซึ่งอยู่ในเครื่องเย็บเล่มออกเพื่อหลีกเลี่ยงไม่ให้มีหน้าที่ขาดหาย นำกระดาษที่ติดในถาดมาตรฐานของอุปกรณ์เย็บเล่มออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 2 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด F เปิดฝาปิด N4 เปิดฝาปิด N5 เปิดฝาปิด H ยกที่จับ R4 ขึ้น หมุนปุ่ม R3 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว หมุนปุ่ม R2 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดระหว่างฝาปิด N4 กับ N5 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน เพื่อลดความเสี่ยงต่อการบาดเจ็บจากชิ้นส่วนที่ร้อน ควรปล่อยให้พื้นผิวเย็นลงก่อนสัมผัส เพื่อป้องกันความเสียหายจากการคายประจุไฟฟ้าสถิต ให้สัมผัสกรอบโลหะของเครื่องพิมพ์ก่อนเข้าถึงหรือสัมผัสกับบริเวณภายในของเครื่องพิมพ์ นำกระดาษที่ติดภายใต้ลูกกลิ้งทางออกถาดมาตรฐานออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด B ดันที่จับ N1 ลง หมุนปุ่ม N2 ไปในทิศทางทวนเข็มนาฬิกา นำกระดาษที่ติดออก เพื่อป้องกันไม่ให้เกิดความเสียหายกับเครื่องพิมพ์ ให้ถอดอุปกรณ์เสริมใด ๆ ออกก่อนจะนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ดันที่จับ N1 กลับเข้าที่ ปิดที่จับ N5 แล้วปิดที่จับ N4 ปิดฝาปิด F หมุนที่จับ R4 กลับไปยังตำแหน่งเริ่มต้น ปิดฝาปิด H การแก้ไขกระดาษติด ในอุปกรณ์เย็บเล่มตอกรู การนำกระดาษที่ติดออก ในอุปกรณ์เย็บเล่มตอกรู กระดาษติดในอุปกรณ์เย็บเล่มแบบตอกลวดเย็บ"},{"UUID":"1a63b33d-ca1f-4ee1-a862-f08d1f536605","title":"การแก้ไขกระดาษติด","link":"clearing-jams.html","desc":"กระดาษติดในอุปกรณ์เย็บเล่ม หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาดมาตรฐานของอุปกรณ์เย็บเล่มออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว","descFull":"กระดาษติดในอุปกรณ์เย็บเล่ม หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาดมาตรฐานของอุปกรณ์เย็บเล่มออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว อย่านำหน้ากระดาษที่พิมพ์ซึ่งอยู่ในเครื่องเย็บเล่มออกเพื่อหลีกเลี่ยงไม่ให้มีหน้าที่ขาดหาย นำกระดาษที่ติดในถาด 3 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาครอบอุปกรณ์ส่งกระดาษ G แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาครอบอุปกรณ์ส่งกระดาษ G เปิดฝาครอบอุปกรณ์ส่งกระดาษ F เปิดฝาปิด H ย้ายที่จับ R3 ไปทางขวา แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ย้ายที่จับ R1 ไปทางซ้าย หมุนปุ่ม R2 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว หมุนปุ่ม R5 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดออกจากถาดมาตรฐานของอุปกรณ์เย็บเล่ม ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ยกที่จับ R4 ขึ้น หมุนปุ่ม R2 ไปในทิศทางตามเข็มนาฬิกา แล้วนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาครอบอุปกรณ์ส่งกระดาษ F หมุนที่จับ R1, R3 และ R4 กลับไปยังตำแหน่งเริ่มต้น ปิดฝาปิด H หากเครื่องพิมพ์ของคุณถูกกำหนดค่าด้วยอุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ ให้ดำเนินการต่อไปนี้: นำกระดาษที่ติดในถาดมาตรฐานของอุปกรณ์เย็บเล่มออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว นำกระดาษที่ติดในถาด 1 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว อย่านำหน้ากระดาษที่พิมพ์ซึ่งอยู่ในเครื่องเย็บเล่มออกเพื่อหลีกเลี่ยงไม่ให้มีหน้าที่ขาดหาย นำกระดาษที่ติดในถาด 3 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด F เปิดฝาปิด H เปิดฝาปิด N4 เปิดฝาปิด N5 ยกที่จับ R4 ขึ้น หมุนปุ่ม R2 ไปในทิศทางตามเข็มนาฬิกา แล้วนำกระดาษที่ติดในที่จับ R4 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ย้ายที่จับ R1 ไปทางซ้าย หมุนปุ่ม R2 ไปในทิศทางทวนเข็มนาฬิกา แล้วนำกระดาษที่ติดระหว่างฝาปิด N4 และ N5 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด B ด้านในของเครื่องพิมพ์อาจร้อน เพื่อลดความเสี่ยงต่อการบาดเจ็บจากชิ้นส่วนที่ร้อน ควรปล่อยให้พื้นผิวเย็นลงก่อนสัมผัส เพื่อป้องกันความเสียหายจากการคายประจุไฟฟ้าสถิต ให้สัมผัสกรอบโลหะของเครื่องพิมพ์ก่อนเข้าถึงหรือสัมผัสกับบริเวณภายในของเครื่องพิมพ์ นำกระดาษที่ติดภายใต้ลูกกลิ้งทางออกถาดมาตรฐานออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด B ดันที่จับ N1 ลง หมุนปุ่ม N2 ไปในทิศทางทวนเข็มนาฬิกา นำกระดาษที่ติดออก เพื่อป้องกันไม่ให้เกิดความเสียหายกับเครื่องพิมพ์ ให้ถอดอุปกรณ์เสริมใด ๆ ออกก่อนจะนำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ดันที่จับ N1 กลับเข้าที่ ปิดฝาปิด N5 แล้วปิดฝาปิด N4 ปิดฝาปิด F หมุนที่จับ R1 และ R4 กลับไปยังตำแหน่งเริ่มต้น ปิดฝาปิด H กระดาษติดในตัวทำ Booklet นำกระดาษที่ติดในถาด 2 ออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว เปิดฝาปิด H หมุน R6, R11 และ R10 ไปในทิศทางตามเข็มนาฬิกา ดึงตัวทำ Booklet ออก นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว หมุน R9 ไปในทิศทางทวนเข็มนาฬิกาจนกระทั่งหยุด เปิดฝาปิด R8 นำกระดาษที่ติดออก ตรวจสอบให้แน่ใจว่าได้นำเศษกระดาษออกจนหมดแล้ว ปิดฝาปิด R8 หมุนตัวทำ Booklet เข้าไปยังอุปกรณ์เย็บเล่ม ปิดฝาปิด H การแก้ไขกระดาษติด ในอุปกรณ์เย็บเล่ม การนำกระดาษที่ติดออก ในอุปกรณ์เย็บเล่ม กระดาษติดในอุปกรณ์เย็บเล่ม"},{"UUID":"402ea0c4-3265-47f8-bca5-0d1ed7ba4def","title":"ปัญหาการเชื่อมต่อเครือข่าย","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"ไม่สามารถเปิด Embedded Web Server ไม่สามารถเปิด","descFull":"ไม่สามารถเปิด Embedded Web Server ไม่สามารถเปิด Embedded Web Server ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เปิดอยู่ ตรวจสอบให้แน่ใจว่า IP แอดเดรสของเครื่องพิมพ์ถูกต้อง ดู IP แอดเดรสบนแผงควบคุม IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 ตรวจสอบว่าคุณติดตั้งเบราว์เซอร์ที่รองรับ Internet Explorer เวอร์ชัน 11 หรือใหม่กว่า Microsoft Edge Safari เวอร์ชัน 6 หรือใหม่กว่า Google Chrome  เวอร์ชัน 32 หรือใหม่กว่า Mozilla Firefox เวอร์ชัน 24 หรือใหม่กว่า ตรวจสอบว่าการเชื่อมต่อเครือข่ายใช้งานได้หรือไม่ หากไม่สามารถเชื่อมต่อได้ โปรดติดต่อผู้ดูแลระบบของคุณ ตรวจสอบให้แน่ใจว่าสายเคเบิลที่เชื่อมต่อกับเครื่องพิมพ์และเซิร์ฟเวอร์พิมพ์แน่นดีแล้ว หากต้องการข้อมูลเพิ่มเติม โปรดดูในเอกสารที่ให้มาพร้อมกับเซิร์ฟเวอร์พิมพ์ ตรวจสอบว่าพร็อกซีเซิร์ฟเวอร์สำหรับเว็บปิดใช้งานอยู่หรือไม่ หากปิดใช้งานเซิร์ฟเวอร์ โปรดติดต่อผู้ดูแลระบบของคุณ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ไม่สามารถเปิด Embedded Web Server การแก้ไขปัญหา ไม่สามารถเปิด Embedded Web Server"},{"UUID":"43be0472-4497-47ed-8742-508076366e86","title":"ปัญหาการเชื่อมต่อเครือข่าย","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"ไม่สามารถเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ไม่สามารถเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้:","descFull":"ไม่สามารถเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ไม่สามารถเชื่อมต่อเครื่องพิมพ์เข้ากับเครือข่าย Wi-Fi ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต ภาพรวมเครือข่าย อะแดปเตอร์ที่ใช้งาน  แล้วเลือก  อัตโนมัติ ตรวจสอบให้แน่ใจว่าคอมพิวเตอร์เชื่อมต่อเข้ากับเครือข่าย Wi‑Fi ที่ถูกต้องแล้ว โปรดดูข้อมูลเพิ่มเติมที่  เราเตอร์บางตัวอาจใช้ชื่อ Wi‑Fi เริ่มต้นร่วมกัน ตรวจสอบให้แน่ใจว่าคุณป้อนรหัสผ่านเครือข่ายที่ถูกต้อง ใส่ใจในช่องว่าง ตัวเลข และตัวพิมพ์ใหญ่ในรหัสผ่าน ตรวจสอบว่าได้เลือกโหมดการรักษาความปลอดภัยไร้สายถูกต้องแล้วใช่หรือไม่ จากแผงควบคุม ไปที่  การตั้งค่า เครือข่าย/พอร์ต แบบไร้สาย โหมดรักษาความปลอดภัยไร้สาย หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ไม่สามารถเชื่อมต่อเครื่องพิมพ์กับ Wi-Fi ได้ การแก้ไขปัญหา ไม่สามารถเชื่อมต่อเครื่องพิมพ์กับ Wi-Fi ได้"},{"UUID":"9daa9095-4774-4093-9aa6-66e75eacb140","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์","link":"trb-cannot-detect-internal-option-topic.html","desc":"ไม่พบตัวเลือกภายใน ไม่พบตัวเลือกภายใน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปิดเครื่องพิมพ์ รอประมาณ","descFull":"ไม่พบตัวเลือกภายใน ไม่พบตัวเลือกภายใน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ พิมพ์ หน้าการตั้งค่าเมนู  แล้วตรวจสอบว่ามีตัวเลือกภายในปรากฏอยู่ในรายการคุณสมบัติที่ติดตั้งหรือไม่ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน หน้าการตั้งค่าเมนู ตรวจสอบว่าติดตั้งตัวเลือกภายในลงในบอร์ดตัวควบคุมอย่างถูกต้องหรือไม่ ปิดเครื่องพิมพ์ และถอดปลั๊กสายไฟออกจากเต้าเสียบ ตรวจสอบให้แน่ใจว่าตัวเลือกภายในได้รับการติดตั้งในจุดเชื่อมต่อที่เหมาะสมในบอร์ดตัวควบคุมแล้ว เชื่อมต่อสายไฟเข้ากับเต้าเสียบ แล้วจึงเปิดเครื่องพิมพ์ เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดไฟไหม้หรือไฟฟ้าช็อต เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย ตรวจสอบว่ามีตัวเลือกภายในอยู่ในไดรเวอร์การพิมพ์หรือไม่ หากจำเป็น ให้เพิ่มตัวเลือกภายในในไดรเวอร์การพิมพ์ด้วยตนเอง เพื่อให้สามารถใช้งานสำหรับงานพิมพ์ได้ โปรดดูข้อมูลเพิ่มเติมที่  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์ ไม่พบตัวเลือกภายใน ไม่พบตัวเลือกภายใน ไม่พบตัวเลือกภายใน"},{"UUID":"5d89788f-402f-404e-9578-26a8197dcfec","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์","link":"trb-cannot-detect-internal-option-topic.html","desc":"พอร์ตโซลูชันภายในทำงานไม่ถูกต้อง พอร์ตโซลูชันภายในทำงานไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: พิมพ์ หน้าการตั้งค่าเมนู","descFull":"พอร์ตโซลูชันภายในทำงานไม่ถูกต้อง พอร์ตโซลูชันภายในทำงานไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: พิมพ์ หน้าการตั้งค่าเมนู  แล้วตรวจสอบว่าพอร์ตโซลูชันภายใน (ISP) ปรากฏอยู่ในรายการคุณสมบัติที่ติดตั้งหรือไม่ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน หน้าการตั้งค่าเมนู นำออกแล้วติดตั้ง ISP ใหม่ โปรดดูข้อมูลเพิ่มเติมที่  ตรวจสอบสายเคเบิลและการเชื่อมต่อ ISP ใช้สายเคเบิลที่ถูกต้องและตรวจสอบให้แน่ใจว่าต่อสายเคเบิลเข้ากับ ISP อย่างแน่นดีแล้ว ตรวจสอบว่าสายอินเตอร์เฟซโซลูชันของ ISP ต่อเข้ากับช่องต่อของบอร์ดตัวควบคุมอย่างแน่นดีแล้วหรือไม่ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ การแก้ไขปัญหา พอร์ตโซลูชันภายใน ปัญหาตัวเลือกเครื่องพิมพ์ พอร์ตโซลูชันภายใน พอร์ตโซลูชันภายในทำงานไม่ถูกต้อง"},{"UUID":"84eb4464-6056-4450-8ea7-5b3e56bc0dde","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์","link":"trb-cannot-detect-internal-option-topic.html","desc":"การ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมทำงานไม่ถูกต้อง การ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมทำงานไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: พิมพ์ หน้าการตั้งค่าเมนู","descFull":"การ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมทำงานไม่ถูกต้อง การ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมทำงานไม่ถูกต้อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: พิมพ์ หน้าการตั้งค่าเมนู  แล้วตรวจสอบว่าการ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมปรากฏอยู่ในรายการคุณสมบัติที่ติดตั้งหรือไม่ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน หน้าการตั้งค่าเมนู ถอด แล้วติดตั้งการ์ดอินเตอร์เฟซแบบขนานหรืออนุกรมอีกครั้ง โปรดดูข้อมูลเพิ่มเติมที่  ตรวจสอบการเชื่อมต่อระหว่างสายเคเบิลและการ์ดอินเตอร์เฟซแบบขนานหรืออนุกรม หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาตัวเลือกเครื่องพิมพ์ การ์ดอินเตอร์เฟซแบบขนาน ปัญหาตัวเลือกเครื่องพิมพ์ การ์ดอินเตอร์เฟซแบบอนุกรม การแก้ไขปัญหา การ์ดอินเตอร์เฟซแบบขนาน การแก้ไขปัญหา การ์ดอินเตอร์เฟซแบบอนุกรม"},{"UUID":"2c4c4477-f6b6-4139-bf43-3075ee7e1bb8","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์","link":"trb-cannot-detect-internal-option-topic.html","desc":"ตรวจพบแฟลชที่มีข้อบกพร่อง ตรวจพบแฟลชที่มีข้อบกพร่อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เปลี่ยนหน่วยความจำแฟลชที่มีข้อบกพร่อง เลือก","descFull":"ตรวจพบแฟลชที่มีข้อบกพร่อง ตรวจพบแฟลชที่มีข้อบกพร่อง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เปลี่ยนหน่วยความจำแฟลชที่มีข้อบกพร่อง เลือก  ดำเนินการต่อ  เพื่อละเว้นข้อความและทำการพิมพ์ต่อ ยกเลิกงานพิมพ์ปัจจุบัน ข้อความเกี่ยวกับเครื่องพิมพ์ ตรวจพบแฟลชที่มีข้อบกพร่อง หน่วยความจำแฟลชที่มีข้อบกพร่อง การแก้ไขปัญหา หน่วยความจำแฟลชที่มีข้อบกพร่อง"},{"UUID":"9a825e9c-1ff1-4091-9d5e-c9dd2d03b729","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์","link":"trb-cannot-detect-internal-option-topic.html","desc":"พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก ","descFull":"พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: เลือก  ดำเนินการต่อ  เพื่อล้างข้อความและทำการพิมพ์ต่อ ลบฟอนต์ มาโคร และข้อมูลอื่นๆ ที่เก็บอยู่ในหน่วยความจำแฟลช ติดตั้งไดรฟ์จัดเก็บข้อมูล ฟอนต์และมาโครที่ดาวน์โหลดที่ไม่ได้จัดเก็บไว้ในหน่วยความจำแฟลชก่อนหน้านี้จะถูกลบ ข้อความเกี่ยวกับเครื่องพิมพ์ พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร พื้นที่ว่างในหน่วยความจำแฟลชไม่เพียงพอสำหรับทรัพยากร"},{"UUID":"55467b42-57dd-4120-8b8d-6fcba0772c97","title":"ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"เปลี่ยนตลับหมึก พื้นที่เครื่องพิมพ์ไม่ตรงกัน ในการแก้ไขปัญหานี้ ให้ซื้อตลับหมึกพิมพ์ตามภูมิภาคที่ถูกต้อง ซึ่งตรงกับภูมิภาคของเครื่องพิมพ์","descFull":"เปลี่ยนตลับหมึก พื้นที่เครื่องพิมพ์ไม่ตรงกัน ในการแก้ไขปัญหานี้ ให้ซื้อตลับหมึกพิมพ์ตามภูมิภาคที่ถูกต้อง ซึ่งตรงกับภูมิภาคของเครื่องพิมพ์ หรือซื้อตลับหมึกพิมพ์รุ่นสากล หมายเลขแรกในข้อความหลัง 42 จะระบุภูมิภาคของเครื่องพิมพ์ หมายเลขที่สองในข้อความหลังจาก 42 จะแสดงภูมิภาคของตลับหมึก ติดตั้งตลับหมึกที่ถูกต้อง ภูมิภาคเครื่องพิมพ์และตลับหมึก ภูมิภาค รหัสตัวเลข ภูมิภาคสากลหรือไม่ได้กำหนดภูมิภาค 0 อเมริกาเหนือ (สหรัฐอเมริกา, แคนาดา) 1 เขตเศรษฐกิจยุโรป, ยุโรปตะวันตก, ประเทศนอร์ดิก, สวิตเซอร์แลนด์ 2 เอเชียแปซิฟิก 3 ละตินอเมริกา 4 ประเทศอื่นๆ ในยุโรป, ตะวันออกกลาง, แอฟริกา 5 ออสเตรเลีย, นิวซีแลนด์ 6 ภูมิภาคไม่ถูกต้อง 9 ในการดูตั้งค่าภูมิภาคของเครื่องพิมพ์และกลักหมึก ให้พิมพ์ หน้าทดสอบคุณภาพการพิมพ์  จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ ข้อความเกี่ยวกับเครื่องพิมพ์ เปลี่ยนตลับหมึก พื้นที่เครื่องพิมพ์ไม่ตรงกัน เปลี่ยนตลับหมึก พื้นที่เครื่องพิมพ์ไม่ตรงกัน ตลับหมึก พื้นที่เครื่องพิมพ์ไม่ตรงกัน"},{"UUID":"a00c0b00-7995-4f09-b07a-27e168d9e859","title":"ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"ตลับหมึก [สี] ปกติที่เติมแล้ว เครื่องพิมพ์ตรวจพบตลับหมึกปกติของ Lexmark","descFull":"ตลับหมึก [สี] ปกติที่เติมแล้ว เครื่องพิมพ์ตรวจพบตลับหมึกปกติของ Lexmark ที่เติมด้วยหมึกที่ไม่ใช่ของแท้จากบริษัทอื่นที่ไม่ใช่ Lexmark เครื่องพิมพ์ตรวจพบตลับหมึกที่เติมด้วยหมึกที่ไม่ใช่ของแท้จากบริษัทอื่นที่ไม่ใช่ผู้ผลิตเครื่องพิมพ์ของคุณ เลือก  ตกลง  เพื่อดำเนินการต่อ ไฟแสดงอายุการใช้งานของส่วนประกอบเครื่องพิมพ์ทั้งหมดได้รับการออกแบบให้ทำงานร่วมกับวัสดุสิ้นเปลืองและชิ้นส่วนต่างๆ ของ Lexmark และอาจให้ผลที่ไม่สามารถคาดเดาได้เมื่อใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นที่ไม่ใช่ Lexmark ในเครื่องพิมพ์ Lexmark ของคุณ ไฟแสดงอายุการใช้งานของส่วนประกอบเครื่องพิมพ์ทั้งหมดได้รับการออกแบบให้ทำงานร่วมกับวัสดุสิ้นเปลืองและชิ้นส่วนต่างๆ ของผู้ผลิต และอาจให้ผลที่ไม่สามารถคาดเดาได้เมื่อใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นที่ไม่ใช่ผู้ผลิตเครื่องพิมพ์ในเครื่องพิมพ์ของคุณ สำหรับข้อมูลเพิ่มเติม โปรดดูคำประกาศการรับประกันแบบจำกัดของเครื่องพิมพ์ ข้อความเกี่ยวกับเครื่องพิมพ์ ตลับหมึกปกติที่เติมแล้ว หมึกที่ไม่ใช่ของแท้ วัสดุสิ้นเปลืองของผู้ผลิตรายอื่น"},{"UUID":"ff38dc7a-d640-452d-980d-348ee5f4ae0a","title":"ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"วัสดุสิ้นเปลืองที่ไม่ใช่ของ Lexmark วัสดุสิ้นเปลืองที่ไม่ใช่ของ Dell วัสดุสิ้นเปลืองที่ไม่ใช่ของผู้ผลิตเครื่องพิมพ์","descFull":"วัสดุสิ้นเปลืองที่ไม่ใช่ของ Lexmark วัสดุสิ้นเปลืองที่ไม่ใช่ของ Dell วัสดุสิ้นเปลืองที่ไม่ใช่ของผู้ผลิตเครื่องพิมพ์ เครื่องพิมพ์ตรวจพบว่ามีวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของ Lexmark ติดตั้งอยู่ในเครื่องพิมพ์ เครื่องพิมพ์ตรวจพบว่ามีวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของ Dell ติดตั้งอยู่ในเครื่องพิมพ์ เครื่องพิมพ์ตรวจพบว่ามีวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่รู้จักติดตั้งอยู่ในเครื่องพิมพ์ เครื่องพิมพ์ Lexmark ของคุณถูกออกแบบมาให้ทำงานได้ดีที่สุดกับวัสดุสิ้นเปลืองและชิ้นส่วน Lexmark ของแท้ การใช้อุปกรณ์สิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจมีผลต่อประสิทธิภาพ ความน่าเชื่อถือ หรืออายุการใช้งานของเครื่องพิมพ์และส่วนประกอบ Imaging เครื่องพิมพ์ Dell ของคุณถูกออกแบบมาให้ทำงานได้ดีที่สุดกับวัสดุสิ้นเปลืองและชิ้นส่วน Dell ของแท้ การใช้อุปกรณ์สิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจมีผลต่อประสิทธิภาพ ความน่าเชื่อถือ หรืออายุการใช้งานของเครื่องพิมพ์และส่วนประกอบ Imaging เครื่องพิมพ์ของคุณถูกออกแบบมาให้ทำงานได้ดีที่สุดกับวัสดุสิ้นเปลืองและชิ้นส่วนของแท้ที่ผลิตโดยผู้ผลิตเครื่องพิมพ์ การใช้อุปกรณ์สิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจมีผลต่อประสิทธิภาพ ความน่าเชื่อถือ หรืออายุการใช้งานของเครื่องพิมพ์และส่วนประกอบ Imaging ไฟแสดงอายุการใช้งานทั้งหมดถูกออกแบบมาเพื่อให้ทำงานร่วมกับวัสดุสิ้นเปลืองและชิ้นส่วนต่างๆ ของ Lexmark และอาจให้ผลที่ไม่สามารถคาดเดาได้หากใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่น การใช้ส่วนประกอบการสร้างภาพที่เกินอายุการใช้งานที่กำหนดอาจทำให้เครื่องพิมพ์ Lexmark หรือส่วนประกอบที่เกี่ยวข้องเสียหายได้ ไฟแสดงอายุการใช้งานทั้งหมดได้รับการออกแบบมาเพื่อทำงานร่วมกับวัสดุสิ้นเปลืองและชิ้นส่วนต่างๆ ของ Dell และอาจให้ผลที่ไม่สามารถคาดเดาได้หากใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่น การใช้ส่วนประกอบการสร้างภาพที่เกินอายุการใช้งานที่กำหนดอาจทำให้เครื่องพิมพ์ Dell หรือส่วนประกอบที่เกี่ยวข้องเสียหาย ไฟแสดงอายุการใช้งานทั้งหมดถูกออกแบบมาเพื่อทำงานร่วมกับวัสดุสิ้นเปลืองและชิ้นส่วนต่างๆ จากผู้ผลิตเครื่องพิมพ์ และอาจให้ผลที่ไม่สามารถคาดเดาได้หากใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่น การใช้ส่วนประกอบการสร้างภาพเกินอายุการใช้งานที่กำหนดอาจทำให้เครื่องพิมพ์หรือส่วนประกอบที่เกี่ยวข้องเสียหาย การใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นจะมีผลกับการรับประกัน ความเสียหายที่เกิดจากการใช้วัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นอาจไม่อยู่ภายใต้ความคุ้มครองจากการรับประกัน ในการยอมรับความเสี่ยงเหล่านี้ทั้งหมดและใช้งานวัสดุสิ้นเปลืองหรือชิ้นส่วนที่ไม่ใช่ของแท้ในเครื่องพิมพ์ของคุณต่อไป ให้ใช้นิ้วมืองสองนิ้วแตะข้อความแสดงข้อผิดพลาดบนส่วนแสดงผลค้างไว้เป็นเวลา 15 นาที เมื่อกล่องโต้ตอบยืนยันปรากฏขึ้น ให้แตะที่  ดำเนินการต่อ หากคุณไม่ต้องการรับความเสี่ยงเหล่านี้ ให้ถอดวัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นออกจากเครื่องพิมพ์ของคุณ แล้วติดตั้งวัสดุสิ้นเปลืองหรือชิ้นส่วน Lexmark ของแท้ โปรดดูข้อมูลเพิ่มเติมที่  หากคุณไม่ต้องการรับความเสี่ยงเหล่านี้ ให้ถอดวัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นออกจากเครื่องพิมพ์ของคุณ แล้วจึงติดตั้งวัสดุสิ้นเปลืองหรือชิ้นส่วน Dell ของแท้ หากคุณไม่ต้องการรับความเสี่ยงเหล่านี้ ให้ถอดวัสดุสิ้นเปลืองหรือชิ้นส่วนของผู้ผลิตรายอื่นออกจากเครื่องพิมพ์ของคุณ แล้วจึงติดตั้งวัสดุสิ้นเปลืองหรือชิ้นส่วนจากผู้ผลิตเครื่องพิมพ์ หากเครื่องพิมพ์ไม่พิมพ์งานหลังจากล้างข้อความแสดงข้อผิดพลาด ให้รีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การใช้วัสดุสิ้นเปลืองและตัวนับ เลือกชิ้นส่วนหรือวัสดุสิ้นเปลืองที่คุณต้องการรีเซ็ตแล้วเลือก  เริ่มต้น อ่านข้อความเตือนแล้วเลือก  ดำเนินการต่อ ใช้นิ้วมือสองนิ้วแตะที่ส่วนแสดงผลเป็นเวลา 15 วินาทีเพื่อล้างข้อความ หากคุณไม่สามารถรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง ให้นำวัสดุนั้นไปคืนที่ร้านค้าที่ซื้อ ข้อความเกี่ยวกับเครื่องพิมพ์ วัสดุสิ้นเปลืองที่ไม่ใช่ของ Lexmark วัสดุสิ้นเปลืองที่ไม่ใช่ของ Lexmark ข้อความเกี่ยวกับเครื่องพิมพ์ วัสดุสิ้นเปลืองที่ไม่ใช่ของ Dell วัสดุสิ้นเปลืองที่ไม่ใช่ของ Dell ข้อความเกี่ยวกับเครื่องพิมพ์ วัสดุสิ้นเปลืองที่ไม่ใช่ของผู้ผลิตเครื่องพิมพ์ วัสดุสิ้นเปลืองที่ไม่ใช่ของผู้ผลิตเครื่องพิมพ์ การรีเซต ตัวนับการใช้วัสดุสิ้นเปลือง ตัวนับการใช้วัสดุสิ้นเปลือง การรีเซต การรีเซ็ตตัวนับการใช้วัสดุสิ้นเปลือง"},{"UUID":"618df890-3c7a-49fe-b9e1-052bfd032ab3","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"กระดาษม้วนงอ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปรับตัวนำในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ใส่ ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ","descFull":"กระดาษม้วนงอ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ปรับตัวนำในถาดให้อยู่ในตำแหน่งที่ถูกต้องสำหรับกระดาษที่ใส่ ให้ระบุประเภทกระดาษจากค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ ทั้งนี้ขึ้นอยู่กับระบบปฏิบัติการของคุณ ตรวจสอบให้แน่ใจว่าการตั้งค่าตรงกับกระดาษที่ใส่เข้าไป คุณยังสามารถเปลี่ยนการตั้งค่าบนแผงควบคุมเครื่องพิมพ์ได้เช่นกัน ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ นำกระดาษออก พลิกกระดาษ แล้วป้อนกระดาษอีกครั้ง ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพการพิมพ์ กระดาษม้วนงอ กระดาษม้วนงอ"},{"UUID":"01d0ca40-e59e-4fd3-befe-f24ec4ae519c","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"ซองจดหมายปิดผนึกขณะพิมพ์ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ใช้ซองจดหมายที่เก็บไว้ในสภาพแวดล้อมที่แห้ง การพิมพ์บนซองจดหมายที่มีความชื้นสูงอาจทำให้ปิดผนึกซองได้ ตรวจสอบให้แน่ใจว่าประเภทกระดาษถูกตั้งเป็น","descFull":"ซองจดหมายปิดผนึกขณะพิมพ์ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ใช้ซองจดหมายที่เก็บไว้ในสภาพแวดล้อมที่แห้ง การพิมพ์บนซองจดหมายที่มีความชื้นสูงอาจทำให้ปิดผนึกซองได้ ตรวจสอบให้แน่ใจว่าประเภทกระดาษถูกตั้งเป็น  ซองจดหมาย  จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาเกี่ยวกับการป้อนกระดาษ ซองจดหมายปิดผนึกขณะพิมพ์ ซองจดหมายปิดผนึกขณะพิมพ์"},{"UUID":"0a2ab37b-133c-4c6b-9df5-b22c0e284f91","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"การพิมพ์แบบเรียงหน้าไม่ทำงาน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่ ","descFull":"การพิมพ์แบบเรียงหน้าไม่ทำงาน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ การจัดวาง เรียงหน้า  จากนั้นเลือก  เปิด [1,2,1,2,1,2] จากเอกสารที่คุณกำลังพิมพ์ ให้เปิดค่ากำหนดการพิมพ์หรือกรอบโต้ตอบการพิมพ์ จากนั้นเลือก  เรียงหน้า ลดจำนวนหน้าที่จะพิมพ์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาเกี่ยวกับการป้อนกระดาษ การพิมพ์แบบเรียงหน้าไม่ทำงาน การพิมพ์แบบเรียงหน้าไม่ทำงาน"},{"UUID":"fe6dcc41-95ff-4e50-8e8d-26b1a9cae996","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"การเชื่อมโยงถาดไม่ทำงาน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าถาดที่เชื่อมโยงมีขนาดกระดาษ แนวกระดาษ และประเภทกระดาษเดียวกันหรือไม่","descFull":"การเชื่อมโยงถาดไม่ทำงาน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าถาดที่เชื่อมโยงมีขนาดกระดาษ แนวกระดาษ และประเภทกระดาษเดียวกันหรือไม่ ตรวจสอบให้แน่ใจว่าตัวนำกระดาษอยู่ในตำแหน่งที่ถูกต้องหรือไม่ ตั้งขนาดกระดาษและประเภทกระดาษให้ตรงกับกระดาษที่ใส่ในถาดที่เชื่อมโยง จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ตรวจสอบให้แน่ใจว่าได้ตั้งให้  การเชื่อมโยงถาด  เป็น  อัตโนมัติ  โปรดดูข้อมูลเพิ่มเติมที่  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาเกี่ยวกับการป้อนกระดาษ การเชื่อมโยงถาดไม่ทำงาน การเชื่อมโยงถาดไม่ทำงาน"},{"UUID":"a229efd5-6741-49c3-9ce1-9c9613d3f1ab","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"กระดาษติดบ่อย ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าใส่กระดาษอย่างถูกต้องหรือไม่ ตรวจสอบให้แน่ใจว่าตัวนำกระดาษอยู่ในตำแหน่งที่ถูกต้องหรือไม่ ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด","descFull":"กระดาษติดบ่อย ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบว่าใส่กระดาษอย่างถูกต้องหรือไม่ ตรวจสอบให้แน่ใจว่าตัวนำกระดาษอยู่ในตำแหน่งที่ถูกต้องหรือไม่ ตรวจสอบว่าความสูงของปึกกระดาษอยู่ต่ำกว่าตัวแสดงระดับกระดาษสูงสุด ตรวจสอบให้แน่ใจว่าพิมพ์ด้วยขนาดและประเภทกระดาษที่แนะนำ ตั้งค่าขนาดกระดาษและประเภทกระดาษที่ถูกต้อง จากแผงควบคุม ไปที่  การตั้งค่า กระดาษ การกำหนดค่าถาด ขนาด/ประเภทของกระดาษ ป้อนกระดาษที่นำออกมาจากบรรจุภัณฑ์ใหม่ กระดาษจะดูดซับความชื้นเนื่องจากมีความชื้นสูง เก็บกระดาษไว้ในห่อกระดาษต้นฉบับจนกว่าคุณจะต้องการใช้ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาเกี่ยวกับการป้อนกระดาษ กระดาษติดบ่อย กระดาษติดบ่อย"},{"UUID":"7f979b56-b00e-4970-93d7-34135fcd0cef","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ","link":"trb-paper-curl-topic.html","desc":"จะไม่พิมพ์หน้ากระดาษที่ติดซ้ำ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"จะไม่พิมพ์หน้ากระดาษที่ติดซ้ำ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การแจ้งเตือน การกู้คืนเนื้อหากระดาษติด ในเมนู  การกู้คืนกระดาษติด  เลือก  เปิด  หรือ  อัตโนมัติ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการพิมพ์ จะไม่พิมพ์หน้ากระดาษที่ติดซ้ำ จะไม่พิมพ์หน้ากระดาษที่ติดซ้ำ"},{"UUID":"2a631f6a-6730-447d-838f-60a520ffd45c","title":"ปัญหาการรับส่งอีเมล","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"การปิดใช้งานข้อความแสดงข้อผิดพลาด “ยังไม่มีการตั้งค่าเซิร์ฟเวอร์ SMTP” จากแผงควบคุม ไปที่","descFull":"การปิดใช้งานข้อความแสดงข้อผิดพลาด “ยังไม่มีการตั้งค่าเซิร์ฟเวอร์ SMTP” จากแผงควบคุม ไปที่  การตั้งค่า อีเมล การตั้งค่าอีเมล ตั้งค่า ปิดใช้งานข้อผิดพลาด “ไม่ได้ตั้งค่าเซิร์ฟเวอร์ SMTP”  เป็น  เปิด เพื่อป้องกันไม่ให้เกิดข้อผิดพลาดอีก ให้ทำอย่างน้อยหนึ่งอย่างต่อไปนี้: อัพเดตเฟิร์มแวร์ของเครื่องพิมพ์ สำหรับข้อมูลเพิ่มเติม ดูส่วน “การอัปเดตเฟิร์มแวร์” กำหนดค่าการตั้งค่า SMTP ของอีเมล โปรดดูข้อมูลเพิ่มเติมที่  ข้อผิดพลาดไม่ได้ตั้งค่าเซิร์ฟเวอร์ SMTP การระงับใช้ การแก้ไขปัญหา ข้อผิดพลาดไม่ได้ตั้งค่าเซิร์ฟเวอร์ SMTP การปิดใช้งานข้อผิดพลาดไม่ได้ตั้งค่าเซิร์ฟเวอร์ SMTP"},{"UUID":"612677ca-1533-4d6b-952a-1f436ea62cb7","title":"ปัญหาการรับส่งอีเมล","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"ไม่สามารถส่งอีเมลได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้อีกหนึ่งข้อ: ตรวจสอบว่ามีการกำหนดค่าการตั้งค่า SMTP ของอีเมลนั้นอย่างถูกต้อง","descFull":"ไม่สามารถส่งอีเมลได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้อีกหนึ่งข้อ: ตรวจสอบว่ามีการกำหนดค่าการตั้งค่า SMTP ของอีเมลนั้นอย่างถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เชื่อมต่อกับเครือข่าย และเชื่อมต่อเครือข่ายเข้ากับอินเตอร์เน็ตแล้ว หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาอีเมล ไม่สามารถส่งอีเมลได้ ไม่สามารถส่งอีเมลได้"},{"UUID":"17038599-7714-40e9-ba1a-e6b140871d57","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ไม่แสดงหมายเลขเรียกเข้า ไม่แสดงหมายเลขเรียกเข้า คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น จากแผงควบคุม ไปที่","descFull":"ไม่แสดงหมายเลขเรียกเข้า ไม่แสดงหมายเลขเรียกเข้า คำแนะนำเหล่านี้ใช้ได้กับเครื่องพิมพ์ที่มีการ์ดแฟกซ์ติดตั้งอยู่เท่านั้น จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ ส่วนควบคุมของผู้ดูแล ตั้งค่า  เปิดใช้งานหมายเลขเรียกเข้า  เป็น  เปิด หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ ไม่แสดงหมายเลขเรียกเข้า ไม่แสดงหมายเลขเรียกเข้า"},{"UUID":"ae04e6d0-4def-4f6e-9148-3386e29762c1","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : แก้ไขปัญหาข้อความแจ้งข้อผิดพลาดที่ปรากฏบนส่วนแสดงผล","descFull":"ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : แก้ไขปัญหาข้อความแจ้งข้อผิดพลาดที่ปรากฏบนส่วนแสดงผล ตรวจสอบให้แน่ใจว่าการเชื่อมต่อสายเคเบิลสำหรับโทรศัพท์ ชุดหูฟัง หรือเครื่องตอบรับอัตโนมัติยึดแน่นดี ตรวจสอบสัญญาณพร้อมโทรออก โทรไปที่หมายเลขแฟกซ์เพื่อตรวจสอบว่าหมายเลขแฟกซ์ทำงานถูกต้องหรือไม่ หากใช้คุณสมบัติ On Hook Dial (การโทรแบบไม่ยกหู) ให้เปิดเสียงให้ดังขึ้นเพื่อตรวจสอบว่าได้ยินสัญญาณพร้อมโทรออกหรือไม่ ตรวจสอบช่องเสียบสายโทรศัพท์ที่ผนัง เชื่อมต่อโทรศัพท์อนาล็อกเข้ากับช่องเสียบที่ผนังโดยตรง รอฟังสัญญาณพร้อมโทรออก หากไม่ได้ยินสัญญาณพร้อมโทรออก ให้ใช้สายเคเบิลโทรศัพท์เส้นอื่น หากยังคงไม่ได้ยินสัญญาณพร้อมโทรออก ให้เชื่อมต่อโทรศัพท์อนาล็อกเข้ากับช่องเสียบที่ผนังช่องอื่น ถ้าหากได้ยินเสียงสัญญาณพร้อมโทร ให้ต่อเครื่องพิมพ์เข้ากับช่องเสียบสายโทรศัพท์ที่ผนัง ตรวจสอบว่าเครื่องพิมพ์เชื่อมต่อกับบริการโทรศัพท์อนาล็อกหรือเชื่อมต่อกับช่องเสียบดิจิตอลที่ถูกต้องหรือไม่ หากคุณใช้บริการโทรศัพท์ Integrated Services for Digital Network (ISDN) ให้เชื่อมต่อกับพอร์ตโทรศัพท์อนาล็อกของอแดปเตอร์ขั้ว ISDN หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อผู้ให้บริการ ISDN ของคุณ หากคุณใช้ DSL ให้เชื่อมต่อตัวกรอง DSL หรือเราเตอร์ที่สนับสนุนการใช้งานแบบอนาล็อก หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อผู้ให้บริการ DSL ของคุณ หากคุณใช้บริการโทรศัพท์ Private Branch Exchange (PBX) ต้องตรวจสอบให้แน่ใจว่ามีการเชื่อมต่อเข้ากับการเชื่อมต่อแบบอนาล็อกของ PBX หากไม่มีการเชื่อมต่อดังกล่าว ควรพิจารณาติดตั้งสายโทรศัพท์แบบอนาล็อกสำหรับเครื่องแฟกซ์ ตัดการเชื่อมต่ออุปกรณ์อื่นชั่วคราวและปิดการใช้งานบริการโทรศัพท์อื่นๆ ถอดอุปกรณ์อื่นๆ (เช่น เครื่องตอบรับ คอมพิวเตอร์ โมเด็ม หรือตัวแยกสัญญาณสายโทรศัพท์) ที่อยู่ระหว่างเครื่องพิมพ์และสายโทรศัพท์ ปิดใช้งานการรอสายและระบบฝากข้อความเสียง หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อบริษัทที่ให้บริการโทรศัพท์ของคุณ สแกนเอกสารต้นฉบับครั้งละหนึ่งหน้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้"},{"UUID":"96f4881a-72ca-4144-b5d8-b73e5150f3e6","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"สามารถรับได้แต่ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ สามารถรับได้แต่ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ใส่เอกสารต้นฉบับในถาด ADF","descFull":"สามารถรับได้แต่ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ สามารถรับได้แต่ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ใส่เอกสารต้นฉบับในถาด ADF หรือวางบนกระจกสแกนเนอร์ ตั้งหมายเลขทางลัดให้ถูกต้อง ตรวจสอบว่ามีการตั้งหมายเลขทางลัดสำหรับหมายเลขโทรศัพท์ที่ต้องการโทรออกหรือไม่ กดหมายเลขโทรศัพท์ด้วยตนเอง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ไม่สามารถส่งแฟกซ์โดยใช้แฟกซ์อนาล็อกได้"},{"UUID":"642a774b-ec56-4a61-8ba5-00942ac9e1aa","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"สามารถส่งแต่ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ สามารถส่งแต่ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าแหล่งกระดาษไม่ว่างเปล่า ตรวจสอบการตั้งค่าการหน่วงเวลาจำนวนเสียงเรียกเข้า","descFull":"สามารถส่งแต่ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ สามารถส่งแต่ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าแหล่งกระดาษไม่ว่างเปล่า ตรวจสอบการตั้งค่าการหน่วงเวลาจำนวนเสียงเรียกเข้า จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์ การตั้งค่าการรับแฟกซ์ เสียงเรียกเข้าเพื่อให้รับสาย หากเครื่องพิมพ์พิมพ์ออกมาเป็นหน้าว่าง โปรดดูที่  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ สามารถส่งแต่ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้ ไม่สามารถรับแฟกซ์โดยใช้แฟกซ์อนาล็อกได้"},{"UUID":"1435c047-36e9-4469-b679-ba26e37fd03e","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ไม่สามารถตั้งค่า etherFAX ได้ ไม่สามารถตั้งค่า etherFAX","descFull":"ไม่สามารถตั้งค่า etherFAX ได้ ไม่สามารถตั้งค่า etherFAX ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : ตรวจสอบการเชื่อมต่อเครื่องพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เครือข่าย หน้าการตั้งค่าเครือข่าย ตรวจสอบสถานะเครือข่ายบนหน้าที่พิมพ์ ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เชื่อมต่อกับเครือข่าย และเชื่อมต่อเครือข่ายเข้ากับอินเตอร์เน็ตแล้ว ตรวจสอบให้แน่ใจว่า etherFAX ได้รับการตั้งค่าอย่างถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  หากปัญหายังคงมีอยู่ โปรดไปที่  https://www.etherfax.net/lexmark ปัญหาการแฟกซ์ ไม่สามารถตั้งค่า etherFAX ได้ ไม่สามารถตั้งค่า etherFAX ได้"},{"UUID":"301e2701-97ca-4c2f-ab6e-208c73fa7733","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX ได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX","descFull":"ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX ได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์เชื่อมต่อกับเครือข่าย และเชื่อมต่อเครือข่ายเข้ากับอินเตอร์เน็ตแล้ว ตรวจสอบให้แน่ใจว่า etherFAX ได้รับการตั้งค่าอย่างถูกต้อง โปรดดูข้อมูลเพิ่มเติมที่  แยกเอกสารขนาดใหญ่ออกเป็นไฟล์ที่มีขนาดเล็กกว่าหลายไฟล์ หากปัญหายังคงมีอยู่ โปรดไปที่  https://www.etherfax.net/lexmark ปัญหาการแฟกซ์ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX ได้ ไม่สามารถส่งหรือรับแฟกซ์โดยใช้ etherFAX ได้"},{"UUID":"d50868ea-2608-48e9-8825-aca1f76e4655","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"คุณภาพการพิมพ์แฟกซ์ไม่ดี คุณภาพการพิมพ์แฟกซ์ไม่ดี ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: แก้ไขข้อบกพร่องคุณภาพการพิมพ์ พิมพ์","descFull":"คุณภาพการพิมพ์แฟกซ์ไม่ดี คุณภาพการพิมพ์แฟกซ์ไม่ดี ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: แก้ไขข้อบกพร่องคุณภาพการพิมพ์ พิมพ์ หน้าทดสอบคุณภาพการพิมพ์  จากแผงควบคุม ให้ไปที่  การตั้งค่า การแก้ไขปัญหา หน้าทดสอบคุณภาพการพิมพ์ แก้ไขข้อบกพร่องคุณภาพการพิมพ์ โปรดดูข้อมูลเพิ่มเติมที่  หากคุณกำลังใช้แฟกซ์อนาล็อก ให้ลดความเร็วในการรับข้อมูลแฟกซ์ขาเข้า จากแผงควบคุม ไปที่  การตั้งค่า แฟกซ์ การตั้งค่าแฟกซ์  การตั้งค่าการรับแฟกซ์ ส่วนควบคุมของผู้ดูแล ในเมนู ความเร็วสูงสุด  ให้เลือกความเร็วในการรับข้อมูลที่ต่ำลง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ คุณภาพการพิมพ์ไม่ดี คุณภาพการพิมพ์แฟกซ์ไม่ดี"},{"UUID":"931b5cec-a126-4f9b-8f1d-5a457afeb9bd","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน ปิดเครื่องพิมพ์ รอประมาณ 10","descFull":"ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ ส่งหรือดึงข้อมูลแฟกซ์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน ข้อมูลที่ปรากฏบนใบปะหน้าแฟกซ์ไม่ครบถ้วน"},{"UUID":"2cee30e1-9470-478b-89e1-b24ecda8bb1e","title":"ปัญหาการแฟกซ์","link":"trb-caller-id-not-shown-topic.html","desc":"ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้ ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : ตรวจสอบให้แน่ใจว่าอัปเดตไดรเวอร์การพิมพ์แล้ว","descFull":"ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้ ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้ : ตรวจสอบให้แน่ใจว่าอัปเดตไดรเวอร์การพิมพ์แล้ว หากต้องการข้อมูลเพิ่มเติม โปรดเข้าไปที่  www.lexmark.com/downloads ตรวจสอบให้แน่ใจว่าอัปเดตไดรเวอร์การพิมพ์แล้ว สำหรับข้อมูลเพิ่มเติม โปรดติดต่อร้านค้าที่คุณซื้อเครื่องพิมพ์ ตรวจสอบให้แน่ใจว่าได้อัปเดตไดรเวอร์การพิมพ์แล้ว จากนั้นจึงส่งแฟกซ์ หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ล้างการตั้งค่า  แสดงผลการตั้งค่าก่อนการส่งแฟกซ์ทุกครั้ง จากเอกสารที่คุณกำลังส่งแฟกซ์ ให้เปิดกรอบโต้ตอบ  การพิมพ์ เลือกเครื่องพิมพ์ จากนั้นคลิก  คุณสมบัติ ,  ค่ากำหนด ,  ตัวเลือก หรือ  ตั้งค่า คลิก  แฟกซ์  แล้วจากนั้นล้างการตั้งค่า  แสดงผลการตั้งค่าก่อนการส่งแฟกซ์ทุกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการแฟกซ์ ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้ ไม่สามารถส่งใบปะหน้าแฟกซ์จากคอมพิวเตอร์ได้"},{"UUID":"5b024df4-1c84-4b97-a29c-7bdb2698f9f5","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"ไม่สามารถสแกนไปยังคอมพิวเตอร์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ดำเนินงานทำสำเนา หากงานล้มเหลว ปิดเครื่องพิมพ์","descFull":"ไม่สามารถสแกนไปยังคอมพิวเตอร์ได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ดำเนินงานทำสำเนา หากงานล้มเหลว ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ ตรวจสอบการเชื่อมต่อเครื่องพิมพ์ พิมพ์  หน้าการตั้งค่าเครือข่าย  จากแผงควบคุม ไปที่  การตั้งค่า รายงาน เครือข่าย แล้วเลือก  หน้าการตั้งค่าเครือข่าย ตรวจสอบส่วนแรกของหน้าและยืนยันว่าสถานะเป็นเชื่อมต่อแล้วหรือไม่ ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์และคอมพิวเตอร์เชื่อมต่ออยู่กับเครือข่ายเดียวกัน หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน ไม่สามารถสแกนไปยังคอมพิวเตอร์ได้ ไม่สามารถสแกนไปยังคอมพิวเตอร์ได้"},{"UUID":"200f4442-1a77-4925-8daf-0442b2967d3c","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"ไม่สามารถสแกนไปยังโฟลเดอร์เครือข่ายได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: สร้างทางลัดโฟลเดอร์เครือข่าย แล้วสแกนเอกสารโดยใช้ทางลัด โปรดดูข้อมูลเพิ่มเติมที่","descFull":"ไม่สามารถสแกนไปยังโฟลเดอร์เครือข่ายได้ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: สร้างทางลัดโฟลเดอร์เครือข่าย แล้วสแกนเอกสารโดยใช้ทางลัด โปรดดูข้อมูลเพิ่มเติมที่  ตรวจสอบว่าพาธและรูปแบบโฟลเดอร์เครือข่ายนั้นถูกต้อง ตัวอย่างเช่น  // server_hostname /foldername/path  โดยที่  server_hostname  คือโดเมนที่มีคุณสมบัติครบถ้วน (FQDN) หรือ IP แอดเดรส ตรวจสอบให้แน่ใจว่าคุณมีสิทธิ์การเข้าถึงเพื่อเขียนในโฟลเดอร์เครือข่าย อัปเดตทางลัดโฟลเดอร์เครือข่าย เปิดเว็บบราวเซอร์แล้วพิมพ์ IP แอดเดรสของเครื่องพิมพ์ในช่องแอดเดรส ดู IP แอดเดรสของเครื่องพิมพ์บนหน้าจอหลักของเครื่องพิมพ์ IP แอดเดรสจะเป็นตัวเลขสี่ชุดที่คั่นด้วยจุด เช่น 123.123.123.123 หากคุณกำลังใช้เซิร์ฟเวอร์พร็อกซี่ ให้ปิดใช้งานชั่วคราวเพื่อโหลดเว็บเพจอย่างถูกต้อง คลิก  ทางลัด  แล้วเลือกทางลัด หากคุณมีทางลัดหลายประเภท ให้เลือก  โฟลเดอร์เครือข่าย ในช่อง แชร์พาธ ให้พิมพ์พาธโฟลเดอร์เครือข่าย ตัวอย่างเช่น  \\\\server_hostname\\foldername\\path ใช้เครื่องหมายสแลชไปด้านหน้าเสมอเมื่อพิมพ์แชร์พาธ จากเมนู  การตรวจสอบความถูกต้อง  ให้เลือกวิธีการตรวจสอบความถูกต้องของคุณ หากตั้งค่า  การตรวจสอบความถูกต้อง  เป็น “ ใช้ชื่อผู้ใช้และรหัสผ่านที่กำหนด ” จากนั้นในช่อง ชื่อผู้ใช้ และ รผัสผ่าน ให้พิมพ์ข้อมูลรับรองของคุณ คลิก  บันทึก ตรวจสอบให้แน่ใจว่าเครื่องพิมพ์และโฟลเดอร์เครือข่ายเชื่อมต่ออยู่กับเครือข่ายเดียวกัน หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ไม่สามารถสแกนไปยังโฟลเดอร์เครือข่ายได้ ปัญหาการสแกน ไม่สามารถสแกนไปยังโฟลเดอร์เครือข่ายได้"},{"UUID":"64a10d92-ac46-492b-9918-0433264a3b5e","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"ทำสำเนาเอกสารหรือภาพถ่ายบางส่วน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าป้อนเอกสารหรือภาพถ่ายโดยคว่ำหน้าลงในขอบมุมบนซ้ายของกระจกสแกนเนอร์ ตั้งค่าขนาดกระดาษให้ตรงกับกระดาษที่ใส่ในถาด หากปัญหายังคงมีอยู่","descFull":"ทำสำเนาเอกสารหรือภาพถ่ายบางส่วน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าป้อนเอกสารหรือภาพถ่ายโดยคว่ำหน้าลงในขอบมุมบนซ้ายของกระจกสแกนเนอร์ ตั้งค่าขนาดกระดาษให้ตรงกับกระดาษที่ใส่ในถาด หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการทำสำเนา ทำสำเนาเอกสารได้เพียงแค่บางส่วน ปัญหาการทำสำเนา ทำสำเนาภาพถ่ายได้เพียงแค่บางส่วน ทำสำเนาเอกสารหรือภาพถ่ายได้เพียงแค่บางส่วน ปัญหาการสแกน ทำสำเนาเอกสารได้เพียงแค่บางส่วน ปัญหาการสแกน ทำสำเนาภาพถ่ายได้เพียงแค่บางส่วน"},{"UUID":"519d3800-85f9-4671-966c-cea50ecb3404","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"คุณภาพของสำเนาไม่ดี ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ทำความสะอาดกระจกสแกนเนอร์และกระจก ADF ด้วยผ้านุ่มไม่มีขนชุบน้ำหมาดๆ","descFull":"คุณภาพของสำเนาไม่ดี ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ทำความสะอาดกระจกสแกนเนอร์และกระจก ADF ด้วยผ้านุ่มไม่มีขนชุบน้ำหมาดๆ หากเครื่องพิมพ์ของท่านมีกระจก ADF แผ่นที่สองอยู่ด้านใน ADF ให้ทำความสะอาดกระจกส่วนดังกล่าวด้วย โปรดดูข้อมูลเพิ่มเติมที่  ตรวจสอบให้แน่ใจว่าป้อนเอกสารหรือภาพถ่ายโดยคว่ำหน้าลงในขอบมุมบนซ้ายของกระจกสแกนเนอร์ ตรวจสอบคุณภาพของเอกสารต้นฉบับหรือภาพถ่าย และปรับการตั้งค่าคุณภาพการสแกนตามความเหมาะสม หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการทำสำเนา คุณภาพของสำเนาไม่ดี คุณภาพของสำเนาไม่ดี ปัญหาการสแกน คุณภาพของสำเนาไม่ดี คุณภาพการสแกนไม่ดี"},{"UUID":"7f9f6e26-ab54-4b53-b0d3-f95066e0140c","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"เส้นสีเข้มแนวตั้งเมื่อสแกนจาก ADF ยกฝาครอบสแกนเนอร์ขึ้น แล้วนำเครื่องมือทำความสะอาดกระจกออก เช็ดกระจก","descFull":"เส้นสีเข้มแนวตั้งเมื่อสแกนจาก ADF ยกฝาครอบสแกนเนอร์ขึ้น แล้วนำเครื่องมือทำความสะอาดกระจกออก เช็ดกระจก ADF ด้านข้างกระจกสแกนเนอร์ เปิดฝาปิด A1 แล้วทำความสะอาดกระจก ADF นำเครื่องมือกลับติดตั้งกลับเข้าที่ ปิดฝาครอบสแกนเนอร์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการทำความสะอาดสแกนเนอร์ โปรดดู  หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน เส้นสีเข้มแนวตั้งบนงานพิมพ์เมื่อสแกนจาก ADF เส้นสีเข้มแนวตั้งบนงานพิมพ์เมื่อสแกนจาก ADF ปัญหาคุณภาพการสแกน"},{"UUID":"c47cd12f-ac35-4f24-973e-71498702b994","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"ภาพหรือข้อความเป็นรอยหยักเมื่อสแกนจาก ADF ภาพหรือข้อความเป็นรอยหยักเมื่อสแกนจาก ADF ป้อนกระดาษธรรมดาที่สะอาด","descFull":"ภาพหรือข้อความเป็นรอยหยักเมื่อสแกนจาก ADF ภาพหรือข้อความเป็นรอยหยักเมื่อสแกนจาก ADF ป้อนกระดาษธรรมดาที่สะอาด 50 แผ่นเข้าใน ADF กระดาษธรรมดาจะช่วยทำความสะอาดหรือขจัดฝุ่นและสารเคลือบอื่นๆ ออกจากลูกกลิ้งตัวป้อนกระดาษ ADF จากแผงควบคุม ปัดไปทางขวาที่ศูนย์ควบคุม แล้วเลือก  ป้อนเอกสารต้นฉบับเข้าใน ADF สแกนเอกสาร หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน ภาพเป็นรอยหยัก ปัญหาการสแกน ข้อความเป็นรอยหยัก การแก้ไขปัญหา ภาพเป็นรอยหยักจากการสแกน ADF การแก้ไขปัญหา ข้อความเป็นรอยหยักจากการสแกน ADF ภาพเป็นรอยหยักจากการสแกน ADF ข้อความเป็นรอยหยักจากการสแกน ADF"},{"UUID":"e7730fa8-9f73-45c8-a80e-e81658d61c4b","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"สแกนงานไม่สำเร็จ สแกนงานไม่สำเร็จ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าสายเคเบิลอีเทอร์เน็ตหรือสายเคเบิล USB","descFull":"สแกนงานไม่สำเร็จ สแกนงานไม่สำเร็จ ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าสายเคเบิลอีเทอร์เน็ตหรือสายเคเบิล USB เชื่อมต่อกับคอมพิวเตอร์และเครื่องพิมพ์แน่นดีแล้ว ตรวจสอบไฟล์ที่คุณต้องการสแกน และตรวจสอบให้แน่ใจว่า: ไม่ได้มีชื่อไฟล์นี้อยู่แล้วในโฟลเดอร์ปลายทาง ไม่ได้เปิดเอกสารหรือภาพถ่ายที่คุณต้องการสแกนในแอปพลิเคชันอื่น ตรวจสอบให้แน่ใจว่ามีการทำเครื่องหมายในกล่องตัวเลือก  เพิ่มประทับเวลา  หรือ  เขียนทับไฟล์ที่มีอยู่  ในการกำหนดค่าปลายทาง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน สแกนงานไม่สำเร็จ สแกนงานไม่สำเร็จ การแก้ไขปัญหา สแกนงานไม่สำเร็จ"},{"UUID":"2d6d60fb-8912-480a-8bf1-22dcad80097f","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"ปิดสแกนเนอร์ไม่ลง ปิดสแกนเนอร์ไม่ลง นำสิ่งกีดขวางที่ทำให้ฝาสแกนเนอร์เปิดอยู่ออก ปิดสแกนเนอร์ หากปัญหายังคงมีอยู่","descFull":"ปิดสแกนเนอร์ไม่ลง ปิดสแกนเนอร์ไม่ลง นำสิ่งกีดขวางที่ทำให้ฝาสแกนเนอร์เปิดอยู่ออก ปิดสแกนเนอร์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน ปิดสแกนเนอร์ไม่ลง ปิดสแกนเนอร์ไม่ลง"},{"UUID":"c30859ea-69e9-482f-8e82-ea11f382258e","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"การสแกนใช้เวลานานหรือทำให้เครื่องคอมพิวเตอร์หยุดชะงัก การสแกนใช้เวลานานหรือทำให้เครื่องคอมพิวเตอร์หยุดชะงัก ปิดแอปพลิเคชันทั้งหมดที่รบกวนการสแกน สแกนเอกสารอีกครั้ง หากปัญหายังคงมีอยู่","descFull":"การสแกนใช้เวลานานหรือทำให้เครื่องคอมพิวเตอร์หยุดชะงัก การสแกนใช้เวลานานหรือทำให้เครื่องคอมพิวเตอร์หยุดชะงัก ปิดแอปพลิเคชันทั้งหมดที่รบกวนการสแกน สแกนเอกสารอีกครั้ง หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการสแกน การสแกนใช้เวลานานเกินไป ปัญหาการสแกน การสแกนทำให้คอมพิวเตอร์ค้าง การสแกนใช้เวลานานหรือทำให้เครื่องคอมพิวเตอร์หยุดชะงัก"},{"UUID":"85d3dd71-c80d-4f3e-b42c-c4f186ae8549","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"สแกนเนอร์ไม่ตอบสนอง สแกนเนอร์ไม่ตอบสนอง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้เสียบสายไฟเข้ากับเครื่องพิมพ์และเต้าเสียบแล้ว เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต","descFull":"สแกนเนอร์ไม่ตอบสนอง สแกนเนอร์ไม่ตอบสนอง ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: ตรวจสอบให้แน่ใจว่าได้เสียบสายไฟเข้ากับเครื่องพิมพ์และเต้าเสียบแล้ว เพื่อหลีกเลี่ยงความเสี่ยงต่อการเกิดอัคคีภัยหรือไฟฟ้าช็อต ให้เชื่อมต่อสายไฟเข้ากับเต้าเสียบที่ได้รับการจัดระดับที่เหมาะสมและต่อลงดินอย่างเหมาะสมซึ่งอยู่ใกล้ผลิตภัณฑ์และเข้าถึงได้ง่าย ตรวจสอบว่าเครื่องพิมพ์เปิดอยู่หรือไม่ แล้วแก้ไขปัญหาจากข้อความแจ้งข้อผิดพลาดใดๆ ที่ปรากฏบนส่วนแสดงผล ปิดเครื่องพิมพ์ รอประมาณ 10 วินาที แล้วเปิดเครื่องพิมพ์ หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาการทำสำเนา สแกนเนอร์ไม่ตอบสนอง ปัญหาการสแกน สแกนเนอร์ไม่ตอบสนอง สแกนเนอร์ไม่ตอบสนอง"},{"UUID":"7ed9eff6-fd74-4053-a7fc-7c3aaeff69ab","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"การปรับการลงทะเบียนสแกนเนอร์ การปรับการลงทะเบียนสแกนเนอร์ จากแผงควบคุม ไปที่ ","descFull":"การปรับการลงทะเบียนสแกนเนอร์ การปรับการลงทะเบียนสแกนเนอร์ จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การกำหนดค่าสแกนเนอร์ การลงทะเบียนสแกนเนอร์ด้วยตนเอง จากเมนู การทดสอบการพิมพ์แบบด่วน  ให้เลือก  เริ่มต้น วางหน้าการทดสอบลงบนกระจกสแกนเนอร์แล้วเลือก  การลงทะเบียนบนแท่นสแกน ในเมนู การทดสอบการทำสำเนาแบบด่วน  ให้เลือก  เริ่มต้น เปรียบเทียบหน้าการทดสอบกับเอกสารต้นฉบับ หากระยะห่างของหน้าทดสอบแตกต่างจากเอกสารต้นฉบับ ให้ปรับการตั้งค่า  ระยะขอบด้านซ้าย  และ  ระยะขอบด้านบน ทำซ้ำ   และ   จนกระทั่งระยะขอบของหน้า  การทดสอบการทำสำเนาแบบด่วน  ใกล้เคียงกับเอกสารต้นฉบับที่สุด การปรับ การลงทะเบียนสแกนเนอร์"},{"UUID":"d5feae87-116d-41e9-8efc-3356f9418633","title":"ปัญหาการสแกน","link":"trb-cannot-scan-to-computer-topic.html","desc":"การปรับการลงทะเบียน ADF จากแผงควบคุม ไปที่ ","descFull":"การปรับการลงทะเบียน ADF จากแผงควบคุม ไปที่  การตั้งค่า อุปกรณ์ การดูแลรักษา เมนูการกำหนดค่า การกำหนดค่าสแกนเนอร์ การลงทะเบียนสแกนเนอร์ด้วยตนเอง จากเมนู การทดสอบการพิมพ์แบบด่วน  ให้เลือก  เริ่มต้น วางหน้าการทดสอบบนถาด ADF เลือก  การลงทะเบียน ADF ด้านหน้า  หรือ  การลงทะเบียน ADF ด้านหลัง ในการจัดแนว การลงทะเบียน ADF ด้านหน้า  ให้หงายหน้าการทดสอบขึ้นและใส่โดยหันด้านสั้นเข้าไปใน ADF ในการจัดแนว การลงทะเบียน ADF ด้านหลัง  ให้คว่ำหน้าการทดสอบลงและใส่โดยหันด้านสั้นเข้าไปใน ADF ในเมนู การทดสอบการทำสำเนาแบบด่วน  ให้เลือก  เริ่มต้น เปรียบเทียบหน้าการทดสอบกับเอกสารต้นฉบับ หากระยะห่างของหน้าทดสอบแตกต่างจากเอกสารต้นฉบับ ให้ปรับการตั้งค่า  ปรับตามแนวนอน  และ  ระยะขอบด้านบน ทำซ้ำ   และ   จนกระทั่งระยะขอบของหน้า  การทดสอบการทำสำเนาแบบด่วน  ใกล้เคียงกับเอกสารต้นฉบับที่สุด การลงทะเบียน ADF การปรับ การปรับการลงทะเบียน ADF"},{"UUID":"f75bdb52-f9ac-4cb4-b862-c35e71d75942","title":"ปัญหาคุณภาพสี","link":"modifying-colors-in-printed-output-topic.html","desc":"การแก้ไขสีในงานพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า","descFull":"การแก้ไขสีในงานพิมพ์ จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง การปรับแก้สี ในเมนู  การปรับแก้สี  ให้เลือก  ด้วยตนเอง ในเมนู  เนื้อหาการปรับแก้สี  เลือกการตั้งค่าการแปลงค่าสีที่เหมาะสม เมนูสีแบบกำหนดด้วยตนเอง ประเภทวัตถุ และตารางการแปลงสี ประเภทวัตถุ ตารางการแปลงสี ภาพ RGB ข้อความ RGB ภาพกราฟิก RGB สมจริง —ให้สีที่สว่างสดใสและอิ่มตัวมากขึ้น และสามารถใช้ได้กับรูปแบบสีขาเข้าทั้งหมด ส่วนแสดงผล sRGB —ให้ผลลัพธ์ที่ใกล้เคียงกับสีที่แสดงบนหน้าจอคอมพิวเตอร์ การใช้หมึกสีดำเหมาะสำหรับการพิมพ์ภาพถ่าย ส่วนแสดงผล‑สีดำแท้ —ให้ผลลัพธ์ที่ใกล้เคียงกับสีที่แสดงบนหน้าจอคอมพิวเตอร์ จะใช้การตั้งค่านี้เฉพาะหมึกสีดำเพื่อสร้างระดับสีเทากลางในหลายๆ ระดับ sRGB แบบสมจริง —ให้ความอิ่มตัวของสีที่เพิ่มขึ้นสำหรับการปรับแก้สีใน  ส่วนแสดงผล sRGB  การใช้หมึกสีดำเหมาะสำหรับการพิมพ์ภาพกราฟิกเชิงธุรกิจ ปิด ภาพ CMYK ข้อความ CMYK ภาพกราฟิก CMYK US CMYK —ใช้การปรับแก้สีที่ใกล้เคียงกับข้อกำหนดสำหรับเอาต์พุตสีของ Web Offset Publishing (SWOP) Euro CMYK —ใช้การปรับแก้สีที่ใกล้เคียงกับเอาต์พุตสีแบบ Euroscale CMYK แบบสมจริง —เพิ่มความอิ่มตัวของสีของการตั้งค่าการปรับแก้สีของ  US CMYK ปิด การแก้ไขสีเอาต์พุต การปรับแก้สีด้วยตนเอง การปรับแก้สี"},{"UUID":"22461e04-d7db-4d3f-9e1b-f62747be47db","title":"ปัญหาคุณภาพสี","link":"modifying-colors-in-printed-output-topic.html","desc":"คำถามที่พบบ่อยเกี่ยวกับการพิมพ์สี สี RGB คืออะไร สี","descFull":"คำถามที่พบบ่อยเกี่ยวกับการพิมพ์สี สี RGB คืออะไร สี RGB คือวิธีการอธิบายสีโดยระบุปริมาณสีแดง สีเขียว หรือสีน้ำเงิน ที่ใช้ในการสร้างสีใดสีหนึ่ง สามารถเพิ่มสีแดง สีเขียว และสีน้ำเงินได้หลายรูปแบบเพื่อสร้างสีที่หลากหลายตามธรรมชาติ หน้าจอคอมพิวเตอร์ สแกนเนอร์ และกล้องดิจิตอลใช้วิธีนี้ในการแสดงสี สี CMYK คืออะไร สี CMYK คือวิธีการอธิบายสีโดยระบุปริมาณสีน้ำเงินเขียว สีม่วงแดง สีเหลืองและสีดำที่ใช้เพื่อสร้างสีใดสีหนึ่งขึ้นมาใหม่โดยเฉพาะ สามารถพิมพ์หมึกหรือผงหมึกสี CMYK ในหลายระดับเพื่อให้ได้สีแบบที่มองเห็นตามธรรมชาติ สื่อสิ่งพิมพ์ เครื่องพิมพ์แบบอิงค์เจ็ท และเครื่องพิมพ์เลเซอร์สีใช้วิธีนี้ในการสร้างสี มีการระบุสีในเอกสารที่จะพิมพ์อย่างไร มีการใช้โปรแกรมซอฟต์แวร์เพื่อระบุและแก้ไขสีในเอกสาร โดยใช้การผสมสี RGB หรือ CMYK สำหรับข้อมูลเพิ่มเติม ให้ดูที่หัวข้อวิธีใช้โปรแกรมซอฟต์แวร์ เครื่องพิมพ์จะทราบสีที่จะพิมพ์ได้อย่างไร เมื่อพิมพ์เอกสาร ข้อมูลที่อธิบายประเภทและสีของวัตถุแต่ละชิ้นจะถูกส่งไปยังเครื่องพิมพ์ จากนั้น ข้อมูลจะถูกส่งผ่านตารางการแปลงสี สีจะถูกแปลเป็นปริมาณผงหมึกสี CMYK ที่ใช้สำหรับการสร้างสีที่คุณต้องการ ข้อมูลออบเจกต์จะกำหนดการใช้ตารางการแปลงสี ตัวอย่างเช่น คุณสามารถนำตารางการแปลงสีชนิดหนึ่งไปใช้กับข้อความ ในขณะที่นำตารางการแปลงสีที่อื่นไปใช้กับภาพถ่าย การปรับแก้สีด้วยตนเองคืออะไร เมื่อเปิดใช้งานการปรับแก้สีด้วยตนเอง เครื่องพิมพ์จะใช้ตารางการแปลงสีที่ผู้ใช้เลือกเพื่อประมวลผลวัตถุ การตั้งค่าการปรับแก้สีด้วยตนเองเป็นค่าเฉพาะสำหรับชนิดของวัตถุที่กำลังพิมพ์ (ข้อความ กราฟิก หรือภาพ) และยังขึ้นอยู่กับวิธีการระบุสีของวัตถุในโปรแกรมซอฟต์แวร์ (การผสมกันของ RGB หรือ CMYK) หากต้องการใช้ตารางแปลงค่าสีอื่นด้วยตนเอง โปรดดูที่  หากโปรแกรมซอฟต์แวร์ไม่ได้ระบุสีโดยใช้การผสมกันของ RGB หรือ CMYK การปรับแก้สีด้วยตนเองจะไม่มีประโยชน์ และยังไม่มีประสิทธิภาพหากโปรแกรมซอฟต์แวร์หรือระบบปฏิบัติการของคอมพิวเตอร์ควบคุมการปรับสี ในสถานการณ์ส่วนใหญ่ การตั้งค่าการปรับแก้สีเป็นอัตโนมัติจะสร้างสีที่ต้องการสำหรับเอกสาร ฉันจะจับคู่สีใดสีหนึ่ง (เช่น โลโก้ของบริษัท) ได้อย่างไร จากเมนู คุณภาพ  เครื่องพิมพ์จะมีชุด ตัวอย่างสี ให้เลือก 9 ประเภท นอกจากนี้ ยังมีชุดเหล่านี้ให้ใช้งานจากหน้า ตัวอย่างสี ของ Embedded Web Server อีกด้วย การเลือกชุดตัวอย่างจะทำให้มีการพิมพ์หลายหน้าที่ประกอบด้วยกล่องสีหลายร้อยกล่อง แต่ละกล่องจะมีการผสม CMYK หรือ RGB ขึ้นอยู่กับตารางที่เลือก จะได้สีของแต่ละกล่องที่สังเกตได้จากการส่งการผสมสี CMYK หรือ RGB ที่มีฉลากอยู่บนกล่อง ด้วยการตรวจสอบชุด ตัวอย่างสี  คุณจะสามารถระบุกล่องที่มีสีใกล้เคียงกับสีที่กำลังจับคู่มากที่สุดได้ ทั้งนี้ จะสามารถใช้การผสมสีที่มีฉลากบนกล่องเพื่อปรับแก้สีของวัตถุในโปรแกรมซอฟต์แวร์ได้ สำหรับข้อมูลเพิ่มเติม ให้ดูที่หัวข้อวิธีใช้โปรแกรมซอฟต์แวร์ อาจจำเป็นต้องปรับแก้สีด้วยตนเองเพื่อใช้ตารางแปลงสีที่เลือกสำหรับวัตถุนั้นๆ การใช้การเลือกชุด ตัวอย่างสี กับปัญหาการจับคู่สีที่ต้องการจะขึ้นอยู่กับ: การตั้งค่า การปรับแก้สี ที่ใช้ ( อัตโนมัติ ,  ปิด  หรือ ด้วยตนเอง ) ประเภทของวัตถุที่พิมพ์ (ข้อความ กราฟิก หรือภาพ) วิธีการระบุสีของวัตถุในโปรแกรมซอฟต์แวร์ (การผสม RGB หรือ CMYK) หากโปรแกรมซอฟต์แวร์ไม่ได้ระบุสีโดยใช้การผสม RGB หรือ CMYK หน้า ตัวอย่างสี จะไม่มีประโยชน์ โปรแกรมซอฟต์แวร์บางโปรแกรมจะปรับค่าผสม RGB หรือ CMYK ที่ระบุไว้ในโปรแกรมโดยใช้การจัดการสี ในสถานการณ์เหล่านี้ สีที่พิมพ์ออกมาอาจไม่ตรงกับหน้า ตัวอย่างสี ปัญหาคุณภาพสี คำถามที่พบบ่อยเกี่ยวกับการพิมพ์สี การพิมพ์สี การปรับแก้สี ตัวอย่างสี"},{"UUID":"0cbe4254-3c3c-4081-ad9a-a8d39e987b9d","title":"ปัญหาคุณภาพสี","link":"modifying-colors-in-printed-output-topic.html","desc":"งานที่พิมพ์ออกมามีสีปน งานที่พิมพ์ออกมามีสีปน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่","descFull":"งานที่พิมพ์ออกมามีสีปน งานที่พิมพ์ออกมามีสีปน ให้ปฏิบัติตามข้อใดข้อหนึ่งต่อไปนี้: จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ปรับสี จากแผงควบคุม ไปที่  การตั้งค่า พิมพ์ คุณภาพ การสร้างภาพขั้นสูง  แล้วเลือก  ความสมดุลของสี  จากนั้น ปรับการตั้งค่า หากปัญหายังคงมีอยู่ โปรดติดต่อ ฝ่ายให้คำปรึกษาลูกค้า หากปัญหายังคงมีอยู่ โปรดติดต่อ ตัวแทนจำหน่ายของคุณ ปัญหาคุณภาพสี งานที่พิมพ์ออกมามีสี งานที่พิมพ์ออกมามีสี การแก้ไขปัญหา งานที่พิมพ์ออกมามีสี"},{"UUID":"ef3762ae-3b49-44ec-9620-f8a0feb4fec4","title":"การแก้ไขปัญหา","link":"trb-contacting-customer-support-topic.html","desc":"การติดต่อฝ่ายให้คำปรึกษาลูกค้า การติดต่อฝ่ายให้คำปรึกษาลูกค้า ก่อนติดต่อฝ่ายให้คำปรึกษาลูกค้า โปรดตรวจสอบให้แน่ใจว่ามีข้อมูลต่อไปนี้: ปัญหาเครื่องพิมพ์","descFull":"การติดต่อฝ่ายให้คำปรึกษาลูกค้า การติดต่อฝ่ายให้คำปรึกษาลูกค้า ก่อนติดต่อฝ่ายให้คำปรึกษาลูกค้า โปรดตรวจสอบให้แน่ใจว่ามีข้อมูลต่อไปนี้: ปัญหาเครื่องพิมพ์ ข้อความแจ้งข้อผิดพลาด ประเภทรุ่นของเครื่องพิมพ์และหมายเลขประจำเครื่อง ไปที่  https://support.lexmark.com  เพื่อรับความช่วยเหลือทางอีเมลหรือแชท หรือเรียกดูไลบรารีคู่มือ เอกสารความช่วยเหลือ ไดรเวอร์ และการดาวน์โหลดอื่นๆ นอกจากนี้ยังมีบริการฝ่ายให้คำปรึกษาทางเทคนิคผ่านทางโทรศัพท์อีกด้วย ในสหรัฐอเมริกาหรือแคนาดา โทร 1-800-539-6275 สำหรับประเทศหรือภูมิภาคอื่นๆ โปรดไปที่  ไดเรกทอรีข้อมูลติดต่อฝ่ายให้คำปรึกษาสากล ไปยังสถานที่ที่คุณซื้อเครื่องพิมพ์ การติดต่อฝ่ายให้คำปรึกษาลูกค้า ฝ่ายให้คำปรึกษาลูกค้า"},{"UUID":"9d39b623-f8fb-4f8e-92fc-9a47689b8af0","title":"การแก้ไขปัญหา","link":"troubleshooting-chapter.html","desc":"การติดต่อตัวแทนจำหน่ายของคุณ ก่อนติดต่อตัวแทนจำหน่ายของคุณ โปรดตรวจสอบให้แน่ใจว่ามีข้อมูลต่อไปนี้: ปัญหาเครื่องพิมพ์ ข้อความแจ้งข้อผิดพลาด","descFull":"การติดต่อตัวแทนจำหน่ายของคุณ ก่อนติดต่อตัวแทนจำหน่ายของคุณ โปรดตรวจสอบให้แน่ใจว่ามีข้อมูลต่อไปนี้: ปัญหาเครื่องพิมพ์ ข้อความแจ้งข้อผิดพลาด ประเภทรุ่นของเครื่องพิมพ์และหมายเลขประจำเครื่อง การติดต่อตัวแทนจำหน่ายของคุณ ตัวแทนจำหน่ายเครื่องพิมพ์"},{"UUID":"7bbf5783-5a44-4fb8-99fb-95f59adf50f6","title":"การแก้ไขปัญหา","link":"troubleshooting-chapter.html","desc":"การติดต่อฝ่ายให้คำปรึกษาทางเทคนิค เมื่อคุณติดต่อฝ่ายให้คำปรึกษาทางเทคนิค ให้อธิบายปัญหา ข้อความที่แสดงบนหน้าจอของเครื่องพิมพ์ และขั้นตอนการแก้ไขปัญหาที่คุณได้ดำเนินการไปแล้ว","descFull":"การติดต่อฝ่ายให้คำปรึกษาทางเทคนิค เมื่อคุณติดต่อฝ่ายให้คำปรึกษาทางเทคนิค ให้อธิบายปัญหา ข้อความที่แสดงบนหน้าจอของเครื่องพิมพ์ และขั้นตอนการแก้ไขปัญหาที่คุณได้ดำเนินการไปแล้ว โปรดดูป้ายด้านในฝาด้านหน้าบนหรือด้านหลังของเครื่องพิมพ์ แล้วจดบันทึกสิ่งต่อไปนี้: รุ่นเครื่องพิมพ์ หมายเลขแท็กบริการหรือรหัสบริการด่วน สำหรับข้อมูลเพิ่มเติม โปรดไปที่  www.dell.com/support การแก้ไขปัญหา การติดต่อฝ่ายให้คำปรึกษาทางเทคนิค การติดต่อฝ่ายให้คำปรึกษาทางเทคนิค"},{"UUID":"c82552f4-24b2-40f8-a8c8-15c005bb5538","title":"รีไซเคิลและกำจัด","link":"recycling-lexmark-products-topic.html","desc":"การรีไซเคิลผลิตภัณฑ์ Lexmark การรีไซเคิลผลิตภัณฑ์ Lexmark ไปที่","descFull":"การรีไซเคิลผลิตภัณฑ์ Lexmark การรีไซเคิลผลิตภัณฑ์ Lexmark ไปที่  www.lexmark.com/recycle เลือกประเทศหรือภูมิภาคของคุณ เลือกโปรแกรมการรีไซเคิล การรีไซเคิลผลิตภัณฑ์"},{"UUID":"db68accd-2f64-4046-b7c0-6b7063983c0c","title":"รีไซเคิลและกำจัด","link":"recycling-lexmark-packaging-topic.html","desc":"การรีไซเคิลบรรจุภัณฑ์ Lexmark การรีไซเคิลบรรจุภัณฑ์ Lexmark Lexmark","descFull":"การรีไซเคิลบรรจุภัณฑ์ Lexmark การรีไซเคิลบรรจุภัณฑ์ Lexmark Lexmark มุ่งมั่นอย่างต่อเนื่องเพื่อลดปริมาณบรรจุภัณฑ์ บรรจุภัณฑ์ที่ลดปริมาณลงช่วยให้มั่นใจว่าเครื่องพิมพ์ Lexmark จะได้รับการขนส่งอย่างมีประสิทธิภาพและคำนึงถึงสิ่งแวดล้อมมากที่สุด และมีบรรจุภัณฑ์ที่จำเป็นต้องทิ้งน้อยลง ประสิทธิภาพเหล่านี้ก่อให้เกิดการปล่อยก๊าซเรือนกระจกน้อยลง ประหยัดพลังงาน และประหยัดทรัพยากรธรรมชาติ นอกจากนี้ Lexmark ยังนำเสนอโปรแกรมการรีไซเคิลส่วนประกอบของบรรจุภัณฑ์ในบางประเทศหรือภูมิภาคอีกด้วย หากต้องการข้อมูลเพิ่มเติม โปรดเข้าไปที่  www.lexmark.com/recycle กล่องบรรจุของ Lexmark สามารถนำกลับมารีไซเคิลได้ 100% หากมีศูนย์รีไซเคิลวัสดุที่ทำจากลูกฟูกอยู่ อาจไม่มีศูนย์รีไซเคิลในท้องถิ่นของคุณ โฟมที่ใช้ในบรรจุภัณฑ์ของ Lexmark สามารถรีไซเคิลได้ในกรณีที่มีศูนย์รีไซเคิลโฟมอยู่ อาจไม่มีศูนย์รีไซเคิลในท้องถิ่นของคุณ เมื่อคุณส่งคืนตลับหมึกกลับมายัง Lexmark คุณสามารถนำกล่องบรรจุของตลับหมึกดังกล่าวกลับมาใช้ใหม่ได้ โดย Lexmark จะรีไซเคิลกล่องดังกล่าว การรีไซเคิลผลิตภัณฑ์ บรรจุภัณฑ์"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFP"}},[_vm._v("\n    CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFP\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_th","title":"ข้อมูลเพื่อความปลอดภัย"}},[_vm._v("\n    ข้อมูลเพื่อความปลอดภัย\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"คำอธิบายสัญลักษณ์"}},[_vm._v("\n     คำอธิบายสัญลักษณ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"คำประกาศเกี่ยวกับผลิตภัณฑ์"}},[_vm._v("\n     คำประกาศเกี่ยวกับผลิตภัณฑ์\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_th","title":"เรียนรู้เกี่ยวกับเครื่องพิมพ์"}},[_vm._v("\n    เรียนรู้เกี่ยวกับเครื่องพิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_th","title":"การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์"}},[_vm._v("\n     การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_th","title":"การค้นหาหมายเลขประจำเครื่องของเครื่องพิมพ์"}},[_vm._v("\n     การค้นหาหมายเลขประจำเครื่องของเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_th","title":"การกำหนดค่าเครื่องพิมพ์"}},[_vm._v("\n     การกำหนดค่าเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_th","title":"การใช้แผงควบคุม"}},[_vm._v("\n     การใช้แผงควบคุม\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_th","title":"ไอคอนหน้าจอหลัก"}},[_vm._v("\n     ไอคอนหน้าจอหลัก\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_th","title":"สีของไฟแสดงสถานะ"}},[_vm._v("\n     สีของไฟแสดงสถานะ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_th","title":"การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์"}},[_vm._v("\n     การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_th","title":"การค้นหาช่องสำหรับความปลอดภัย"}},[_vm._v("\n     การค้นหาช่องสำหรับความปลอดภัย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"การเลือกกระดาษ"}},[_vm._v("\n     การเลือกกระดาษ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10650","title":"คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์"}},[_vm._v("\n     คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_th","title":"ตั้งค่า ติดตั้ง และกำหนดค่า"}},[_vm._v("\n    ตั้งค่า ติดตั้ง และกำหนดค่า\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10777"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_th","title":"การเลือกตำแหน่งสำหรับเครื่องพิมพ์"}},[_vm._v("\n     การเลือกตำแหน่งสำหรับเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_th","title":"พอร์ตเครื่องพิมพ์"}},[_vm._v("\n     พอร์ตเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10976","title":"การกำหนดค่าแอปและโซลูชัน"}},[_vm._v("\n     การกำหนดค่าแอปและโซลูชัน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11153","title":"การตั้งค่าและการใช้คุณสมบัติการเข้าถึง"}},[_vm._v("\n     การตั้งค่าและการใช้คุณสมบัติการเข้าถึง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11458","title":"การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์"}},[_vm._v("\n     การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_th","title":"การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ"}},[_vm._v("\n     การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12254","title":"การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์"}},[_vm._v("\n     การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12580","title":"การติดตั้งตัวเลือกฮาร์ดแวร์"}},[_vm._v("\n     การติดตั้งตัวเลือกฮาร์ดแวร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14111","title":"การเชื่อมต่อเครือข่าย"}},[_vm._v("\n     การเชื่อมต่อเครือข่าย\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_th","title":"รักษาความปลอดภัยของเครื่องพิมพ์"}},[_vm._v("\n    รักษาความปลอดภัยของเครื่องพิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14463"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_th","title":"การลบหน่วยความจำเครื่องพิมพ์"}},[_vm._v("\n     การลบหน่วยความจำเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_th","title":"การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์"}},[_vm._v("\n     การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_th","title":"การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน"}},[_vm._v("\n     การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_th","title":"คำประกาศเกี่ยวกับความถาวรของข้อมูล"}},[_vm._v("\n     คำประกาศเกี่ยวกับความถาวรของข้อมูล\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_th","title":"พิมพ์"}},[_vm._v("\n    พิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14655"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_th","title":"การพิมพ์จากคอมพิวเตอร์"}},[_vm._v("\n     การพิมพ์จากคอมพิวเตอร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14706","title":"การพิมพ์จากอุปกรณ์มือถือ"}},[_vm._v("\n     การพิมพ์จากอุปกรณ์มือถือ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_th","title":"การพิมพ์จากแฟลชไดรฟ์"}},[_vm._v("\n     การพิมพ์จากแฟลชไดรฟ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_th","title":"การกำหนดค่างานลับ"}},[_vm._v("\n     การกำหนดค่างานลับ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_th","title":"การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ"}},[_vm._v("\n     การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_th","title":"การพิมพ์รายการตัวอย่างฟอนต์"}},[_vm._v("\n     การพิมพ์รายการตัวอย่างฟอนต์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_th","title":"การพิมพ์รายการไดเรกทอรี่"}},[_vm._v("\n     การพิมพ์รายการไดเรกทอรี่\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_th","title":"การใส่แผ่นคั่นในงานพิมพ์"}},[_vm._v("\n     การใส่แผ่นคั่นในงานพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_th","title":"การยกเลิกงานพิมพ์"}},[_vm._v("\n     การยกเลิกงานพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_th","title":"การปรับความเข้มของหมึก"}},[_vm._v("\n     การปรับความเข้มของหมึก\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_th","title":"ทำสำเนา"}},[_vm._v("\n    ทำสำเนา\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15201"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_th","title":"การทำสำเนา"}},[_vm._v("\n     การทำสำเนา\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_th","title":"การทำสำเนาภาพถ่าย"}},[_vm._v("\n     การทำสำเนาภาพถ่าย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_th","title":"การทำสำเนาบนกระดาษหัวจดหมาย"}},[_vm._v("\n     การทำสำเนาบนกระดาษหัวจดหมาย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_th","title":"การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน"}},[_vm._v("\n     การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_th","title":"การย่อหรือขยายขนาดสำเนา"}},[_vm._v("\n     การย่อหรือขยายขนาดสำเนา\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_th","title":"การเรียงหน้าสำเนา"}},[_vm._v("\n     การเรียงหน้าสำเนา\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_th","title":"การใส่แผ่นคั่นระหว่างสำเนา"}},[_vm._v("\n     การใส่แผ่นคั่นระหว่างสำเนา\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_th","title":"การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว"}},[_vm._v("\n     การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_th","title":"การสำเนาบัตร"}},[_vm._v("\n     การสำเนาบัตร\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_th","title":"การสร้างทางลัดสำเนา"}},[_vm._v("\n     การสร้างทางลัดสำเนา\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_th","title":"อีเมล"}},[_vm._v("\n    อีเมล\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15474"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_th","title":"การกำหนดค่าการตั้งค่า SMTP"}},[_vm._v("\n     การกำหนดค่าการตั้งค่า SMTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_th","title":"การส่งอีเมล"}},[_vm._v("\n     การส่งอีเมล\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_th","title":"การสร้างทางลัดอีเมล"}},[_vm._v("\n     การสร้างทางลัดอีเมล\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_th","title":"แฟกซ์"}},[_vm._v("\n    แฟกซ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16923"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_th","title":"การส่งแฟกซ์"}},[_vm._v("\n     การส่งแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_th","title":"การกำหนดเวลาการแฟกซ์"}},[_vm._v("\n     การกำหนดเวลาการแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_th","title":"การสร้างทางลัดปลายทางแฟกซ์"}},[_vm._v("\n     การสร้างทางลัดปลายทางแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_th","title":"การเปลี่ยนความละเอียดของแฟกซ์"}},[_vm._v("\n     การเปลี่ยนความละเอียดของแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_th","title":"การปรับความเข้มของแฟกซ์"}},[_vm._v("\n     การปรับความเข้มของแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_th","title":"การพิมพ์บันทึกการแฟกซ์"}},[_vm._v("\n     การพิมพ์บันทึกการแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_th","title":"การปิดกั้นแฟกซ์ที่ไม่ต้องการ"}},[_vm._v("\n     การปิดกั้นแฟกซ์ที่ไม่ต้องการ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_th","title":"การระงับแฟกซ์"}},[_vm._v("\n     การระงับแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_th","title":"การส่งต่อแฟกซ์"}},[_vm._v("\n     การส่งต่อแฟกซ์\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_th","title":"สแกน"}},[_vm._v("\n    สแกน\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17219"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_th","title":"การสแกนไปยังคอมพิวเตอร์"}},[_vm._v("\n     การสแกนไปยังคอมพิวเตอร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_th","title":"การสแกนไปยังเซิร์ฟเวอร์ FTP"}},[_vm._v("\n     การสแกนไปยังเซิร์ฟเวอร์ FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_th","title":"การสร้างทางลัด FTP"}},[_vm._v("\n     การสร้างทางลัด FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_th","title":"การสแกนไปยังโฟลเดอร์เครือข่าย"}},[_vm._v("\n     การสแกนไปยังโฟลเดอร์เครือข่าย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_th","title":"การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย"}},[_vm._v("\n     การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_th","title":"การสร้างทางลัดโฟลเดอร์เครือข่าย"}},[_vm._v("\n     การสร้างทางลัดโฟลเดอร์เครือข่าย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_th","title":"การสแกนไปยังแฟลชไดร์ฟ"}},[_vm._v("\n     การสแกนไปยังแฟลชไดร์ฟ\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_th","title":"เมนูเครื่องพิมพ์"}},[_vm._v("\n    เมนูเครื่องพิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17508"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_th","title":"ผังเมนู"}},[_vm._v("\n     ผังเมนู\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17822","title":"อุปกรณ์"}},[_vm._v("\n     อุปกรณ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20056","title":"พิมพ์"}},[_vm._v("\n     พิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21338","title":"กระดาษ"}},[_vm._v("\n     กระดาษ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21670","title":"ทำสำเนา"}},[_vm._v("\n     ทำสำเนา\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22229","title":"แฟกซ์"}},[_vm._v("\n     แฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24096","title":"อีเมล"}},[_vm._v("\n     อีเมล\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25193","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25899","title":"ไดรฟ์ USB"}},[_vm._v("\n     ไดรฟ์ USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26745","title":"เครือข่าย/พอร์ต"}},[_vm._v("\n     เครือข่าย/พอร์ต\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28896","title":"การรักษาความปลอดภัย"}},[_vm._v("\n     การรักษาความปลอดภัย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29993","title":"บริการระบบคลาวด์"}},[_vm._v("\n     บริการระบบคลาวด์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30050","title":"รายงาน"}},[_vm._v("\n     รายงาน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_th","title":"การแก้ไขปัญหา"}},[_c('strong',[_vm._v("\n      การแก้ไขปัญหา\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_th","title":"Forms Merge"}},[_c('strong',[_vm._v("\n      Forms Merge\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_th","title":"การพิมพ์ หน้าการตั้งค่าเมนู"}},[_vm._v("\n     การพิมพ์\n     "),_c('strong',[_vm._v("\n      หน้าการตั้งค่าเมนู\n     ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_th","title":"ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์"}},[_vm._v("\n    ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30533"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_th","title":"การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ"}},[_vm._v("\n     การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_th","title":"การใช้อุปกรณ์เย็บเล่มตอกรู"}},[_vm._v("\n     การใช้อุปกรณ์เย็บเล่มตอกรู\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_th","title":"การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต"}},[_vm._v("\n     การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_th","title":"การใช้อุปกรณ์เย็บเล่ม"}},[_vm._v("\n     การใช้อุปกรณ์เย็บเล่ม\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_th","title":"การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ"}},[_vm._v("\n     การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_th","title":"ดูแลรักษาเครื่องพิมพ์"}},[_vm._v("\n    ดูแลรักษาเครื่องพิมพ์\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30943"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_th","title":"การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง"}},[_vm._v("\n     การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_th","title":"การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง"}},[_vm._v("\n     การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_th","title":"การตั้งค่าการแจ้งเตือนทางอีเมล"}},[_vm._v("\n     การตั้งค่าการแจ้งเตือนทางอีเมล\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_th","title":"การสร้างรายงานและบันทึก"}},[_vm._v("\n     การสร้างรายงานและบันทึก\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_th","title":"การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง"}},[_vm._v("\n     การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31798","title":"การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง"}},[_vm._v("\n     การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32422","title":"การทำความสะอาดชิ้นส่วนเครื่องพิมพ์"}},[_vm._v("\n     การทำความสะอาดชิ้นส่วนเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32586","title":"การประหยัดพลังงานและกระดาษ"}},[_vm._v("\n     การประหยัดพลังงานและกระดาษ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_th","title":"การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น"}},[_vm._v("\n     การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_th","title":"การแก้ไขปัญหา"}},[_vm._v("\n    การแก้ไขปัญหา\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32724"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_th","title":"ปัญหาคุณภาพการพิมพ์"}},[_vm._v("\n     ปัญหาคุณภาพการพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_th","title":"รหัสข้อผิดพลาดของเครื่องพิมพ์"}},[_vm._v("\n     รหัสข้อผิดพลาดของเครื่องพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_th","title":"ปัญหาเกี่ยวกับการพิมพ์"}},[_vm._v("\n     ปัญหาเกี่ยวกับการพิมพ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_th","title":"เครื่องพิมพ์ไม่ตอบสนอง"}},[_vm._v("\n     เครื่องพิมพ์ไม่ตอบสนอง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_th","title":"ไม่สามารถอ่านแฟลชไดรฟ์ได้"}},[_vm._v("\n     ไม่สามารถอ่านแฟลชไดรฟ์ได้\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_th","title":"การเปิดใช้งานพอร์ต USB"}},[_vm._v("\n     การเปิดใช้งานพอร์ต USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_th","title":"การแก้ไขกระดาษติด"}},[_vm._v("\n     การแก้ไขกระดาษติด\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36148","title":"ปัญหาการเชื่อมต่อเครือข่าย"}},[_vm._v("\n     ปัญหาการเชื่อมต่อเครือข่าย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36241","title":"ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์"}},[_vm._v("\n     ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36414","title":"ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง"}},[_vm._v("\n     ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36562","title":"ปัญหาเกี่ยวกับการป้อนกระดาษ"}},[_vm._v("\n     ปัญหาเกี่ยวกับการป้อนกระดาษ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36756","title":"ปัญหาการรับส่งอีเมล"}},[_vm._v("\n     ปัญหาการรับส่งอีเมล\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36811","title":"ปัญหาการแฟกซ์"}},[_vm._v("\n     ปัญหาการแฟกซ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37133","title":"ปัญหาการสแกน"}},[_vm._v("\n     ปัญหาการสแกน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37551","title":"ปัญหาคุณภาพสี"}},[_vm._v("\n     ปัญหาคุณภาพสี\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_th","title":"การติดต่อฝ่ายให้คำปรึกษาลูกค้า"}},[_vm._v("\n     การติดต่อฝ่ายให้คำปรึกษาลูกค้า\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_th","title":"รีไซเคิลและกำจัด"}},[_vm._v("\n    รีไซเคิลและกำจัด\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37777"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_th","title":"การรีไซเคิลผลิตภัณฑ์ Lexmark"}},[_vm._v("\n     การรีไซเคิลผลิตภัณฑ์ Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_th","title":"การรีไซเคิลบรรจุภัณฑ์ Lexmark"}},[_vm._v("\n     การรีไซเคิลบรรจุภัณฑ์ Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_th","title":"คำประกาศ"}},[_vm._v("\n    คำประกาศ\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37813"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37816","title":"ข้อมูลผลิตภัณฑ์"}},[_vm._v("\n     ข้อมูลผลิตภัณฑ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37833","title":"หมายเหตุการปรับปรุง"}},[_vm._v("\n     หมายเหตุการปรับปรุง\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_th","title":"เครื่องหมายการค้า"}},[_vm._v("\n     เครื่องหมายการค้า\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_th","title":"คำประกาศเรื่องการอนุญาต"}},[_vm._v("\n     คำประกาศเรื่องการอนุญาต\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_th","title":"ระดับการปล่อยเสียงรบกวน"}},[_vm._v("\n     ระดับการปล่อยเสียงรบกวน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37931","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_th","title":"การทิ้งผลิตภัณฑ์"}},[_vm._v("\n     การทิ้งผลิตภัณฑ์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_th","title":"การแจ้งเตือนความไวต่อไฟฟ้าสถิต"}},[_vm._v("\n     การแจ้งเตือนความไวต่อไฟฟ้าสถิต\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_th","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_th","title":"ข้อมูลเกี่ยวกับอุณหภูมิ"}},[_vm._v("\n     ข้อมูลเกี่ยวกับอุณหภูมิ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_th","title":"ประกาศเรื่องเลเซอร์"}},[_vm._v("\n     ประกาศเรื่องเลเซอร์\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_th","title":"การใช้พลังงาน"}},[_vm._v("\n     การใช้พลังงาน\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38175","title":"Thailand NBTC technical standards conformity statementคำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย"}},[_vm._v("\n     Thailand NBTC technical standards conformity statement\n     "),_c('br'),_vm._v("\n     คำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38182","title":"คำประกาศควบคุมสำหรับผลิตภัณฑ์ไร้สาย"}},[_vm._v("\n     คำประกาศควบคุมสำหรับผลิตภัณฑ์ไร้สาย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_th","title":"ประกาศเกี่ยวกับชิ้นส่วนแบบแยก"}},[_vm._v("\n     ประกาศเกี่ยวกับชิ้นส่วนแบบแยก\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_th","title":"การแผ่รังสีความถี่คลื่นวิทยุ"}},[_vm._v("\n     การแผ่รังสีความถี่คลื่นวิทยุ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38208","title":"Notice to users in Thailandประกาศถึงผู้ใช้ในประเทศไทย"}},[_vm._v("\n     Notice to users in Thailand\n     "),_c('br'),_vm._v("\n     ประกาศถึงผู้ใช้ในประเทศไทย\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_th","title":"คำประกาศคลื่นวิทยุรบกวน"}},[_vm._v("\n     คำประกาศคลื่นวิทยุรบกวน\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js